var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e19) { throw _e19; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e20) { didErr = true; err = _e20; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function e(t) {
  return e = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, e(t);
}
function t(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, r(o.key), o);
  }
}
function n(e, n, r) {
  return n && t(e.prototype, n), r && t(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function r(t) {
  var n = function (t, n) {
    if ("object" != e(t) || !t) return t;
    var r = t[Symbol.toPrimitive];
    if (void 0 !== r) {
      var o = r.call(t, n || "default");
      if ("object" != e(o)) return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === n ? String : Number)(t);
  }(t, "string");
  return "symbol" == e(n) ? n : String(n);
}
function o(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function i(t, n, r) {
  return n = d(n), function (t, n) {
    if (n && ("object" === e(n) || "function" == typeof n)) return n;
    if (void 0 !== n) throw new TypeError("Derived constructors may only return object or undefined");
    return a(t);
  }(t, l() ? Reflect.construct(n, r || [], d(t).constructor) : n.apply(t, r));
}
function a(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function s(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && u(e, t);
}
function c(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return c = function c(e) {
    if (null === e || !function (e) {
      try {
        return -1 !== Function.toString.call(e).indexOf("[native code]");
      } catch (t) {
        return "function" == typeof e;
      }
    }(e)) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, n);
    }
    function n() {
      return function (e, t, n) {
        if (l()) return Reflect.construct.apply(null, arguments);
        var r = [null];
        r.push.apply(r, t);
        var o = new (e.bind.apply(e, r))();
        return n && u(o, n.prototype), o;
      }(e, arguments, d(this).constructor);
    }
    return n.prototype = Object.create(e.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), u(n, e);
  }, c(e);
}
function l() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (l = function l() {
    return !!e;
  })();
}
function u(e, t) {
  return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, u(e, t);
}
function d(e) {
  return d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, d(e);
}
var p, h, f, m, g, _, v;
!function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.oauth = "oauth", e.otp = "otp", e.crypto = "crypto", e.passwords = "passwords", e.passkeys = "passkeys";
}(p || (p = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft", e.Apple = "apple", e.Github = "github", e.GitLab = "gitlab", e.Facebook = "facebook", e.Discord = "discord", e.Salesforce = "salesforce", e.Slack = "slack", e.Amazon = "amazon", e.Bitbucket = "bitbucket", e.LinkedIn = "linkedin", e.Coinbase = "coinbase", e.Twitch = "twitch", e.Twitter = "twitter", e.TikTok = "tiktok", e.Snapchat = "snapchat", e.Figma = "figma", e.Yahoo = "yahoo";
}(h || (h = {})), function (e) {
  e.Vessel = "Vessel", e.Phantom = "Phantom", e.Metamask = "Metamask", e.Coinbase = "Coinbase", e.Binance = "Binance", e.GenericEthereumWallet = "Other Ethereum Wallet", e.GenericSolanaWallet = "Other Solana Wallet";
}(f || (f = {})), function (e) {
  e.embedded = "embedded", e.floating = "floating", e.embeddedOnly = "embeddedOnly", e.floatingOrEmbedded = "floatingOrEmbedded", e.forceLegacyEmbedded = "forceLegacyEmbedded";
}(m || (m = {})), function (e) {
  e.SMS = "sms", e.WhatsApp = "whatsapp", e.Email = "email";
}(g || (g = {})), function (e) {
  e.MagicLinkLoginOrCreateEvent = "MAGIC_LINK_LOGIN_OR_CREATE", e.OTPsLoginOrCreateEvent = "OTP_LOGIN_OR_CREATE", e.OTPsAuthenticate = "OTP_AUTHENTICATE", e.CryptoWalletAuthenticateStart = "CRYPTO_WALLET_AUTHENTICATE_START", e.CryptoWalletAuthenticate = "CRYPTO_WALLET_AUTHENTICATE", e.PasswordCreate = "PASSWORD_CREATE", e.PasswordAuthenticate = "PASSWORD_AUTHENTICATE", e.PasswordResetByEmailStart = "PASSWORD_RESET_BY_EMAIL_START", e.PasswordResetByEmail = "PASSWORD_RESET_BY_EMAIL", e.PasskeyRegister = "PASSKEY_REGISTER", e.PasskeyAuthenticate = "PASSKEY_AUTHENTICATE", e.PasskeySkip = "PASSKEY_SKIP", e.PasskeyDone = "PASSKEY_DONE", e.B2BMagicLinkEmailLoginOrSignup = "B2B_MAGIC_LINK_EMAIL_LOGIN_OR_SIGNUP", e.B2BMagicLinkAuthenticate = "B2B_MAGIC_LINK_AUTHENTICATE", e.B2BMagicLinkEmailDiscoverySend = "B2B_MAGIC_LINK_EMAIL_DISCOVERY_SEND", e.B2BMagicLinkDiscoveryAuthenticate = "B2B_MAGIC_LINK_DISCOVERY_AUTHENTICATE", e.B2BSSOStart = "B2B_SSO_START", e.B2BSSOAuthenticate = "B2B_SSO_AUTHENTICATE", e.B2BOAuthAuthenticate = "B2B_OAUTH_AUTHENTICATE", e.B2BOAuthDiscoveryAuthenticate = "B2B_OAUTH_DISCOVERY_AUTHENTICATE", e.B2BDiscoveryOrganizationsCreate = "B2B_DISCOVERY_ORGANIZATIONS_CREATE", e.B2BDiscoveryIntermediateSessionExchange = "B2B_DISCOVERY_INTERMEDIATE_SESSION_EXCHANGE", e.B2BPasswordAuthenticate = "B2B_PASSWORD_AUTHENTICATE", e.B2BPasswordResetByEmailStart = "B2B_PASSWORD_RESET_BY_EMAIL_START", e.B2BPasswordResetByEmail = "B2B_PASSWORD_RESET_BY_EMAIL", e.B2BPasswordResetBySession = "B2B_PASSWORD_RESET_BY_SESSION", e.B2BSMSOTPSend = "B2B_SMS_OTP_SEND", e.B2BSMSOTPAuthenticate = "B2B_SMS_OTP_AUTHENTICATE", e.B2BTOTPCreate = "B2B_TOTP_CREATE", e.B2BTOTPAuthenticate = "B2B_TOTP_AUTHENTICATE", e.B2BRecoveryCodesRecover = "B2B_RECOVERY_CODES_RECOVER";
}(_ || (_ = {})), function (e) {
  e[e.emailMagicLinks = 0] = "emailMagicLinks", e[e.oauth = 1] = "oauth", e[e.otp = 2] = "otp", e[e.passwords = 3] = "passwords";
}(v || (v = {}));
var y,
  C,
  b,
  w,
  k = function (e) {
    function t(e, n) {
      var r;
      return o(this, t), (r = i(this, t, [e + "\n" + n])).message = e + "\n" + n, r.name = "SDKAPIUnreachableError", r.details = n, Object.setPrototypeOf(a(r), t.prototype), r;
    }
    return s(t, c(Error)), n(t);
  }(),
  E = function (e) {
    function t(e, n) {
      var r;
      return o(this, t), (r = i(this, t)).name = "StytchSDKUsageError", r.message = "Invalid call to ".concat(e, "\n") + n, r;
    }
    return s(t, c(Error)), n(t);
  }(),
  S = function (e) {
    function t(e) {
      var n, r;
      o(this, t), (n = i(this, t)).name = "StytchSDKSchemaError";
      var a = null === (r = e.body) || void 0 === r ? void 0 : r.map(function (e) {
        return "".concat(e.dataPath, ": ").concat(e.message);
      }).join("\n");
      return n.message = "[400] Request does not match expected schema\n".concat(a), n;
    }
    return s(t, c(Error)), n(t);
  }(),
  x = function (e) {
    function t(e) {
      var n;
      o(this, t), (n = i(this, t)).name = "StytchSDKAPIError";
      var r = e.status_code,
        a = e.error_type,
        s = e.error_message,
        c = e.error_url,
        l = e.request_id;
      return n.error_type = a, n.error_message = s, n.error_url = c, n.request_id = l, n.status_code = r, n.message = "[".concat(r, "] ").concat(a, "\n") + "".concat(s, "\n") + "See ".concat(c, " for more information.\n") + (l ? "request_id: ".concat(l, "\n") : ""), n;
    }
    return s(t, c(Error)), n(t);
  }(),
  O = ["unauthorized_credentials", "user_unauthenticated", "invalid_secret_authentication", "session_not_found"],
  L = function (e) {
    function t(e, n) {
      var r;
      return o(this, t), (r = i(this, t, [n])).name = e, r;
    }
    return s(t, c(Error)), n(t);
  }(),
  A = function (e) {
    function t(e) {
      var n;
      return o(this, t), n = i(this, t, ["StytchAPIUnreachableError", e]), Object.setPrototypeOf(a(n), t.prototype), n;
    }
    return s(t, L), n(t);
  }(),
  T = function (e) {
    function t(e) {
      var n;
      o(this, t);
      var r = null === (n = e.body) || void 0 === n ? void 0 : n.map(function (e) {
        return "".concat(e.dataPath, ": ").concat(e.message);
      }).join("\n");
      return i(this, t, ["StytchAPISchemaError", "Request does not match expected schema\n".concat(r)]);
    }
    return s(t, L), n(t);
  }(),
  P = function (e) {
    function t(e) {
      var n;
      o(this, t);
      var r = e.status_code,
        a = e.error_type,
        s = e.error_message,
        c = e.error_url,
        l = e.request_id;
      return (n = i(this, t, ["StytchAPIError", "[".concat(r, "] ").concat(a, "\n") + "".concat(s, "\n") + "See ".concat(c, " for more information.\n") + (l ? "request_id: ".concat(l, "\n") : "")])).error_type = a, n.error_message = s, n.error_url = c, n.request_id = l, n.status_code = r, n;
    }
    return s(t, L), n(t);
  }(),
  M = function (e) {
    function t(e, n, r) {
      var a;
      return o(this, t), (a = i(this, t, [e, n])).options = r, a;
    }
    return s(t, L), n(t);
  }(),
  R = function (e) {
    function t() {
      return o(this, t), i(this, t, ["NoCurrentSessionError", "There is no session currently available. Make sure the user is authenticated with a valid session."]);
    }
    return s(t, M), n(t);
  }(),
  D = function (e) {
    function t(e) {
      return o(this, t), i(this, t, ["InternalError", e || "An internal error has occurred. Please contact Stytch if this occurs."]);
    }
    return s(t, M), n(t);
  }(),
  F = function (e) {
    function t() {
      return o(this, t), i(this, t, ["NoBiometricsRegistrationError", "There is no biometric registration available. Authenticate with another method and add a new biometric registration first."]);
    }
    return s(t, M), n(t);
  }(),
  j = function (e) {
    function t() {
      return o(this, t), i(this, t, ["BiometricsUnavailableError", "Biometrics is not available on the device."]);
    }
    return s(t, M), n(t);
  }(),
  I = function (e) {
    function t() {
      return o(this, t), i(this, t, ["KeyInvalidatedError", "The biometrics enrollment on the device has changed."]);
    }
    return s(t, M), n(t);
  }(),
  B = function (e) {
    function t() {
      return o(this, t), i(this, t, ["KeystoreUnavailableError", "The Android keystore is unavailable on the device. Consider setting allowFallbackToCleartext to true."]);
    }
    return s(t, M), n(t);
  }(),
  N = function (e) {
    function t() {
      return o(this, t), i(this, t, ["NoBiometricsEnrolledError", "There is no biometric factor enrolled on the device. Add a biometric factor in the device settings."]);
    }
    return s(t, M), n(t);
  }(),
  H = function (e) {
    function t() {
      return o(this, t), i(this, t, ["UserCancellationError", "The user canceled the prompt. Ask the user to try again."]);
    }
    return s(t, M), n(t);
  }(),
  U = function (e) {
    function t() {
      return o(this, t), i(this, t, ["UserLockedOutError", "The user has been locked out due to too many failed attempts. Ask the user to try again later."]);
    }
    return s(t, M), n(t);
  }(),
  $ = function (e) {
    function t() {
      return o(this, t), i(this, t, ["DeviceCredentialsNotAllowedError", "The device credentials allowment is mismatched. Change the allowDeviceCredentials parameter to be the same in both the register and authenticate methods."]);
    }
    return s(t, M), n(t);
  }(),
  V = function (e) {
    function t() {
      return o(this, t), i(this, t, ["MissingGoogleClientIDError", "No Google client ID was found in the project."]);
    }
    return s(t, M), n(t);
  }(),
  Z = function (e) {
    function t() {
      return o(this, t), i(this, t, ["MissingPKCEError", "Make sure this flow is completed on the same device on which it was started."]);
    }
    return s(t, M), n(t);
  }(),
  z = function (e) {
    function t() {
      return o(this, t), i(this, t, ["MissingAuthorizationCredentialIDTokenError", "The authorization credential is missing an ID token."]);
    }
    return s(t, M), n(t);
  }(),
  W = function (e) {
    function t() {
      return o(this, t), i(this, t, ["InvalidAuthorizationCredentialError", "The authorization credential is invalid. Verify that OAuth is set up correctly in the developer console, and call the start flow method."]);
    }
    return s(t, M), n(t);
  }(),
  K = function (e) {
    function t() {
      return o(this, t), i(this, t, ["NoCredentialsPresentError", "The user did not provide credentials for a Google OneTap attempt"]);
    }
    return s(t, M), n(t);
  }(),
  G = function (e) {
    function t() {
      return o(this, t), i(this, t, ["MissingPublicKeyError", "Failed to retrieve the public key. Add a new biometric registration."]);
    }
    return s(t, M), n(t);
  }(),
  q = function (e) {
    function t() {
      return o(this, t), i(this, t, ["ChallengeSigningFailedError", "Failed to sign the challenge with the key."]);
    }
    return s(t, M), n(t);
  }(),
  Y = function (e) {
    function t() {
      return o(this, t), i(this, t, ["SDKNotConfiguredError", "Stytch client is not confiured. You must call the configure method before using the SDK"]);
    }
    return s(t, M), n(t);
  }(),
  J = function (e) {
    function t() {
      return o(this, t), i(this, t, ["FailedCodeChallengeError", "Failed to create a code challenge"]);
    }
    return s(t, M), n(t);
  }(),
  X = function (e) {
    function t() {
      return o(this, t), i(this, t, ["PasskeysUnsupportedError", "Passkeys are not supported on this device"]);
    }
    return s(t, M), n(t);
  }(),
  Q = function (e) {
    function t() {
      return o(this, t), i(this, t, ["FailedToDecryptDataError", "Failed to decrypt user data"]);
    }
    return s(t, M), n(t);
  }(),
  ee = function (e) {
    function t() {
      return o(this, t), i(this, t, ["BiometricsFailedError", "Biometric authentication failed"]);
    }
    return s(t, M), n(t);
  }(),
  te = function (e) {
    function t() {
      return o(this, t), i(this, t, ["InvalidStartUrlError", "The start URL was invalid or improperly formatted."]);
    }
    return s(t, M), n(t);
  }(),
  ne = function (e) {
    function t() {
      return o(this, t), i(this, t, ["InvalidRedirectSchemeError", "The scheme from the given redirect urls was invalid. Possible reasons include: nil scheme, non-custom scheme (using http or https), or differing schemes for login/signup urls."]);
    }
    return s(t, M), n(t);
  }(),
  re = function (e) {
    function t() {
      return o(this, t), i(this, t, ["MissingUrlError", "The underlying web authentication service failed to return a URL."]);
    }
    return s(t, M), n(t);
  }(),
  oe = function (e) {
    function t() {
      return o(this, t), i(this, t, ["InvalidCredentialTypeError", "The public key credential type was not of the expected type."]);
    }
    return s(t, M), n(t);
  }(),
  ie = function (e) {
    function t() {
      return o(this, t), i(this, t, ["MissingAttestationObjectError", "The public key credential is missing the attestation object."]);
    }
    return s(t, M), n(t);
  }(),
  ae = function (e) {
    function t() {
      return o(this, t), i(this, t, ["JSONDataNotConvertibleToStringError", "JSON data unable to be converted to String type."]);
    }
    return s(t, M), n(t);
  }(),
  se = function (e) {
    function t() {
      return o(this, t), i(this, t, ["RandomNumberGenerationFailed", "Random number generation failed"]);
    }
    return s(t, M), n(t);
  }(),
  ce = function (e) {
    function t() {
      return o(this, t), i(this, t, ["PasskeysInvalidEncoding", "Invalid passkey encoding"]);
    }
    return s(t, M), n(t);
  }(),
  le = function (e) {
    function t() {
      return o(this, t), i(this, t, ["PasskeysMisconfigured", "Passkeys are misconfigured. Verify that you have added the correct associated domain for your application, and that the signing information is correct."]);
    }
    return s(t, M), n(t);
  }(),
  ue = function (e) {
    function t() {
      return o(this, t), i(this, t, ["SignInWithAppleMisconfigured", "Sign In With Apple is misconfigured. Verify that you have correctly configured Apple OAuth in the Stytch Dashboard and added the Sign In With Apple capability to your project."]);
    }
    return s(t, M), n(t);
  }();
function de(e) {
  switch (e.message) {
    case "internal_error":
      return new D(e.message);
    case "no_current_session":
      return new R();
    case "no_biometrics_registration":
      return new F();
    case "biometrics_unavailable":
    case "device_hardware_error":
    case "biometrics_not_available":
      return new j();
    case "key_invalidated":
    case "no_biometric_key":
      return new I();
    case "no_biometrics_enrolled":
      return new N();
    case "keystore_unavailable":
      return new B();
    case "device_credentials_not_allowed":
      return new $();
    case "user_cancellation":
      return new H();
    case "user_locked_out":
      return new U();
    case "google_onetap_missing_id_token":
    case "oauth_apple_missing_id_token":
    case "missing_authorization_credential_id_token":
      return new z();
    case "google_onetap_missing_member":
    case "oauth_apple_credential_invalid":
    case "invalid_authorization_credential":
      return new W();
    case "missing_public_key":
      return new G();
    case "challenge_signing_failed":
      return new q();
    case "no_credentials_present":
      return new K();
    case "sdk_not_configured":
      return new Y();
    case "failed_code_challenge":
      return new J();
    case "passkeys_unsupported":
      return new X();
    case "failed_to_decrypt_data":
      return new Q();
    case "biometrics_failed":
      return new ee();
    case "invalid_start_url":
      return new te();
    case "invalid_redirect_scheme":
      return new ne();
    case "missing_url":
      return new re();
    case "invalid_credential_type":
      return new oe();
    case "missing_attestation_object":
      return new ie();
    case "json_data_not_convertible_to_string":
      return new ae();
    case "random_number_generation_failed":
      return new se();
    case "passkeys_invalid_encoding":
      return new ce();
    case "passkeys_misconfigured":
      return new le();
    case "signinwithapple_misconfigured":
      return new ue();
    default:
      return new M(e.name, e.message);
  }
}
function pe(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var r,
        o,
        i,
        a,
        s = [],
        c = !0,
        l = !1;
      try {
        if (i = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          c = !1;
        } else for (; !(c = (r = i.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
      } catch (e) {
        l = !0, o = e;
      } finally {
        try {
          if (!c && null != n["return"] && (a = n["return"](), Object(a) !== a)) return;
        } finally {
          if (l) throw o;
        }
      }
      return s;
    }
  }(e, t) || fe(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function he(e, t) {
  var _n2 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
  if (!_n2) {
    if (Array.isArray(e) || (_n2 = fe(e)) || t && e && "number" == typeof e.length) {
      _n2 && (e = _n2);
      var r = 0,
        o = function o() {};
      return {
        s: o,
        n: function n() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function e(_e2) {
          throw _e2;
        },
        f: o
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var i,
    a = !0,
    s = !1;
  return {
    s: function s() {
      _n2 = _n2.call(e);
    },
    n: function n() {
      var e = _n2.next();
      return a = e.done, e;
    },
    e: function e(_e3) {
      s = !0, i = _e3;
    },
    f: function f() {
      try {
        a || null == _n2["return"] || _n2["return"]();
      } finally {
        if (s) throw i;
      }
    }
  };
}
function fe(e, t) {
  if (e) {
    if ("string" == typeof e) return me(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? me(e, t) : void 0;
  }
}
function me(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function ge(e) {
  return ge = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
    return _typeof(e);
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
  }, ge(e);
}
function _e() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _e = function _e() {
    return t;
  };
  var e,
    t = {},
    n = Object.prototype,
    r = n.hasOwnProperty,
    o = Object.defineProperty || function (e, t, n) {
      e[t] = n.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    s = i.asyncIterator || "@@asyncIterator",
    c = i.toStringTag || "@@toStringTag";
  function l(e, t, n) {
    return Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), e[t];
  }
  try {
    l({}, "");
  } catch (e) {
    l = function l(e, t, n) {
      return e[t] = n;
    };
  }
  function u(e, t, n, r) {
    var i = t && t.prototype instanceof _ ? t : _,
      a = Object.create(i.prototype),
      s = new T(r || []);
    return o(a, "_invoke", {
      value: x(e, n, s)
    }), a;
  }
  function d(e, t, n) {
    try {
      return {
        type: "normal",
        arg: e.call(t, n)
      };
    } catch (e) {
      return {
        type: "throw",
        arg: e
      };
    }
  }
  t.wrap = u;
  var p = "suspendedStart",
    h = "suspendedYield",
    f = "executing",
    m = "completed",
    g = {};
  function _() {}
  function v() {}
  function y() {}
  var C = {};
  l(C, a, function () {
    return this;
  });
  var b = Object.getPrototypeOf,
    w = b && b(b(P([])));
  w && w !== n && r.call(w, a) && (C = w);
  var k = y.prototype = _.prototype = Object.create(C);
  function E(e) {
    ["next", "throw", "return"].forEach(function (t) {
      l(e, t, function (e) {
        return this._invoke(t, e);
      });
    });
  }
  function S(e, t) {
    function n(o, i, a, s) {
      var c = d(e[o], e, i);
      if ("throw" !== c.type) {
        var l = c.arg,
          u = l.value;
        return u && "object" == ge(u) && r.call(u, "__await") ? t.resolve(u.__await).then(function (e) {
          n("next", e, a, s);
        }, function (e) {
          n("throw", e, a, s);
        }) : t.resolve(u).then(function (e) {
          l.value = e, a(l);
        }, function (e) {
          return n("throw", e, a, s);
        });
      }
      s(c.arg);
    }
    var i;
    o(this, "_invoke", {
      value: function value(e, r) {
        function o() {
          return new t(function (t, o) {
            n(e, r, t, o);
          });
        }
        return i = i ? i.then(o, o) : o();
      }
    });
  }
  function x(t, n, r) {
    var o = p;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === m) {
        if ("throw" === i) throw a;
        return {
          value: e,
          done: !0
        };
      }
      for (r.method = i, r.arg = a;;) {
        var s = r.delegate;
        if (s) {
          var c = O(s, r);
          if (c) {
            if (c === g) continue;
            return c;
          }
        }
        if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
          if (o === p) throw o = m, r.arg;
          r.dispatchException(r.arg);
        } else "return" === r.method && r.abrupt("return", r.arg);
        o = f;
        var l = d(t, n, r);
        if ("normal" === l.type) {
          if (o = r.done ? m : h, l.arg === g) continue;
          return {
            value: l.arg,
            done: r.done
          };
        }
        "throw" === l.type && (o = m, r.method = "throw", r.arg = l.arg);
      }
    };
  }
  function O(t, n) {
    var r = n.method,
      o = t.iterator[r];
    if (o === e) return n.delegate = null, "throw" === r && t.iterator["return"] && (n.method = "return", n.arg = e, O(t, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = new TypeError("The iterator does not provide a '" + r + "' method")), g;
    var i = d(o, t.iterator, n.arg);
    if ("throw" === i.type) return n.method = "throw", n.arg = i.arg, n.delegate = null, g;
    var a = i.arg;
    return a ? a.done ? (n[t.resultName] = a.value, n.next = t.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, g) : a : (n.method = "throw", n.arg = new TypeError("iterator result is not an object"), n.delegate = null, g);
  }
  function L(e) {
    var t = {
      tryLoc: e[0]
    };
    1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
  }
  function A(e) {
    var t = e.completion || {};
    t.type = "normal", delete t.arg, e.completion = t;
  }
  function T(e) {
    this.tryEntries = [{
      tryLoc: "root"
    }], e.forEach(L, this), this.reset(!0);
  }
  function P(t) {
    if (t || "" === t) {
      var n = t[a];
      if (n) return n.call(t);
      if ("function" == typeof t.next) return t;
      if (!isNaN(t.length)) {
        var o = -1,
          i = function n() {
            for (; ++o < t.length;) if (r.call(t, o)) return n.value = t[o], n.done = !1, n;
            return n.value = e, n.done = !0, n;
          };
        return i.next = i;
      }
    }
    throw new TypeError(ge(t) + " is not iterable");
  }
  return v.prototype = y, o(k, "constructor", {
    value: y,
    configurable: !0
  }), o(y, "constructor", {
    value: v,
    configurable: !0
  }), v.displayName = l(y, c, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
    var t = "function" == typeof e && e.constructor;
    return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
  }, t.mark = function (e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, l(e, c, "GeneratorFunction")), e.prototype = Object.create(k), e;
  }, t.awrap = function (e) {
    return {
      __await: e
    };
  }, E(S.prototype), l(S.prototype, s, function () {
    return this;
  }), t.AsyncIterator = S, t.async = function (e, n, r, o, i) {
    void 0 === i && (i = Promise);
    var a = new S(u(e, n, r, o), i);
    return t.isGeneratorFunction(n) ? a : a.next().then(function (e) {
      return e.done ? e.value : a.next();
    });
  }, E(k), l(k, c, "Generator"), l(k, a, function () {
    return this;
  }), l(k, "toString", function () {
    return "[object Generator]";
  }), t.keys = function (e) {
    var t = Object(e),
      n = [];
    for (var r in t) n.push(r);
    return n.reverse(), function e() {
      for (; n.length;) {
        var r = n.pop();
        if (r in t) return e.value = r, e.done = !1, e;
      }
      return e.done = !0, e;
    };
  }, t.values = P, T.prototype = {
    constructor: T,
    reset: function reset(t) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(A), !t) for (var n in this) "t" === n.charAt(0) && r.call(this, n) && !isNaN(+n.slice(1)) && (this[n] = e);
    },
    stop: function stop() {
      this.done = !0;
      var e = this.tryEntries[0].completion;
      if ("throw" === e.type) throw e.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(t) {
      if (this.done) throw t;
      var n = this;
      function o(r, o) {
        return s.type = "throw", s.arg = t, n.next = r, o && (n.method = "next", n.arg = e), !!o;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var a = this.tryEntries[i],
          s = a.completion;
        if ("root" === a.tryLoc) return o("end");
        if (a.tryLoc <= this.prev) {
          var c = r.call(a, "catchLoc"),
            l = r.call(a, "finallyLoc");
          if (c && l) {
            if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
            if (this.prev < a.finallyLoc) return o(a.finallyLoc);
          } else if (c) {
            if (this.prev < a.catchLoc) return o(a.catchLoc, !0);
          } else {
            if (!l) throw new Error("try statement without catch or finally");
            if (this.prev < a.finallyLoc) return o(a.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(e, t) {
      for (var n = this.tryEntries.length - 1; n >= 0; --n) {
        var o = this.tryEntries[n];
        if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, g) : this.complete(a);
    },
    complete: function complete(e, t) {
      if ("throw" === e.type) throw e.arg;
      return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), g;
    },
    finish: function finish(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), A(n), g;
      }
    },
    "catch": function _catch(e) {
      for (var t = this.tryEntries.length - 1; t >= 0; --t) {
        var n = this.tryEntries[t];
        if (n.tryLoc === e) {
          var r = n.completion;
          if ("throw" === r.type) {
            var o = r.arg;
            A(n);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(t, n, r) {
      return this.delegate = {
        iterator: P(t),
        resultName: n,
        nextLoc: r
      }, "next" === this.method && (this.arg = e), g;
    }
  }, t;
}
function ve(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Ce(r.key), r);
  }
}
function ye(e, t, n) {
  return t && ve(e.prototype, t), n && ve(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ce(e) {
  var t = function (e, t) {
    if ("object" != ge(e) || !e) return e;
    var n = e[Symbol.toPrimitive];
    if (void 0 !== n) {
      var r = n.call(e, t || "default");
      if ("object" != ge(r)) return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" == ge(t) ? t : String(t);
}
function be(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function we(e, t, n) {
  return t = xe(t), function (e, t) {
    if (t && ("object" === ge(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e);
  }(e, Ee() ? Reflect.construct(t, n || [], xe(e).constructor) : t.apply(e, n));
}
function ke(e) {
  var t = "function" == typeof Map ? new Map() : void 0;
  return ke = function ke(e) {
    if (null === e || !function (e) {
      try {
        return -1 !== Function.toString.call(e).indexOf("[native code]");
      } catch (t) {
        return "function" == typeof e;
      }
    }(e)) return e;
    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== t) {
      if (t.has(e)) return t.get(e);
      t.set(e, n);
    }
    function n() {
      return function (e, t, n) {
        if (Ee()) return Reflect.construct.apply(null, arguments);
        var r = [null];
        r.push.apply(r, t);
        var o = new (e.bind.apply(e, r))();
        return n && Se(o, n.prototype), o;
      }(e, arguments, xe(this).constructor);
    }
    return n.prototype = Object.create(e.prototype, {
      constructor: {
        value: n,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Se(n, e);
  }, ke(e);
}
function Ee() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (e) {}
  return (Ee = function Ee() {
    return !!e;
  })();
}
function Se(e, t) {
  return Se = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  }, Se(e, t);
}
function xe(e) {
  return xe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, xe(e);
}
!function (e) {
  e.emailMagicLinks = "emailMagicLinks", e.sso = "sso", e.passwords = "passwords", e.oauth = "oauth";
}(y || (y = {})), function (e) {
  e.Discovery = "Discovery", e.Organization = "Organization", e.PasswordReset = "PasswordReset";
}(C || (C = {})), function (e) {
  e.smsOtp = "smsOtp", e.totp = "totp";
}(b || (b = {})), function (e) {
  e.Google = "google", e.Microsoft = "microsoft";
}(w || (w = {}));
var Oe,
  Le = "https://accounts.google.com/gsi",
  Ae = "".concat(Le, "/client"),
  Te = 30;
function Pe(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  }
  return n;
}
function Me(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        c(r.next(e));
      } catch (e) {
        i(e);
      }
    }
    function s(e) {
      try {
        c(r["throw"](e));
      } catch (e) {
        i(e);
      }
    }
    function c(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(a, s);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError, function (e) {
  e.RequiredCatcha = "Catcha Required";
}(Oe || (Oe = {}));
var Re,
  De = function (e) {
    function t(e) {
      var n;
      return be(this, t), (n = we(this, t, [e])).type = e, n;
    }
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(e, "prototype", {
        writable: !1
      }), t && Se(e, t);
    }(t, ke(Error)), ye(t);
  }();
function Fe(e) {
  var t,
    n = e.method,
    r = e.finalURL,
    o = e.basicAuthHeader,
    i = e.xSDKClientHeader,
    a = e.xSDKParentHostHeader,
    s = e.body;
  return Me(this, void 0, void 0, _e().mark(function e() {
    var c, l, u, d, p, h;
    return _e().wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return c = {
            Authorization: o,
            "Content-Type": "application/json",
            "X-SDK-Client": i
          }, a && (c["X-SDK-Parent-Host"] = a), l = {
            method: n,
            headers: c,
            body: s && JSON.stringify(s)
          }, e.prev = 3, e.next = 6, fetch(r, l);
        case 6:
          u = e.sent, e.next = 14;
          break;
        case 9:
          if (e.prev = 9, e.t0 = e["catch"](3), "Failed to fetch" !== e.t0.message) {
            e.next = 13;
            break;
          }
          throw new A("Unable to contact the Stytch servers. Are you online?");
        case 13:
          throw e.t0;
        case 14:
          if (!(u.status <= 299)) {
            e.next = 25;
            break;
          }
          return e.prev = 15, e.next = 18, u.json();
        case 18:
          return d = e.sent, e.abrupt("return", d.data);
        case 22:
          throw e.prev = 22, e.t1 = e["catch"](15), new A("Invalid JSON response from the Stytch servers.");
        case 25:
          if (200 === u.status || !(null === (t = u.headers.get("content-type")) || void 0 === t ? void 0 : t.includes("application/json"))) {
            e.next = 38;
            break;
          }
          return e.prev = 26, e.next = 29, u.json();
        case 29:
          p = e.sent, e.next = 35;
          break;
        case 32:
          throw e.prev = 32, e.t2 = e["catch"](26), new A("Invalid or no response from server");
        case 35:
          if (!("body" in p || "params" in p || "query" in p)) {
            e.next = 37;
            break;
          }
          throw new T(p);
        case 37:
          throw new P(p);
        case 38:
          return e.prev = 38, e.next = 41, u.text();
        case 41:
          h = e.sent, e.next = 47;
          break;
        case 44:
          throw e.prev = 44, e.t3 = e["catch"](38), new A("Invalid response from the Stytch servers.");
        case 47:
          if (!h.includes("Captcha required")) {
            e.next = 49;
            break;
          }
          throw new De(Oe.RequiredCatcha);
        case 49:
          throw new A("Invalid response from the Stytch servers.");
        case 50:
        case "end":
          return e.stop();
      }
    }, e, null, [[3, 9], [15, 22], [26, 32], [38, 44]]);
  }));
}
var je = new Uint8Array(16);
function Ie() {
  if (!Re && !(Re = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Re(je);
}
var Be = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
for (var Ne = [], He = 0; He < 256; ++He) Ne.push((He + 256).toString(16).substr(1));
function Ue(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    n = (Ne[e[t + 0]] + Ne[e[t + 1]] + Ne[e[t + 2]] + Ne[e[t + 3]] + "-" + Ne[e[t + 4]] + Ne[e[t + 5]] + "-" + Ne[e[t + 6]] + Ne[e[t + 7]] + "-" + Ne[e[t + 8]] + Ne[e[t + 9]] + "-" + Ne[e[t + 10]] + Ne[e[t + 11]] + Ne[e[t + 12]] + Ne[e[t + 13]] + Ne[e[t + 14]] + Ne[e[t + 15]]).toLowerCase();
  if (!function (e) {
    return "string" == typeof e && Be.test(e);
  }(n)) throw TypeError("Stringified UUID is invalid");
  return n;
}
function $e(e, t, n) {
  var r = (e = e || {}).random || (e.rng || Ie)();
  if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
    n = n || 0;
    for (var o = 0; o < 16; ++o) t[n + o] = r[o];
    return t;
  }
  return Ue(r);
}
var Ve = {};
function Ze(e, t) {
  return Me(this, void 0, void 0, _e().mark(function n() {
    return _e().wrap(function (n) {
      for (;;) switch (n.prev = n.next) {
        case 0:
          if (void 0 === Ve[e]) {
            n.next = 2;
            break;
          }
          return n.abrupt("return", Ve[e]);
        case 2:
          return Ve[e] = ze(e, t), n.abrupt("return", Ve[e]);
        case 4:
        case "end":
          return n.stop();
      }
    }, n);
  }));
}
function ze(e, t) {
  return new Promise(function (n, r) {
    var o = function (e) {
      var t = We(e);
      if (t[0]) return t[0];
    }(e);
    if (o && "true" === o.dataset.loaded) try {
      n(t());
    } catch (t) {
      return r(new Error("".concat(e, " already loaded, but module was not found in global scope: ").concat(t)));
    }
    var i = function (e) {
      var t = document.createElement("script");
      return t.setAttribute("src", e), t.setAttribute("async", "true"), t.setAttribute("defer", "true"), document.head.appendChild(t), t;
    }(e);
    i.addEventListener("load", function () {
      i.dataset.loaded = "true";
      try {
        n(t());
      } catch (t) {
        r(new Error("".concat(e, " was loaded, but module was not found in global scope: ").concat(t)));
      }
    }), i.addEventListener("error", function (t) {
      r(new Error("".concat(e, " could not be loaded: ").concat(t)));
    });
  });
}
var We = function We(e) {
  return document.querySelectorAll('script[src="'.concat(e, '"]'));
};
var Ke,
  Ge = ["[Stytch]"],
  qe = function qe() {
    for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
    return (e = console).warn.apply(e, Ge.concat(n));
  },
  Ye = function Ye() {
    for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
    return (e = console).error.apply(e, Ge.concat(n));
  },
  Je = "\nYou can find your public token at https://stytch.com/dashboard/api-keys.",
  Xe = function Xe(e) {
    var t = "StytchUIClient" === e ? "import { createStytchUIClient } from '@stytch/nextjs/ui';\n    \nconst stytch = createStytchUIClient('public-token-...');\n" : "import { createStytchHeadlessClient } from '@stytch/nextjs/ui';\n    \nconst stytch = createStytchHeadlessClient('public-token-...');\n";
    if ("undefined" == typeof window) throw new Error("The ".concat(e, " is not compatible with server-side environments.\nIf using nextjs, use the create").concat(e, " method instead.\n```\n").concat(t, "\n```\n"));
  },
  Qe = {
    US: "1",
    AX: "358",
    AS: "1684",
    AG: "1268",
    AI: "1264",
    AR: "54",
    AT: "43",
    AU: "61",
    BE: "32",
    BJ: "229",
    BO: "591",
    BR: "55",
    IO: "246",
    BN: "673",
    BG: "359",
    BF: "226",
    CM: "237",
    CA: "1",
    BQ: "599",
    CF: "236",
    CL: "56",
    CX: "61",
    CC: "61",
    CO: "57",
    CD: "243",
    CK: "682",
    CR: "506",
    HR: "385",
    CZ: "420",
    DK: "45",
    DO: "1829",
    EC: "593",
    SV: "503",
    EE: "372",
    SZ: "268",
    FK: "500",
    FI: "358",
    FR: "33",
    GF: "594",
    DE: "49",
    GH: "233",
    GR: "30",
    GD: "1473",
    GT: "502",
    GG: "44",
    GW: "245",
    GY: "592",
    HU: "36",
    IS: "354",
    IN: "91",
    IE: "353",
    IM: "44",
    IT: "39",
    JM: "1876",
    JP: "81",
    KZ: "7",
    KE: "254",
    KI: "686",
    KR: "82",
    LV: "371",
    LT: "370",
    LU: "352",
    MO: "853",
    MT: "356",
    MH: "692",
    MR: "222",
    MU: "230",
    YT: "262",
    MX: "52",
    MC: "377",
    ME: "382",
    NR: "674",
    NL: "31",
    NZ: "64",
    NI: "505",
    NF: "672",
    NO: "47",
    PA: "507",
    PY: "595",
    PE: "51",
    PN: "870",
    PL: "48",
    PT: "351",
    PR: "1",
    RO: "40",
    BL: "590",
    SH: "290",
    KN: "1869",
    LC: "1758",
    MF: "590",
    PM: "508",
    SM: "378",
    ST: "239",
    SC: "248",
    SX: "599",
    SK: "421",
    SI: "386",
    ZA: "27",
    SS: "211",
    ES: "34",
    SR: "597",
    SJ: "47",
    SE: "46",
    CH: "41",
    TW: "886",
    TZ: "255",
    TK: "690",
    TO: "676",
    TT: "1868",
    TR: "90",
    UA: "380",
    GB: "44",
    UM: "1",
    UY: "598",
    VA: "379",
    EH: "212"
  },
  et = function et(e) {
    return e.includes("public-token-test");
  },
  tt = function tt(e) {
    var t = {
      isObject: function isObject(n, r) {
        var o = "object" === ge(r) && !Array.isArray(r) && null !== r;
        if (!o) throw new E(e, n + " must be an object.");
        return t;
      },
      isOptionalObject: function isOptionalObject(e, n) {
        return void 0 === n ? t : t.isObject(e, n);
      },
      isString: function isString(n, r) {
        if ("string" != typeof r) throw new E(e, n + " must be a string.");
        return t;
      },
      isOptionalString: function isOptionalString(e, n) {
        return void 0 === n ? t : t.isString(e, n);
      },
      isStringArray: function isStringArray(n, r) {
        if (!Array.isArray(r)) throw new E(e, n + " must be an array of strings.");
        var o,
          i = he(r);
        try {
          for (i.s(); !(o = i.n()).done;) {
            if ("string" != typeof o.value) throw new E(e, n + " must be an array of strings.");
          }
        } catch (e) {
          i.e(e);
        } finally {
          i.f();
        }
        return t;
      },
      isOptionalStringArray: function isOptionalStringArray(e, n) {
        return void 0 === n ? t : t.isStringArray(e, n);
      },
      isNumber: function isNumber(n, r) {
        if ("number" != typeof r) throw new E(e, n + " must be a number.");
        return t;
      },
      isOptionalNumber: function isOptionalNumber(e, n) {
        return void 0 === n ? t : t.isNumber(e, n);
      },
      isBoolean: function isBoolean(n, r) {
        if ("boolean" != typeof r) throw new E(e, n + " must be a boolean.");
        return t;
      },
      isOptionalBoolean: function isOptionalBoolean(e, n) {
        return void 0 === n ? t : t.isBoolean(e, n);
      }
    };
    return t;
  },
  nt = function nt(e) {
    return Pe(e, ["request_id", "status_code"]);
  },
  rt = function rt(e) {
    return Pe(e, ["__user"]);
  },
  ot = ye(function e(t, n, r) {
    var o = this,
      i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : function () {
        return Promise.resolve(void 0);
      };
    be(this, e), this.bootstrapPromise = r, this.isEnabled = function () {
      return Me(o, void 0, void 0, _e().mark(function e() {
        return _e().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.abrupt("return", this.state.then(function (e) {
                return e.enabled;
              }));
            case 1:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getTelemetryID = function () {
      return Me(o, void 0, void 0, _e().mark(function e() {
        var t, n, r, o;
        return _e().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.state;
            case 2:
              if (t = e.sent, n = t.publicToken, r = t.enabled, o = t.dfpBackendURL, r) {
                e.next = 8;
                break;
              }
              return e.abrupt("return", void 0);
            case 8:
              return e.next = 10, window.GetTelemetryID(n, "".concat(o, "/submit"));
            case 10:
              return e.abrupt("return", e.sent);
            case 11:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getDFPTelemetryIDAndCaptcha = function () {
      return Me(o, void 0, void 0, _e().mark(function e() {
        var t, n, r, o, i, a;
        return _e().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.state;
            case 2:
              if (t = e.sent, n = t.enabled, r = t.executeRecaptcha, o = t.mode, i = void 0, a = void 0, n) {
                e.next = 12;
                break;
              }
              return e.next = 11, r();
            case 11:
              a = e.sent;
            case 12:
              if ("DECISIONING" !== o) {
                e.next = 18;
                break;
              }
              return e.next = 15, this.getTelemetryID();
            case 15:
              i = e.sent, e.next = 25;
              break;
            case 18:
              if ("OBSERVATION" !== o) {
                e.next = 25;
                break;
              }
              return e.next = 21, this.getTelemetryID();
            case 21:
              return i = e.sent, e.next = 24, r();
            case 24:
              a = e.sent;
            case 25:
              return e.abrupt("return", {
                dfp_telemetry_id: i,
                captcha_token: a
              });
            case 26:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.retryWithCaptchaAndDFP = function (e, t) {
      return Me(o, void 0, void 0, _e().mark(function n() {
        var r, o, i;
        return _e().wrap(function (n) {
          for (;;) switch (n.prev = n.next) {
            case 0:
              return n.next = 2, this.state;
            case 2:
              if (r = n.sent, o = r.enabled, i = r.executeRecaptcha, e.type !== Oe.RequiredCatcha || !o) {
                n.next = 14;
                break;
              }
              if (!t.body) {
                n.next = 13;
                break;
              }
              return n.next = 9, this.getTelemetryID();
            case 9:
              return t.body.dfp_telemetry_id = n.sent, n.next = 12, i();
            case 12:
              t.body.captcha_token = n.sent;
            case 13:
              return n.abrupt("return", t);
            case 14:
              throw new Error("Unable to query captcha and/or dfp telemetry ID");
            case 15:
            case "end":
              return n.stop();
          }
        }, n, this);
      }));
    }, this.state = r.then(function (e) {
      return Me(o, void 0, void 0, _e().mark(function r() {
        return _e().wrap(function (r) {
          for (;;) switch (r.prev = r.next) {
            case 0:
              if (e.runDFPProtectedAuth) {
                r.next = 2;
                break;
              }
              return r.abrupt("return", {
                publicToken: t,
                dfpBackendURL: n,
                enabled: !1,
                loaded: !1,
                executeRecaptcha: i
              });
            case 2:
              return r.next = 4, Ze("".concat("https://elements.stytch.com", "/telemetry.js"), function () {
                return window.GetTelemetryID;
              });
            case 4:
              return r.abrupt("return", {
                publicToken: t,
                dfpBackendURL: n,
                enabled: !0,
                mode: e.dfpProtectedAuthMode || "OBSERVATION",
                loaded: !0,
                executeRecaptcha: i
              });
            case 5:
            case "end":
              return r.stop();
          }
        }, r);
      }));
    });
  }),
  it = function it() {
    return {
      isEnabled: function isEnabled() {
        return Me(void 0, void 0, void 0, _e().mark(function e() {
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", !1);
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      getTelemetryID: function getTelemetryID() {
        return Me(void 0, void 0, void 0, _e().mark(function e() {
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", void 0);
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      getDFPTelemetryIDAndCaptcha: function getDFPTelemetryIDAndCaptcha() {
        return Me(void 0, void 0, void 0, _e().mark(function e() {
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", {
                  dfp_telemetry_id: void 0,
                  captcha_token: void 0
                });
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      },
      retryWithCaptchaAndDFP: function retryWithCaptchaAndDFP() {
        return Me(void 0, void 0, void 0, _e().mark(function e() {
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                throw new Error("DFP protected auth is disabled");
              case 1:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      }
    };
  },
  at = function () {
    function e() {
      be(this, e);
    }
    return ye(e, null, [{
      key: "marshall",
      value: function value(e) {
        return Object.assign(Object.assign({}, e), {
          name: e.name,
          message: e.message,
          stack: e.stack
        });
      }
    }, {
      key: "inflate",
      value: function value(e, t) {
        var n = new e(t);
        return Object.assign(n, t), Object.setPrototypeOf(n, e.prototype), n;
      }
    }, {
      key: "unmarshall",
      value: function value(t) {
        if ("name" in t) switch (t.name) {
          case "SDKAPIUnreachableError":
            return e.inflate(k, t);
          case "StytchSDKSchemaError":
            return e.inflate(S, t);
          case "StytchAPIUnreachableError":
            return e.inflate(A, t);
          case "StytchAPISchemaError":
            return e.inflate(T, t);
          case "StytchSDKAPIError":
            return e.inflate(x, t);
          case "StytchAPIError":
            return e.inflate(P, t);
          case "TypeError":
            return e.inflate(TypeError, t);
          case "SyntaxError":
            return e.inflate(SyntaxError, t);
          case "ReferenceError":
            return e.inflate(ReferenceError, t);
          case "RangeError":
            return e.inflate(RangeError, t);
          case "EvalError":
            return e.inflate(EvalError, t);
          case "URIError":
            return e.inflate(URIError, t);
        }
        return e.inflate(Error, t);
      }
    }]), e;
  }(),
  st = function () {
    function e(t) {
      be(this, e), this.maxBatchSize = t.maxBatchSize, this.logEventURL = t.logEventURL, setInterval(this.flush.bind(this), t.intervalDurationMs), this.batch = [];
    }
    return ye(e, [{
      key: "logEvent",
      value: function value(e, t) {
        this.batch.push({
          telemetry: e,
          event: t
        }), this.batch.length >= this.maxBatchSize && this.flush();
      }
    }, {
      key: "flush",
      value: function value() {
        return Me(this, void 0, void 0, _e().mark(function e() {
          var t;
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (this.batch.length) {
                  e.next = 2;
                  break;
                }
                return e.abrupt("return");
              case 2:
                return t = this.batch, this.batch = [], e.prev = 4, e.next = 7, fetch(this.logEventURL, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(t)
                });
              case 7:
                e.next = 11;
                break;
              case 9:
                e.prev = 9, e.t0 = e["catch"](4);
              case 11:
              case "end":
                return e.stop();
            }
          }, e, this, [[4, 9]]);
        }));
      }
    }]), e;
  }();
!function (e) {
  e.LoginOrCreateEML = "login_or_create_eml", e.LoginOrCreateOTP = "login_or_create_otp", e.ResetPassword = "reset_password";
}(Ke || (Ke = {}));
var ct = ye(function e(t, n) {
    var r = this;
    be(this, e), this._networkClient = t, this._subscriptionService = n, this.get = function () {
      return Me(r, void 0, void 0, _e().mark(function e() {
        var t, n;
        return _e().wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this._networkClient.fetchSDK({
                url: "/users/me",
                errorMessage: "Failed to retrieve user info.",
                method: "GET"
              });
            case 2:
              return t = e.sent, n = nt(t), this._subscriptionService.updateUser(n), e.abrupt("return", n);
            case 6:
            case "end":
              return e.stop();
          }
        }, e, this);
      }));
    }, this.getSync = function () {
      return r._subscriptionService.getUser();
    }, this.getInfo = function () {
      return {
        user: r.getSync(),
        fromCache: r._subscriptionService.getFromCache()
      };
    }, this.update = function (e) {
      return Me(r, void 0, void 0, _e().mark(function t() {
        var n, r;
        return _e().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return tt("stytch.user.update").isOptionalObject("untrusted_metadata", e.untrusted_metadata), t.next = 3, this._networkClient.fetchSDK({
                url: "/users/me",
                body: e,
                errorMessage: "Failed to update user.",
                method: "PUT"
              });
            case 3:
              return n = t.sent, r = nt(n.__user), this._subscriptionService.updateUser(r), t.abrupt("return", rt(n));
            case 7:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteEmail = function (e) {
      return Me(r, void 0, void 0, _e().mark(function t() {
        var n, r;
        return _e().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/emails/".concat(e),
                errorMessage: "Failed to delete email.",
                method: "DELETE"
              });
            case 2:
              return n = t.sent, r = nt(n.__user), this._subscriptionService.updateUser(r), t.abrupt("return", rt(n));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deletePhoneNumber = function (e) {
      return Me(r, void 0, void 0, _e().mark(function t() {
        var n, r;
        return _e().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/phone_numbers/".concat(e),
                errorMessage: "Failed to delete phone number.",
                method: "DELETE"
              });
            case 2:
              return n = t.sent, r = nt(n.__user), this._subscriptionService.updateUser(r), t.abrupt("return", rt(n));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteTOTP = function (e) {
      return Me(r, void 0, void 0, _e().mark(function t() {
        var n, r;
        return _e().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/totps/".concat(e),
                errorMessage: "Failed to delete TOTP.",
                method: "DELETE"
              });
            case 2:
              return n = t.sent, r = nt(n.__user), this._subscriptionService.updateUser(r), t.abrupt("return", rt(n));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteOAuthRegistration = function (e) {
      return Me(r, void 0, void 0, _e().mark(function t() {
        var n, r;
        return _e().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/oauth/".concat(e),
                errorMessage: "Failed to delete OAuth registration.",
                method: "DELETE"
              });
            case 2:
              return n = t.sent, r = nt(n.__user), this._subscriptionService.updateUser(r), t.abrupt("return", rt(n));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteWebauthnRegistration = function (e) {
      return Me(r, void 0, void 0, _e().mark(function t() {
        var n, r;
        return _e().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/webauthn_registrations/".concat(e),
                errorMessage: "Failed to delete WebAuthn registration.",
                method: "DELETE"
              });
            case 2:
              return n = t.sent, r = nt(n.__user), this._subscriptionService.updateUser(r), t.abrupt("return", rt(n));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.deleteBiometricRegistration = function (e) {
      return Me(r, void 0, void 0, _e().mark(function t() {
        var n, r;
        return _e().wrap(function (t) {
          for (;;) switch (t.prev = t.next) {
            case 0:
              return t.next = 2, this._networkClient.fetchSDK({
                url: "/users/biometric_registrations/".concat(e),
                errorMessage: "Failed to delete Biometric registration.",
                method: "DELETE"
              });
            case 2:
              return n = t.sent, r = nt(n.__user), this._subscriptionService.updateUser(r), t.abrupt("return", rt(n));
            case 6:
            case "end":
              return t.stop();
          }
        }, t, this);
      }));
    }, this.onChange = function (e) {
      var t = r._subscriptionService.getUser();
      return r._subscriptionService.subscribeToState(function (n) {
        var r;
        (null == n ? void 0 : n.user) !== t && (t = null !== (r = null == n ? void 0 : n.user) && void 0 !== r ? r : null, e(t));
      });
    };
  }),
  lt = function () {
    function e(t, n) {
      var r = this;
      be(this, e), this._networkClient = t, this._subscriptionService = n, this.getSync = function () {
        return r._subscriptionService.getSession();
      }, this.getInfo = function () {
        return {
          session: r.getSync(),
          fromCache: r._subscriptionService.getFromCache()
        };
      }, this.onChange = function (e) {
        var t = r._subscriptionService.getSession();
        return r._subscriptionService.subscribeToState(function (n) {
          var r;
          (null == n ? void 0 : n.session) !== t && (t = null !== (r = null == n ? void 0 : n.session) && void 0 !== r ? r : null, e(t));
        });
      }, this.revoke = function (e) {
        return Me(r, void 0, void 0, _e().mark(function t() {
          var n;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return t.prev = 0, t.next = 3, this._networkClient.fetchSDK({
                  url: "/sessions/revoke",
                  errorMessage: "Error revoking session",
                  method: "POST"
                });
              case 3:
                return n = t.sent, this._subscriptionService.destroyState(), t.abrupt("return", n);
              case 8:
                throw t.prev = 8, t.t0 = t["catch"](0), ((null == e ? void 0 : e.forceClear) || O.includes(t.t0.error_type)) && this._subscriptionService.destroyState(), t.t0;
              case 12:
              case "end":
                return t.stop();
            }
          }, t, this, [[0, 8]]);
        }));
      }, this.authenticate = function (e) {
        return Me(r, void 0, void 0, _e().mark(function t() {
          var n,
            r,
            o,
            i,
            a = this;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return n = this._subscriptionService.getSession(), r = function r() {
                  var e;
                  return (null == n ? void 0 : n.session_id) !== (null === (e = a._subscriptionService.getSession()) || void 0 === e ? void 0 : e.session_id);
                }, t.prev = 2, o = {
                  session_duration_minutes: null == e ? void 0 : e.session_duration_minutes
                }, t.next = 6, this._networkClient.fetchSDK({
                  url: "/sessions/authenticate",
                  body: o,
                  errorMessage: "Error authenticating session",
                  method: "POST"
                });
              case 6:
                if (i = t.sent, !r()) {
                  t.next = 9;
                  break;
                }
                return t.abrupt("return", this.authenticate(e));
              case 9:
                return this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: i.user
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", rt(i));
              case 13:
                if (t.prev = 13, t.t0 = t["catch"](2), !r()) {
                  t.next = 17;
                  break;
                }
                return t.abrupt("return", this.authenticate(e));
              case 17:
                throw O.includes(t.t0.error_type) && this._subscriptionService.destroySession(), t.t0;
              case 19:
              case "end":
                return t.stop();
            }
          }, t, this, [[2, 13]]);
        }));
      };
    }
    return ye(e, [{
      key: "getTokens",
      value: function value() {
        return this._subscriptionService.getTokens();
      }
    }, {
      key: "updateSession",
      value: function value(e) {
        var t;
        tt("stytch.session.updateSession").isString("session_token", e.session_token).isOptionalString("session_jwt", null !== (t = e.session_jwt) && void 0 !== t ? t : void 0), this._subscriptionService.updateTokens(e);
      }
    }]), e;
  }(),
  ut = Promise.resolve({
    pkceRequiredForEmailMagicLinks: !1
  }),
  dt = function () {
    function e(t, n, r, o) {
      var i = this,
        a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : ut,
        s = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : it();
      be(this, e), this._networkClient = t, this._subscriptionService = n, this._pkceManager = r, this._passwordResetPKCEManager = o, this._config = a, this.dfpProtectedAuth = s, this.email = {
        loginOrCreate: function loginOrCreate(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return Me(i, void 0, void 0, _e().mark(function n() {
            var r, o, i, a, s, c, l;
            return _e().wrap(function (n) {
              for (;;) switch (n.prev = n.next) {
                case 0:
                  return n.next = 2, this._config;
                case 2:
                  if (r = n.sent, o = r.pkceRequiredForEmailMagicLinks, i = void 0, !o) {
                    n.next = 9;
                    break;
                  }
                  return n.next = 8, this.getCodeChallenge();
                case 8:
                  i = n.sent;
                case 9:
                  return n.next = 11, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
                case 11:
                  return a = n.sent, s = a.dfp_telemetry_id, c = a.captcha_token, l = Object.assign(Object.assign({}, t), {
                    email: e,
                    code_challenge: i,
                    captcha_token: c,
                    dfp_telemetry_id: s
                  }), n.abrupt("return", this._networkClient.retriableFetchSDK({
                    url: "/magic_links/email/login_or_create",
                    body: l,
                    errorMessage: "Failed to send magic link",
                    method: "POST",
                    retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                  }));
                case 16:
                case "end":
                  return n.stop();
              }
            }, n, this);
          }));
        },
        send: function send(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return Me(i, void 0, void 0, _e().mark(function n() {
            var r, o, i, a, s, c, l, u, d;
            return _e().wrap(function (n) {
              for (;;) switch (n.prev = n.next) {
                case 0:
                  return n.next = 2, this._config;
                case 2:
                  if (r = n.sent, o = r.pkceRequiredForEmailMagicLinks, i = void 0, !o) {
                    n.next = 9;
                    break;
                  }
                  return n.next = 8, this.getCodeChallenge();
                case 8:
                  i = n.sent;
                case 9:
                  return n.next = 11, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
                case 11:
                  return a = n.sent, s = a.dfp_telemetry_id, c = a.captcha_token, l = Object.assign(Object.assign({}, t), {
                    email: e,
                    code_challenge: i,
                    captcha_token: c,
                    dfp_telemetry_id: s
                  }), u = !!this._subscriptionService.getSession(), d = u ? "/magic_links/email/send/secondary" : "/magic_links/email/send/primary", n.abrupt("return", this._networkClient.retriableFetchSDK({
                    url: d,
                    body: l,
                    errorMessage: "Failed to send magic link",
                    method: "POST",
                    retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                  }));
                case 18:
                case "end":
                  return n.stop();
              }
            }, n, this);
          }));
        }
      }, this.authenticate = function (e, t) {
        return Me(i, void 0, void 0, _e().mark(function n() {
          var r, o;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return tt("stytch.magicLinks.authenticate").isString("Token", e).isNumber("session_duration_minutes", t.session_duration_minutes), n.next = 3, this._passwordResetPKCEManager.getPKPair();
              case 3:
                if (r = n.sent, o = null, !(null == r ? void 0 : r.code_verifier)) {
                  n.next = 19;
                  break;
                }
                return n.prev = 6, n.next = 9, this.handlePKCEForAuthenticate(this._passwordResetPKCEManager, Object.assign(Object.assign({}, t), {
                  token: e
                }));
              case 9:
                o = n.sent, n.next = 19;
                break;
              case 12:
                if (n.prev = 12, n.t0 = n["catch"](6), !n.t0.message.includes("pkce")) {
                  n.next = 18;
                  break;
                }
                console.log("Authenticate with passwords pkce namespace failed. Falling back to authenticate with magic_links namespace."), n.next = 19;
                break;
              case 18:
                throw n.t0;
              case 19:
                if (o) {
                  n.next = 23;
                  break;
                }
                return n.next = 22, this.handlePKCEForAuthenticate(this._pkceManager, Object.assign(Object.assign({}, t), {
                  token: e
                }));
              case 22:
                o = n.sent;
              case 23:
                return this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: o.user
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), n.abrupt("return", rt(o));
              case 25:
              case "end":
                return n.stop();
            }
          }, n, this, [[6, 12]]);
        }));
      };
    }
    return ye(e, [{
      key: "getCodeChallenge",
      value: function value() {
        return Me(this, void 0, void 0, _e().mark(function e() {
          var t;
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._pkceManager.getPKPair();
              case 2:
                if (!(t = e.sent)) {
                  e.next = 5;
                  break;
                }
                return e.abrupt("return", t.code_challenge);
              case 5:
                return e.next = 7, this._pkceManager.startPKCETransaction();
              case 7:
                return t = e.sent, e.abrupt("return", t.code_challenge);
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "handlePKCEForAuthenticate",
      value: function value(e, t) {
        return Me(this, void 0, void 0, _e().mark(function n() {
          var r, o, i;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, e.getPKPair();
              case 2:
                return r = n.sent, o = Object.assign({
                  code_verifier: null == r ? void 0 : r.code_verifier
                }, t), n.next = 6, this._networkClient.fetchSDK({
                  url: "/magic_links/authenticate",
                  body: o,
                  errorMessage: "Failed to authenticate token.",
                  method: "POST"
                });
              case 6:
                return i = n.sent, e.clearPKPair(), n.abrupt("return", i);
              case 9:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }]), e;
  }(),
  pt = ye(function e(t, n) {
    var r = this,
      o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {
        return Promise.resolve(void 0);
      },
      i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : it();
    be(this, e), this._networkClient = t, this._subscriptionService = n, this.executeRecaptcha = o, this.dfpProtectedAuth = i, this.sms = {
      loginOrCreate: function loginOrCreate(e, t) {
        return Me(r, void 0, void 0, _e().mark(function n() {
          var r, o, i, a;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return r = n.sent, o = r.dfp_telemetry_id, i = r.captcha_token, a = Object.assign(Object.assign({}, t), {
                  phone_number: e,
                  captcha_token: i,
                  dfp_telemetry_id: o
                }), n.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/otps/sms/login_or_create",
                  body: a,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 7:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      },
      send: function send(e, t) {
        return Me(r, void 0, void 0, _e().mark(function n() {
          var r, o, i, a, s, c;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return r = n.sent, o = r.dfp_telemetry_id, i = r.captcha_token, a = Object.assign(Object.assign({}, t), {
                  phone_number: e,
                  captcha_token: i,
                  dfp_telemetry_id: o
                }), s = !!this._subscriptionService.getSession(), c = s ? "/otps/sms/send/secondary" : "/otps/sms/send/primary", n.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: c,
                  body: a,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 9:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }, this.whatsapp = {
      loginOrCreate: function loginOrCreate(e, t) {
        return Me(r, void 0, void 0, _e().mark(function n() {
          var r, o, i, a;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return r = n.sent, o = r.dfp_telemetry_id, i = r.captcha_token, a = Object.assign(Object.assign({}, t), {
                  phone_number: e,
                  dfp_telemetry_id: o,
                  captcha_token: i
                }), n.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/otps/whatsapp/login_or_create",
                  body: a,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 7:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      },
      send: function send(e, t) {
        return Me(r, void 0, void 0, _e().mark(function n() {
          var r, o, i, a, s, c;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 2:
                return r = n.sent, o = r.dfp_telemetry_id, i = r.captcha_token, a = Object.assign(Object.assign({}, t), {
                  phone_number: e,
                  captcha_token: i,
                  dfp_telemetry_id: o
                }), s = !!this._subscriptionService.getSession(), c = s ? "/otps/whatsapp/send/secondary" : "/otps/whatsapp/send/primary", n.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: c,
                  body: a,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST",
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 9:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }, this.email = {
      loginOrCreate: function loginOrCreate(e, t) {
        return Me(r, void 0, void 0, _e().mark(function n() {
          var r, o;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, this.executeRecaptcha();
              case 2:
                return r = n.sent, o = Object.assign(Object.assign({}, t), {
                  email: e,
                  captcha_token: r
                }), n.abrupt("return", this._networkClient.fetchSDK({
                  url: "/otps/email/login_or_create",
                  body: o,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST"
                }));
              case 5:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      },
      send: function send(e, t) {
        return Me(r, void 0, void 0, _e().mark(function n() {
          var r, o, i, a;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, this.executeRecaptcha();
              case 2:
                return r = n.sent, o = Object.assign(Object.assign({}, t), {
                  email: e,
                  captcha_token: r
                }), i = !!this._subscriptionService.getSession(), a = i ? "/otps/email/send/secondary" : "/otps/email/send/primary", n.abrupt("return", this._networkClient.fetchSDK({
                  url: a,
                  body: o,
                  errorMessage: "Failed to send one time passcode",
                  method: "POST"
                }));
              case 7:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }, this.authenticate = function (e, t, n) {
      return Me(r, void 0, void 0, _e().mark(function r() {
        var o, i, a, s, c;
        return _e().wrap(function (r) {
          for (;;) switch (r.prev = r.next) {
            case 0:
              return tt("stytch.otps.authenticate").isString("Code", e).isNumber("session_duration_minutes", n.session_duration_minutes), r.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
            case 3:
              return o = r.sent, i = o.dfp_telemetry_id, a = o.captcha_token, s = Object.assign({
                token: e,
                method_id: t,
                dfp_telemetry_id: i,
                captcha_token: a
              }, n), r.next = 9, this._networkClient.retriableFetchSDK({
                url: "/otps/authenticate",
                body: s,
                errorMessage: "Failed to authenticate token.",
                method: "POST",
                retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
              });
            case 9:
              return c = r.sent, this._subscriptionService.updateStateAndTokens({
                state: {
                  session: c.session,
                  user: c.user
                },
                session_token: c.session_token,
                session_jwt: c.session_jwt,
                intermediate_session_token: null
              }), r.abrupt("return", rt(c));
            case 12:
            case "end":
              return r.stop();
          }
        }, r, this);
      }));
    };
  }),
  ht = function () {
    function e(t, n, r, o, i) {
      be(this, e), this._networkClient = t, this._subscriptionService = n, this._pkceManager = r, this._dynamicConfig = o, this._config = i, this.google = {
        start: this.startOAuthFlow(h.Google)
      }, this.apple = {
        start: this.startOAuthFlow(h.Apple)
      }, this.microsoft = {
        start: this.startOAuthFlow(h.Microsoft)
      }, this.github = {
        start: this.startOAuthFlow(h.Github)
      }, this.gitlab = {
        start: this.startOAuthFlow(h.GitLab)
      }, this.facebook = {
        start: this.startOAuthFlow(h.Facebook)
      }, this.discord = {
        start: this.startOAuthFlow(h.Discord)
      }, this.salesforce = {
        start: this.startOAuthFlow(h.Salesforce)
      }, this.slack = {
        start: this.startOAuthFlow(h.Slack)
      }, this.amazon = {
        start: this.startOAuthFlow(h.Amazon)
      }, this.bitbucket = {
        start: this.startOAuthFlow(h.Bitbucket)
      }, this.linkedin = {
        start: this.startOAuthFlow(h.LinkedIn)
      }, this.coinbase = {
        start: this.startOAuthFlow(h.Coinbase)
      }, this.twitch = {
        start: this.startOAuthFlow(h.Twitch)
      }, this.twitter = {
        start: this.startOAuthFlow(h.Twitter)
      }, this.tiktok = {
        start: this.startOAuthFlow(h.TikTok)
      }, this.snapchat = {
        start: this.startOAuthFlow(h.Snapchat)
      }, this.figma = {
        start: this.startOAuthFlow(h.Figma)
      }, this.yahoo = {
        start: this.startOAuthFlow(h.Yahoo)
      };
    }
    return ye(e, [{
      key: "authenticate",
      value: function value(e, t) {
        return Me(this, void 0, void 0, _e().mark(function n() {
          var r, o;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return tt("stytch.oauth.authenticate").isString("Token", e).isNumber("session_duration_minutes", t.session_duration_minutes), n.next = 3, this._pkceManager.getPKPair();
              case 3:
                return (r = n.sent) || qe("No code verifier found in local storage for OAuth flow.\nConsider using stytch.oauth.$provider.start() to add PKCE to your OAuth flows for added security.\nSee https://stytch.com/docs/oauth#guides_pkce for more information."), n.next = 7, this._networkClient.fetchSDK({
                  url: "/oauth/authenticate",
                  method: "POST",
                  body: Object.assign({
                    token: e,
                    code_verifier: null == r ? void 0 : r.code_verifier
                  }, t),
                  errorMessage: "Failed to authenticate token"
                });
              case 7:
                return o = n.sent, this._pkceManager.clearPKPair(), this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: o.session,
                    user: nt(o.__user)
                  },
                  session_token: o.session_token,
                  session_jwt: o.session_jwt,
                  intermediate_session_token: null
                }), n.abrupt("return", rt(o));
              case 11:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }, {
      key: "getBaseApiUrl",
      value: function value() {
        return Me(this, void 0, void 0, _e().mark(function e() {
          var t, n;
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._dynamicConfig;
              case 2:
                if (t = e.sent, !(n = t.cnameDomain)) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", "https://".concat(n));
              case 6:
                if (!et(this._config.publicToken)) {
                  e.next = 8;
                  break;
                }
                return e.abrupt("return", this._config.testAPIURL);
              case 8:
                return e.abrupt("return", this._config.liveAPIURL);
              case 9:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "startOAuthFlow",
      value: function value(e) {
        var t = this;
        return function () {
          var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = n.login_redirect_url,
            o = n.signup_redirect_url,
            i = n.custom_scopes,
            a = n.provider_params;
          return Me(t, void 0, void 0, _e().mark(function t() {
            var n, s, c, l, u, d, p;
            return _e().wrap(function (t) {
              for (;;) switch (t.prev = t.next) {
                case 0:
                  return t.next = 2, this._dynamicConfig;
                case 2:
                  return n = t.sent, s = n.cnameDomain, c = n.pkceRequiredForOAuth, t.next = 7, this.getBaseApiUrl();
                case 7:
                  if (l = t.sent, this._networkClient.logEvent({
                    name: "start_oauth_flow",
                    details: {
                      provider_type: e,
                      custom_scopes: i,
                      cname_domain: s,
                      pkce: c,
                      provider_params: a
                    }
                  }), (u = new URL("".concat(l, "/v1/public/oauth/").concat(e, "/start"))).searchParams.set("public_token", this._config.publicToken), !c) {
                    t.next = 18;
                    break;
                  }
                  return t.next = 14, this._pkceManager.startPKCETransaction();
                case 14:
                  d = t.sent, u.searchParams.set("code_challenge", d.code_challenge), t.next = 19;
                  break;
                case 18:
                  this._pkceManager.clearPKPair();
                case 19:
                  if (i && (tt("startOAuthFlow").isStringArray("custom_scopes", i), u.searchParams.set("custom_scopes", i.join(" "))), a) for (p in tt("startOAuthFlow").isOptionalObject("provider_params", a), a) u.searchParams.set("provider_" + p, a[p]);
                  r && u.searchParams.set("login_redirect_url", r), o && u.searchParams.set("signup_redirect_url", o), window.location.href = u.toString();
                case 24:
                case "end":
                  return t.stop();
              }
            }, t, this);
          }));
        };
      }
    }]), e;
  }(),
  ft = function () {
    function e(t, n) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function () {
          return Promise.resolve(void 0);
        },
        o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : it();
      be(this, e), this._networkClient = t, this._subscriptionService = n, this.executeRecaptcha = r, this.dfpProtectedAuth = o;
    }
    return ye(e, [{
      key: "authenticateStart",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.cryptoWallets.authenticateStart").isString("crypto_wallet_address", e.crypto_wallet_address).isString("crypto_wallet_type", e.crypto_wallet_type), n = !!this._subscriptionService.getSession(), t.next = 4, this.executeRecaptcha();
              case 4:
                return r = t.sent, o = n ? "/crypto_wallets/authenticate/start/secondary" : "/crypto_wallets/authenticate/start/primary", t.abrupt("return", this._networkClient.fetchSDK({
                  url: o,
                  method: "POST",
                  errorMessage: "Failed to start wallet authentication.",
                  body: {
                    crypto_wallet_address: e.crypto_wallet_address,
                    crypto_wallet_type: e.crypto_wallet_type,
                    captcha_token: r
                  }
                }));
              case 7:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.cryptoWallets.authenticate").isString("signature", e.signature).isString("crypto_wallet_address", e.crypto_wallet_address).isString("crypto_wallet_type", e.crypto_wallet_type).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, o = n.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/crypto_wallets/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate.",
                  body: {
                    session_duration_minutes: e.session_duration_minutes,
                    crypto_wallet_address: e.crypto_wallet_address,
                    crypto_wallet_type: e.crypto_wallet_type,
                    signature: e.signature,
                    captcha_token: o,
                    dfp_telemetry_id: r
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return i = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: nt(i.__user)
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", rt(i));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }(),
  mt = function () {
    function e(t, n, r) {
      be(this, e), this._networkClient = t, this._subscriptionService = n, this.dfpProtectedAuth = r;
    }
    return ye(e, [{
      key: "create",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.totps.create").isNumber("expiration_minutes", e.expiration_minutes), t.next = 3, this._networkClient.fetchSDK({
                  url: "/totps",
                  method: "POST",
                  errorMessage: "Failed to create TOTP",
                  body: {
                    expiration_minutes: e.expiration_minutes
                  }
                });
              case 3:
                return n = t.sent, this._subscriptionService.updateUser(n.__user), t.abrupt("return", rt(n));
              case 6:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.totps.authenticate").isNumber("session_duration_minutes", e.session_duration_minutes).isString("totp_code", e.totp_code), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, o = n.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/totps/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate TOTP",
                  body: {
                    session_duration_minutes: e.session_duration_minutes,
                    totp_code: e.totp_code,
                    captcha_token: o,
                    dfp_telemetry_id: r
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return i = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: i.__user
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", rt(i));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "recoveryCodes",
      value: function value() {
        return Me(this, void 0, void 0, _e().mark(function e() {
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.abrupt("return", this._networkClient.fetchSDK({
                  url: "/totps/recovery_codes",
                  method: "POST",
                  errorMessage: "Failed to retrieve recovery codes"
                }));
              case 1:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "recover",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.totps.recover").isNumber("session_duration_minutes", e.session_duration_minutes).isString("recovery_code", e.recovery_code), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, o = n.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/totps/recover",
                  method: "POST",
                  errorMessage: "Failed to recover TOTP",
                  body: {
                    session_duration_minutes: e.session_duration_minutes,
                    recovery_code: e.recovery_code,
                    captcha_token: o,
                    dfp_telemetry_id: r
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return i = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: i.__user
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", rt(i));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }();
function gt(e) {
  for (var t = "==".slice(0, (4 - e.length % 4) % 4), n = e.replace(/-/g, "+").replace(/_/g, "/") + t, r = atob(n), o = new ArrayBuffer(r.length), i = new Uint8Array(o), a = 0; a < r.length; a++) i[a] = r.charCodeAt(a);
  return o;
}
function _t(e) {
  var t,
    n = "",
    r = he(new Uint8Array(e));
  try {
    for (r.s(); !(t = r.n()).done;) {
      var o = t.value;
      n += String.fromCharCode(o);
    }
  } catch (e) {
    r.e(e);
  } finally {
    r.f();
  }
  return btoa(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
var vt = "copy",
  yt = "convert";
function Ct(e, t, n) {
  if (t === vt) return n;
  if (t === yt) return e(n);
  if (t instanceof Array) return n.map(function (n) {
    return Ct(e, t[0], n);
  });
  if (t instanceof Object) {
    for (var r = {}, o = 0, i = Object.entries(t); o < i.length; o++) {
      var a = pe(i[o], 2),
        s = a[0],
        c = a[1];
      if (c.derive) {
        var l = c.derive(n);
        void 0 !== l && (n[s] = l);
      }
      if (s in n) null != n[s] ? r[s] = Ct(e, c.schema, n[s]) : r[s] = null;else if (c.required) throw new Error("Missing key: ".concat(s));
    }
    return r;
  }
}
function bt(e, t) {
  return {
    required: !0,
    schema: e,
    derive: t
  };
}
function wt(e) {
  return {
    required: !0,
    schema: e
  };
}
function kt(e) {
  return {
    required: !1,
    schema: e
  };
}
var Et = {
    type: wt(vt),
    id: wt(yt),
    transports: kt(vt)
  },
  St = {
    appid: kt(vt),
    appidExclude: kt(vt),
    credProps: kt(vt)
  },
  xt = {
    appid: kt(vt),
    appidExclude: kt(vt),
    credProps: kt(vt)
  },
  Ot = {
    publicKey: wt({
      rp: wt(vt),
      user: wt({
        id: wt(yt),
        name: wt(vt),
        displayName: wt(vt)
      }),
      challenge: wt(yt),
      pubKeyCredParams: wt(vt),
      timeout: kt(vt),
      excludeCredentials: kt([Et]),
      authenticatorSelection: kt(vt),
      attestation: kt(vt),
      extensions: kt(St)
    }),
    signal: kt(vt)
  },
  Lt = {
    type: wt(vt),
    id: wt(vt),
    rawId: wt(yt),
    authenticatorAttachment: kt(vt),
    response: wt({
      clientDataJSON: wt(yt),
      attestationObject: wt(yt),
      transports: bt(vt, function (e) {
        var t;
        return (null == (t = e.getTransports) ? void 0 : t.call(e)) || [];
      })
    }),
    clientExtensionResults: bt(xt, function (e) {
      return e.getClientExtensionResults();
    })
  },
  At = {
    mediation: kt(vt),
    publicKey: wt({
      challenge: wt(yt),
      timeout: kt(vt),
      rpId: kt(vt),
      allowCredentials: kt([Et]),
      userVerification: kt(vt),
      extensions: kt(St)
    }),
    signal: kt(vt)
  },
  Tt = {
    type: wt(vt),
    id: wt(vt),
    rawId: wt(yt),
    authenticatorAttachment: kt(vt),
    response: wt({
      clientDataJSON: wt(yt),
      authenticatorData: wt(yt),
      signature: wt(yt),
      userHandle: wt(yt)
    }),
    clientExtensionResults: bt(xt, function (e) {
      return e.getClientExtensionResults();
    })
  };
function Pt(e) {
  return Ct(gt, Ot, e);
}
function Mt(e) {
  return Ct(_t, Lt, e);
}
function Rt(e) {
  return Me(this, void 0, void 0, _e().mark(function t() {
    var n;
    return _e().wrap(function (t) {
      for (;;) switch (t.prev = t.next) {
        case 0:
          return t.next = 2, navigator.credentials.create(Pt(e));
        case 2:
          return n = t.sent, t.abrupt("return", Mt(n));
        case 4:
        case "end":
          return t.stop();
      }
    }, t);
  }));
}
function Dt(e) {
  return Ct(gt, At, e);
}
function Ft(e) {
  return Ct(_t, Tt, e);
}
function jt(e) {
  return Me(this, void 0, void 0, _e().mark(function t() {
    var n;
    return _e().wrap(function (t) {
      for (;;) switch (t.prev = t.next) {
        case 0:
          return t.next = 2, navigator.credentials.get(Dt(e));
        case 2:
          return n = t.sent, t.abrupt("return", Ft(n));
        case 4:
        case "end":
          return t.stop();
      }
    }, t);
  }));
}
var It = function () {
    function e(t, n, r) {
      be(this, e), this._networkClient = t, this._subscriptionService = n, this.dfpProtectedAuth = r, this.checkEligibleInputs = function () {
        return !(document.querySelectorAll("input[autocomplete*='webauthn']").length < 1) || (console.error('No <input> with `"webauthn"` in its `autocomplete` attribute was detected'), !1);
      };
    }
    return ye(e, [{
      key: "register",
      value: function value(e) {
        var t, n;
        return Me(this, void 0, void 0, _e().mark(function r() {
          var o, i, a, s, c;
          return _e().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return tt("stytch.webauthn.register").isOptionalString("domain", null == e ? void 0 : e.domain).isOptionalString("authenticator_type", null == e ? void 0 : e.authenticator_type).isOptionalBoolean("is_passkey", null == e ? void 0 : e.is_passkey).isOptionalNumber("session_duration_minutes", null == e ? void 0 : e.session_duration_minutes), r.next = 3, this._networkClient.fetchSDK({
                  url: "/webauthn/register/start",
                  method: "POST",
                  errorMessage: "Failed to start WebAuthn registration",
                  body: {
                    domain: null !== (t = null == e ? void 0 : e.domain) && void 0 !== t ? t : window.location.hostname,
                    authenticator_type: null !== (n = null == e ? void 0 : e.authenticator_type) && void 0 !== n ? n : void 0,
                    return_passkey_credential_options: null == e ? void 0 : e.is_passkey,
                    user_agent: navigator.userAgent
                  }
                });
              case 3:
                return o = r.sent, i = o.public_key_credential_creation_options, a = JSON.parse(i), r.next = 8, Rt({
                  publicKey: a
                });
              case 8:
                return s = r.sent, r.next = 11, this._networkClient.fetchSDK({
                  url: "/webauthn/register",
                  method: "POST",
                  errorMessage: "Failed to register WebAuthn device",
                  body: {
                    public_key_credential: JSON.stringify(s),
                    session_duration_minutes: null == e ? void 0 : e.session_duration_minutes
                  }
                });
              case 11:
                return c = r.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: c.session,
                    user: c.__user
                  },
                  session_token: c.session_token,
                  session_jwt: c.session_jwt,
                  intermediate_session_token: null
                }), r.abrupt("return", rt(c));
              case 14:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        var t, n;
        return Me(this, void 0, void 0, _e().mark(function r() {
          var o, i, a, s, c, l, u, d, p, h, f, m;
          return _e().wrap(function (r) {
            for (;;) switch (r.prev = r.next) {
              case 0:
                return tt("stytch.webauthn.authenticate").isOptionalString("domain", e.domain).isNumber("session_duration_minutes", e.session_duration_minutes).isOptionalBoolean("is_passkey", e.is_passkey).isOptionalObject("signal", e.signal), r.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                if (o = r.sent, i = o.dfp_telemetry_id, a = o.captcha_token, !e.conditional_mediation) {
                  r.next = 14;
                  break;
                }
                return r.next = 9, this.browserSupportsAutofill();
              case 9:
                if (r.sent) {
                  r.next = 12;
                  break;
                }
                return console.error("Browser does not support WebAuthn autofill"), r.abrupt("return", null);
              case 12:
                if (this.checkEligibleInputs()) {
                  r.next = 14;
                  break;
                }
                return r.abrupt("return", null);
              case 14:
                return s = !!this._subscriptionService.getSession(), c = s ? "/webauthn/authenticate/start/secondary" : "/webauthn/authenticate/start/primary", r.next = 18, this._networkClient.fetchSDK({
                  url: c,
                  method: "POST",
                  errorMessage: "Failed to start WebAuthn authentication",
                  body: {
                    domain: null !== (t = e.domain) && void 0 !== t ? t : window.location.hostname,
                    return_passkey_credential_options: null == e ? void 0 : e.is_passkey
                  }
                });
              case 18:
                return l = r.sent, u = l.public_key_credential_request_options, d = new AbortController(), p = {
                  publicKey: JSON.parse(u),
                  signal: null !== (n = e.signal) && void 0 !== n ? n : d.signal
                }, h = Object.assign(Object.assign({}, p), {
                  mediation: "conditional"
                }), r.next = 25, jt(e.conditional_mediation ? h : p);
              case 25:
                return f = r.sent, r.next = 28, this._networkClient.retriableFetchSDK({
                  url: "/webauthn/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate WebAuthn device",
                  body: {
                    public_key_credential: JSON.stringify(f),
                    session_duration_minutes: e.session_duration_minutes,
                    dfp_telemetry_id: i,
                    captcha_token: a
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 28:
                return m = r.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: m.session,
                    user: m.__user
                  },
                  session_token: m.session_token,
                  session_jwt: m.session_jwt,
                  intermediate_session_token: null
                }), r.abrupt("return", rt(m));
              case 31:
              case "end":
                return r.stop();
            }
          }, r, this);
        }));
      }
    }, {
      key: "update",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return n = "/webauthn/update/" + e.webauthn_registration_id, t.next = 3, this._networkClient.fetchSDK({
                  url: n,
                  method: "PUT",
                  errorMessage: "Failed to update WebAuthn Registration",
                  body: {
                    name: e.name
                  }
                });
              case 3:
                return t.abrupt("return", t.sent);
              case 4:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "browserSupportsAutofill",
      value: function value() {
        return Me(this, void 0, void 0, _e().mark(function e() {
          var t;
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                if (void 0 !== (t = window.PublicKeyCredential) && void 0 !== t.isConditionalMediationAvailable) {
                  e.next = 3;
                  break;
                }
                return e.abrupt("return", new Promise(function (e) {
                  return e(!1);
                }));
              case 3:
                return e.abrupt("return", t.isConditionalMediationAvailable());
              case 4:
              case "end":
                return e.stop();
            }
          }, e);
        }));
      }
    }]), e;
  }(),
  Bt = Promise.resolve({
    pkceRequiredForPasswordResets: !1
  }),
  Nt = function () {
    function e(t, n, r) {
      var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Bt,
        i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : it();
      be(this, e), this._networkClient = t, this._subscriptionService = n, this._pkceManager = r, this._config = o, this.dfpProtectedAuth = i;
    }
    return ye(e, [{
      key: "getCodeChallenge",
      value: function value() {
        return Me(this, void 0, void 0, _e().mark(function e() {
          var t, n;
          return _e().wrap(function (e) {
            for (;;) switch (e.prev = e.next) {
              case 0:
                return e.next = 2, this._config;
              case 2:
                if (t = e.sent, t.pkceRequiredForPasswordResets) {
                  e.next = 6;
                  break;
                }
                return e.abrupt("return", void 0);
              case 6:
                return e.next = 8, this._pkceManager.getPKPair();
              case 8:
                if (!(n = e.sent)) {
                  e.next = 11;
                  break;
                }
                return e.abrupt("return", n.code_challenge);
              case 11:
                return e.next = 13, this._pkceManager.startPKCETransaction();
              case 13:
                return n = e.sent, e.abrupt("return", n.code_challenge);
              case 15:
              case "end":
                return e.stop();
            }
          }, e, this);
        }));
      }
    }, {
      key: "create",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.passwords.create").isString("password", e.password).isString("email", e.email).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, o = n.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/passwords",
                  method: "POST",
                  errorMessage: "Failed to create password.",
                  body: {
                    email: e.email,
                    password: e.password,
                    session_duration_minutes: e.session_duration_minutes,
                    captcha_token: o,
                    dfp_telemetry_id: r
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return i = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: i.user
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", rt(i));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "authenticate",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.passwords.authenticate").isString("password", e.password).isString("email", e.email).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, o = n.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/passwords/authenticate",
                  method: "POST",
                  errorMessage: "Failed to authenticate password.",
                  body: {
                    email: e.email,
                    password: e.password,
                    session_duration_minutes: e.session_duration_minutes,
                    captcha_token: o,
                    dfp_telemetry_id: r
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return i = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: i.user
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", rt(i));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByEmailStart",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.passwords.resetByEmailStart").isString("email", e.email).isOptionalString("login_redirect_url", e.login_redirect_url).isOptionalString("reset_password_redirect_url", e.reset_password_redirect_url).isOptionalString("reset_password_template_id", e.reset_password_template_id).isOptionalNumber("reset_password_expiration_minutes", e.reset_password_expiration_minutes), t.next = 3, this.getCodeChallenge();
              case 3:
                return n = t.sent, t.next = 6, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 6:
                return r = t.sent, o = r.dfp_telemetry_id, i = r.captcha_token, t.abrupt("return", this._networkClient.retriableFetchSDK({
                  url: "/passwords/email/reset/start",
                  method: "POST",
                  errorMessage: "Failed to start password reset flow.",
                  body: {
                    email: e.email,
                    login_redirect_url: e.login_redirect_url,
                    reset_password_redirect_url: e.reset_password_redirect_url,
                    reset_password_expiration_minutes: e.reset_password_expiration_minutes,
                    reset_password_template_id: e.reset_password_template_id,
                    code_challenge: n,
                    captcha_token: i,
                    dfp_telemetry_id: o
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                }));
              case 10:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByEmail",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i, a, s;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.passwords.resetByEmail").isString("token", e.token).isString("password", e.password).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, o = n.captcha_token, t.next = 8, this._pkceManager.getPKPair();
              case 8:
                return i = t.sent, a = null == i ? void 0 : i.code_verifier, t.next = 12, this._networkClient.retriableFetchSDK({
                  url: "/passwords/email/reset",
                  method: "POST",
                  errorMessage: "Failed to reset password.",
                  body: {
                    token: e.token,
                    password: e.password,
                    session_duration_minutes: e.session_duration_minutes,
                    captcha_token: o,
                    code_verifier: a,
                    dfp_telemetry_id: r
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 12:
                return s = t.sent, this._pkceManager.clearPKPair(), this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: s.session,
                    user: s.user
                  },
                  session_token: s.session_token,
                  session_jwt: s.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", rt(s));
              case 16:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetByExistingPassword",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.passwords.resetByExistingPassword").isString("email", e.email).isString("existing_password", e.existing_password).isString("new_password", e.new_password).isNumber("session_duration_minutes", e.session_duration_minutes), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, o = n.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/passwords/existing_password/reset",
                  method: "POST",
                  errorMessage: "Failed to reset password.",
                  body: {
                    email: e.email,
                    existing_password: e.existing_password,
                    new_password: e.new_password,
                    session_duration_minutes: e.session_duration_minutes,
                    dfp_telemetry_id: r,
                    captcha_token: o
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return i = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: i.user
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", rt(i));
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "resetBySession",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          var n, r, o, i;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.passwords.resetBySession").isString("password", e.password), t.next = 3, this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha();
              case 3:
                return n = t.sent, r = n.dfp_telemetry_id, o = n.captcha_token, t.next = 8, this._networkClient.retriableFetchSDK({
                  url: "/passwords/session/reset",
                  method: "POST",
                  errorMessage: "Failed to reset by session.",
                  body: {
                    password: e.password,
                    session_duration_minutes: e.session_duration_minutes,
                    dfp_telemetry_id: r,
                    captcha_token: o
                  },
                  retryCallback: this.dfpProtectedAuth.retryWithCaptchaAndDFP
                });
              case 8:
                return i = t.sent, this._subscriptionService.updateStateAndTokens({
                  state: {
                    session: i.session,
                    user: i.user
                  },
                  session_token: i.session_token,
                  session_jwt: i.session_jwt,
                  intermediate_session_token: null
                }), t.abrupt("return", i);
              case 11:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }, {
      key: "strengthCheck",
      value: function value(e) {
        return Me(this, void 0, void 0, _e().mark(function t() {
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                return tt("stytch.passwords.strengthCheck").isOptionalString("email", e.email).isString("password", e.password), t.abrupt("return", this._networkClient.fetchSDK({
                  url: "/passwords/strength_check",
                  method: "POST",
                  errorMessage: "Failed to check password strength.",
                  body: {
                    email: e.email,
                    password: e.password
                  }
                }));
              case 2:
              case "end":
                return t.stop();
            }
          }, t, this);
        }));
      }
    }]), e;
  }();
Promise.resolve({
  pkceRequiredForEmailMagicLinks: !1
}), Promise.resolve({
  pkceRequiredForPasswordResets: !1
});
var Ht = function () {
    function e(t) {
      be(this, e), this.iframeURL = t, this.createIframe();
    }
    return ye(e, [{
      key: "createIframe",
      value: function value() {
        var e = document.querySelector('[src~="'.concat(this.iframeURL, '"]'));
        e ? qe("It looks like you're creating multiple copies of the Stytch client. This behavior is unsupported, and unintended side effects may occur. Make sure you are creating the Stytch client at the global level, and not inside a component's render function.") : ((e = document.createElement("iframe")).src = this.iframeURL, e.style.position = "absolute", e.style.width = "0", e.style.height = "0", e.style.border = "0", document.body.appendChild(e)), "true" !== e.dataset.loaded ? this.frame = new Promise(function (t) {
          e.addEventListener("load", function () {
            e.dataset.loaded = "true", t(e);
          }, {
            once: !0
          });
        }) : this.frame = Promise.resolve(e);
      }
    }, {
      key: "call",
      value: function value(e, t) {
        return Me(this, void 0, void 0, _e().mark(function n() {
          var r,
            o,
            i = this;
          return _e().wrap(function (n) {
            for (;;) switch (n.prev = n.next) {
              case 0:
                return n.next = 2, this.frame;
              case 2:
                return r = n.sent, o = new MessageChannel(), n.abrupt("return", new Promise(function (n, a) {
                  var s;
                  o.port1.onmessage = function (e) {
                    var t = e.data;
                    o.port1.close(), t.success ? n(t.payload) : a(at.unmarshall(t.error));
                  };
                  var c = {
                    method: e,
                    args: t
                  };
                  null === (s = r.contentWindow) || void 0 === s || s.postMessage(c, i.iframeURL, [o.port2]);
                }));
              case 5:
              case "end":
                return n.stop();
            }
          }, n, this);
        }));
      }
    }]), e;
  }(),
  Ut = function () {
    function e(t, n) {
      be(this, e), this._networkClient = t, this.dfpProtectedAuth = n;
    }
    return ye(e, [{
      key: "searchUser",
      value: function value(e) {
        var t = this;
        return this.dfpProtectedAuth.getDFPTelemetryIDAndCaptcha().then(function (n) {
          var r = n.dfp_telemetry_id,
            o = n.captcha_token;
          return t._networkClient.fetchSDK({
            url: "/users/search",
            method: "POST",
            body: {
              email: e,
              dfp_telemetry_id: r,
              captcha_token: o
            },
            errorMessage: "Error searching for user ".concat(e)
          });
        });
      }
    }, {
      key: "searchMember",
      value: function value(e, t) {
        return this._networkClient.fetchSDK({
          url: "/b2b/organizations/members/search",
          method: "POST",
          body: {
            email_address: e,
            organization_id: t
          },
          errorMessage: "Error searching for member ".concat(e)
        });
      }
    }]), e;
  }(),
  $t = function () {
    function e(t, n) {
      var r = this;
      be(this, e), this._subscriptionService = t, this._headlessSessionClient = n, this._onDataChange = function (e) {
        !function (e) {
          return !!(null == e ? void 0 : e.session);
        }(e) ? r.cancelBackgroundRefresh() : r.scheduleBackgroundRefresh();
      }, this._reauthenticateWithBackoff = function () {
        return Me(r, void 0, void 0, _e().mark(function t() {
          var n;
          return _e().wrap(function (t) {
            for (;;) switch (t.prev = t.next) {
              case 0:
                n = 0;
              case 1:
                return t.prev = 2, t.next = 5, this._headlessSessionClient.authenticate();
              case 5:
                return t.abrupt("return", t.sent);
              case 8:
                if (t.prev = 8, t.t0 = t["catch"](2), !e.isUnrecoverableError(t.t0)) {
                  t.next = 12;
                  break;
                }
                return t.abrupt("return", Promise.reject(t.t0));
              case 12:
                return n++, t.next = 15, new Promise(function (t) {
                  return setTimeout(t, e.timeoutForAttempt(n));
                });
              case 15:
                t.next = 1;
                break;
              case 17:
              case "end":
                return t.stop();
            }
          }, t, this, [[2, 8]]);
        }));
      }, this.timeout = null, this._subscriptionService.subscribeToState(this._onDataChange);
    }
    return ye(e, [{
      key: "performBackgroundRefresh",
      value: function value() {
        var e = this;
        this._reauthenticateWithBackoff().then(function () {
          e.scheduleBackgroundRefresh();
        })["catch"](function (t) {
          qe("Session background refresh failed. Signalling to app that user is logged out.", {
            error: t
          }), e._subscriptionService.destroySession();
        });
      }
    }, {
      key: "scheduleBackgroundRefresh",
      value: function value() {
        var t = this;
        this.cancelBackgroundRefresh(), this.timeout = setTimeout(function () {
          t.performBackgroundRefresh();
        }, e.REFRESH_INTERVAL_MS);
      }
    }, {
      key: "cancelBackgroundRefresh",
      value: function value() {
        null !== this.timeout && (clearTimeout(this.timeout), this.timeout = null);
      }
    }], [{
      key: "timeoutForAttempt",
      value: function value(e) {
        return e = Math.min(e, 7), Math.floor(350 * Math.random()) - 175 + 2e3 * Math.pow(2, e);
      }
    }, {
      key: "isUnrecoverableError",
      value: function value(e) {
        return O.includes(e.error_type);
      }
    }]), e;
  }();
$t.REFRESH_INTERVAL_MS = 18e4;
var Vt = ye(function e(t, n) {
  var r = this;
  be(this, e), this._subscriptionService = t, this.emptyState = n, this.onStateChange = function (e) {
    return r._subscriptionService.subscribeToState(function (t) {
      e(null != t ? t : r.emptyState);
    });
  };
});
var Zt = "bootstrap";
var zt = /*#__PURE__*/function () {
  function zt(e, t, n) {
    var _this = this;
    _classCallCheck(this, zt);
    this._publicToken = e, this._networkClient = t, this._dataLayer = n, this._bootstrapDataPromise = this._networkClient.fetchSDK({
      url: "/projects/bootstrap/".concat(this._publicToken),
      method: "GET",
      errorMessage: "Error fetching bootstrap data for SDK for ".concat(this._publicToken)
    }).then(zt.mapBootstrapData).then(function (e) {
      return _this._dataLayer.setItem(Zt, JSON.stringify(e)), e;
    })["catch"](function (e) {
      return Ye(e), {
        displayWatermark: !1,
        cnameDomain: null,
        emailDomains: ["stytch.com"],
        captchaSettings: {
          enabled: !1
        },
        pkceRequiredForEmailMagicLinks: !1,
        pkceRequiredForPasswordResets: !1,
        pkceRequiredForOAuth: !1,
        pkceRequiredForSso: !1,
        slugPattern: null,
        createOrganizationEnabled: !1,
        passwordConfig: null,
        runDFPProtectedAuth: !1,
        rbacPolicy: null
      };
    });
  }
  _createClass(zt, [{
    key: "getSync",
    value: function getSync() {
      var e = this._dataLayer.getItem(Zt);
      if (null === e) return {
        displayWatermark: !1,
        cnameDomain: null,
        emailDomains: ["stytch.com"],
        captchaSettings: {
          enabled: !1
        },
        pkceRequiredForEmailMagicLinks: !1,
        pkceRequiredForPasswordResets: !1,
        pkceRequiredForOAuth: !1,
        pkceRequiredForSso: !1,
        slugPattern: null,
        createOrganizationEnabled: !1,
        passwordConfig: null,
        runDFPProtectedAuth: !1,
        rbacPolicy: null
      };
      try {
        return JSON.parse(e);
      } catch (e) {
        return {
          displayWatermark: !1,
          cnameDomain: null,
          emailDomains: ["stytch.com"],
          captchaSettings: {
            enabled: !1
          },
          pkceRequiredForEmailMagicLinks: !1,
          pkceRequiredForPasswordResets: !1,
          pkceRequiredForOAuth: !1,
          pkceRequiredForSso: !1,
          slugPattern: null,
          createOrganizationEnabled: !1,
          passwordConfig: null,
          runDFPProtectedAuth: !1,
          rbacPolicy: null
        };
      }
    }
  }, {
    key: "getAsync",
    value: function getAsync() {
      return this._bootstrapDataPromise;
    }
  }], [{
    key: "mapBootstrapData",
    value: function mapBootstrapData(e) {
      var t, n;
      var r = null !== e.password_config ? {
        ludsComplexity: e.password_config.luds_complexity,
        ludsMinimumCount: e.password_config.luds_minimum_count
      } : null;
      return {
        displayWatermark: !e.disable_sdk_watermark,
        captchaSettings: e.captcha_settings,
        cnameDomain: e.cname_domain,
        emailDomains: e.email_domains,
        pkceRequiredForEmailMagicLinks: e.pkce_required_for_email_magic_links,
        pkceRequiredForPasswordResets: e.pkce_required_for_password_resets,
        pkceRequiredForOAuth: e.pkce_required_for_oauth,
        pkceRequiredForSso: e.pkce_required_for_sso,
        slugPattern: e.slug_pattern,
        createOrganizationEnabled: e.create_organization_enabled,
        passwordConfig: r,
        runDFPProtectedAuth: null !== (t = e.dfp_protected_auth_enabled) && void 0 !== t && t,
        dfpProtectedAuthMode: e.dfp_protected_auth_mode,
        rbacPolicy: null !== (n = e.rbac_policy) && void 0 !== n ? n : null
      };
    }
  }]);
  return zt;
}();
function Wt(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  }
  return n;
}
function Kt(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        c(r.next(e));
      } catch (e) {
        i(e);
      }
    }
    function s(e) {
      try {
        c(r["throw"](e));
      } catch (e) {
        i(e);
      }
    }
    function c(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(a, s);
    }
    c((r = r.apply(e, t || [])).next());
  });
}
"function" == typeof SuppressedError && SuppressedError;
var Gt = /*#__PURE__*/_createClass(function Gt(e) {
  var _this2 = this;
  _classCallCheck(this, Gt);
  this.bootstrapPromise = e, this.executeRecaptcha = function () {
    return Kt(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$this$state, e, t, n;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.state;
          case 2:
            _yield$this$state = _context.sent;
            e = _yield$this$state.captchaClient;
            t = _yield$this$state.configured;
            n = _yield$this$state.siteKey;
            if (!t) {
              _context.next = 10;
              break;
            }
            _context.next = 9;
            return new Promise(function (t) {
              return e.ready(t);
            });
          case 9:
            return _context.abrupt("return", e.execute(n, {
              action: "LOGIN"
            }));
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
  }, this.state = e.then(function (e) {
    return Kt(_this2, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var t;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!e.captchaSettings.enabled) {
              _context2.next = 9;
              break;
            }
            _context2.t1 = !0;
            _context2.next = 4;
            return t = e.captchaSettings.siteKey, Ze("https://www.google.com/recaptcha/enterprise.js?render=".concat(t), function () {
              return window.grecaptcha.enterprise;
            });
          case 4:
            _context2.t2 = _context2.sent;
            _context2.t3 = e.captchaSettings.siteKey;
            _context2.t0 = {
              configured: _context2.t1,
              captchaClient: _context2.t2,
              siteKey: _context2.t3
            };
            _context2.next = 10;
            break;
          case 9:
            _context2.t0 = {
              configured: !1
            };
          case 10:
            return _context2.abrupt("return", _context2.t0);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
  });
});
var qt = /*#__PURE__*/function () {
  function qt(e) {
    var _this3 = this;
    _classCallCheck(this, qt);
    this.iframeURL = e, this.oneTapStart = function (e) {
      return _this3.call("oneTapStart", e);
    }, this.oneTapSubmit = function (e) {
      return _this3.call("oneTapSubmit", e);
    }, this.parsedPhoneNumber = function (e) {
      return _this3.call("parsedPhoneNumber", e);
    };
  }
  _createClass(qt, [{
    key: "frameClient",
    get: function get() {
      var e;
      return this._frameClient = null !== (e = this._frameClient) && void 0 !== e ? e : new Ht(this.iframeURL), this._frameClient;
    }
  }, {
    key: "call",
    value: function call(e, t) {
      return this.frameClient.call(e, [t]);
    }
  }]);
  return qt;
}();
var Yt = /*#__PURE__*/function (_ht) {
  _inherits(Yt, _ht);
  function Yt(e, t, n, r, o, i) {
    var _this4;
    _classCallCheck(this, Yt);
    _this4 = _callSuper(this, Yt, [e, t, n, r, o]), _this4._oneTap = i, _this4.startOneTap = function (e) {
      return Kt(_assertThisInitialized(_this4), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var t, n, r;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this._oneTap.createOneTapClient();
            case 2:
              t = _context3.sent;
              if (t.success) {
                _context3.next = 5;
                break;
              }
              throw new Error("One Tap could not load: ".concat(t.reason));
            case 5:
              n = t.client, r = this._oneTap.createOnSuccessHandler({
                signupRedirectUrl: e.signup_redirect_url,
                loginRedirectUrl: e.login_redirect_url,
                onSuccess: this._oneTap.RedirectOnSuccess
              });
              return _context3.abrupt("return", n.render({
                style: {
                  position: m.floating
                },
                onOneTapCancelled: e.onOneTapCancelled,
                callback: r
              }));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }, _this4.googleOneTap = {
      start: _this4.startOneTap
    };
    return _this4;
  }
  return _createClass(Yt);
}(ht);
var Jt = /*#__PURE__*/function () {
  function Jt(e, t, n, r) {
    _classCallCheck(this, Jt);
    this._publicToken = e, this._subscriptionDataLayer = t, this.baseURL = n, this.additionalTelemetryDataFn = r, this.updateSessionToken = function () {
      return null;
    }, this.eventLogger = new st({
      maxBatchSize: 15,
      intervalDurationMs: 800,
      logEventURL: this.buildSDKUrl("/events")
    });
  }
  _createClass(Jt, [{
    key: "logEvent",
    value: function logEvent(_ref) {
      var e = _ref.name,
        t = _ref.details,
        _ref$error = _ref.error,
        n = _ref$error === void 0 ? {} : _ref$error;
      this.eventLogger.logEvent(this.createTelemetryBlob(), {
        public_token: this._publicToken,
        event_name: e,
        details: t,
        error_code: n.error_code,
        error_description: n.error_description,
        http_status_code: n.http_status_code
      });
    }
  }, {
    key: "createTelemetryBlob",
    value: function createTelemetryBlob() {
      return Object.assign(Object.assign({
        event_id: "event-id-".concat($e()),
        app_session_id: "app-session-id-".concat($e()),
        persistent_id: "persistent-id-".concat($e()),
        client_sent_at: new Date().toISOString(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }, this.additionalTelemetryDataFn()), {
        app: {
          identifier: window.location.hostname
        },
        sdk: {
          identifier: "Stytch.js Javascript SDK",
          version: "4.12.0"
        }
      });
    }
  }, {
    key: "fetchSDK",
    value: function fetchSDK(_ref2) {
      var e = _ref2.url,
        t = _ref2.body,
        n = _ref2.errorMessage,
        r = _ref2.method;
      return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var o, i, a, s;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              o = this._subscriptionDataLayer.readSessionCookie().session_token, i = "Basic " + window.btoa(this._publicToken + ":" + (o || this._publicToken)), a = window.btoa(JSON.stringify(this.createTelemetryBlob())), s = window.location.origin;
              return _context4.abrupt("return", Fe({
                basicAuthHeader: i,
                body: t,
                errorMessage: n,
                finalURL: this.buildSDKUrl(e),
                method: r,
                xSDKClientHeader: a,
                xSDKParentHostHeader: s
              }));
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "retriableFetchSDK",
    value: function retriableFetchSDK(_ref3) {
      var e = _ref3.url,
        t = _ref3.body,
        n = _ref3.errorMessage,
        r = _ref3.method,
        o = _ref3.retryCallback;
      return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var i, a, s, c;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              i = this._subscriptionDataLayer.readSessionCookie().session_token, a = "Basic " + window.btoa(this._publicToken + ":" + (i || this._publicToken)), s = window.btoa(JSON.stringify(this.createTelemetryBlob())), c = window.location.origin;
              return _context5.abrupt("return", function (e) {
                var t = e.method,
                  n = e.errorMessage,
                  r = e.finalURL,
                  o = e.basicAuthHeader,
                  i = e.xSDKClientHeader,
                  a = e.xSDKParentHostHeader,
                  s = e.body,
                  c = e.retryCallback;
                return Me(this, void 0, void 0, _e().mark(function e() {
                  var l;
                  return _e().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return l = {
                          method: t,
                          errorMessage: n,
                          finalURL: r,
                          basicAuthHeader: o,
                          xSDKClientHeader: i,
                          xSDKParentHostHeader: a,
                          body: s
                        }, e.prev = 1, e.next = 4, Fe(l);
                      case 4:
                      case 15:
                        return e.abrupt("return", e.sent);
                      case 7:
                        if (e.prev = 7, e.t0 = e["catch"](1), !(e.t0 instanceof De)) {
                          e.next = 16;
                          break;
                        }
                        return e.next = 12, c(e.t0, l);
                      case 12:
                        return l = e.sent, e.next = 15, Fe(l);
                      case 16:
                        throw e.t0;
                      case 17:
                      case "end":
                        return e.stop();
                    }
                  }, e, null, [[1, 7]]);
                }));
              }({
                basicAuthHeader: a,
                body: t,
                errorMessage: n,
                finalURL: this.buildSDKUrl(e),
                method: r,
                xSDKClientHeader: s,
                xSDKParentHostHeader: c,
                retryCallback: o
              }));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "buildSDKUrl",
    value: function buildSDKUrl(e) {
      return "".concat(this.baseURL, "/sdk/v1").concat(e);
    }
  }]);
  return Jt;
}();
var Xt = "undefined" != typeof window && "IdentityCredential" in window,
  Qt = function Qt(e) {
    return e === m.forceLegacyEmbedded ? "force" : e === m.embeddedOnly || e === m.embedded || e === m.floatingOrEmbedded;
  },
  en = function en(e) {
    var t = Qt(e);
    return "force" === t || t && !Xt;
  };
var tn = /*#__PURE__*/function () {
  function tn(e, t) {
    _classCallCheck(this, tn);
    this._googleClient = e, this._clientId = t;
  }
  _createClass(tn, [{
    key: "cancel",
    value: function cancel() {
      this._googleClient.cancel();
    }
  }, {
    key: "render",
    value: function render(_ref4) {
      var e = _ref4.callback,
        t = _ref4.onOneTapCancelled,
        n = _ref4.style;
      return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this5 = this;
        var r, o, i;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              r = Qt(n.position), o = en(n.position), i = {
                client_id: this._clientId,
                callback: e,
                auto_select: !1,
                context: "use",
                itp_support: !0,
                use_fedcm_for_prompt: "force" !== r
              };
              return _context6.abrupt("return", (o && (i.prompt_parent_id = "google-parent-prompt", i.cancel_on_tap_outside = !1), this._googleClient.initialize(i), new Promise(function (e) {
                _this5._googleClient.prompt(function (n) {
                  var r, i, a, s, c;
                  if (n.isSkippedMoment()) {
                    var _o2 = null !== (i = null === (r = n.getSkippedReason) || void 0 === r ? void 0 : r.call(n)) && void 0 !== i ? i : "unknown_reason";
                    return "user_cancel" === _o2 && (null == t || t()), e({
                      success: !1,
                      reason: _o2
                    });
                  }
                  return !n.isNotDisplayed && o || (null === (a = n.isNotDisplayed) || void 0 === a ? void 0 : a.call(n)) ? e({
                    success: !1,
                    reason: null !== (c = null === (s = n.getNotDisplayedReason) || void 0 === s ? void 0 : s.call(n)) && void 0 !== c ? c : "unknown_reason"
                  }) : n.isDismissedMoment() ? void 0 : (_this5.styleFrame(o), e({
                    success: !0
                  }));
                });
              })));
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "styleFrame",
    value: function styleFrame(e) {
      e && Array.from(document.getElementsByTagName("iframe")).forEach(function (e) {
        e.src.includes(Le) && (e.style.width = "100%");
      });
    }
  }]);
  return tn;
}();
var nn = /*#__PURE__*/function () {
  function nn(e, t) {
    var _this6 = this;
    _classCallCheck(this, nn);
    this._publicToken = e, this.clientsideServices = t, this.createOnSuccessHandler = function (_ref5) {
      var e = _ref5.loginRedirectUrl,
        t = _ref5.signupRedirectUrl,
        n = _ref5.onSuccess;
      return function (r) {
        return Kt(_this6, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
          var o, _yield$this$submitGoo, i;
          return _regeneratorRuntime().wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                o = r.credential;
                _context7.next = 3;
                return this.submitGoogleOneTapToken({
                  credential: o,
                  loginRedirectUrl: e,
                  signupRedirectUrl: t
                });
              case 3:
                _yield$this$submitGoo = _context7.sent;
                i = _yield$this$submitGoo.redirect_url;
                n(i);
              case 6:
              case "end":
                return _context7.stop();
            }
          }, _callee7, this);
        }));
      };
    }, this.RedirectOnSuccess = function (e) {
      window.location.href = e;
    };
  }
  _createClass(nn, [{
    key: "createOneTapClient",
    value: function createOneTapClient() {
      return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var e, _yield$this$fetchGoog;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return this.fetchGoogleStart();
            case 3:
              _yield$this$fetchGoog = _context8.sent;
              e = _yield$this$fetchGoog.googleClientId;
              _context8.next = 10;
              break;
            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](0);
              return _context8.abrupt("return", {
                success: !1,
                reason: _context8.t0.error_type
              });
            case 10:
              if (!("" === e)) {
                _context8.next = 12;
                break;
              }
              return _context8.abrupt("return", {
                success: !1,
                reason: "oauth_config_not_found"
              });
            case 12:
              _context8.t1 = !0;
              _context8.t2 = tn;
              _context8.next = 16;
              return Ze(Ae, function () {
                return window.google.accounts.id;
              });
            case 16:
              _context8.t3 = _context8.sent;
              _context8.t4 = e;
              _context8.t5 = new _context8.t2(_context8.t3, _context8.t4);
              return _context8.abrupt("return", {
                success: _context8.t1,
                client: _context8.t5
              });
            case 20:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 7]]);
      }));
    }
  }, {
    key: "fetchGoogleStart",
    value: function fetchGoogleStart() {
      return this.googleConfig || (this.googleConfig = this.clientsideServices.oneTapStart({
        publicToken: this._publicToken
      })), this.googleConfig;
    }
  }, {
    key: "submitGoogleOneTapToken",
    value: function submitGoogleOneTapToken(_ref6) {
      var e = _ref6.credential,
        t = _ref6.loginRedirectUrl,
        n = _ref6.signupRedirectUrl;
      return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _yield$this$fetchGoog2, r;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.fetchGoogleStart();
            case 2:
              _yield$this$fetchGoog2 = _context9.sent;
              r = _yield$this$fetchGoog2.oauthCallbackId;
              return _context9.abrupt("return", this.clientsideServices.oneTapSubmit({
                publicToken: this._publicToken,
                idToken: e,
                loginRedirectURL: t,
                oauthCallbackID: r,
                signupRedirectURL: n
              }));
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
    }
  }], [{
    key: "WillGoogleOneTapShowBannerForUA",
    value: function WillGoogleOneTapShowBannerForUA(e) {
      var t = function t(e, _t2) {
          return -1 !== e.indexOf(_t2);
        },
        n = t(e, "iPad") || t(e, "Android") && !t(e, "Mobile") || t(e, "Silk"),
        r = t(e, "iPod") || t(e, "iPhone") || t(e, "Android") || t(e, "IEMobile");
      return !n && r;
    }
  }, {
    key: "WillGoogleOneTapShowEmbedded",
    value: function WillGoogleOneTapShowEmbedded() {
      return !nn.WillGoogleOneTapShowBannerForUA(navigator.userAgent);
    }
  }]);
  return nn;
}();
function rn(e) {
  var t = e.toString(16);
  return 1 === t.length && (t = "0" + t), t;
}
var on = /*#__PURE__*/function () {
  function on(e, t) {
    _classCallCheck(this, on);
    this._dataLayer = e, this.namespace = t;
  }
  _createClass(on, [{
    key: "key",
    value: function key() {
      return "PKCE_VERIFIER:" + this.namespace;
    }
  }, {
    key: "startPKCETransaction",
    value: function startPKCETransaction() {
      return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var e;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return on.createProofkeyPair();
            case 2:
              e = _context10.sent;
              return _context10.abrupt("return", (this._dataLayer.setItem(this.key(), JSON.stringify(e)), e));
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "getPKPair",
    value: function getPKPair() {
      var e = this._dataLayer.getItem(this.key());
      if (null !== e) try {
        return JSON.parse(e);
      } catch (e) {
        return void qe("Found malformed Proof Key pair in localstorage.");
      }
    }
  }, {
    key: "clearPKPair",
    value: function clearPKPair() {
      return this._dataLayer.removeItem(this.key());
    }
  }], [{
    key: "createProofkeyPair",
    value: function createProofkeyPair() {
      return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _String$fromCharCode;
        var e, t, n, r;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              e = new Uint32Array(16);
              window.crypto.getRandomValues(e);
              t = Array.from(e).map(rn).join("");
              _context11.next = 5;
              return window.crypto.subtle.digest("SHA-256", new TextEncoder().encode(t));
            case 5:
              n = _context11.sent;
              return _context11.abrupt("return", {
                code_challenge: (r = n, btoa((_String$fromCharCode = String.fromCharCode).call.apply(_String$fromCharCode, [null].concat(_toConsumableArray(new Uint8Array(r))))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "")),
                code_verifier: t
              });
            case 7:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }));
    }
  }]);
  return on;
}();
var an = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
  sn = function sn(e) {
    return {
      signup_magic_link_url: e.signupRedirectURL,
      signup_expiration_minutes: e.signupExpirationMinutes,
      login_magic_link_url: e.loginRedirectURL,
      login_expiration_minutes: e.loginExpirationMinutes,
      login_template_id: e.loginTemplateId,
      signup_template_id: e.signupTemplateId
    };
  },
  cn = function cn(e, t) {
    return {
      email: e,
      login_redirect_url: t.loginRedirectURL,
      login_expiration_minutes: t.loginExpirationMinutes,
      reset_password_redirect_url: t.resetPasswordRedirectURL,
      reset_password_expiration_minutes: t.resetPasswordExpirationMinutes,
      reset_password_template_id: t.resetPasswordTemplateId
    };
  },
  ln = function ln(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var n;
    return function () {
      for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
        r[_key] = arguments[_key];
      }
      clearTimeout(n), n = setTimeout(function () {
        return e.apply(void 0, r);
      }, t);
    };
  },
  un = function un(e) {
    return (document.cookie ? document.cookie.split("; ") : []).filter(function (t) {
      var _t$split = t.split("="),
        _t$split2 = _slicedToArray(_t$split, 1),
        n = _t$split2[0];
      return e === n;
    }).length > 1;
  };
/*! js-cookie v3.0.1 | MIT */
function dn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n) e[r] = n[r];
  }
  return e;
}
var pn = function e(t, n) {
  function r(e, r, o) {
    if ("undefined" != typeof document) {
      "number" == typeof (o = dn({}, n, o)).expires && (o.expires = new Date(Date.now() + 864e5 * o.expires)), o.expires && (o.expires = o.expires.toUTCString()), e = encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var i = "";
      for (var a in o) o[a] && (i += "; " + a, !0 !== o[a] && (i += "=" + o[a].split(";")[0]));
      return document.cookie = e + "=" + t.write(r, e) + i;
    }
  }
  return Object.create({
    set: r,
    get: function get(e) {
      if ("undefined" != typeof document && (!arguments.length || e)) {
        for (var n = document.cookie ? document.cookie.split("; ") : [], r = {}, o = 0; o < n.length; o++) {
          var i = n[o].split("="),
            a = i.slice(1).join("=");
          try {
            var s = decodeURIComponent(i[0]);
            if (r[s] = t.read(a, s), e === s) break;
          } catch (e) {}
        }
        return e ? r[e] : r;
      }
    },
    remove: function remove(e, t) {
      r(e, "", dn({}, t, {
        expires: -1
      }));
    },
    withAttributes: function withAttributes(t) {
      return e(this.converter, dn({}, this.attributes, t));
    },
    withConverter: function withConverter(t) {
      return e(dn({}, this.converter, t), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(n)
    },
    converter: {
      value: Object.freeze(t)
    }
  });
}({
  read: function read(e) {
    return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function write(e) {
    return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
}, {
  path: "/"
});
var hn = function hn(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return "stytch_sdk_state_".concat(e).concat(t ? "::".concat(t) : "");
  },
  fn = new Map(),
  mn = function mn(e) {
    clearTimeout(fn.get(e));
  },
  gn = function gn(e, t, n) {
    mn(e);
    var r = setTimeout(function () {
      void 0 === pn.get(e) && pn.set(e, t, n);
    }, 10);
    return fn.set(e, r), pn.set(e, t, n);
  };
var _n = /*#__PURE__*/function () {
  function _n(e, t) {
    var _this7 = this;
    _classCallCheck(this, _n);
    this.browserSessionStorage = {
      getItem: function getItem(e) {
        return sessionStorage.getItem(hn(_this7.publicToken, e));
      },
      setItem: function setItem(e, t) {
        return sessionStorage.setItem(hn(_this7.publicToken, e), t);
      },
      removeItem: function removeItem(e) {
        return sessionStorage.removeItem(hn(_this7.publicToken, e));
      }
    }, this.publicToken = e, this.state = null, this.stateKeysUpdated = new Set(), this.subscriptions = {}, (null == t ? void 0 : t.cookieOptions) ? (tt("SubscriptionDataLayer").isOptionalString("cookieOptions.opaqueTokenCookieName", t.cookieOptions.opaqueTokenCookieName).isOptionalString("cookieOptions.jwtCookieName", t.cookieOptions.jwtCookieName).isOptionalString("cookieOptions.istCookieName", t.cookieOptions.istCookieName).isOptionalString("cookieOptions.path", t.cookieOptions.path).isOptionalString("cookieOptions.domain", t.cookieOptions.domain), this._jwtCookieName = t.cookieOptions.jwtCookieName || null, this._opaqueTokenCookieName = t.cookieOptions.opaqueTokenCookieName || null, this._cookiePath = t.cookieOptions.path || null, this._domain = t.cookieOptions.domain || null, this._cookieAvailableToSubdomains = t.cookieOptions.availableToSubdomains || !1, this._istCookieName = t.cookieOptions.istCookieName || null) : (this._opaqueTokenCookieName = null, this._jwtCookieName = null, this._cookiePath = null, this._domain = null, this._cookieAvailableToSubdomains = !1, this._istCookieName = null);
    var n = localStorage.getItem(hn(this.publicToken));
    if (!n) return;
    var r;
    try {
      r = JSON.parse(n);
    } catch (e) {
      return void this.syncToLocalStorage();
    }
    this.state = r;
  }
  _createClass(_n, [{
    key: "opaqueTokenCookieName",
    get: function get() {
      var e;
      return null !== (e = this._opaqueTokenCookieName) && void 0 !== e ? e : "stytch_session";
    }
  }, {
    key: "jwtCookieName",
    get: function get() {
      var e;
      return null !== (e = this._jwtCookieName) && void 0 !== e ? e : "stytch_session_jwt";
    }
  }, {
    key: "istCookieName",
    get: function get() {
      var e;
      return null !== (e = this._istCookieName) && void 0 !== e ? e : "stytch_intermediate_session_token";
    }
  }, {
    key: "readSessionCookie",
    value: function readSessionCookie() {
      return {
        session_token: pn.get(this.opaqueTokenCookieName),
        session_jwt: pn.get(this.jwtCookieName)
      };
    }
  }, {
    key: "readIntermediateSessionTokenCookie",
    value: function readIntermediateSessionTokenCookie() {
      return pn.get(this.istCookieName);
    }
  }, {
    key: "writeSessionCookie",
    value: function writeSessionCookie(e) {
      var t, n, r, o;
      var i = e.state,
        a = e.session_token,
        s = e.session_jwt,
        c = _n.generateCookieOpts({
          expiresAt: null !== (n = null === (t = null == i ? void 0 : i.session) || void 0 === t ? void 0 : t.expires_at) && void 0 !== n ? n : "",
          availableToSubdomains: this._cookieAvailableToSubdomains,
          path: this._cookiePath,
          domain: this._domain
        });
      gn(this.opaqueTokenCookieName, a, c), gn(this.jwtCookieName, s, c);
      var l = _n.generateCookieOpts({
        expiresAt: null !== (o = null === (r = null == i ? void 0 : i.session) || void 0 === r ? void 0 : r.expires_at) && void 0 !== o ? o : "",
        availableToSubdomains: !this._cookieAvailableToSubdomains,
        path: this._cookiePath,
        domain: this._domain
      });
      un(this.jwtCookieName) && pn.remove(this.jwtCookieName, l), un(this.opaqueTokenCookieName) && pn.remove(this.opaqueTokenCookieName, l), un(this.jwtCookieName) && qe("Could not remove extraneous JWT cookie. This might happen if the cookie has been set using multiple `path` settings, and may produce unwanted behavior."), un(this.opaqueTokenCookieName) && qe("Could not remove extraneous opaque token cookie.");
    }
  }, {
    key: "writeIntermediateSessionTokenCookie",
    value: function writeIntermediateSessionTokenCookie(e) {
      var t = new Date(Date.now() + 6e5),
        n = _n.generateCookieOpts({
          expiresAt: t.toString(),
          availableToSubdomains: this._cookieAvailableToSubdomains,
          path: this._cookiePath,
          domain: this._domain
        });
      gn(this.istCookieName, e, n);
    }
  }, {
    key: "removeSessionCookie",
    value: function removeSessionCookie() {
      this.removeCookies([this.opaqueTokenCookieName, this.jwtCookieName]);
    }
  }, {
    key: "removeISTCookie",
    value: function removeISTCookie() {
      this.removeCookies([this.istCookieName]);
    }
  }, {
    key: "removeCookies",
    value: function removeCookies(e) {
      var _this8 = this;
      [!0, !1].forEach(function (t) {
        [_this8._cookiePath, null].forEach(function (n) {
          [_this8._domain, null].forEach(function (r) {
            var o = _n.generateCookieOpts({
              expiresAt: new Date(0).toString(),
              availableToSubdomains: t,
              path: n,
              domain: r
            });
            e.forEach(function (e) {
              pn.remove(e, o);
            });
          });
        });
      }), e.forEach(mn);
    }
  }, {
    key: "syncToLocalStorage",
    value: function syncToLocalStorage() {
      localStorage.setItem(hn(this.publicToken), JSON.stringify(this.state));
    }
  }, {
    key: "getItem",
    value: function getItem(e) {
      return localStorage.getItem(hn(this.publicToken, e));
    }
  }, {
    key: "setItem",
    value: function setItem(e, t) {
      return localStorage.setItem(hn(this.publicToken, e), t);
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      return localStorage.removeItem(hn(this.publicToken, e));
    }
  }], [{
    key: "generateCookieOpts",
    value: function generateCookieOpts(_ref7) {
      var e = _ref7.path,
        t = _ref7.domain,
        n = _ref7.availableToSubdomains,
        r = _ref7.expiresAt;
      var o = {
        expires: new Date(r),
        sameSite: "lax"
      };
      return e && (o.path = e), Boolean("localhost" === window.location.hostname || "[::1]" === window.location.hostname || window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) ? o.secure = !1 : (n && (o.domain = t || window.location.host), o.secure = !0), o;
    }
  }]);
  return _n;
}();
var vn = /*#__PURE__*/function (_n3) {
  _inherits(vn, _n3);
  function vn() {
    _classCallCheck(this, vn);
    return _callSuper(this, vn, arguments);
  }
  return _createClass(vn);
}(_n);
var yn = Symbol["for"]("__stytch_DataLayer"),
  Cn = function Cn(e, t) {
    var n = function () {
      var e = window;
      return e[yn] || (e[yn] = {}), e[yn];
    }();
    return n[e] || (n[e] = new vn(e, t)), n[e];
  },
  bn = function bn(e, t) {
    Object.values(e).forEach(function (e) {
      return e(t);
    });
  },
  wn = function () {
    var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref8$KEYS_TO_EXCLUDE = _ref8.KEYS_TO_EXCLUDE,
      e = _ref8$KEYS_TO_EXCLUDE === void 0 ? [] : _ref8$KEYS_TO_EXCLUDE;
    var t = function t(n, r) {
      return _typeof(n) == _typeof(r) && (null === n || null === r ? n === r : "object" == _typeof(n) ? Object.keys(n).length === Object.keys(r).length && !Object.keys(n).some(function (e) {
        return !(e in r);
      }) && Object.entries(n).filter(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 1),
          t = _ref10[0];
        return !e.includes(t);
      }).every(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
          e = _ref12[0],
          n = _ref12[1];
        return t(n, r[e]);
      }) : n === r);
    };
    return t;
  }({
    KEYS_TO_EXCLUDE: ["last_accessed_at"]
  });
var kn = /*#__PURE__*/function () {
  function kn(e, t) {
    var _this9 = this;
    _classCallCheck(this, kn);
    this._publicToken = e, this._datalayer = t, this.fromCache = !0, this._listen = function (e) {
      if (e.key !== hn(_this9._publicToken)) return;
      var t = null === e.newValue || "null" === e.newValue ? null : JSON.parse(e.newValue);
      _this9.updateState(t, !0);
    }, window.addEventListener("storage", this._listen);
    var _this$_datalayer$read = this._datalayer.readSessionCookie(),
      n = _this$_datalayer$read.session_token;
    n || this.destroySession();
  }
  _createClass(kn, [{
    key: "getTokens",
    value: function getTokens() {
      var _this$_datalayer$read2 = this._datalayer.readSessionCookie(),
        e = _this$_datalayer$read2.session_token,
        t = _this$_datalayer$read2.session_jwt;
      return "string" != typeof e || "string" != typeof t ? null : {
        session_token: e,
        session_jwt: t
      };
    }
  }, {
    key: "getIntermediateSessionToken",
    value: function getIntermediateSessionToken() {
      return this._datalayer.readIntermediateSessionTokenCookie() || null;
    }
  }, {
    key: "destroyState",
    value: function destroyState() {
      this.updateStateAndTokens({
        state: null,
        session_token: null,
        session_jwt: null,
        intermediate_session_token: null
      });
    }
  }, {
    key: "destroySession",
    value: function destroySession() {
      this._datalayer.removeSessionCookie(), this.updateState(null);
    }
  }, {
    key: "_updateStateAndTokensInternal",
    value: function _updateStateAndTokensInternal(e) {
      var t = this._datalayer.state,
        n = null === e.state ? null : Object.assign(Object.assign({}, this._datalayer.state), e.state);
      this._datalayer.state = n;
      var r = this.getFromCache();
      this.setCacheRefreshed(), !r && wn(t, n) || bn(this._datalayer.subscriptions, n);
    }
  }, {
    key: "updateStateAndTokens",
    value: function updateStateAndTokens(e) {
      e.state ? (this._datalayer.writeSessionCookie(e), this._datalayer.removeISTCookie()) : e.intermediate_session_token ? (this._datalayer.writeIntermediateSessionTokenCookie(e.intermediate_session_token), this._datalayer.removeSessionCookie()) : (this._datalayer.removeSessionCookie(), this._datalayer.removeISTCookie()), this._updateStateAndTokensInternal(e), this._datalayer.syncToLocalStorage();
    }
  }, {
    key: "updateState",
    value: function updateState(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var n = this._datalayer.state,
        r = null === e ? null : Object.assign(Object.assign({}, this._datalayer.state), e);
      this._datalayer.state = r;
      var o = this.getFromCache();
      this.setCacheRefreshed();
      var i = !wn(n, r);
      (o || i) && (bn(this._datalayer.subscriptions, r), i && !t && this._datalayer.syncToLocalStorage());
    }
  }, {
    key: "updateTokens",
    value: function updateTokens(e) {
      var t = e.session_token,
        n = e.session_jwt,
        r = this._datalayer.readSessionCookie(),
        o = Object.assign(Object.assign({}, r), {
          session_token: t,
          session_jwt: n
        });
      t || n ? (this._datalayer.writeSessionCookie(o), this._datalayer.removeISTCookie()) : this._datalayer.removeSessionCookie();
    }
  }, {
    key: "subscribeToState",
    value: function subscribeToState(e) {
      return function (e, t) {
        var n = Math.random().toString(36).slice(-10);
        return e[n] = t, function () {
          return delete e[n];
        };
      }(this._datalayer.subscriptions, e);
    }
  }, {
    key: "getState",
    value: function getState() {
      return this._datalayer.state;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("storage", this._listen);
    }
  }, {
    key: "syncFromDeviceStorage",
    value: function syncFromDeviceStorage() {
      return null;
    }
  }, {
    key: "getFromCache",
    value: function getFromCache() {
      return this.fromCache;
    }
  }, {
    key: "setCacheRefreshed",
    value: function setCacheRefreshed() {
      this.fromCache = !1;
    }
  }]);
  return kn;
}();
var En = /*#__PURE__*/function (_kn) {
  _inherits(En, _kn);
  function En() {
    var _this10;
    _classCallCheck(this, En);
    _this10 = _callSuper(this, En, arguments), _this10.updateUser = function (e) {
      return _this10.updateState({
        user: e
      });
    }, _this10.getUser = function () {
      var e, t;
      return null !== (t = null === (e = _this10.getState()) || void 0 === e ? void 0 : e.user) && void 0 !== t ? t : null;
    }, _this10.getSession = function () {
      var e, t;
      return null !== (t = null === (e = _this10.getState()) || void 0 === e ? void 0 : e.session) && void 0 !== t ? t : null;
    };
    return _this10;
  }
  return _createClass(En);
}(kn);
var Sn = Symbol["for"]("stytch__internal_b2c"),
  xn = function xn(e) {
    var t = e;
    if (!t[Sn]) throw Error("Internals not found!");
    return t[Sn];
  };
var On = /*#__PURE__*/_createClass(function On(e, t) {
  var _this11 = this;
  _classCallCheck(this, On);
  var n;
  Xe("StytchHeadlessClient"), "string" != typeof (n = e) ? qe("Public token is malformed. Expected a string, got ".concat(ge(n), ".").concat(Je)) : "" === n ? qe('Public token is malformed. Expected "public-token-...", got an empty string.'.concat(Je)) : n.startsWith("public-token-") || qe('Public token is malformed. Expected "public-token-...", got '.concat(n, ".").concat(Je));
  var r = t,
    o = function (e) {
      var t, n, r, o, i, a, s, c, l, u;
      return {
        cookieOptions: null == e ? void 0 : e.cookieOptions,
        endpoints: {
          sdkBackendURL: null !== (n = null === (t = null == e ? void 0 : e.endpoints) || void 0 === t ? void 0 : t.sdkBackendURL) && void 0 !== n ? n : "https://web.stytch.com",
          testAPIURL: null !== (o = null === (r = null == e ? void 0 : e.endpoints) || void 0 === r ? void 0 : r.testAPIURL) && void 0 !== o ? o : "https://test.stytch.com",
          liveAPIURL: null !== (a = null === (i = null == e ? void 0 : e.endpoints) || void 0 === i ? void 0 : i.liveAPIURL) && void 0 !== a ? a : "https://api.stytch.com",
          dfpBackendURL: null !== (c = null === (s = null == e ? void 0 : e.endpoints) || void 0 === s ? void 0 : s.dfpBackendURL) && void 0 !== c ? c : "https://telemetry.stytch.com",
          clientsideServicesIframeURL: null !== (u = null === (l = null == e ? void 0 : e.endpoints) || void 0 === l ? void 0 : l.clientsideServicesIframeURL) && void 0 !== u ? u : "https://js.stytch.com/clientside-services/index.html"
        }
      };
    }(r);
  this._dataLayer = Cn(e, r), this._subscriptionService = new En(e, this._dataLayer), this._stateChangeClient = new Vt(this._subscriptionService, {}), this.onStateChange = function () {
    var _this11$_stateChangeC;
    return (_this11$_stateChangeC = _this11._stateChangeClient).onStateChange.apply(_this11$_stateChangeC, arguments);
  };
  var i = new on(this._dataLayer, "passwords");
  this._networkClient = new Jt(e, this._dataLayer, o.endpoints.sdkBackendURL, function () {
    var e, t, n, r;
    return {
      stytch_user_id: null === (t = null === (e = _this11._dataLayer.state) || void 0 === e ? void 0 : e.user) || void 0 === t ? void 0 : t.user_id,
      stytch_session_id: null === (r = null === (n = _this11._dataLayer.state) || void 0 === n ? void 0 : n.session) || void 0 === r ? void 0 : r.session_id
    };
  });
  var a = new zt(e, this._networkClient, this._dataLayer),
    s = new Gt(a.getAsync()),
    c = new ot(e, o.endpoints.dfpBackendURL, a.getAsync(), s.executeRecaptcha),
    l = new qt(o.endpoints.clientsideServicesIframeURL),
    u = new nn(e, l),
    d = new Ut(this._networkClient, c);
  var p, h;
  this.user = new ct(this._networkClient, this._subscriptionService), this.session = new lt(this._networkClient, this._subscriptionService), this.magicLinks = new dt(this._networkClient, this._subscriptionService, new on(this._dataLayer, "magic_links"), i, a.getAsync(), c), this.otps = new pt(this._networkClient, this._subscriptionService, s.executeRecaptcha, c), this.oauth = new Yt(this._networkClient, this._subscriptionService, new on(this._dataLayer, "oauth"), a.getAsync(), {
    publicToken: e,
    testAPIURL: o.endpoints.testAPIURL,
    liveAPIURL: o.endpoints.liveAPIURL
  }, u), this.cryptoWallets = new ft(this._networkClient, this._subscriptionService, s.executeRecaptcha, c), this.totps = new mt(this._networkClient, this._subscriptionService, c), this.webauthn = new It(this._networkClient, this._subscriptionService, c), this.passwords = new Nt(this._networkClient, this._subscriptionService, i, a.getAsync(), c), this._sessionManager = new $t(this._subscriptionService, this.session), this._dataLayer.readSessionCookie().session_token && this._sessionManager.performBackgroundRefresh(), this._networkClient.logEvent({
    name: "sdk_instance_instantiated",
    details: {
      event_callback_registered: !1,
      error_callback_registered: !1,
      success_callback_registered: !1
    }
  }), p = this, h = {
    bootstrap: a,
    clientsideServices: l,
    captcha: s,
    oneTap: u,
    searchManager: d,
    publicToken: e,
    dataLayer: this._dataLayer,
    networkClient: this._networkClient
  }, Object.assign(p, _defineProperty({}, Sn, h));
});
var Ln,
  An,
  Tn,
  Pn,
  Mn,
  Rn,
  Dn,
  Fn,
  jn = {},
  In = [],
  Bn = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
  Nn = Array.isArray;
function Hn(e, t) {
  for (var n in t) e[n] = t[n];
  return e;
}
function Un(e) {
  var t = e.parentNode;
  t && t.removeChild(e);
}
function $n(e, t, n) {
  var r,
    o,
    i,
    a = {};
  for (i in t) "key" == i ? r = t[i] : "ref" == i ? o = t[i] : a[i] = t[i];
  if (arguments.length > 2 && (a.children = arguments.length > 3 ? Ln.call(arguments, 2) : n), "function" == typeof e && null != e.defaultProps) for (i in e.defaultProps) void 0 === a[i] && (a[i] = e.defaultProps[i]);
  return Vn(e, a, r, o, null);
}
function Vn(e, t, n, r, o) {
  var i = {
    type: e,
    props: t,
    key: n,
    ref: r,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    constructor: void 0,
    __v: null == o ? ++Tn : o,
    __i: -1,
    __u: 0
  };
  return null == o && null != An.vnode && An.vnode(i), i;
}
function Zn() {
  return {
    current: null
  };
}
function zn(e) {
  return e.children;
}
function Wn(e, t) {
  this.props = e, this.context = t;
}
function Kn(e, t) {
  if (null == t) return e.__ ? Kn(e.__, e.__i + 1) : null;
  for (var n; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
  return "function" == typeof e.type ? Kn(e) : null;
}
function Gn(e) {
  var t, n;
  if (null != (e = e.__) && null != e.__c) {
    for (e.__e = e.__c.base = null, t = 0; t < e.__k.length; t++) if (null != (n = e.__k[t]) && null != n.__e) {
      e.__e = e.__c.base = n.__e;
      break;
    }
    return Gn(e);
  }
}
function qn(e) {
  (!e.__d && (e.__d = !0) && Pn.push(e) && !Yn.__r++ || Mn !== An.debounceRendering) && ((Mn = An.debounceRendering) || Rn)(Yn);
}
function Yn() {
  var e, t, n, r, o, i, a, s, c;
  for (Pn.sort(Dn); e = Pn.shift();) e.__d && (t = Pn.length, r = void 0, i = (o = (n = e).__v).__e, s = [], c = [], (a = n.__P) && ((r = Hn({}, o)).__v = o.__v + 1, An.vnode && An.vnode(r), ir(a, r, o, n.__n, void 0 !== a.ownerSVGElement, 32 & o.__u ? [i] : null, s, null == i ? Kn(o) : i, !!(32 & o.__u), c), r.__.__k[r.__i] = r, ar(s, r, c), r.__e != i && Gn(r)), Pn.length > t && Pn.sort(Dn));
  Yn.__r = 0;
}
function Jn(e, t, n, r, o, i, a, s, c, l, u) {
  var d,
    p,
    h,
    f,
    m,
    g = r && r.__k || In,
    _ = t.length;
  for (n.__d = c, function (e, t, n) {
    var r,
      o,
      i,
      a,
      s,
      c = t.length,
      l = n.length,
      u = l,
      d = 0;
    for (e.__k = [], r = 0; r < c; r++) null != (o = e.__k[r] = null == (o = t[r]) || "boolean" == typeof o || "function" == typeof o ? null : "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? Vn(null, o, null, null, o) : Nn(o) ? Vn(zn, {
      children: o
    }, null, null, null) : o.__b > 0 ? Vn(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o) ? (o.__ = e, o.__b = e.__b + 1, s = er(o, n, a = r + d, u), o.__i = s, i = null, -1 !== s && (u--, (i = n[s]) && (i.__u |= 131072)), null == i || null === i.__v ? (-1 == s && d--, "function" != typeof o.type && (o.__u |= 65536)) : s !== a && (s === a + 1 ? d++ : s > a ? u > c - a ? d += s - a : d-- : d = s < a && s == a - 1 ? s - a : 0, s !== r + d && (o.__u |= 65536))) : (i = n[r]) && null == i.key && i.__e && (i.__e == e.__d && (e.__d = Kn(i)), cr(i, i, !1), n[r] = null, u--);
    if (u) for (r = 0; r < l; r++) null != (i = n[r]) && 0 == (131072 & i.__u) && (i.__e == e.__d && (e.__d = Kn(i)), cr(i, i));
  }(n, t, g), c = n.__d, d = 0; d < _; d++) null != (h = n.__k[d]) && "boolean" != typeof h && "function" != typeof h && (p = -1 === h.__i ? jn : g[h.__i] || jn, h.__i = d, ir(e, h, p, o, i, a, s, c, l, u), f = h.__e, h.ref && p.ref != h.ref && (p.ref && sr(p.ref, null, h), u.push(h.ref, h.__c || f, h)), null == m && null != f && (m = f), 65536 & h.__u || p.__k === h.__k ? c = Xn(h, c, e) : "function" == typeof h.type && void 0 !== h.__d ? c = h.__d : f && (c = f.nextSibling), h.__d = void 0, h.__u &= -196609);
  n.__d = c, n.__e = m;
}
function Xn(e, t, n) {
  var r, o;
  if ("function" == typeof e.type) {
    for (r = e.__k, o = 0; r && o < r.length; o++) r[o] && (r[o].__ = e, t = Xn(r[o], t, n));
    return t;
  }
  return e.__e != t && (n.insertBefore(e.__e, t || null), t = e.__e), t && t.nextSibling;
}
function Qn(e, t) {
  return t = t || [], null == e || "boolean" == typeof e || (Nn(e) ? e.some(function (e) {
    Qn(e, t);
  }) : t.push(e)), t;
}
function er(e, t, n, r) {
  var o = e.key,
    i = e.type,
    a = n - 1,
    s = n + 1,
    c = t[n];
  if (null === c || c && o == c.key && i === c.type) return n;
  if (r > (null != c && 0 == (131072 & c.__u) ? 1 : 0)) for (; a >= 0 || s < t.length;) {
    if (a >= 0) {
      if ((c = t[a]) && 0 == (131072 & c.__u) && o == c.key && i === c.type) return a;
      a--;
    }
    if (s < t.length) {
      if ((c = t[s]) && 0 == (131072 & c.__u) && o == c.key && i === c.type) return s;
      s++;
    }
  }
  return -1;
}
function tr(e, t, n) {
  "-" === t[0] ? e.setProperty(t, null == n ? "" : n) : e[t] = null == n ? "" : "number" != typeof n || Bn.test(t) ? n : n + "px";
}
function nr(e, t, n, r, o) {
  var i;
  e: if ("style" === t) {
    if ("string" == typeof n) e.style.cssText = n;else {
      if ("string" == typeof r && (e.style.cssText = r = ""), r) for (t in r) n && t in n || tr(e.style, t, "");
      if (n) for (t in n) r && n[t] === r[t] || tr(e.style, t, n[t]);
    }
  } else if ("o" === t[0] && "n" === t[1]) i = t !== (t = t.replace(/(PointerCapture)$|Capture$/, "$1")), t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + i] = n, n ? r ? n.u = r.u : (n.u = Date.now(), e.addEventListener(t, i ? or : rr, i)) : e.removeEventListener(t, i ? or : rr, i);else {
    if (o) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");else if ("width" !== t && "height" !== t && "href" !== t && "list" !== t && "form" !== t && "tabIndex" !== t && "download" !== t && "rowSpan" !== t && "colSpan" !== t && "role" !== t && t in e) try {
      e[t] = null == n ? "" : n;
      break e;
    } catch (e) {}
    "function" == typeof n || (null == n || !1 === n && "-" !== t[4] ? e.removeAttribute(t) : e.setAttribute(t, n));
  }
}
function rr(e) {
  var t = this.l[e.type + !1];
  if (e.t) {
    if (e.t <= t.u) return;
  } else e.t = Date.now();
  return t(An.event ? An.event(e) : e);
}
function or(e) {
  return this.l[e.type + !0](An.event ? An.event(e) : e);
}
function ir(e, t, n, r, o, i, a, s, c, l) {
  var u,
    d,
    p,
    h,
    f,
    m,
    g,
    _,
    v,
    y,
    C,
    b,
    w,
    k,
    E,
    S = t.type;
  if (void 0 !== t.constructor) return null;
  128 & n.__u && (c = !!(32 & n.__u), i = [s = t.__e = n.__e]), (u = An.__b) && u(t);
  e: if ("function" == typeof S) try {
    if (_ = t.props, v = (u = S.contextType) && r[u.__c], y = u ? v ? v.props.value : u.__ : r, n.__c ? g = (d = t.__c = n.__c).__ = d.__E : ("prototype" in S && S.prototype.render ? t.__c = d = new S(_, y) : (t.__c = d = new Wn(_, y), d.constructor = S, d.render = lr), v && v.sub(d), d.props = _, d.state || (d.state = {}), d.context = y, d.__n = r, p = d.__d = !0, d.__h = [], d._sb = []), null == d.__s && (d.__s = d.state), null != S.getDerivedStateFromProps && (d.__s == d.state && (d.__s = Hn({}, d.__s)), Hn(d.__s, S.getDerivedStateFromProps(_, d.__s))), h = d.props, f = d.state, d.__v = t, p) null == S.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);else {
      if (null == S.getDerivedStateFromProps && _ !== h && null != d.componentWillReceiveProps && d.componentWillReceiveProps(_, y), !d.__e && (null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(_, d.__s, y) || t.__v === n.__v)) {
        for (t.__v !== n.__v && (d.props = _, d.state = d.__s, d.__d = !1), t.__e = n.__e, t.__k = n.__k, t.__k.forEach(function (e) {
          e && (e.__ = t);
        }), C = 0; C < d._sb.length; C++) d.__h.push(d._sb[C]);
        d._sb = [], d.__h.length && a.push(d);
        break e;
      }
      null != d.componentWillUpdate && d.componentWillUpdate(_, d.__s, y), null != d.componentDidUpdate && d.__h.push(function () {
        d.componentDidUpdate(h, f, m);
      });
    }
    if (d.context = y, d.props = _, d.__P = e, d.__e = !1, b = An.__r, w = 0, "prototype" in S && S.prototype.render) {
      for (d.state = d.__s, d.__d = !1, b && b(t), u = d.render(d.props, d.state, d.context), k = 0; k < d._sb.length; k++) d.__h.push(d._sb[k]);
      d._sb = [];
    } else do {
      d.__d = !1, b && b(t), u = d.render(d.props, d.state, d.context), d.state = d.__s;
    } while (d.__d && ++w < 25);
    d.state = d.__s, null != d.getChildContext && (r = Hn(Hn({}, r), d.getChildContext())), p || null == d.getSnapshotBeforeUpdate || (m = d.getSnapshotBeforeUpdate(h, f)), Jn(e, Nn(E = null != u && u.type === zn && null == u.key ? u.props.children : u) ? E : [E], t, n, r, o, i, a, s, c, l), d.base = t.__e, t.__u &= -161, d.__h.length && a.push(d), g && (d.__E = d.__ = null);
  } catch (e) {
    t.__v = null, c || null != i ? (t.__e = s, t.__u |= c ? 160 : 32, i[i.indexOf(s)] = null) : (t.__e = n.__e, t.__k = n.__k), An.__e(e, t, n);
  } else null == i && t.__v === n.__v ? (t.__k = n.__k, t.__e = n.__e) : t.__e = function (e, t, n, r, o, i, a, s, c) {
    var l,
      u,
      d,
      p,
      h,
      f,
      m,
      g = n.props,
      _ = t.props,
      v = t.type;
    if ("svg" === v && (o = !0), null != i) for (l = 0; l < i.length; l++) if ((h = i[l]) && "setAttribute" in h == !!v && (v ? h.localName === v : 3 === h.nodeType)) {
      e = h, i[l] = null;
      break;
    }
    if (null == e) {
      if (null === v) return document.createTextNode(_);
      e = o ? document.createElementNS("http://www.w3.org/2000/svg", v) : document.createElement(v, _.is && _), i = null, s = !1;
    }
    if (null === v) g === _ || s && e.data === _ || (e.data = _);else {
      if (i = i && Ln.call(e.childNodes), g = n.props || jn, !s && null != i) for (g = {}, l = 0; l < e.attributes.length; l++) g[(h = e.attributes[l]).name] = h.value;
      for (l in g) h = g[l], "children" == l || ("dangerouslySetInnerHTML" == l ? d = h : "key" === l || l in _ || nr(e, l, null, h, o));
      for (l in _) h = _[l], "children" == l ? p = h : "dangerouslySetInnerHTML" == l ? u = h : "value" == l ? f = h : "checked" == l ? m = h : "key" === l || s && "function" != typeof h || g[l] === h || nr(e, l, h, g[l], o);
      if (u) s || d && (u.__html === d.__html || u.__html === e.innerHTML) || (e.innerHTML = u.__html), t.__k = [];else if (d && (e.innerHTML = ""), Jn(e, Nn(p) ? p : [p], t, n, r, o && "foreignObject" !== v, i, a, i ? i[0] : n.__k && Kn(n, 0), s, c), null != i) for (l = i.length; l--;) null != i[l] && Un(i[l]);
      s || (l = "value", void 0 !== f && (f !== e[l] || "progress" === v && !f || "option" === v && f !== g[l]) && nr(e, l, f, g[l], !1), l = "checked", void 0 !== m && m !== e[l] && nr(e, l, m, g[l], !1));
    }
    return e;
  }(n.__e, t, n, r, o, i, a, c, l);
  (u = An.diffed) && u(t);
}
function ar(e, t, n) {
  t.__d = void 0;
  for (var r = 0; r < n.length; r++) sr(n[r], n[++r], n[++r]);
  An.__c && An.__c(t, e), e.some(function (t) {
    try {
      e = t.__h, t.__h = [], e.some(function (e) {
        e.call(t);
      });
    } catch (e) {
      An.__e(e, t.__v);
    }
  });
}
function sr(e, t, n) {
  try {
    "function" == typeof e ? e(t) : e.current = t;
  } catch (e) {
    An.__e(e, n);
  }
}
function cr(e, t, n) {
  var r, o;
  if (An.unmount && An.unmount(e), (r = e.ref) && (r.current && r.current !== e.__e || sr(r, null, t)), null != (r = e.__c)) {
    if (r.componentWillUnmount) try {
      r.componentWillUnmount();
    } catch (e) {
      An.__e(e, t);
    }
    r.base = r.__P = null, e.__c = void 0;
  }
  if (r = e.__k) for (o = 0; o < r.length; o++) r[o] && cr(r[o], t, n || "function" != typeof e.type);
  n || null == e.__e || Un(e.__e), e.__ = e.__e = e.__d = void 0;
}
function lr(e, t, n) {
  return this.constructor(e, n);
}
function ur(e, t, n) {
  var r, o, i, a;
  An.__ && An.__(e, t), o = (r = "function" == typeof n) ? null : n && n.__k || t.__k, i = [], a = [], ir(t, e = (!r && n || t).__k = $n(zn, null, [e]), o || jn, jn, void 0 !== t.ownerSVGElement, !r && n ? [n] : o ? null : t.firstChild ? Ln.call(t.childNodes) : null, i, !r && n ? n : o ? o.__e : t.firstChild, r, a), ar(i, e, a);
}
function dr(e, t) {
  ur(e, t, dr);
}
function pr(e, t, n) {
  var r,
    o,
    i,
    a,
    s = Hn({}, e.props);
  for (i in e.type && e.type.defaultProps && (a = e.type.defaultProps), t) "key" == i ? r = t[i] : "ref" == i ? o = t[i] : s[i] = void 0 === t[i] && void 0 !== a ? a[i] : t[i];
  return arguments.length > 2 && (s.children = arguments.length > 3 ? Ln.call(arguments, 2) : n), Vn(e.type, s, r || e.key, o || e.ref, null);
}
function hr(e, t) {
  var n = {
    __c: t = "__cC" + Fn++,
    __: e,
    Consumer: function Consumer(e, t) {
      return e.children(t);
    },
    Provider: function Provider(e) {
      var n, r;
      return this.getChildContext || (n = [], (r = {})[t] = this, this.getChildContext = function () {
        return r;
      }, this.shouldComponentUpdate = function (e) {
        this.props.value !== e.value && n.some(function (e) {
          e.__e = !0, qn(e);
        });
      }, this.sub = function (e) {
        n.push(e);
        var t = e.componentWillUnmount;
        e.componentWillUnmount = function () {
          n.splice(n.indexOf(e), 1), t && t.call(e);
        };
      }), e.children;
    }
  };
  return n.Provider.__ = n.Consumer.contextType = n;
}
Ln = In.slice, An = {
  __e: function __e(e, t, n, r) {
    for (var o, i, a; t = t.__;) if ((o = t.__c) && !o.__) try {
      if ((i = o.constructor) && null != i.getDerivedStateFromError && (o.setState(i.getDerivedStateFromError(e)), a = o.__d), null != o.componentDidCatch && (o.componentDidCatch(e, r || {}), a = o.__d), a) return o.__E = o;
    } catch (t) {
      e = t;
    }
    throw e;
  }
}, Tn = 0, Wn.prototype.setState = function (e, t) {
  var n;
  n = null != this.__s && this.__s !== this.state ? this.__s : this.__s = Hn({}, this.state), "function" == typeof e && (e = e(Hn({}, n), this.props)), e && Hn(n, e), null != e && this.__v && (t && this._sb.push(t), qn(this));
}, Wn.prototype.forceUpdate = function (e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), qn(this));
}, Wn.prototype.render = zn, Pn = [], Rn = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Dn = function Dn(e, t) {
  return e.__v.__b - t.__v.__b;
}, Yn.__r = 0, Fn = 0;
var fr,
  mr,
  gr,
  _r,
  vr = 0,
  yr = [],
  Cr = [],
  br = An.__b,
  wr = An.__r,
  kr = An.diffed,
  Er = An.__c,
  Sr = An.unmount;
function xr(e, t) {
  An.__h && An.__h(mr, e, vr || t), vr = 0;
  var n = mr.__H || (mr.__H = {
    __: [],
    __h: []
  });
  return e >= n.__.length && n.__.push({
    __V: Cr
  }), n.__[e];
}
function Or(e) {
  return vr = 1, Lr(Zr, e);
}
function Lr(e, t, n) {
  var r = xr(fr++, 2);
  if (r.t = e, !r.__c && (r.__ = [n ? n(t) : Zr(void 0, t), function (e) {
    var t = r.__N ? r.__N[0] : r.__[0],
      n = r.t(t, e);
    t !== n && (r.__N = [n, r.__[1]], r.__c.setState({}));
  }], r.__c = mr, !mr.u)) {
    var o = function o(e, t, n) {
      if (!r.__c.__H) return !0;
      var o = r.__c.__H.__.filter(function (e) {
        return e.__c;
      });
      if (o.every(function (e) {
        return !e.__N;
      })) return !i || i.call(this, e, t, n);
      var a = !1;
      return o.forEach(function (e) {
        if (e.__N) {
          var t = e.__[0];
          e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (a = !0);
        }
      }), !(!a && r.__c.props === e) && (!i || i.call(this, e, t, n));
    };
    mr.u = !0;
    var i = mr.shouldComponentUpdate,
      a = mr.componentWillUpdate;
    mr.componentWillUpdate = function (e, t, n) {
      if (this.__e) {
        var r = i;
        i = void 0, o(e, t, n), i = r;
      }
      a && a.call(this, e, t, n);
    }, mr.shouldComponentUpdate = o;
  }
  return r.__N || r.__;
}
function Ar(e, t) {
  var n = xr(fr++, 3);
  !An.__s && Vr(n.__H, t) && (n.__ = e, n.i = t, mr.__H.__h.push(n));
}
function Tr(e, t) {
  var n = xr(fr++, 4);
  !An.__s && Vr(n.__H, t) && (n.__ = e, n.i = t, mr.__h.push(n));
}
function Pr(e) {
  return vr = 5, Rr(function () {
    return {
      current: e
    };
  }, []);
}
function Mr(e, t, n) {
  vr = 6, Tr(function () {
    return "function" == typeof e ? (e(t()), function () {
      return e(null);
    }) : e ? (e.current = t(), function () {
      return e.current = null;
    }) : void 0;
  }, null == n ? n : n.concat(e));
}
function Rr(e, t) {
  var n = xr(fr++, 7);
  return Vr(n.__H, t) ? (n.__V = e(), n.i = t, n.__h = e, n.__V) : n.__;
}
function Dr(e, t) {
  return vr = 8, Rr(function () {
    return e;
  }, t);
}
function Fr(e) {
  var t = mr.context[e.__c],
    n = xr(fr++, 9);
  return n.c = e, t ? (null == n.__ && (n.__ = !0, t.sub(mr)), t.props.value) : e.__;
}
function jr(e, t) {
  An.useDebugValue && An.useDebugValue(t ? t(e) : e);
}
function Ir() {
  var e = xr(fr++, 11);
  if (!e.__) {
    for (var t = mr.__v; null !== t && !t.__m && null !== t.__;) t = t.__;
    var n = t.__m || (t.__m = [0, 0]);
    e.__ = "P" + n[0] + "-" + n[1]++;
  }
  return e.__;
}
function Br() {
  for (var e; e = yr.shift();) if (e.__P && e.__H) try {
    e.__H.__h.forEach(Ur), e.__H.__h.forEach($r), e.__H.__h = [];
  } catch (t) {
    e.__H.__h = [], An.__e(t, e.__v);
  }
}
An.__b = function (e) {
  mr = null, br && br(e);
}, An.__r = function (e) {
  wr && wr(e), fr = 0;
  var t = (mr = e.__c).__H;
  t && (gr === mr ? (t.__h = [], mr.__h = [], t.__.forEach(function (e) {
    e.__N && (e.__ = e.__N), e.__V = Cr, e.__N = e.i = void 0;
  })) : (t.__h.forEach(Ur), t.__h.forEach($r), t.__h = [], fr = 0)), gr = mr;
}, An.diffed = function (e) {
  kr && kr(e);
  var t = e.__c;
  t && t.__H && (t.__H.__h.length && (1 !== yr.push(t) && _r === An.requestAnimationFrame || ((_r = An.requestAnimationFrame) || Hr)(Br)), t.__H.__.forEach(function (e) {
    e.i && (e.__H = e.i), e.__V !== Cr && (e.__ = e.__V), e.i = void 0, e.__V = Cr;
  })), gr = mr = null;
}, An.__c = function (e, t) {
  t.some(function (e) {
    try {
      e.__h.forEach(Ur), e.__h = e.__h.filter(function (e) {
        return !e.__ || $r(e);
      });
    } catch (n) {
      t.some(function (e) {
        e.__h && (e.__h = []);
      }), t = [], An.__e(n, e.__v);
    }
  }), Er && Er(e, t);
}, An.unmount = function (e) {
  Sr && Sr(e);
  var t,
    n = e.__c;
  n && n.__H && (n.__H.__.forEach(function (e) {
    try {
      Ur(e);
    } catch (e) {
      t = e;
    }
  }), n.__H = void 0, t && An.__e(t, n.__v));
};
var Nr = "function" == typeof requestAnimationFrame;
function Hr(e) {
  var t,
    n = function n() {
      clearTimeout(r), Nr && cancelAnimationFrame(t), setTimeout(e);
    },
    r = setTimeout(n, 100);
  Nr && (t = requestAnimationFrame(n));
}
function Ur(e) {
  var t = mr,
    n = e.__c;
  "function" == typeof n && (e.__c = void 0, n()), mr = t;
}
function $r(e) {
  var t = mr;
  e.__c = e.__(), mr = t;
}
function Vr(e, t) {
  return !e || e.length !== t.length || t.some(function (t, n) {
    return t !== e[n];
  });
}
function Zr(e, t) {
  return "function" == typeof t ? t(e) : t;
}
function zr(e, t) {
  for (var n in t) e[n] = t[n];
  return e;
}
function Wr(e, t) {
  for (var n in e) if ("__source" !== n && !(n in t)) return !0;
  for (var r in t) if ("__source" !== r && e[r] !== t[r]) return !0;
  return !1;
}
function Kr(e) {
  this.props = e;
}
function Gr(e, t) {
  function n(e) {
    var n = this.props.ref,
      r = n == e.ref;
    return !r && n && (n.call ? n(null) : n.current = null), t ? !t(this.props, e) || !r : Wr(this.props, e);
  }
  function r(t) {
    return this.shouldComponentUpdate = n, $n(e, t);
  }
  return r.displayName = "Memo(" + (e.displayName || e.name) + ")", r.prototype.isReactComponent = !0, r.__f = !0, r;
}
(Kr.prototype = new Wn()).isPureReactComponent = !0, Kr.prototype.shouldComponentUpdate = function (e, t) {
  return Wr(this.props, e) || Wr(this.state, t);
};
var qr = An.__b;
An.__b = function (e) {
  e.type && e.type.__f && e.ref && (e.props.ref = e.ref, e.ref = null), qr && qr(e);
};
var Yr = "undefined" != typeof Symbol && Symbol["for"] && Symbol["for"]("react.forward_ref") || 3911;
function Jr(e) {
  function t(t) {
    var n = zr({}, t);
    return delete n.ref, e(n, t.ref || null);
  }
  return t.$$typeof = Yr, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (e.displayName || e.name) + ")", t;
}
var Xr = function Xr(e, t) {
    return null == e ? null : Qn(Qn(e).map(t));
  },
  Qr = {
    map: Xr,
    forEach: Xr,
    count: function count(e) {
      return e ? Qn(e).length : 0;
    },
    only: function only(e) {
      var t = Qn(e);
      if (1 !== t.length) throw "Children.only";
      return t[0];
    },
    toArray: Qn
  },
  eo = An.__e;
An.__e = function (e, t, n, r) {
  if (e.then) for (var o, i = t; i = i.__;) if ((o = i.__c) && o.__c) return null == t.__e && (t.__e = n.__e, t.__k = n.__k), o.__c(e, t);
  eo(e, t, n, r);
};
var to = An.unmount;
function no(e, t, n) {
  return e && (e.__c && e.__c.__H && (e.__c.__H.__.forEach(function (e) {
    "function" == typeof e.__c && e.__c();
  }), e.__c.__H = null), null != (e = zr({}, e)).__c && (e.__c.__P === n && (e.__c.__P = t), e.__c = null), e.__k = e.__k && e.__k.map(function (e) {
    return no(e, t, n);
  })), e;
}
function ro(e, t, n) {
  return e && n && (e.__v = null, e.__k = e.__k && e.__k.map(function (e) {
    return ro(e, t, n);
  }), e.__c && e.__c.__P === t && (e.__e && n.appendChild(e.__e), e.__c.__e = !0, e.__c.__P = n)), e;
}
function oo() {
  this.__u = 0, this.t = null, this.__b = null;
}
function io(e) {
  var t = e.__.__c;
  return t && t.__a && t.__a(e);
}
function ao(e) {
  var t, n, r;
  function o(o) {
    if (t || (t = e()).then(function (e) {
      n = e["default"] || e;
    }, function (e) {
      r = e;
    }), r) throw r;
    if (!n) throw t;
    return $n(n, o);
  }
  return o.displayName = "Lazy", o.__f = !0, o;
}
function so() {
  this.u = null, this.o = null;
}
An.unmount = function (e) {
  var t = e.__c;
  t && t.__R && t.__R(), t && 32 & e.__u && (e.type = null), to && to(e);
}, (oo.prototype = new Wn()).__c = function (e, t) {
  var n = t.__c,
    r = this;
  null == r.t && (r.t = []), r.t.push(n);
  var o = io(r.__v),
    i = !1,
    a = function a() {
      i || (i = !0, n.__R = null, o ? o(s) : s());
    };
  n.__R = a;
  var s = function s() {
    if (! --r.__u) {
      if (r.state.__a) {
        var e = r.state.__a;
        r.__v.__k[0] = ro(e, e.__c.__P, e.__c.__O);
      }
      var t;
      for (r.setState({
        __a: r.__b = null
      }); t = r.t.pop();) t.forceUpdate();
    }
  };
  r.__u++ || 32 & t.__u || r.setState({
    __a: r.__b = r.__v.__k[0]
  }), e.then(a, a);
}, oo.prototype.componentWillUnmount = function () {
  this.t = [];
}, oo.prototype.render = function (e, t) {
  if (this.__b) {
    if (this.__v.__k) {
      var n = document.createElement("div"),
        r = this.__v.__k[0].__c;
      this.__v.__k[0] = no(this.__b, n, r.__O = r.__P);
    }
    this.__b = null;
  }
  var o = t.__a && $n(zn, null, e.fallback);
  return o && (o.__u &= -33), [$n(zn, null, t.__a ? null : e.children), o];
};
var co = function co(e, t, n) {
  if (++n[1] === n[0] && e.o["delete"](t), e.props.revealOrder && ("t" !== e.props.revealOrder[0] || !e.o.size)) for (n = e.u; n;) {
    for (; n.length > 3;) n.pop()();
    if (n[1] < n[0]) break;
    e.u = n = n[2];
  }
};
function lo(e) {
  return this.getChildContext = function () {
    return e.context;
  }, e.children;
}
function uo(e) {
  var t = this,
    n = e.i;
  t.componentWillUnmount = function () {
    ur(null, t.l), t.l = null, t.i = null;
  }, t.i && t.i !== n && t.componentWillUnmount(), t.l || (t.i = n, t.l = {
    nodeType: 1,
    parentNode: n,
    childNodes: [],
    appendChild: function appendChild(e) {
      this.childNodes.push(e), t.i.appendChild(e);
    },
    insertBefore: function insertBefore(e, n) {
      this.childNodes.push(e), t.i.appendChild(e);
    },
    removeChild: function removeChild(e) {
      this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1), t.i.removeChild(e);
    }
  }), ur($n(lo, {
    context: t.context
  }, e.__v), t.l);
}
function po(e, t) {
  var n = $n(uo, {
    __v: e,
    i: t
  });
  return n.containerInfo = t, n;
}
(so.prototype = new Wn()).__a = function (e) {
  var t = this,
    n = io(t.__v),
    r = t.o.get(e);
  return r[0]++, function (o) {
    var i = function i() {
      t.props.revealOrder ? (r.push(o), co(t, e, r)) : o();
    };
    n ? n(i) : i();
  };
}, so.prototype.render = function (e) {
  this.u = null, this.o = new Map();
  var t = Qn(e.children);
  e.revealOrder && "b" === e.revealOrder[0] && t.reverse();
  for (var n = t.length; n--;) this.o.set(t[n], this.u = [1, 0, this.u]);
  return e.children;
}, so.prototype.componentDidUpdate = so.prototype.componentDidMount = function () {
  var e = this;
  this.o.forEach(function (t, n) {
    co(e, n, t);
  });
};
var ho = "undefined" != typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103,
  fo = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/,
  mo = /^on(Ani|Tra|Tou|BeforeInp|Compo)/,
  go = /[A-Z0-9]/g,
  _o = "undefined" != typeof document,
  vo = function vo(e) {
    return ("undefined" != typeof Symbol && "symbol" == _typeof(Symbol()) ? /fil|che|rad/ : /fil|che|ra/).test(e);
  };
function yo(e, t, n) {
  return null == t.__k && (t.textContent = ""), ur(e, t), "function" == typeof n && n(), e ? e.__c : null;
}
function Co(e, t, n) {
  return dr(e, t), "function" == typeof n && n(), e ? e.__c : null;
}
Wn.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function (e) {
  Object.defineProperty(Wn.prototype, e, {
    configurable: !0,
    get: function get() {
      return this["UNSAFE_" + e];
    },
    set: function set(t) {
      Object.defineProperty(this, e, {
        configurable: !0,
        writable: !0,
        value: t
      });
    }
  });
});
var bo = An.event;
function wo() {}
function ko() {
  return this.cancelBubble;
}
function Eo() {
  return this.defaultPrevented;
}
An.event = function (e) {
  return bo && (e = bo(e)), e.persist = wo, e.isPropagationStopped = ko, e.isDefaultPrevented = Eo, e.nativeEvent = e;
};
var So,
  xo = {
    enumerable: !1,
    configurable: !0,
    get: function get() {
      return this["class"];
    }
  },
  Oo = An.vnode;
An.vnode = function (e) {
  "string" == typeof e.type && function (e) {
    var t = e.props,
      n = e.type,
      r = {};
    for (var o in t) {
      var i = t[o];
      if (!("value" === o && "defaultValue" in t && null == i || _o && "children" === o && "noscript" === n || "class" === o || "className" === o)) {
        var a = o.toLowerCase();
        "defaultValue" === o && "value" in t && null == t.value ? o = "value" : "download" === o && !0 === i ? i = "" : "ondoubleclick" === a ? o = "ondblclick" : "onchange" !== a || "input" !== n && "textarea" !== n || vo(t.type) ? "onfocus" === a ? o = "onfocusin" : "onblur" === a ? o = "onfocusout" : mo.test(o) ? o = a : -1 === n.indexOf("-") && fo.test(o) ? o = o.replace(go, "-$&").toLowerCase() : null === i && (i = void 0) : a = o = "oninput", "oninput" === a && r[o = a] && (o = "oninputCapture"), r[o] = i;
      }
    }
    "select" == n && r.multiple && Array.isArray(r.value) && (r.value = Qn(t.children).forEach(function (e) {
      e.props.selected = -1 != r.value.indexOf(e.props.value);
    })), "select" == n && null != r.defaultValue && (r.value = Qn(t.children).forEach(function (e) {
      e.props.selected = r.multiple ? -1 != r.defaultValue.indexOf(e.props.value) : r.defaultValue == e.props.value;
    })), t["class"] && !t.className ? (r["class"] = t["class"], Object.defineProperty(r, "className", xo)) : (t.className && !t["class"] || t["class"] && t.className) && (r["class"] = r.className = t.className), e.props = r;
  }(e), e.$$typeof = ho, Oo && Oo(e);
};
var Lo = An.__r;
An.__r = function (e) {
  Lo && Lo(e), So = e.__c;
};
var Ao = An.diffed;
An.diffed = function (e) {
  Ao && Ao(e);
  var t = e.props,
    n = e.__e;
  null != n && "textarea" === e.type && "value" in t && t.value !== n.value && (n.value = null == t.value ? "" : t.value), So = null;
};
var To = {
  ReactCurrentDispatcher: {
    current: {
      readContext: function readContext(e) {
        return So.__n[e.__c].props.value;
      }
    }
  }
};
function Po(e) {
  return $n.bind(null, e);
}
function Mo(e) {
  return !!e && e.$$typeof === ho;
}
function Ro(e) {
  return Mo(e) && e.type === zn;
}
function Do(e) {
  return Mo(e) ? pr.apply(null, arguments) : e;
}
function Fo(e) {
  return !!e.__k && (ur(null, e), !0);
}
function jo(e) {
  return e && (e.base || 1 === e.nodeType && e) || null;
}
var Io = function Io(e, t) {
    return e(t);
  },
  Bo = function Bo(e, t) {
    return e(t);
  },
  No = zn;
function Ho(e) {
  e();
}
function Uo(e) {
  return e;
}
function $o() {
  return [!1, Ho];
}
var Vo = Tr,
  Zo = Mo;
function zo(e, t) {
  var n = t(),
    r = Or({
      h: {
        __: n,
        v: t
      }
    }),
    o = r[0].h,
    i = r[1];
  return Tr(function () {
    o.__ = n, o.v = t, Wo(o) && i({
      h: o
    });
  }, [e, n, t]), Ar(function () {
    return Wo(o) && i({
      h: o
    }), e(function () {
      Wo(o) && i({
        h: o
      });
    });
  }, [e]), n;
}
function Wo(e) {
  var t,
    n,
    r = e.v,
    o = e.__;
  try {
    var i = r();
    return !((t = o) === (n = i) && (0 !== t || 1 / t == 1 / n) || t != t && n != n);
  } catch (e) {
    return !0;
  }
}
var Ko = {
    useState: Or,
    useId: Ir,
    useReducer: Lr,
    useEffect: Ar,
    useLayoutEffect: Tr,
    useInsertionEffect: Vo,
    useTransition: $o,
    useDeferredValue: Uo,
    useSyncExternalStore: zo,
    startTransition: Ho,
    useRef: Pr,
    useImperativeHandle: Mr,
    useMemo: Rr,
    useCallback: Dr,
    useContext: Fr,
    useDebugValue: jr,
    version: "17.0.2",
    Children: Qr,
    render: yo,
    hydrate: Co,
    unmountComponentAtNode: Fo,
    createPortal: po,
    createElement: $n,
    createContext: hr,
    createFactory: Po,
    cloneElement: Do,
    createRef: Zn,
    Fragment: zn,
    isValidElement: Mo,
    isElement: Zo,
    isFragment: Ro,
    findDOMNode: jo,
    Component: Wn,
    PureComponent: Kr,
    memo: Gr,
    forwardRef: Jr,
    flushSync: Bo,
    unstable_batchedUpdates: Io,
    StrictMode: No,
    Suspense: oo,
    SuspenseList: so,
    lazy: ao,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: To
  },
  Go = Object.freeze({
    __proto__: null,
    Children: Qr,
    PureComponent: Kr,
    StrictMode: No,
    Suspense: oo,
    SuspenseList: so,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: To,
    cloneElement: Do,
    createFactory: Po,
    createPortal: po,
    "default": Ko,
    findDOMNode: jo,
    flushSync: Bo,
    forwardRef: Jr,
    hydrate: Co,
    isElement: Zo,
    isFragment: Ro,
    isValidElement: Mo,
    lazy: ao,
    memo: Gr,
    render: yo,
    startTransition: Ho,
    unmountComponentAtNode: Fo,
    unstable_batchedUpdates: Io,
    useDeferredValue: Uo,
    useInsertionEffect: Vo,
    useSyncExternalStore: zo,
    useTransition: $o,
    version: "17.0.2",
    Component: Wn,
    Fragment: zn,
    createContext: hr,
    createElement: $n,
    createRef: Zn,
    useCallback: Dr,
    useContext: Fr,
    useDebugValue: jr,
    useEffect: Ar,
    useErrorBoundary: function useErrorBoundary(e) {
      var t = xr(fr++, 10),
        n = Or();
      return t.__ = e, mr.componentDidCatch || (mr.componentDidCatch = function (e, r) {
        t.__ && t.__(e, r), n[1](e);
      }), [n[0], function () {
        n[1](void 0);
      }];
    },
    useId: Ir,
    useImperativeHandle: Mr,
    useLayoutEffect: Tr,
    useMemo: Rr,
    useReducer: Lr,
    useRef: Pr,
    useState: Or
  }),
  qo = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function Yo(e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (n) {
    var r = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(t, n, r.get ? r : {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  }), t;
}
var Jo,
  Xo = {
    exports: {}
  },
  Qo = {},
  ei = Symbol["for"]("react.element"),
  ti = Symbol["for"]("react.portal"),
  ni = Symbol["for"]("react.fragment"),
  ri = Symbol["for"]("react.strict_mode"),
  oi = Symbol["for"]("react.profiler"),
  ii = Symbol["for"]("react.provider"),
  ai = Symbol["for"]("react.context"),
  si = Symbol["for"]("react.server_context"),
  ci = Symbol["for"]("react.forward_ref"),
  li = Symbol["for"]("react.suspense"),
  ui = Symbol["for"]("react.suspense_list"),
  di = Symbol["for"]("react.memo"),
  pi = Symbol["for"]("react.lazy"),
  hi = Symbol["for"]("react.offscreen");
function fi(e) {
  if ("object" == _typeof(e) && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case ei:
        switch (e = e.type) {
          case ni:
          case oi:
          case ri:
          case li:
          case ui:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case si:
              case ai:
              case ci:
              case pi:
              case di:
              case ii:
                return e;
              default:
                return t;
            }
        }
      case ti:
        return t;
    }
  }
}
Jo = Symbol["for"]("react.module.reference"), Qo.ContextConsumer = ai, Qo.ContextProvider = ii, Qo.Element = ei, Qo.ForwardRef = ci, Qo.Fragment = ni, Qo.Lazy = pi, Qo.Memo = di, Qo.Portal = ti, Qo.Profiler = oi, Qo.StrictMode = ri, Qo.Suspense = li, Qo.SuspenseList = ui, Qo.isAsyncMode = function () {
  return !1;
}, Qo.isConcurrentMode = function () {
  return !1;
}, Qo.isContextConsumer = function (e) {
  return fi(e) === ai;
}, Qo.isContextProvider = function (e) {
  return fi(e) === ii;
}, Qo.isElement = function (e) {
  return "object" == _typeof(e) && null !== e && e.$$typeof === ei;
}, Qo.isForwardRef = function (e) {
  return fi(e) === ci;
}, Qo.isFragment = function (e) {
  return fi(e) === ni;
}, Qo.isLazy = function (e) {
  return fi(e) === pi;
}, Qo.isMemo = function (e) {
  return fi(e) === di;
}, Qo.isPortal = function (e) {
  return fi(e) === ti;
}, Qo.isProfiler = function (e) {
  return fi(e) === oi;
}, Qo.isStrictMode = function (e) {
  return fi(e) === ri;
}, Qo.isSuspense = function (e) {
  return fi(e) === li;
}, Qo.isSuspenseList = function (e) {
  return fi(e) === ui;
}, Qo.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === ni || e === oi || e === ri || e === li || e === ui || e === hi || "object" == _typeof(e) && null !== e && (e.$$typeof === pi || e.$$typeof === di || e.$$typeof === ii || e.$$typeof === ai || e.$$typeof === ci || e.$$typeof === Jo || void 0 !== e.getModuleId);
}, Qo.typeOf = fi, Xo.exports = Qo;
var mi = function mi(e, t, n, r) {
  var o = n ? n.call(r, e, t) : void 0;
  if (void 0 !== o) return !!o;
  if (e === t) return !0;
  if ("object" != _typeof(e) || !e || "object" != _typeof(t) || !t) return !1;
  var i = Object.keys(e),
    a = Object.keys(t);
  if (i.length !== a.length) return !1;
  for (var s = Object.prototype.hasOwnProperty.bind(t), c = 0; c < i.length; c++) {
    var l = i[c];
    if (!s(l)) return !1;
    var u = e[l],
      d = t[l];
    if (!1 === (o = n ? n.call(r, u, d, l) : void 0) || void 0 === o && u !== d) return !1;
  }
  return !0;
};
function gi(e) {
  function t(e, r, c, l, p) {
    for (var h, f, m, g, C, w = 0, k = 0, E = 0, S = 0, x = 0, M = 0, D = m = h = 0, j = 0, I = 0, B = 0, N = 0, H = c.length, U = H - 1, $ = "", V = "", Z = "", z = ""; j < H;) {
      if (f = c.charCodeAt(j), j === U && 0 !== k + S + E + w && (0 !== k && (f = 47 === k ? 10 : 47), S = E = w = 0, H++, U++), 0 === k + S + E + w) {
        if (j === U && (0 < I && ($ = $.replace(d, "")), 0 < $.trim().length)) {
          switch (f) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              $ += c.charAt(j);
          }
          f = 59;
        }
        switch (f) {
          case 123:
            for (h = ($ = $.trim()).charCodeAt(0), m = 1, N = ++j; j < H;) {
              switch (f = c.charCodeAt(j)) {
                case 123:
                  m++;
                  break;
                case 125:
                  m--;
                  break;
                case 47:
                  switch (f = c.charCodeAt(j + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (D = j + 1; D < U; ++D) switch (c.charCodeAt(D)) {
                          case 47:
                            if (42 === f && 42 === c.charCodeAt(D - 1) && j + 2 !== D) {
                              j = D + 1;
                              break e;
                            }
                            break;
                          case 10:
                            if (47 === f) {
                              j = D + 1;
                              break e;
                            }
                        }
                        j = D;
                      }
                  }
                  break;
                case 91:
                  f++;
                case 40:
                  f++;
                case 34:
                case 39:
                  for (; j++ < U && c.charCodeAt(j) !== f;);
              }
              if (0 === m) break;
              j++;
            }
            if (m = c.substring(N, j), 0 === h && (h = ($ = $.replace(u, "").trim()).charCodeAt(0)), 64 === h) {
              switch (0 < I && ($ = $.replace(d, "")), f = $.charCodeAt(1)) {
                case 100:
                case 109:
                case 115:
                case 45:
                  I = r;
                  break;
                default:
                  I = P;
              }
              if (N = (m = t(r, I, m, f, p + 1)).length, 0 < R && (C = s(3, m, I = n(P, $, B), r, L, O, N, f, p, l), $ = I.join(""), void 0 !== C && 0 === (N = (m = C.trim()).length) && (f = 0, m = "")), 0 < N) switch (f) {
                case 115:
                  $ = $.replace(b, a);
                case 100:
                case 109:
                case 45:
                  m = $ + "{" + m + "}";
                  break;
                case 107:
                  m = ($ = $.replace(_, "$1 $2")) + "{" + m + "}", m = 1 === T || 2 === T && i("@" + m, 3) ? "@-webkit-" + m + "@" + m : "@" + m;
                  break;
                default:
                  m = $ + m, 112 === l && (V += m, m = "");
              } else m = "";
            } else m = t(r, n(r, $, B), m, l, p + 1);
            Z += m, m = B = I = D = h = 0, $ = "", f = c.charCodeAt(++j);
            break;
          case 125:
          case 59:
            if (1 < (N = ($ = (0 < I ? $.replace(d, "") : $).trim()).length)) switch (0 === D && (h = $.charCodeAt(0), 45 === h || 96 < h && 123 > h) && (N = ($ = $.replace(" ", ":")).length), 0 < R && void 0 !== (C = s(1, $, r, e, L, O, V.length, l, p, l)) && 0 === (N = ($ = C.trim()).length) && ($ = "\0\0"), h = $.charCodeAt(0), f = $.charCodeAt(1), h) {
              case 0:
                break;
              case 64:
                if (105 === f || 99 === f) {
                  z += $ + c.charAt(j);
                  break;
                }
              default:
                58 !== $.charCodeAt(N - 1) && (V += o($, h, f, $.charCodeAt(2)));
            }
            B = I = D = h = 0, $ = "", f = c.charCodeAt(++j);
        }
      }
      switch (f) {
        case 13:
        case 10:
          47 === k ? k = 0 : 0 === 1 + h && 107 !== l && 0 < $.length && (I = 1, $ += "\0"), 0 < R * F && s(0, $, r, e, L, O, V.length, l, p, l), O = 1, L++;
          break;
        case 59:
        case 125:
          if (0 === k + S + E + w) {
            O++;
            break;
          }
        default:
          switch (O++, g = c.charAt(j), f) {
            case 9:
            case 32:
              if (0 === S + w + k) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  g = "";
                  break;
                default:
                  32 !== f && (g = " ");
              }
              break;
            case 0:
              g = "\\0";
              break;
            case 12:
              g = "\\f";
              break;
            case 11:
              g = "\\v";
              break;
            case 38:
              0 === S + k + w && (I = B = 1, g = "\f" + g);
              break;
            case 108:
              if (0 === S + k + w + A && 0 < D) switch (j - D) {
                case 2:
                  112 === x && 58 === c.charCodeAt(j - 3) && (A = x);
                case 8:
                  111 === M && (A = M);
              }
              break;
            case 58:
              0 === S + k + w && (D = j);
              break;
            case 44:
              0 === k + E + S + w && (I = 1, g += "\r");
              break;
            case 34:
            case 39:
              0 === k && (S = S === f ? 0 : 0 === S ? f : S);
              break;
            case 91:
              0 === S + k + E && w++;
              break;
            case 93:
              0 === S + k + E && w--;
              break;
            case 41:
              0 === S + k + w && E--;
              break;
            case 40:
              if (0 === S + k + w) {
                if (0 === h) if (2 * x + 3 * M == 533) ;else h = 1;
                E++;
              }
              break;
            case 64:
              0 === k + E + S + w + D + m && (m = 1);
              break;
            case 42:
            case 47:
              if (!(0 < S + w + E)) switch (k) {
                case 0:
                  switch (2 * f + 3 * c.charCodeAt(j + 1)) {
                    case 235:
                      k = 47;
                      break;
                    case 220:
                      N = j, k = 42;
                  }
                  break;
                case 42:
                  47 === f && 42 === x && N + 2 !== j && (33 === c.charCodeAt(N + 2) && (V += c.substring(N, j + 1)), g = "", k = 0);
              }
          }
          0 === k && ($ += g);
      }
      M = x, x = f, j++;
    }
    if (0 < (N = V.length)) {
      if (I = r, 0 < R && void 0 !== (C = s(2, V, I, e, L, O, N, l, p, l)) && 0 === (V = C).length) return z + V + Z;
      if (V = I.join(",") + "{" + V + "}", 0 != T * A) {
        switch (2 !== T || i(V, 2) || (A = 0), A) {
          case 111:
            V = V.replace(y, ":-moz-$1") + V;
            break;
          case 112:
            V = V.replace(v, "::-webkit-input-$1") + V.replace(v, "::-moz-$1") + V.replace(v, ":-ms-input-$1") + V;
        }
        A = 0;
      }
    }
    return z + V + Z;
  }
  function n(e, t, n) {
    var o = t.trim().split(m);
    t = o;
    var i = o.length,
      a = e.length;
    switch (a) {
      case 0:
      case 1:
        var s = 0;
        for (e = 0 === a ? "" : e[0] + " "; s < i; ++s) t[s] = r(e, t[s], n).trim();
        break;
      default:
        var c = s = 0;
        for (t = []; s < i; ++s) for (var l = 0; l < a; ++l) t[c++] = r(e[l] + " ", o[s], n).trim();
    }
    return t;
  }
  function r(e, t, n) {
    var r = t.charCodeAt(0);
    switch (33 > r && (r = (t = t.trim()).charCodeAt(0)), r) {
      case 38:
        return t.replace(g, "$1" + e.trim());
      case 58:
        return e.trim() + t.replace(g, "$1" + e.trim());
      default:
        if (0 < 1 * n && 0 < t.indexOf("\f")) return t.replace(g, (58 === e.charCodeAt(0) ? "" : "$1") + e.trim());
    }
    return e + t;
  }
  function o(e, t, n, r) {
    var a = e + ";",
      s = 2 * t + 3 * n + 4 * r;
    if (944 === s) {
      e = a.indexOf(":", 9) + 1;
      var c = a.substring(e, a.length - 1).trim();
      return c = a.substring(0, e).trim() + c + ";", 1 === T || 2 === T && i(c, 1) ? "-webkit-" + c + c : c;
    }
    if (0 === T || 2 === T && !i(a, 1)) return a;
    switch (s) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4)) break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11)) return a.replace(x, "$1-webkit-$2") + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
          case 115:
            return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
          case 98:
            return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
        }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        return "-webkit-box-pack" + (c = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify")) + "-webkit-" + a + "-ms-flex-pack" + c + a;
      case 1005:
        return h.test(a) ? a.replace(p, ":-webkit-") + a.replace(p, ":-moz-") + a : a;
      case 1e3:
        switch (t = (c = a.substring(13).trim()).indexOf("-") + 1, c.charCodeAt(0) + c.charCodeAt(t)) {
          case 226:
            c = a.replace(C, "tb");
            break;
          case 232:
            c = a.replace(C, "tb-rl");
            break;
          case 220:
            c = a.replace(C, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + c + a;
      case 1017:
        if (-1 === a.indexOf("sticky", 9)) break;
      case 975:
        switch (t = (a = e).length - 10, s = (c = (33 === a.charCodeAt(t) ? a.substring(0, t) : a).substring(e.indexOf(":", 7) + 1).trim()).charCodeAt(0) + (0 | c.charCodeAt(7))) {
          case 203:
            if (111 > c.charCodeAt(8)) break;
          case 115:
            a = a.replace(c, "-webkit-" + c) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(c, "-webkit-" + (102 < s ? "inline-" : "") + "box") + ";" + a.replace(c, "-webkit-" + c) + ";" + a.replace(c, "-ms-" + c + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return c = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + c + "-ms-flex-" + c + a;
          case 115:
            return "-webkit-" + a + "-ms-flex-item-" + a.replace(k, "") + a;
          default:
            return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(k, "") + a;
        }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
      case 931:
      case 953:
        if (!0 === S.test(e)) return 115 === (c = e.substring(e.indexOf(":") + 1)).charCodeAt(0) ? o(e.replace("stretch", "fill-available"), t, n, r).replace(":fill-available", ":stretch") : a.replace(c, "-webkit-" + c) + a.replace(c, "-moz-" + c.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === n + r && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(f, "$1-webkit-$2") + a;
    }
    return a;
  }
  function i(e, t) {
    var n = e.indexOf(1 === t ? ":" : "{"),
      r = e.substring(0, 3 !== t ? n : 10);
    return n = e.substring(n + 1, e.length - 1), D(2 !== t ? r : r.replace(E, "$1"), n, t);
  }
  function a(e, t) {
    var n = o(t, t.charCodeAt(0), t.charCodeAt(1), t.charCodeAt(2));
    return n !== t + ";" ? n.replace(w, " or ($1)").substring(4) : "(" + t + ")";
  }
  function s(e, t, n, r, o, i, a, s, c, u) {
    for (var d, p = 0, h = t; p < R; ++p) switch (d = M[p].call(l, e, h, n, r, o, i, a, s, c, u)) {
      case void 0:
      case !1:
      case !0:
      case null:
        break;
      default:
        h = d;
    }
    if (h !== t) return h;
  }
  function c(e) {
    return void 0 !== (e = e.prefix) && (D = null, e ? "function" != typeof e ? T = 1 : (T = 2, D = e) : T = 0), c;
  }
  function l(e, n) {
    var r = e;
    if (33 > r.charCodeAt(0) && (r = r.trim()), r = [r], 0 < R) {
      var o = s(-1, n, r, r, L, O, 0, 0, 0, 0);
      void 0 !== o && "string" == typeof o && (n = o);
    }
    var i = t(P, r, n, 0, 0);
    return 0 < R && void 0 !== (o = s(-2, i, r, r, L, O, i.length, 0, 0, 0)) && (i = o), "", A = 0, O = L = 1, i;
  }
  var u = /^\0+/g,
    d = /[\0\r\f]/g,
    p = /: */g,
    h = /zoo|gra/,
    f = /([,: ])(transform)/g,
    m = /,\r+?/g,
    g = /([\t\r\n ])*\f?&/g,
    _ = /@(k\w+)\s*(\S*)\s*/,
    v = /::(place)/g,
    y = /:(read-only)/g,
    C = /[svh]\w+-[tblr]{2}/,
    b = /\(\s*(.*)\s*\)/g,
    w = /([\s\S]*?);/g,
    k = /-self|flex-/g,
    E = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
    S = /stretch|:\s*\w+\-(?:conte|avail)/,
    x = /([^-])(image-set\()/,
    O = 1,
    L = 1,
    A = 0,
    T = 1,
    P = [],
    M = [],
    R = 0,
    D = null,
    F = 0;
  return l.use = function e(t) {
    switch (t) {
      case void 0:
      case null:
        R = M.length = 0;
        break;
      default:
        if ("function" == typeof t) M[R++] = t;else if ("object" == _typeof(t)) for (var n = 0, r = t.length; n < r; ++n) e(t[n]);else F = 0 | !!t;
    }
    return e;
  }, l.set = c, void 0 !== e && c(e), l;
}
var _i = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function vi(e) {
  var t = Object.create(null);
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}
var yi = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
  Ci = vi(function (e) {
    return yi.test(e) || 111 === e.charCodeAt(0) && 110 === e.charCodeAt(1) && e.charCodeAt(2) < 91;
  }),
  bi = {
    exports: {}
  },
  wi = {},
  ki = "function" == typeof Symbol && Symbol["for"],
  Ei = ki ? Symbol["for"]("react.element") : 60103,
  Si = ki ? Symbol["for"]("react.portal") : 60106,
  xi = ki ? Symbol["for"]("react.fragment") : 60107,
  Oi = ki ? Symbol["for"]("react.strict_mode") : 60108,
  Li = ki ? Symbol["for"]("react.profiler") : 60114,
  Ai = ki ? Symbol["for"]("react.provider") : 60109,
  Ti = ki ? Symbol["for"]("react.context") : 60110,
  Pi = ki ? Symbol["for"]("react.async_mode") : 60111,
  Mi = ki ? Symbol["for"]("react.concurrent_mode") : 60111,
  Ri = ki ? Symbol["for"]("react.forward_ref") : 60112,
  Di = ki ? Symbol["for"]("react.suspense") : 60113,
  Fi = ki ? Symbol["for"]("react.suspense_list") : 60120,
  ji = ki ? Symbol["for"]("react.memo") : 60115,
  Ii = ki ? Symbol["for"]("react.lazy") : 60116,
  Bi = ki ? Symbol["for"]("react.block") : 60121,
  Ni = ki ? Symbol["for"]("react.fundamental") : 60117,
  Hi = ki ? Symbol["for"]("react.responder") : 60118,
  Ui = ki ? Symbol["for"]("react.scope") : 60119;
function $i(e) {
  if ("object" == _typeof(e) && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case Ei:
        switch (e = e.type) {
          case Pi:
          case Mi:
          case xi:
          case Li:
          case Oi:
          case Di:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case Ti:
              case Ri:
              case Ii:
              case ji:
              case Ai:
                return e;
              default:
                return t;
            }
        }
      case Si:
        return t;
    }
  }
}
function Vi(e) {
  return $i(e) === Mi;
}
wi.AsyncMode = Pi, wi.ConcurrentMode = Mi, wi.ContextConsumer = Ti, wi.ContextProvider = Ai, wi.Element = Ei, wi.ForwardRef = Ri, wi.Fragment = xi, wi.Lazy = Ii, wi.Memo = ji, wi.Portal = Si, wi.Profiler = Li, wi.StrictMode = Oi, wi.Suspense = Di, wi.isAsyncMode = function (e) {
  return Vi(e) || $i(e) === Pi;
}, wi.isConcurrentMode = Vi, wi.isContextConsumer = function (e) {
  return $i(e) === Ti;
}, wi.isContextProvider = function (e) {
  return $i(e) === Ai;
}, wi.isElement = function (e) {
  return "object" == _typeof(e) && null !== e && e.$$typeof === Ei;
}, wi.isForwardRef = function (e) {
  return $i(e) === Ri;
}, wi.isFragment = function (e) {
  return $i(e) === xi;
}, wi.isLazy = function (e) {
  return $i(e) === Ii;
}, wi.isMemo = function (e) {
  return $i(e) === ji;
}, wi.isPortal = function (e) {
  return $i(e) === Si;
}, wi.isProfiler = function (e) {
  return $i(e) === Li;
}, wi.isStrictMode = function (e) {
  return $i(e) === Oi;
}, wi.isSuspense = function (e) {
  return $i(e) === Di;
}, wi.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === xi || e === Mi || e === Li || e === Oi || e === Di || e === Fi || "object" == _typeof(e) && null !== e && (e.$$typeof === Ii || e.$$typeof === ji || e.$$typeof === Ai || e.$$typeof === Ti || e.$$typeof === Ri || e.$$typeof === Ni || e.$$typeof === Hi || e.$$typeof === Ui || e.$$typeof === Bi);
}, wi.typeOf = $i, bi.exports = wi;
var Zi = bi.exports,
  zi = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  },
  Wi = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  },
  Ki = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  },
  Gi = {};
function qi(e) {
  return Zi.isMemo(e) ? Ki : Gi[e.$$typeof] || zi;
}
Gi[Zi.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Gi[Zi.Memo] = Ki;
var Yi = Object.defineProperty,
  Ji = Object.getOwnPropertyNames,
  Xi = Object.getOwnPropertySymbols,
  Qi = Object.getOwnPropertyDescriptor,
  ea = Object.getPrototypeOf,
  ta = Object.prototype;
var na = function e(t, n, r) {
  if ("string" != typeof n) {
    if (ta) {
      var o = ea(n);
      o && o !== ta && e(t, o, r);
    }
    var i = Ji(n);
    Xi && (i = i.concat(Xi(n)));
    for (var a = qi(t), s = qi(n), c = 0; c < i.length; ++c) {
      var l = i[c];
      if (!(Wi[l] || r && r[l] || s && s[l] || a && a[l])) {
        var u = Qi(n, l);
        try {
          Yi(t, l, u);
        } catch (e) {}
      }
    }
  }
  return t;
};
function ra() {
  return (ra = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
var oa = function oa(e, t) {
    for (var n = [e[0]], r = 0, o = t.length; r < o; r += 1) n.push(t[r], e[r + 1]);
    return n;
  },
  ia = function ia(e) {
    return null !== e && "object" == _typeof(e) && "[object Object]" === (e.toString ? e.toString() : Object.prototype.toString.call(e)) && !Xo.exports.typeOf(e);
  },
  aa = Object.freeze([]),
  sa = Object.freeze({});
function ca(e) {
  return "function" == typeof e;
}
function la(e) {
  return e.displayName || e.name || "Component";
}
function ua(e) {
  return e && "string" == typeof e.styledComponentId;
}
var da = "undefined" != typeof process && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled",
  pa = "undefined" != typeof window && "HTMLElement" in window,
  ha = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.REACT_APP_SC_DISABLE_SPEEDY && "" !== process.env.REACT_APP_SC_DISABLE_SPEEDY ? "false" !== process.env.REACT_APP_SC_DISABLE_SPEEDY && process.env.REACT_APP_SC_DISABLE_SPEEDY : "undefined" != typeof process && void 0 !== process.env.SC_DISABLE_SPEEDY && "" !== process.env.SC_DISABLE_SPEEDY && "false" !== process.env.SC_DISABLE_SPEEDY && process.env.SC_DISABLE_SPEEDY);
function fa(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var ma = function () {
    function e(e) {
      this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function (e) {
      for (var t = 0, n = 0; n < e; n++) t += this.groupSizes[n];
      return t;
    }, t.insertRules = function (e, t) {
      if (e >= this.groupSizes.length) {
        for (var n = this.groupSizes, r = n.length, o = r; e >= o;) (o <<= 1) < 0 && fa(16, "" + e);
        this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
        for (var i = r; i < o; i++) this.groupSizes[i] = 0;
      }
      for (var a = this.indexOfGroup(e + 1), s = 0, c = t.length; s < c; s++) this.tag.insertRule(a, t[s]) && (this.groupSizes[e]++, a++);
    }, t.clearGroup = function (e) {
      if (e < this.length) {
        var t = this.groupSizes[e],
          n = this.indexOfGroup(e),
          r = n + t;
        this.groupSizes[e] = 0;
        for (var o = n; o < r; o++) this.tag.deleteRule(n);
      }
    }, t.getGroup = function (e) {
      var t = "";
      if (e >= this.length || 0 === this.groupSizes[e]) return t;
      for (var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, i = r; i < o; i++) t += this.tag.getRule(i) + "/*!sc*/\n";
      return t;
    }, e;
  }(),
  ga = new Map(),
  _a = new Map(),
  va = 1,
  ya = function ya(e) {
    if (ga.has(e)) return ga.get(e);
    for (; _a.has(va);) va++;
    var t = va++;
    return ga.set(e, t), _a.set(t, e), t;
  },
  Ca = function Ca(e) {
    return _a.get(e);
  },
  ba = function ba(e, t) {
    t >= va && (va = t + 1), ga.set(e, t), _a.set(t, e);
  },
  wa = "style[" + da + '][data-styled-version="5.3.5"]',
  ka = new RegExp("^" + da + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),
  Ea = function Ea(e, t, n) {
    for (var r, o = n.split(","), i = 0, a = o.length; i < a; i++) (r = o[i]) && e.registerName(t, r);
  },
  Sa = function Sa(e, t) {
    for (var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, i = n.length; o < i; o++) {
      var a = n[o].trim();
      if (a) {
        var s = a.match(ka);
        if (s) {
          var c = 0 | parseInt(s[1], 10),
            l = s[2];
          0 !== c && (ba(l, c), Ea(e, l, s[3]), e.getTag().insertRules(c, r)), r.length = 0;
        } else r.push(a);
      }
    }
  },
  xa = function xa(e) {
    var t = document.head,
      n = e || t,
      r = document.createElement("style"),
      o = function (e) {
        for (var t = e.childNodes, n = t.length; n >= 0; n--) {
          var r = t[n];
          if (r && 1 === r.nodeType && r.hasAttribute(da)) return r;
        }
      }(n),
      i = void 0 !== o ? o.nextSibling : null;
    r.setAttribute(da, "active"), r.setAttribute("data-styled-version", "5.3.5");
    var a = "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
    return a && r.setAttribute("nonce", a), n.insertBefore(r, i), r;
  },
  Oa = function () {
    function e(e) {
      var t = this.element = xa(e);
      t.appendChild(document.createTextNode("")), this.sheet = function (e) {
        if (e.sheet) return e.sheet;
        for (var t = document.styleSheets, n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          if (o.ownerNode === e) return o;
        }
        fa(17);
      }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      try {
        return this.sheet.insertRule(t, e), this.length++, !0;
      } catch (e) {
        return !1;
      }
    }, t.deleteRule = function (e) {
      this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function (e) {
      var t = this.sheet.cssRules[e];
      return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
  }(),
  La = function () {
    function e(e) {
      var t = this.element = xa(e);
      this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      if (e <= this.length && e >= 0) {
        var n = document.createTextNode(t),
          r = this.nodes[e];
        return this.element.insertBefore(n, r || null), this.length++, !0;
      }
      return !1;
    }, t.deleteRule = function (e) {
      this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.nodes[e].textContent : "";
    }, e;
  }(),
  Aa = function () {
    function e(e) {
      this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function (e, t) {
      return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function (e) {
      this.rules.splice(e, 1), this.length--;
    }, t.getRule = function (e) {
      return e < this.length ? this.rules[e] : "";
    }, e;
  }(),
  Ta = pa,
  Pa = {
    isServer: !pa,
    useCSSOMInjection: !ha
  },
  Ma = function () {
    function e(e, t, n) {
      void 0 === e && (e = sa), void 0 === t && (t = {}), this.options = ra({}, Pa, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && pa && Ta && (Ta = !1, function (e) {
        for (var t = document.querySelectorAll(wa), n = 0, r = t.length; n < r; n++) {
          var o = t[n];
          o && "active" !== o.getAttribute(da) && (Sa(e, o), o.parentNode && o.parentNode.removeChild(o));
        }
      }(this));
    }
    e.registerId = function (e) {
      return ya(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function (t, n) {
      return void 0 === n && (n = !0), new e(ra({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function (e) {
      return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function () {
      return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new Aa(o) : r ? new Oa(o) : new La(o), new ma(e)));
      var e, t, n, r, o;
    }, t.hasNameForId = function (e, t) {
      return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function (e, t) {
      if (ya(e), this.names.has(e)) this.names.get(e).add(t);else {
        var n = new Set();
        n.add(t), this.names.set(e, n);
      }
    }, t.insertRules = function (e, t, n) {
      this.registerName(e, t), this.getTag().insertRules(ya(e), n);
    }, t.clearNames = function (e) {
      this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function (e) {
      this.getTag().clearGroup(ya(e)), this.clearNames(e);
    }, t.clearTag = function () {
      this.tag = void 0;
    }, t.toString = function () {
      return function (e) {
        for (var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++) {
          var i = Ca(o);
          if (void 0 !== i) {
            var a = e.names.get(i),
              s = t.getGroup(o);
            if (a && s && a.size) {
              var c = da + ".g" + o + '[id="' + i + '"]',
                l = "";
              void 0 !== a && a.forEach(function (e) {
                e.length > 0 && (l += e + ",");
              }), r += "" + s + c + '{content:"' + l + '"}/*!sc*/\n';
            }
          }
        }
        return r;
      }(this);
    }, e;
  }(),
  Ra = /(a)(d)/gi,
  Da = function Da(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
  };
function Fa(e) {
  var t,
    n = "";
  for (t = Math.abs(e); t > 52; t = t / 52 | 0) n = Da(t % 52) + n;
  return (Da(t % 52) + n).replace(Ra, "$1-$2");
}
var ja = function ja(e, t) {
    for (var n = t.length; n;) e = 33 * e ^ t.charCodeAt(--n);
    return e;
  },
  Ia = function Ia(e) {
    return ja(5381, e);
  };
var Ba = Ia("5.3.5"),
  Na = function () {
    function e(e, t, n) {
      this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && function (e) {
        for (var t = 0; t < e.length; t += 1) {
          var n = e[t];
          if (ca(n) && !ua(n)) return !1;
        }
        return !0;
      }(e), this.componentId = t, this.baseHash = ja(Ba, t), this.baseStyle = n, Ma.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function (e, t, n) {
      var r = this.componentId,
        o = [];
      if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
        if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);else {
          var i = ns(this.rules, e, t, n).join(""),
            a = Fa(ja(this.baseHash, i) >>> 0);
          if (!t.hasNameForId(r, a)) {
            var s = n(i, "." + a, void 0, r);
            t.insertRules(r, a, s);
          }
          o.push(a), this.staticRulesId = a;
        }
      } else {
        for (var c = this.rules.length, l = ja(this.baseHash, n.hash), u = "", d = 0; d < c; d++) {
          var p = this.rules[d];
          if ("string" == typeof p) u += p;else if (p) {
            var h = ns(p, e, t, n),
              f = Array.isArray(h) ? h.join("") : h;
            l = ja(l, f + d), u += f;
          }
        }
        if (u) {
          var m = Fa(l >>> 0);
          if (!t.hasNameForId(r, m)) {
            var g = n(u, "." + m, void 0, r);
            t.insertRules(r, m, g);
          }
          o.push(m);
        }
      }
      return o.join(" ");
    }, e;
  }(),
  Ha = /^\s*\/\/.*$/gm,
  Ua = [":", "[", ".", "#"];
function $a(e) {
  var t,
    n,
    r,
    o,
    i = void 0 === e ? sa : e,
    a = i.options,
    s = void 0 === a ? sa : a,
    c = i.plugins,
    l = void 0 === c ? aa : c,
    u = new gi(s),
    d = [],
    p = function (e) {
      function t(t) {
        if (t) try {
          e(t + "}");
        } catch (e) {}
      }
      return function (n, r, o, i, a, s, c, l, u, d) {
        switch (n) {
          case 1:
            if (0 === u && 64 === r.charCodeAt(0)) return e(r + ";"), "";
            break;
          case 2:
            if (0 === l) return r + "/*|*/";
            break;
          case 3:
            switch (l) {
              case 102:
              case 112:
                return e(o[0] + r), "";
              default:
                return r + (0 === d ? "/*|*/" : "");
            }
          case -2:
            r.split("/*|*/}").forEach(t);
        }
      };
    }(function (e) {
      d.push(e);
    }),
    h = function h(e, r, i) {
      return 0 === r && -1 !== Ua.indexOf(i[n.length]) || i.match(o) ? e : "." + t;
    };
  function f(e, i, a, s) {
    void 0 === s && (s = "&");
    var c = e.replace(Ha, ""),
      l = i && a ? a + " " + i + " { " + c + " }" : c;
    return t = s, n = i, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), u(a || !i ? "" : i, l);
  }
  return u.use([].concat(l, [function (e, t, o) {
    2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, h));
  }, p, function (e) {
    if (-2 === e) {
      var t = d;
      return d = [], t;
    }
  }])), f.hash = l.length ? l.reduce(function (e, t) {
    return t.name || fa(15), ja(e, t.name);
  }, 5381).toString() : "", f;
}
var Va = Ko.createContext();
Va.Consumer;
var Za = Ko.createContext(),
  za = (Za.Consumer, new Ma()),
  Wa = $a();
function Ka() {
  return Fr(Va) || za;
}
function Ga(e) {
  var t = Or(e.stylisPlugins),
    n = t[0],
    r = t[1],
    o = Ka(),
    i = Rr(function () {
      var t = o;
      return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
        target: e.target
      }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
        useCSSOMInjection: !1
      })), t;
    }, [e.disableCSSOMInjection, e.sheet, e.target]),
    a = Rr(function () {
      return $a({
        options: {
          prefix: !e.disableVendorPrefixes
        },
        plugins: n
      });
    }, [e.disableVendorPrefixes, n]);
  return Ar(function () {
    mi(n, e.stylisPlugins) || r(e.stylisPlugins);
  }, [e.stylisPlugins]), Ko.createElement(Va.Provider, {
    value: i
  }, Ko.createElement(Za.Provider, {
    value: a
  }, e.children));
}
var qa = function () {
    function e(e, t) {
      var n = this;
      this.inject = function (e, t) {
        void 0 === t && (t = Wa);
        var r = n.name + t.hash;
        e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
      }, this.toString = function () {
        return fa(12, String(n.name));
      }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function (e) {
      return void 0 === e && (e = Wa), this.name + e.hash;
    }, e;
  }(),
  Ya = /([A-Z])/,
  Ja = /([A-Z])/g,
  Xa = /^ms-/,
  Qa = function Qa(e) {
    return "-" + e.toLowerCase();
  };
function es(e) {
  return Ya.test(e) ? e.replace(Ja, Qa).replace(Xa, "-ms-") : e;
}
var ts = function ts(e) {
  return null == e || !1 === e || "" === e;
};
function ns(e, t, n, r) {
  if (Array.isArray(e)) {
    for (var o, i = [], a = 0, s = e.length; a < s; a += 1) "" !== (o = ns(e[a], t, n, r)) && (Array.isArray(o) ? i.push.apply(i, o) : i.push(o));
    return i;
  }
  return ts(e) ? "" : ua(e) ? "." + e.styledComponentId : ca(e) ? "function" != typeof (c = e) || c.prototype && c.prototype.isReactComponent || !t ? e : ns(e(t), t, n, r) : e instanceof qa ? n ? (e.inject(n, r), e.getName(r)) : e : ia(e) ? function e(t, n) {
    var r,
      o,
      i = [];
    for (var a in t) t.hasOwnProperty(a) && !ts(t[a]) && (Array.isArray(t[a]) && t[a].isCss || ca(t[a]) ? i.push(es(a) + ":", t[a], ";") : ia(t[a]) ? i.push.apply(i, e(t[a], a)) : i.push(es(a) + ": " + (r = a, (null == (o = t[a]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in _i ? String(o).trim() : o + "px") + ";")));
    return n ? [n + " {"].concat(i, ["}"]) : i;
  }(e) : e.toString();
  var c;
}
var rs = function rs(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function os(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return ca(e) || ia(e) ? rs(ns(oa(aa, [e].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : rs(ns(oa(e, n)));
}
var is = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,
  as = /(^-|-$)/g;
function ss(e) {
  return e.replace(is, "-").replace(as, "");
}
var cs = function cs(e) {
  return Fa(Ia(e) >>> 0);
};
function ls(e) {
  return "string" == typeof e && !0;
}
var us = function us(e) {
    return "function" == typeof e || "object" == _typeof(e) && null !== e && !Array.isArray(e);
  },
  ds = function ds(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
  };
function ps(e, t, n) {
  var r = e[n];
  us(t) && us(r) ? hs(r, t) : e[n] = t;
}
function hs(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  for (var o = 0, i = n; o < i.length; o++) {
    var a = i[o];
    if (us(a)) for (var s in a) ds(s) && ps(e, a[s], s);
  }
  return e;
}
var fs = Ko.createContext();
function ms(e) {
  var t = Fr(fs),
    n = Rr(function () {
      return function (e, t) {
        return e ? ca(e) ? e(t) : Array.isArray(e) || "object" != _typeof(e) ? fa(8) : t ? ra({}, t, {}, e) : e : fa(14);
      }(e.theme, t);
    }, [e.theme, t]);
  return e.children ? Ko.createElement(fs.Provider, {
    value: n
  }, e.children) : null;
}
fs.Consumer;
var gs = {};
function _s(e, t, n) {
  var r = ua(e),
    o = !ls(e),
    i = t.attrs,
    a = void 0 === i ? aa : i,
    s = t.componentId,
    c = void 0 === s ? function (e, t) {
      var n = "string" != typeof e ? "sc" : ss(e);
      gs[n] = (gs[n] || 0) + 1;
      var r = n + "-" + cs("5.3.5" + n + gs[n]);
      return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : s,
    l = t.displayName,
    u = void 0 === l ? function (e) {
      return ls(e) ? "styled." + e : "Styled(" + la(e) + ")";
    }(e) : l,
    d = t.displayName && t.componentId ? ss(t.displayName) + "-" + t.componentId : t.componentId || c,
    p = r && e.attrs ? Array.prototype.concat(e.attrs, a).filter(Boolean) : a,
    h = t.shouldForwardProp;
  r && e.shouldForwardProp && (h = t.shouldForwardProp ? function (n, r, o) {
    return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
  } : e.shouldForwardProp);
  var f,
    m = new Na(n, d, r ? e.componentStyle : void 0),
    g = m.isStatic && 0 === a.length,
    _ = function _(e, t) {
      return function (e, t, n, r) {
        var o = e.attrs,
          i = e.componentStyle,
          a = e.defaultProps,
          s = e.foldedComponentIds,
          c = e.shouldForwardProp,
          l = e.styledComponentId,
          u = e.target,
          d = function (e, t, n) {
            void 0 === e && (e = sa);
            var r = ra({}, t, {
                theme: e
              }),
              o = {};
            return n.forEach(function (e) {
              var t,
                n,
                i,
                a = e;
              for (t in ca(a) && (a = a(r)), a) r[t] = o[t] = "className" === t ? (n = o[t], i = a[t], n && i ? n + " " + i : n || i) : a[t];
            }), [r, o];
          }(function (e, t, n) {
            return void 0 === n && (n = sa), e.theme !== n.theme && e.theme || t || n.theme;
          }(t, Fr(fs), a) || sa, t, o),
          p = d[0],
          h = d[1],
          f = function (e, t, n, r) {
            var o = Ka(),
              i = Fr(Za) || Wa;
            return t ? e.generateAndInjectStyles(sa, o, i) : e.generateAndInjectStyles(n, o, i);
          }(i, r, p),
          m = n,
          g = h.$as || t.$as || h.as || t.as || u,
          _ = ls(g),
          v = h !== t ? ra({}, t, {}, h) : t,
          y = {};
        for (var C in v) "$" !== C[0] && "as" !== C && ("forwardedAs" === C ? y.as = v[C] : (c ? c(C, Ci, g) : !_ || Ci(C)) && (y[C] = v[C]));
        return t.style && h.style !== t.style && (y.style = ra({}, t.style, {}, h.style)), y.className = Array.prototype.concat(s, l, f !== l ? f : null, t.className, h.className).filter(Boolean).join(" "), y.ref = m, $n(g, y);
      }(f, e, t, g);
    };
  return _.displayName = u, (f = Ko.forwardRef(_)).attrs = p, f.componentStyle = m, f.displayName = u, f.shouldForwardProp = h, f.foldedComponentIds = r ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : aa, f.styledComponentId = d, f.target = r ? e.target : e, f.withComponent = function (e) {
    var r = t.componentId,
      o = function (e, t) {
        if (null == e) return {};
        var n,
          r,
          o = {},
          i = Object.keys(e);
        for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o;
      }(t, ["componentId"]),
      i = r && r + "-" + (ls(e) ? e : ss(la(e)));
    return _s(e, ra({}, o, {
      attrs: p,
      componentId: i
    }), n);
  }, Object.defineProperty(f, "defaultProps", {
    get: function get() {
      return this._foldedDefaultProps;
    },
    set: function set(t) {
      this._foldedDefaultProps = r ? hs({}, e.defaultProps, t) : t;
    }
  }), f.toString = function () {
    return "." + f.styledComponentId;
  }, o && na(f, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), f;
}
var vs = function vs(e) {
  return function e(t, n, r) {
    if (void 0 === r && (r = sa), !Xo.exports.isValidElementType(n)) return fa(1, String(n));
    var o = function o() {
      return t(n, r, os.apply(void 0, arguments));
    };
    return o.withConfig = function (o) {
      return e(t, n, ra({}, r, {}, o));
    }, o.attrs = function (o) {
      return e(t, n, ra({}, r, {
        attrs: Array.prototype.concat(r.attrs, o).filter(Boolean)
      }));
    }, o;
  }(_s, e);
};
function ys(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  var o = os.apply(void 0, [e].concat(n)).join(""),
    i = cs(o);
  return new qa(i, o);
}
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function (e) {
  vs[e] = vs(e);
});
var Cs = function Cs() {
    return Fr(fs);
  },
  bs = vs;
var ws = "<div data-prompt_parent_id='g_id_onload' id='google-parent-prompt' style=''></div>";
function ks(e, t) {
  return "undefined" == typeof window ? function () {
    return null;
  } : function (n) {
    if (!!n.config.enableShadowDOM) {
      var r = function (e, t) {
        var n = customElements.get(t);
        if (n) return n;
        var r = /*#__PURE__*/function (_HTMLElement) {
          _inherits(r, _HTMLElement);
          function r(e) {
            var _this12;
            _classCallCheck(this, r);
            _this12 = _callSuper(this, r), _this12.props = e, _this12.rootRef = _this12.attachShadow({
              mode: "open"
            });
            return _this12;
          }
          _createClass(r, [{
            key: "connectedCallback",
            value: function connectedCallback() {
              this.styleSlot = document.createElement("section"), this.rootRef.appendChild(this.styleSlot), this.mountPoint = document.createElement("span"), this.styleSlot.appendChild(this.mountPoint), this.render(this.props);
            }
          }, {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
              this.mountPoint && Ko.unmountComponentAtNode(this.mountPoint);
            }
          }, {
            key: "renderOneTap",
            value: function renderOneTap(e) {
              var t, n, _r2;
              var o = null === (_r2 = null === (n = null === (t = null == e ? void 0 : e.config) || void 0 === t ? void 0 : t.oauthOptions) || void 0 === n ? void 0 : n.providers) || void 0 === _r2 ? void 0 : _r2.find(function (e) {
                  return e.type === h.Google && e.one_tap;
                }),
                i = this.innerHTML.includes(ws);
              o ? i || (this.innerHTML = ws) : this.innerHTML = "";
            }
          }, {
            key: "render",
            value: function render(t) {
              if (!this.mountPoint) throw Error("Cannot render - no mount point defined");
              if (!this.styleSlot) throw Error("Cannot render - no style slot defined");
              this.renderOneTap(t), Ko.render(Ko.createElement(Ga, {
                target: this.styleSlot
              }, Ko.createElement(e, Object.assign({}, t))), this.mountPoint);
            }
          }]);
          return r;
        }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
        return customElements.define(t, r), r;
      }(e, t);
      return new r(n);
    }
    {
      var _r3 = function (e, t) {
        var n = customElements.get(t);
        if (n) return n;
        var r = /*#__PURE__*/function (_HTMLElement2) {
          _inherits(r, _HTMLElement2);
          function r(e) {
            var _this13;
            _classCallCheck(this, r);
            _this13 = _callSuper(this, r), _this13.props = e, _this13.rootRef = document.createElement("div"), _this13.append(_this13.rootRef);
            return _this13;
          }
          _createClass(r, [{
            key: "connectedCallback",
            value: function connectedCallback() {
              this.styleSlot = document.createElement("section"), this.rootRef.appendChild(this.styleSlot), this.mountPoint = document.createElement("span"), this.styleSlot.appendChild(this.mountPoint), this.render(this.props);
            }
          }, {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
              this.mountPoint && Ko.unmountComponentAtNode(this.mountPoint);
            }
          }, {
            key: "render",
            value: function render(t) {
              if (!this.mountPoint) throw Error("Cannot render - no mount point defined");
              if (!this.styleSlot) throw Error("Cannot render - no style slot defined");
              Ko.render(Ko.createElement(Ga, {
                target: this.styleSlot
              }, Ko.createElement(e, Object.assign({}, t))), this.mountPoint);
            }
          }]);
          return r;
        }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
        return customElements.define(t, r), r;
      }(e, t);
      return new _r3(n);
    }
  };
}
var Es = function Es(e, t) {
  switch (t.type) {
    case "transition":
      return Object.assign(Object.assign({}, e), {
        screen: t.screen
      });
    case "set_magic_link_email":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          magicLinkState: {
            email: t.email
          }
        })
      });
    case "update_otp_state":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          otpState: t.otpState
        })
      });
    case "update_crypto_state":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          cryptoState: t.cryptoState
        })
      });
    case "update_password_state":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          passwordState: t.passwordState
        })
      });
    case "set_error_message":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          errorMessage: t.errorMessage
        })
      });
    case "clear_error_message":
      return Object.assign(Object.assign({}, e), {
        formState: Object.assign(Object.assign({}, e.formState), {
          errorMessage: ""
        })
      });
    default:
      throw new Error();
  }
};
var Ss;
!function (e) {
  e.Main = "Main", e.PasskeyRegistrationStart = "Register New Passkey", e.PasskeyRegistrationSuccess = "Passkey Registration Success", e.PasskeyConfirmation = "Passkey Confirmation", e.PasswordCreateOrLogin = "Password", e.PasswordResetForm = "Password Reset Form", e.PasswordForgot = "Password Forgot", e.PasswordBreached = "Password Breached", e.PasswordSetNew = "Password Set New", e.PasswordDedupe = "Password Dedupe", e.PasswordConfirmation = "Password Confirmation", e.EmailConfirmation = "Email Confirmation", e.OTPAuthenticate = "OTP Authenticate", e.OTPConfirmation = "OTP Confirmation", e.CryptoConnect = "Crypto Connect", e.CryptoSignMessage = "Crypto Sign Message", e.CryptoOtherScreen = "Crypto Other Screen", e.CryptoSetupWallet = "Crypto Setup Wallet", e.CryptoError = "Crypto Error", e.CryptoConfirmation = "Crypto Confirmation";
}(Ss || (Ss = {}));
var xs = {
    screen: Ss.Main,
    formState: {
      magicLinkState: {
        email: ""
      },
      otpState: {
        type: g.Email,
        methodId: "",
        otpDestination: ""
      },
      cryptoState: {
        walletAddress: "",
        walletOption: f.Metamask,
        walletChallenge: ""
      },
      passwordState: {
        email: "",
        type: "new"
      },
      resetPasswordState: {
        token: ""
      },
      errorMessage: ""
    }
  },
  Os = {
    products: [p.emailMagicLinks],
    emailMagicLinksOptions: {
      loginRedirectURL: "",
      loginExpirationMinutes: 30,
      signupRedirectURL: "",
      signupExpirationMinutes: 30,
      createUserAsPending: !1
    }
  },
  Ls = {
    container: {
      backgroundColor: "#FFFFFF",
      borderColor: "#ADBCC5",
      borderRadius: "8px",
      width: "400px"
    },
    colors: {
      primary: "#19303D",
      secondary: "#5C727D",
      success: "#0C5A56",
      error: "#8B1214"
    },
    buttons: {
      primary: {
        backgroundColor: "#19303D",
        textColor: "#FFFFFF",
        borderColor: "#19303D",
        borderRadius: "4px"
      },
      secondary: {
        backgroundColor: "#FFFFFF",
        textColor: "#19303D",
        borderColor: "#19303D",
        borderRadius: "4px"
      }
    },
    fontFamily: "Arial, Helvetica, sans-serif",
    hideHeaderText: !1,
    logo: {
      logoImageUrl: ""
    }
  },
  As = Ko.createContext({
    client: {},
    config: Os,
    state: [xs, function () {
      return null;
    }]
  }),
  Ts = function Ts(_ref13) {
    var e = _ref13.children,
      t = _ref13.client,
      n = _ref13.config,
      r = _ref13.callbacks,
      o = _ref13.initialState;
    var i = Ko.useReducer(Es, null != o ? o : xs);
    return Ko.createElement(As.Provider, {
      value: {
        client: t,
        state: i,
        config: n,
        callbacks: r
      }
    }, e);
  },
  Ps = function Ps() {
    return Fr(As);
  },
  Ms = function Ms() {
    return Ps().client;
  },
  Rs = function Rs() {
    return Ps().state;
  },
  Ds = function Ds() {
    return Ps().config;
  },
  Fs = function Fs() {
    var e, t;
    return null !== (t = null === (e = Ps().callbacks) || void 0 === e ? void 0 : e.onError) && void 0 !== t ? t : function () {};
  },
  js = function js() {
    var e, t;
    return null !== (t = null === (e = Ps().callbacks) || void 0 === e ? void 0 : e.onEvent) && void 0 !== t ? t : function () {};
  },
  Is = bs.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  all: unset;\n  width: 100%;\n  height: 45px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 18px;\n  text-transform: none;\n  font-family: ", ";\n  box-shadow: none;\n  text-align: center;\n\n  ", "\n\n  &:disabled {\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n"])), function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    switch (e.variant) {
      case "primary":
        return "\n          border: ".concat(e.theme.buttons.primary.border, ";\n          border-radius: ").concat(e.theme.buttons.primary.borderRadius, ";\n          color: ").concat(e.theme.buttons.primary.textColor, ";\n          background-color: ").concat(e.theme.buttons.primary.backgroundColor, ";\n        ");
      case "outlined":
        return "\n          border: ".concat(e.theme.buttons.secondary.border, ";\n          border-radius: ").concat(e.theme.buttons.secondary.borderRadius, ";\n          color: ").concat(e.theme.buttons.secondary.textColor, ";\n          background-color: ").concat(e.theme.buttons.secondary.backgroundColor, ";\n        ");
      case "text":
        return "\n          color: ".concat(e.theme.colors.primary, ";\n          background-color: transparent;\n          font-weight: 600;\n        ");
    }
  }, function (e) {
    return e.theme.colors.disabled;
  }, function (e) {
    return e.theme.colors.disabledText;
  });
Is.defaultProps = {
  variant: "primary"
};
var Bs = function Bs(e) {
    return null != e ? e : void 0;
  },
  Ns = function Ns(e) {
    return e ? "".concat(e, "px") : void 0;
  },
  Hs = bs.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: ", ";\n\n  flex-direction: ", ";\n  justify-content: ", ";\n  align-items: ", ";\n  flex-grow: ", ";\n  flex-shrink: ", ";\n  order: ", ";\n  align-self: ", ";\n  flex-flow: ", ";\n  flex-wrap: ", ";\n\n  width: ", ";\n  height: ", ";\n  max-width: ", ";\n  max-height: ", ";\n  min-width: ", ";\n  min-height: ", ";\n  padding: ", ";\n  margin: ", ";\n  margin-top: ", ";\n  margin-right: ", ";\n  margin-bottom: ", ";\n  margin-left: ", ";\n  padding-top: ", ";\n  padding-right: ", ";\n  padding-bottom: ", ";\n  padding-left: ", ";\n\n  gap: ", ";\n"])), function (_ref14) {
    var e = _ref14.inline;
    return e ? "inline-flex" : "flex";
  }, function (_ref15) {
    var e = _ref15.direction;
    return Bs(e);
  }, function (_ref16) {
    var e = _ref16.justifyContent,
      t = _ref16.center;
    return t ? "center" : Bs(e);
  }, function (_ref17) {
    var e = _ref17.alignItems,
      t = _ref17.center;
    return t ? "center" : Bs(e);
  }, function (_ref18) {
    var e = _ref18.grow;
    return Bs(e);
  }, function (_ref19) {
    var e = _ref19.shrink;
    return Bs(e);
  }, function (_ref20) {
    var e = _ref20.order;
    return Bs(e);
  }, function (_ref21) {
    var e = _ref21.alignSelf;
    return Bs(e);
  }, function (_ref22) {
    var e = _ref22.flow;
    return Bs(e);
  }, function (_ref23) {
    var e = _ref23.wrap;
    return Bs(e);
  }, function (_ref24) {
    var e = _ref24.width;
    return "string" == typeof e ? e : Ns(e);
  }, function (_ref25) {
    var e = _ref25.height;
    return "string" == typeof e ? e : Ns(e);
  }, function (_ref26) {
    var e = _ref26.maxWidth;
    return "string" == typeof e ? e : Ns(e);
  }, function (_ref27) {
    var e = _ref27.maxHeight;
    return "string" == typeof e ? e : Ns(e);
  }, function (_ref28) {
    var e = _ref28.minWidth;
    return "string" == typeof e ? e : Ns(e);
  }, function (_ref29) {
    var e = _ref29.minHeight;
    return "string" == typeof e ? e : Ns(e);
  }, function (_ref30) {
    var e = _ref30.padding;
    return Ns(e);
  }, function (_ref31) {
    var e = _ref31.margin;
    return Ns(e);
  }, function (_ref32) {
    var e = _ref32.marginTop;
    return Ns(e);
  }, function (_ref33) {
    var e = _ref33.marginRight;
    return Ns(e);
  }, function (_ref34) {
    var e = _ref34.marginBottom;
    return Ns(e);
  }, function (_ref35) {
    var e = _ref35.marginLeft;
    return Ns(e);
  }, function (_ref36) {
    var e = _ref36.paddingTop;
    return Ns(e);
  }, function (_ref37) {
    var e = _ref37.paddingRight;
    return Ns(e);
  }, function (_ref38) {
    var e = _ref38.paddingBottom;
    return Ns(e);
  }, function (_ref39) {
    var e = _ref39.paddingLeft;
    return Ns(e);
  }, function (_ref40) {
    var e = _ref40.gap;
    return Ns(e);
  }),
  Us = bs.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-align: ", ";\n  ", ";\n"])), function (e) {
    return e.color && e.theme.colors[e.color];
  }, function (e) {
    return e.align;
  }, function (e) {
    return e.size && e.theme.typography[e.size];
  });
Us.defaultProps = {
  size: "body",
  color: "primary",
  align: "left"
};
var $s = function $s(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    wrapped: !0
  };
  return function () {
    var n = Ko.createElement(e, null);
    return t.wrapped ? Ko.createElement(Hs, {
      height: 24,
      width: 24
    }, n) : n;
  };
};
var Vs = $s(function () {
  return Ko.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, Ko.createElement("path", {
    fill: "#4caf50",
    d: "M45,16.2l-5,2.75l-5,4.75L35,40h7c1.657,0,3-1.343,3-3V16.2z"
  }), Ko.createElement("path", {
    fill: "#1e88e5",
    d: "M3,16.2l3.614,1.71L13,23.7V40H6c-1.657,0-3-1.343-3-3V16.2z"
  }), Ko.createElement("polygon", {
    fill: "#e53935",
    points: "35,11.2 24,19.45 13,11.2 12,17 13,23.7 24,31.95 35,23.7 36,17"
  }), Ko.createElement("path", {
    fill: "#c62828",
    d: "M3,12.298V16.2l10,7.5V11.2L9.876,8.859C9.132,8.301,8.228,8,7.298,8h0C4.924,8,3,9.924,3,12.298z"
  }), Ko.createElement("path", {
    fill: "#fbc02d",
    d: "M45,12.298V16.2l-10,7.5V11.2l3.124-2.341C38.868,8.301,39.772,8,40.702,8h0 C43.076,8,45,9.924,45,12.298z"
  }));
});
var Zs = $s(function () {
  return Ko.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    id: "Layer_1",
    viewBox: "0 0 103.17322 104.31332",
    xmlSpace: "preserve"
  }, Ko.createElement("defs", {
    id: "defs43"
  }), Ko.createElement("path", {
    d: "m 64.566509,22.116383 v 20.404273 l 7.130526,4.489881 c 0.188058,0.05485 0.595516,0.05877 0.783574,0 L 103.16929,26.320259 c 0,-2.44867 -2.28412,-4.203876 -3.573094,-4.203876 H 64.566509 z",
    id: "path3",
    style: {
      fill: "#0072c6"
    }
  }), Ko.createElement("path", {
    d: "m 64.566509,50.13308 6.507584,4.470291 c 0.916782,0.673874 2.021622,0 2.021622,0 -1.100922,0.673874 30.077495,-20.035993 30.077495,-20.035993 v 37.501863 c 0,4.082422 -2.61322,5.794531 -5.551621,5.794531 H 64.562591 V 50.13308 z",
    id: "path5",
    style: {
      fill: "#0072c6"
    }
  }), Ko.createElement("g", {
    id: "g23",
    transform: "matrix(3.9178712,0,0,3.9178712,-13.481403,-41.384473)"
  }, Ko.createElement("path", {
    d: "m 11.321,20.958 c -0.566,0 -1.017,0.266 -1.35,0.797 -0.333,0.531 -0.5,1.234 -0.5,2.109 0,0.888 0.167,1.59 0.5,2.106 0.333,0.517 0.77,0.774 1.31,0.774 0.557,0 0.999,-0.251 1.325,-0.753 0.326,-0.502 0.49,-1.199 0.49,-2.09 0,-0.929 -0.158,-1.652 -0.475,-2.169 -0.317,-0.516 -0.75,-0.774 -1.3,-0.774 z",
    id: "path25",
    style: {
      fill: "#0072c6"
    }
  }), Ko.createElement("path", {
    d: "m 3.441,13.563 v 20.375 l 15.5,3.25 V 10.563 l -15.5,3 z m 10.372,13.632 c -0.655,0.862 -1.509,1.294 -2.563,1.294 -1.027,0 -1.863,-0.418 -2.51,-1.253 C 8.094,26.4 7.77,25.312 7.77,23.97 c 0,-1.417 0.328,-2.563 0.985,-3.438 0.657,-0.875 1.527,-1.313 2.61,-1.313 1.023,0 1.851,0.418 2.482,1.256 0.632,0.838 0.948,1.942 0.948,3.313 10e-4,1.409 -0.327,2.545 -0.982,3.407 z",
    id: "path27",
    style: {
      fill: "#0072c6"
    }
  })));
});
var zs = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "1",
    fill: "#671BDF"
  }), Ko.createElement("path", {
    d: "M5 8.7284H7.71407L9.29444 12.7716L10.8953 8.7284H13.5379L9.55876 18.3H6.89942L7.98865 15.7637L5 8.7284Z",
    fill: "white"
  }), Ko.createElement("path", {
    d: "M14.2 16.2028C15.108 16.2028 15.8441 15.4667 15.8441 14.5587C15.8441 13.6507 15.108 12.9146 14.2 12.9146C13.292 12.9146 12.5559 13.6507 12.5559 14.5587C12.5559 15.4667 13.292 16.2028 14.2 16.2028Z",
    fill: "white"
  }), Ko.createElement("path", {
    d: "M16.3842 12.3106H13.4243L16.0512 6H19L16.3842 12.3106Z",
    fill: "white"
  }));
});
var Ws = bs.a(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n    text-decoration-color: ", ";\n  }\n"])), function (e) {
    return e.theme.colors.primary;
  }),
  Ks = function Ks(_ref41) {
    var e = _ref41.label,
      t = _ref41.href,
      n = _ref41.Icon;
    return Ko.createElement(Hs, {
      gap: 4
    }, n, Ko.createElement(Ws, {
      href: t,
      target: "_blank",
      rel: "noopener noreferrer"
    }, Ko.createElement(Us, null, "Open in ", e)));
  },
  Gs = function Gs(_ref42) {
    var e = _ref42.emailDomain,
      t = _ref42.reset,
      n = _ref42.email;
    var _ref43 = function (e) {
        return e ? {
          GMAIL: "https://mail.google.com/mail/u/0/#search/".concat(encodeURIComponent("from:@".concat(e, " in:anywhere"))),
          OUTLOOK: "https://outlook.office.com/mail/0/inbox",
          YAHOO: "https://mail.yahoo.com/d/search/keyword=".concat(e)
        } : {
          GMAIL: "https://mail.google.com/mail/u/0/#search/in%3Aanywhere",
          OUTLOOK: "https://outlook.office.com/mail/0/inbox",
          YAHOO: "https://mail.yahoo.com/d/search/referrer=unread"
        };
      }(e),
      r = _ref43.GMAIL,
      o = _ref43.YAHOO,
      i = _ref43.OUTLOOK;
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(Us, {
      size: "header"
    }, "Check your email"), Ko.createElement(Hs, {
      direction: "column",
      gap: 12
    }, Ko.createElement(Us, null, "An email was sent to ", Ko.createElement("b", null, n), "."), Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Ks, {
      href: r,
      label: "Gmail",
      Icon: Ko.createElement(Vs, null)
    }), Ko.createElement(Ks, {
      href: o,
      label: "Yahoo",
      Icon: Ko.createElement(zs, null)
    }), Ko.createElement(Ks, {
      href: i,
      label: "Outlook",
      Icon: Ko.createElement(Zs, null)
    }))), Ko.createElement(Is, {
      onClick: t
    }, "Try again"));
  },
  qs = function qs() {
    var e = Ms(),
      _Rs = Rs(),
      _Rs2 = _slicedToArray(_Rs, 2),
      t = _Rs2[0],
      n = _Rs2[1],
      r = function () {
        var e, t;
        var n = Ms(),
          r = Ds(),
          _Or = Or(function () {
            var _xn$bootstrap$getSync = xn(n).bootstrap.getSync(),
              e = _xn$bootstrap$getSync.emailDomains;
            return e;
          }),
          _Or2 = _slicedToArray(_Or, 2),
          o = _Or2[0],
          i = _Or2[1];
        return Ar(function () {
          xn(n).bootstrap.getAsync().then(function (_ref44) {
            var e = _ref44.emailDomains;
            i(e);
          });
        }, [n]), (null === (e = r.emailMagicLinksOptions) || void 0 === e ? void 0 : e.domainHint) ? null === (t = r.emailMagicLinksOptions) || void 0 === t ? void 0 : t.domainHint : 1 === (null == o ? void 0 : o.length) ? o[0] : null;
      }(),
      o = "" !== t.formState.magicLinkState.email ? t.formState.magicLinkState.email : t.formState.passwordState.email;
    return Ko.createElement(Gs, {
      emailDomain: r,
      reset: function reset() {
        n({
          type: "set_magic_link_email",
          email: ""
        }), n({
          type: "transition",
          screen: Ss.Main
        }), xn(e).networkClient.logEvent({
          name: "email_try_again_clicked",
          details: {
            email: o,
            type: Ke.LoginOrCreateEML
          }
        });
      },
      email: o
    });
  },
  Ys = function Ys() {
    return $n("svg", {
      width: "201",
      height: "200",
      viewBox: "0 0 201 200",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, $n("g", {
      opacity: "0.1"
    }, $n("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.5 0C155.729 0 200.5 44.7715 200.5 99.9999C200.5 155.229 155.729 200 100.5 200C45.2715 200 0.5 155.229 0.5 99.9999C0.5 44.7715 45.2715 0 100.5 0Z",
      fill: "url(#paint0_linear_1356_5135)"
    })), $n("g", {
      opacity: "0.3"
    }, $n("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.5 17.5728C146.023 17.5728 182.927 54.4767 182.927 99.9998C182.927 145.523 146.023 182.427 100.5 182.427C54.9768 182.427 18.0729 145.523 18.0729 99.9998C18.0729 54.4767 54.9768 17.5728 100.5 17.5728Z",
      fill: "url(#paint1_linear_1356_5135)"
    })), $n("g", {
      opacity: "0.7"
    }, $n("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.5 32.231C137.988 32.231 168.378 62.6208 168.378 100.109C168.378 137.597 137.988 167.987 100.5 167.987C63.012 167.987 32.6222 137.597 32.6222 100.109C32.6222 62.6208 63.012 32.231 100.5 32.231Z",
      fill: "url(#paint2_linear_1356_5135)"
    })), $n("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.605 48.7734C128.955 48.7734 151.937 71.7553 151.937 100.105C151.937 128.455 128.955 151.437 100.605 151.437C72.255 151.437 49.2731 128.455 49.2731 100.105C49.2731 71.7553 72.255 48.7734 100.605 48.7734Z",
      fill: "#00AC26",
      fillOpacity: "0.12"
    }), $n("mask", {
      id: "mask0_1356_5135",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: "49",
      y: "48",
      width: "103",
      height: "104"
    }, $n("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M100.605 48.7734C128.955 48.7734 151.937 71.7553 151.937 100.105C151.937 128.455 128.955 151.437 100.605 151.437C72.255 151.437 49.2731 128.455 49.2731 100.105C49.2731 71.7553 72.255 48.7734 100.605 48.7734Z",
      fill: "white"
    })), $n("g", {
      mask: "url(#mask0_1356_5135)"
    }), $n("path", {
      d: "M88 117.5L70.5 100L64.6667 105.833L88 129.167L138 79.1666L132.167 73.3333L88 117.5Z",
      fill: "white"
    }), $n("defs", null, $n("linearGradient", {
      id: "paint0_linear_1356_5135",
      x1: "-86.6375",
      y1: "160.384",
      x2: "170.169",
      y2: "338.297",
      gradientUnits: "userSpaceOnUse"
    }, $n("stop", {
      stopColor: "white"
    }), $n("stop", {
      offset: "1",
      stopColor: "#09F33D"
    })), $n("linearGradient", {
      id: "paint1_linear_1356_5135",
      x1: "-86.6374",
      y1: "160.384",
      x2: "170.169",
      y2: "338.297",
      gradientUnits: "userSpaceOnUse"
    }, $n("stop", {
      stopColor: "#00AC26",
      stopOpacity: "0.4"
    }), $n("stop", {
      offset: "1",
      stopColor: "#BDFFBC",
      stopOpacity: "0.58"
    })), $n("linearGradient", {
      id: "paint2_linear_1356_5135",
      x1: "-86.6375",
      y1: "160.493",
      x2: "170.169",
      y2: "338.406",
      gradientUnits: "userSpaceOnUse"
    }, $n("stop", {
      stopColor: "#F8FFF5"
    }), $n("stop", {
      offset: "1",
      stopColor: "#00AC26",
      stopOpacity: "0.26"
    }))));
  },
  Js = function Js() {
    return $n(Hs, {
      direction: "column",
      gap: 24
    }, $n(Us, {
      size: "header"
    }, "Success"), $n(Us, null, "Your passcode has been successfully verified."), $n("div", {
      style: {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        width: "50%"
      }
    }, $n(Ys, null)));
  },
  Xs = bs(Hs)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (e) {
    return e.theme.colors.secondary;
  }),
  Qs = bs.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  border-bottom: 1px solid ", ";\n  flex-grow: 1;\n"])), function (e) {
    return "left" === e.$placement && "margin-right: 6px;";
  }, function (e) {
    return "right" === e.$placement && "margin-left: 6px;";
  }, function (e) {
    return e.theme.colors.secondary;
  }),
  ec = bs(Us)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (e) {
    return e.theme.colors.secondary;
  }),
  tc = function tc() {
    return Ko.createElement(Xs, {
      alignItems: "center"
    }, Ko.createElement(Qs, {
      $placement: "left"
    }), Ko.createElement(ec, null, "or"), Ko.createElement(Qs, {
      $placement: "right"
    }));
  },
  nc = function nc(e) {
    var t = Ms();
    return Ko.createElement(Is, {
      id: "oauth-".concat(e.providerType),
      type: "submit",
      onClick: function onClick() {
        return t.oauth[e.providerType].start({
          login_redirect_url: e.loginRedirectUrl,
          signup_redirect_url: e.signupRedirectUrl,
          custom_scopes: e.customScopes,
          provider_params: e.providerParams
        });
      },
      variant: "outlined"
    }, Ko.createElement(Hs, {
      justifyContent: "center",
      alignItems: "center",
      gap: 4
    }, e.icon, Ko.createElement("span", {
      style: {
        verticalAlign: "middle"
      }
    }, "Continue with ".concat(e.providerTypeTitle))));
  };
var rc = $s(function () {
  return Ko.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, Ko.createElement("path", {
    fill: "#FFC107",
    d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
  }), Ko.createElement("path", {
    fill: "#FF3D00",
    d: "M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
  }), Ko.createElement("path", {
    fill: "#4CAF50",
    d: "M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
  }), Ko.createElement("path", {
    fill: "#1976D2",
    d: "M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
  }));
});
var oc = function oc(_ref45) {
    var e = _ref45.children;
    return Ko.createElement("div", {
      key: "oauth-error-message"
    }, Ko.createElement(Us, {
      color: "error"
    }, e));
  },
  ic = function ic(_ref46) {
    var e = _ref46.niceName,
      t = _ref46.variableName;
    return Ko.createElement(oc, null, "One Tap cannot render because there are no ", e, " set for this project so we are unable to verify the", " ", Ko.createElement("code", null, t), "  provided in the configuration. To set ", e, " for this project please visit ", Ko.createElement("a", {
      href: "https://stytch.com/docs/javascript-sdk"
    }, "the Stytch dashboard."), "  For more information on why this validation is necessary please visit ", Ko.createElement("a", {
      href: "https://stytch.com/docs/api/url-validation"
    }, "https://stytch.com/docs/api/url-validation."));
  },
  ac = ys(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]))),
  sc = ys(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"]))),
  cc = bs.circle(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  stroke-dasharray: 80px, 200px;\n  stroke-dashoffset: 0;\n  animation: ", " 1.4s ease-in-out infinite;\n  stroke: ", ";\n  fill: none;\n"])), sc, function (e) {
    return e.theme.colors.primary;
  }),
  lc = bs.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  animation: ", " 1.4s ease-in-out infinite;\n"])), function (e) {
    return e.size;
  }, function (e) {
    return e.size;
  }, ac),
  uc = bs.svg(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: block;\n"]))),
  dc = function dc(_ref47) {
    var e = _ref47.size,
      t = _ref47.thickness;
    return Ko.createElement(lc, {
      size: e
    }, Ko.createElement(uc, {
      viewBox: "".concat(e / 2, " ").concat(e / 2, " ").concat(e, " ").concat(e)
    }, Ko.createElement(cc, {
      cx: e,
      cy: e,
      r: (e - t) / 2,
      fill: "none",
      strokeWidth: t
    })));
  },
  pc = function pc() {
    var e = Ds();
    return Rr(function () {
      var t, n, r, o;
      var i = null === (t = e.oauthOptions) || void 0 === t ? void 0 : t.providers[0].position;
      return 1 === e.products.length && e.products.includes(p.oauth) && 1 === (null === (n = e.oauthOptions) || void 0 === n ? void 0 : n.providers.length) && (null === (r = e.oauthOptions) || void 0 === r ? void 0 : r.providers[0].type) === h.Google && !0 === (null === (o = e.oauthOptions) || void 0 === o ? void 0 : o.providers[0].one_tap) && function (e) {
        return e !== m.embeddedOnly && !en(e);
      }(i);
    }, [e]);
  },
  hc = function hc(_ref48) {
    var e = _ref48.enableShadowDOM;
    return e ? Ko.createElement("slot", null) : Ko.createElement("div", {
      "data-prompt_parent_id": "g_id_onload",
      id: "google-parent-prompt"
    });
  };
var fc;
!function (e) {
  e.None = "none", e.OriginNotAllowedForClient = "origin_not_allowed_for_client", e.InvalidOAuthClient = "invalid_client", e.NoConfiguredOAuthClient = "oauth_config_not_found", e.NoConfiguredLoginRedirectUrls = "no_login_redirect_urls_set", e.NoConfiguredSignupRedirectUrls = "no_signup_redirect_urls_set", e.DefaultProviderNotAllowed = "default_provider_not_allowed";
}(fc || (fc = {}));
var mc = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, fc.None, Ko.createElement(Ko.Fragment, null)), fc.OriginNotAllowedForClient, Ko.createElement(function () {
    return Ko.createElement(oc, null, "One Tap cannot render because the current host ", Ko.createElement("code", null, "\"".concat(window.location.host, "\"")), " is not allowed for this project. Make sure to put your project's host into the Google API console. When using localhost for development, you must add both ", Ko.createElement("code", null, "http://localhost"), " and ", Ko.createElement("code", null, "http://localhost:<port_number>"), "  to the Authorized JavaScript origins box. You can learn more ", Ko.createElement("a", {
      href: "https://stytch.com/docs/javascript-sdk"
    }, "here."));
  }, null)), fc.InvalidOAuthClient, Ko.createElement(function () {
    return Ko.createElement(oc, null, "One Tap cannot render because the client ID configured for your project is not recognized by Google.   Please check that the client ID saved in ", Ko.createElement("a", {
      href: "https://stytch.com/dashboard/oauth/google"
    }, "the Stytch Dashboard"), "  matches the client ID in your Google Cloud Console.");
  }, null)), fc.NoConfiguredOAuthClient, Ko.createElement(function () {
    return Ko.createElement(oc, null, "One Tap cannot render because no Google OAuth client configuration could be found for this project. Please make sure a client is configured in the ", Ko.createElement("a", {
      href: "https://stytch.com/dashboard/oauth"
    }, "dashboard."));
  }, null)), fc.NoConfiguredLoginRedirectUrls, Ko.createElement(function () {
    return Ko.createElement(ic, {
      niceName: "login redirect URLs",
      variableName: "oauthOptions.loginRedirectURL"
    });
  }, null)), fc.NoConfiguredSignupRedirectUrls, Ko.createElement(function () {
    return Ko.createElement(ic, {
      niceName: "signup redirect URLs",
      variableName: "oauthOptions.signupRedirectURL"
    });
  }, null)), fc.DefaultProviderNotAllowed, Ko.createElement(function () {
    return Ko.createElement(oc, null, "One Tap cannot render because the Stytch Default OAuth Provider is not compatible with One Tap. Please configure your own Google client in the ", Ko.createElement("a", {
      href: "https://stytch.com/dashboard/oauth"
    }, "dashboard."));
  }, null)),
  gc = bs.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  height: ", ";\n  display: ", ";\n  transition: all 0.5s ease-out;\n  justify-content: center;\n  align-items: center;\n"])), function (e) {
    return "".concat(e.$height, "px");
  }, function (e) {
    return e.pending ? "flex" : "block";
  }),
  _c = function _c(_ref49) {
    var e = _ref49.position;
    var t, n, r, o;
    var i = function (e) {
        var t = Qt(e);
        return "force" === t || t && !Xt ? "embedded" : e !== m.embeddedOnly && "floating";
      }(e),
      a = "embedded" === i,
      s = !!i,
      c = Ds(),
      l = Ms(),
      u = pc(),
      _Or3 = Or(a),
      _Or4 = _slicedToArray(_Or3, 2),
      d = _Or4[0],
      p = _Or4[1],
      _Or5 = Or(!0),
      _Or6 = _slicedToArray(_Or5, 2),
      f = _Or6[0],
      g = _Or6[1],
      _Or7 = Or(47),
      _Or8 = _slicedToArray(_Or7, 2),
      _ = _Or8[0],
      v = _Or8[1],
      _Or9 = Or(fc.None),
      _Or10 = _slicedToArray(_Or9, 2),
      y = _Or10[0],
      C = _Or10[1],
      b = Pr(0),
      w = Pr(),
      k = function () {
        var e = Pr(!1);
        return Ar(function () {
          return function () {
            e.current = !0;
          };
        }, []), e;
      }(),
      E = Dr(function (_ref50) {
        var _ref51 = _slicedToArray(_ref50, 1),
          e = _ref51[0];
        w.current && clearTimeout(w.current), b.current > 1 ? v(function (t) {
          return 0 === e.contentRect.height ? f ? t : 47 : e.contentRect.height;
        }) : w.current = setTimeout(function () {
          return v(function (t) {
            return 0 === e.contentRect.height ? f ? t : 47 : e.contentRect.height;
          });
        }, 100), b.current++;
      }, []);
    Ar(function () {
      if (a) {
        var _e4 = document.getElementById("google-parent-prompt");
        if (_e4) {
          var _t3 = new ResizeObserver(E);
          return _t3.observe(_e4), function () {
            return _t3.disconnect();
          };
        }
      }
    }, [E, a]);
    var S = Dr(function () {
      return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var t, n, _xn, r, o, i, a;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (s) {
                _context12.next = 2;
                break;
              }
              return _context12.abrupt("return");
            case 2:
              _xn = xn(l);
              r = _xn.oneTap;
              _context12.next = 6;
              return r.createOneTapClient();
            case 6:
              o = _context12.sent;
              if (o.success) {
                _context12.next = 9;
                break;
              }
              return _context12.abrupt("return", void ("oauth_config_not_found" === o.reason ? C(fc.NoConfiguredOAuthClient) : "no_signup_redirect_urls_set" === o.reason ? C(fc.NoConfiguredSignupRedirectUrls) : "no_login_redirect_urls_set" === o.reason ? C(fc.NoConfiguredLoginRedirectUrls) : Ye("Unable to load One Tap settings for project", o)));
            case 9:
              i = o.client;
              if (!k.current) {
                _context12.next = 12;
                break;
              }
              return _context12.abrupt("return");
            case 12:
              _context12.next = 14;
              return i.render({
                callback: r.createOnSuccessHandler({
                  loginRedirectUrl: null === (t = c.oauthOptions) || void 0 === t ? void 0 : t.loginRedirectURL,
                  signupRedirectUrl: null === (n = c.oauthOptions) || void 0 === n ? void 0 : n.signupRedirectURL,
                  onSuccess: r.RedirectOnSuccess
                }),
                onOneTapCancelled: function onOneTapCancelled(e) {
                  g(!1), v(47), e && C(fc.OriginNotAllowedForClient);
                },
                style: {
                  position: e
                }
              });
            case 14:
              a = _context12.sent;
              if (k.current) {
                _context12.next = 17;
                break;
              }
              return _context12.abrupt("return", (g(a.success), p(!1), a.success || ("unregistered_origin" === a.reason && C(fc.OriginNotAllowedForClient), "invalid_client" === a.reason && C(fc.InvalidOAuthClient), Ye("Unable to render One Tap prompt", a)), i));
            case 17:
              i.cancel();
            case 18:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }));
    }, [s, l, k, null === (t = c.oauthOptions) || void 0 === t ? void 0 : t.loginRedirectURL, null === (n = c.oauthOptions) || void 0 === n ? void 0 : n.signupRedirectURL, e]);
    Ar(function () {
      var e;
      return S().then(function (t) {
        return e = t;
      })["catch"](function (e) {
        Ye("Unable to render One Tap prompt", e), g(!1), p(!1);
      }), function () {
        return null == e ? void 0 : e.cancel();
      };
    }, [S]);
    var x = Ko.createElement(nc, {
        key: "oauth-".concat(h.Google),
        providerType: h.Google,
        icon: Ko.createElement(rc, null),
        providerTypeTitle: "Google",
        loginRedirectUrl: null === (r = c.oauthOptions) || void 0 === r ? void 0 : r.loginRedirectURL,
        signupRedirectUrl: null === (o = c.oauthOptions) || void 0 === o ? void 0 : o.signupRedirectURL
      }),
      _xn2 = xn(l),
      O = _xn2.publicToken;
    return u ? Ko.createElement(hc, {
      enableShadowDOM: !!c.enableShadowDOM
    }) : y !== fc.None ? Ko.createElement(Ko.Fragment, null, et(O) ? mc[y] : null, x) : a && nn.WillGoogleOneTapShowEmbedded() ? Ko.createElement(gc, {
      pending: d,
      $height: _
    }, d && Ko.createElement(dc, {
      size: 25,
      thickness: 2
    }), f ? Ko.createElement(hc, {
      enableShadowDOM: !!c.enableShadowDOM
    }) : x) : x;
  };
var vc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M12.2227 6.25C13.0547 6.25 14.0977 5.65496 14.7188 4.86157C15.2813 4.14256 15.6914 3.13843 15.6914 2.1343C15.6914 1.99793 15.6797 1.86157 15.6563 1.75C14.7305 1.78719 13.6172 2.40702 12.9492 3.2376C12.4219 3.86983 11.9414 4.86157 11.9414 5.8781C11.9414 6.02686 11.9648 6.17562 11.9766 6.22521C12.0352 6.2376 12.1289 6.25 12.2227 6.25ZM9.29297 21.25C10.4297 21.25 10.9336 20.4442 12.3516 20.4442C13.793 20.4442 14.1094 21.2252 15.375 21.2252C16.6172 21.2252 17.4492 20.0103 18.2344 18.8202C19.1133 17.4566 19.4766 16.1178 19.5 16.0558C19.418 16.031 17.0391 15.0021 17.0391 12.1136C17.0391 9.6095 18.9141 8.4814 19.0195 8.39463C17.7773 6.51033 15.8906 6.46074 15.375 6.46074C13.9805 6.46074 12.8438 7.35331 12.1289 7.35331C11.3555 7.35331 10.3359 6.51033 9.12891 6.51033C6.83203 6.51033 4.5 8.51859 4.5 12.312C4.5 14.6674 5.36719 17.1591 6.43359 18.7707C7.34766 20.1343 8.14453 21.25 9.29297 21.25Z",
    fill: "black"
  }));
});
var yc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M12.0001 2.25C6.47791 2.25 2 6.72709 2 12.2501C2 16.6684 4.86533 20.4168 8.83867 21.7391C9.33844 21.8317 9.52192 21.5222 9.52192 21.2581C9.52192 21.0196 9.51265 20.2319 9.50834 19.3963C6.72631 20.0012 6.13927 18.2164 6.13927 18.2164C5.68437 17.0605 5.02894 16.7532 5.02894 16.7532C4.12163 16.1325 5.09733 16.1453 5.09733 16.1453C6.10151 16.2158 6.63026 17.1758 6.63026 17.1758C7.52217 18.7046 8.96965 18.2626 9.5403 18.0071C9.63006 17.3607 9.88922 16.9196 10.1752 16.6699C7.95405 16.417 5.61913 15.5595 5.61913 11.7278C5.61913 10.636 6.00977 9.74394 6.64947 9.04362C6.54564 8.79175 6.20335 7.77465 6.74635 6.39722C6.74635 6.39722 7.58609 6.12845 9.49708 7.42226C10.2948 7.20069 11.1502 7.08958 12.0001 7.08577C12.8499 7.08958 13.7061 7.20069 14.5052 7.42226C16.4139 6.12845 17.2525 6.39722 17.2525 6.39722C17.7968 7.77465 17.4544 8.79175 17.3505 9.04362C17.9917 9.74394 18.3797 10.636 18.3797 11.7278C18.3797 15.5687 16.0403 16.4144 13.8135 16.6619C14.1722 16.9723 14.4918 17.5808 14.4918 18.5138C14.4918 19.8518 14.4802 20.9287 14.4802 21.2581C14.4802 21.5242 14.6602 21.836 15.1671 21.7378C19.1383 20.414 22 16.6669 22 12.2501C22 6.72709 17.5227 2.25 12.0001 2.25ZM5.74536 16.4953C5.72333 16.545 5.64517 16.5599 5.57396 16.5258C5.50143 16.4932 5.46069 16.4254 5.48421 16.3756C5.50574 16.3244 5.58406 16.3102 5.65643 16.3445C5.72913 16.3771 5.77053 16.4455 5.74536 16.4953ZM6.23725 16.9342C6.18956 16.9785 6.09633 16.9579 6.03307 16.888C5.96766 16.8183 5.9554 16.7251 6.00376 16.6802C6.05294 16.636 6.14336 16.6567 6.20893 16.7264C6.27434 16.797 6.28709 16.8895 6.23725 16.9342ZM6.57471 17.4958C6.51344 17.5384 6.41325 17.4985 6.35132 17.4095C6.29004 17.3206 6.29004 17.214 6.35264 17.1712C6.41474 17.1285 6.51344 17.1669 6.5762 17.2552C6.6373 17.3456 6.6373 17.4523 6.57471 17.4958ZM7.14542 18.1462C7.09061 18.2066 6.97386 18.1904 6.88841 18.1079C6.80098 18.0273 6.77663 17.9129 6.83161 17.8524C6.88709 17.7918 7.0045 17.8089 7.09061 17.8907C7.17738 17.9711 7.20387 18.0864 7.14542 18.1462ZM7.88301 18.3657C7.85883 18.4441 7.74639 18.4797 7.63312 18.4464C7.52002 18.4121 7.446 18.3204 7.46885 18.2412C7.49237 18.1624 7.6053 18.1253 7.7194 18.1609C7.83234 18.195 7.90652 18.2861 7.88301 18.3657ZM8.72242 18.4589C8.72523 18.5413 8.62919 18.6097 8.51029 18.6112C8.39073 18.6139 8.29402 18.5471 8.29269 18.466C8.29269 18.3827 8.38659 18.315 8.50615 18.313C8.62505 18.3107 8.72242 18.3769 8.72242 18.4589ZM9.54704 18.4273C9.56128 18.5077 9.47865 18.5904 9.36058 18.6124C9.2445 18.6336 9.13702 18.5839 9.12229 18.5041C9.10788 18.4216 9.192 18.339 9.30792 18.3176C9.42616 18.2971 9.53197 18.3455 9.54704 18.4273Z",
    fill: "#161614"
  }));
});
var Cc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M22 12C22 6.47715 17.5229 2 12 2C6.47715 2 2 6.47715 2 12C2 16.9913 5.65685 21.1283 10.4375 21.8785V14.8906H7.89844V12H10.4375V9.79688C10.4375 7.29062 11.9304 5.90626 14.2146 5.90626C15.3087 5.90626 16.4531 6.10156 16.4531 6.10156V8.5625H15.1922C13.9499 8.5625 13.5625 9.33335 13.5625 10.1242V12H16.3359L15.8926 14.8906H13.5625V21.8785C18.3431 21.1283 22 16.9913 22 12Z",
    fill: "#1877F2"
  }), Ko.createElement("path", {
    d: "M15.8926 14.8906L16.3359 12H13.5625V10.1242C13.5625 9.33334 13.9499 8.5625 15.1921 8.5625H16.4531V6.10156C16.4531 6.10156 15.3087 5.90625 14.2146 5.90625C11.9304 5.90625 10.4375 7.29062 10.4375 9.79688V12H7.89844V14.8906H10.4375V21.8785C10.9544 21.9595 11.4768 22.0001 12 22C12.5316 22 13.0534 21.9584 13.5625 21.8785V14.8906H15.8926Z",
    fill: "white"
  }));
});
var bc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M9.52382 0.952381H0.952393V9.52381H9.52382V0.952381Z",
    fill: "#F25022"
  }), Ko.createElement("path", {
    d: "M9.52382 10.4762H0.952393V19.0476H9.52382V10.4762Z",
    fill: "#00A4EF"
  }), Ko.createElement("path", {
    d: "M19.0475 0.952381H10.4761V9.52381H19.0475V0.952381Z",
    fill: "#7FBA00"
  }), Ko.createElement("path", {
    d: "M19.0475 10.4762H10.4761V19.0476H19.0475V10.4762Z",
    fill: "#FFB900"
  }));
});
var wc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "-.1 .5 960.2 923.9",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "m958.9 442.4c1.1 26.1-2 52.1-9.2 77.2-7.1 25.1-18.3 48.8-33.1 70.3a240.43 240.43 0 0 1 -53.6 56.2l-.5.4-199.9 149.8-98.3 74.5-59.9 45.2c-3.5 2.7-7.4 4.7-11.5 6.1s-8.5 2.1-12.9 2.1c-4.3 0-8.7-.7-12.8-2.1s-8-3.4-11.5-6.1l-59.9-45.2-98.3-74.5-198.7-148.9-1.2-.8-.4-.4c-20.9-15.7-39-34.7-53.8-56.2s-26-45.3-33.2-70.4c-7.2-25.1-10.3-51.2-9.2-77.3 1.2-26.1 6.5-51.8 15.8-76.2l1.3-3.5 130.7-340.5q1-2.5 2.4-4.8 1.3-2.3 3.1-4.3 1.7-2.1 3.7-3.9 2-1.7 4.2-3.2c3.1-1.9 6.3-3.3 9.8-4.1 3.4-.9 7-1.3 10.5-1.1 3.6.2 7.1.9 10.4 2.2 3.3 1.2 6.5 3 9.3 5.2q2 1.7 3.9 3.6 1.8 2 3.2 4.3 1.5 2.2 2.6 4.7 1.1 2.4 1.8 5l88.1 269.7h356.6l88.1-269.7q.7-2.6 1.9-5 1.1-2.4 2.6-4.7 1.4-2.2 3.2-4.2 1.8-2 3.9-3.7c2.8-2.2 5.9-3.9 9.2-5.2 3.4-1.2 6.9-1.9 10.4-2.1 3.6-.2 7.1.1 10.6 1 3.4.9 6.7 2.3 9.7 4.2q2.3 1.4 4.3 3.2 2 1.7 3.7 3.8 1.7 2.1 3.1 4.4 1.3 2.3 2.3 4.8l130.5 340.6 1.3 3.5c9.3 24.3 14.6 50 15.7 76.1z",
    fill: "#e24329"
  }), Ko.createElement("path", {
    d: "m959 442.5c1.1 26-2 52.1-9.2 77.2s-18.4 48.9-33.2 70.4-32.9 40.5-53.7 56.2l-.5.4-199.9 149.8s-84.9-64.1-182.5-138l286.5-216.8c12.9-9.7 26.4-18.6 40.3-26.8 13.9-8.3 28.3-15.7 43-22.3 14.8-6.6 29.9-12.5 45.2-17.4 15.4-5 31-9.1 46.9-12.4l1.3 3.5c9.3 24.4 14.6 50.1 15.8 76.2z",
    fill: "#fc6d26"
  }), Ko.createElement("path", {
    d: "m480 658.5c97.6 73.7 182.6 138 182.6 138l-98.3 74.5-59.9 45.2c-3.5 2.7-7.4 4.7-11.5 6.1s-8.5 2.1-12.9 2.1c-4.3 0-8.7-.7-12.8-2.1s-8-3.4-11.5-6.1l-59.9-45.2-98.3-74.5s84.9-64.3 182.5-138z",
    fill: "#fca326"
  }), Ko.createElement("path", {
    d: "m480 658.3c-97.7 73.9-182.5 138-182.5 138l-198.7-148.9-1.2-.8-.4-.4c-20.9-15.7-39-34.7-53.8-56.2s-26-45.3-33.2-70.4c-7.2-25.1-10.3-51.2-9.2-77.3 1.2-26.1 6.5-51.8 15.8-76.2l1.3-3.5c15.9 3.3 31.5 7.4 46.9 12.4 15.3 5 30.4 10.8 45.2 17.5 14.7 6.6 29.1 14.1 43 22.3s27.3 17.2 40.3 26.9z",
    fill: "#fc6d26"
  }));
});
var kc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M18.5843 6.16943C17.3733 5.62815 16.0747 5.22936 14.7169 5.00096C14.6922 4.99655 14.6675 5.00757 14.6548 5.0296C14.4877 5.31896 14.3027 5.69645 14.1732 5.99316C12.7128 5.78018 11.2599 5.78018 9.8295 5.99316C9.69993 5.68986 9.50822 5.31896 9.34046 5.0296C9.32772 5.0083 9.30302 4.99729 9.27829 5.00096C7.92126 5.22863 6.62265 5.62742 5.41091 6.16943C5.40042 6.17384 5.39143 6.18119 5.38546 6.19073C2.92227 9.77548 2.2475 13.2721 2.57852 16.7254C2.58002 16.7423 2.58975 16.7584 2.60323 16.7687C4.22837 17.9313 5.8026 18.6371 7.3476 19.1049C7.37232 19.1123 7.39852 19.1035 7.41426 19.0836C7.77973 18.5975 8.10551 18.0848 8.38484 17.5457C8.40132 17.5142 8.38558 17.4767 8.35189 17.4642C7.83515 17.2733 7.3431 17.0405 6.86979 16.7761C6.83235 16.7548 6.82935 16.7026 6.86379 16.6776C6.96339 16.6049 7.06302 16.5293 7.15813 16.4529C7.17534 16.439 7.19932 16.436 7.21955 16.4448C10.329 17.8278 13.6954 17.8278 16.7682 16.4448C16.7884 16.4353 16.8124 16.4382 16.8303 16.4522C16.9255 16.5286 17.0251 16.6049 17.1254 16.6776C17.1599 16.7026 17.1576 16.7548 17.1202 16.7761C16.6469 17.0456 16.1548 17.2733 15.6373 17.4635C15.6036 17.476 15.5886 17.5142 15.6051 17.5457C15.8905 18.0841 16.2162 18.5967 16.575 19.0829C16.5899 19.1035 16.6169 19.1123 16.6416 19.1049C18.1941 18.6371 19.7683 17.9313 21.3935 16.7687C21.4077 16.7584 21.4167 16.743 21.4182 16.7261C21.8144 12.7338 20.7546 9.26579 18.609 6.19146C18.6038 6.18119 18.5948 6.17384 18.5843 6.16943ZM8.84918 14.6227C7.91302 14.6227 7.14165 13.7855 7.14165 12.7573C7.14165 11.7291 7.89806 10.8918 8.84918 10.8918C9.80777 10.8918 10.5717 11.7364 10.5567 12.7573C10.5567 13.7855 9.80028 14.6227 8.84918 14.6227ZM15.1625 14.6227C14.2264 14.6227 13.455 13.7855 13.455 12.7573C13.455 11.7291 14.2114 10.8918 15.1625 10.8918C16.1211 10.8918 16.885 11.7364 16.87 12.7573C16.87 13.7855 16.1211 14.6227 15.1625 14.6227Z",
    fill: "#5865F2"
  }));
});
var Ec = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M6.78176 14.3746C6.78176 15.4153 5.9316 16.2655 4.89088 16.2655C3.85016 16.2655 3 15.4153 3 14.3746C3 13.3339 3.85016 12.4837 4.89088 12.4837H6.78176V14.3746Z",
    fill: "#E01E5A"
  }), Ko.createElement("path", {
    d: "M7.73462 14.3746C7.73462 13.3339 8.58478 12.4837 9.6255 12.4837C10.6662 12.4837 11.5164 13.3339 11.5164 14.3746V19.1091C11.5164 20.1498 10.6662 21 9.6255 21C8.58478 21 7.73462 20.1498 7.73462 19.1091V14.3746Z",
    fill: "#E01E5A"
  }), Ko.createElement("path", {
    d: "M9.6255 6.78176C8.58478 6.78176 7.73462 5.9316 7.73462 4.89088C7.73462 3.85016 8.58478 3 9.6255 3C10.6662 3 11.5164 3.85016 11.5164 4.89088V6.78176H9.6255Z",
    fill: "#36C5F0"
  }), Ko.createElement("path", {
    d: "M9.62541 7.73453C10.6661 7.73453 11.5163 8.58469 11.5163 9.62541C11.5163 10.6661 10.6661 11.5163 9.62541 11.5163H4.89088C3.85016 11.5163 3 10.6661 3 9.62541C3 8.58469 3.85016 7.73453 4.89088 7.73453H9.62541Z",
    fill: "#36C5F0"
  }), Ko.createElement("path", {
    d: "M17.2183 9.62541C17.2183 8.58469 18.0684 7.73453 19.1091 7.73453C20.1499 7.73453 21 8.58469 21 9.62541C21 10.6661 20.1499 11.5163 19.1091 11.5163H17.2183V9.62541Z",
    fill: "#2EB67D"
  }), Ko.createElement("path", {
    d: "M16.2654 9.62541C16.2654 10.6661 15.4152 11.5163 14.3745 11.5163C13.3338 11.5163 12.4836 10.6661 12.4836 9.62541V4.89088C12.4836 3.85016 13.3338 3 14.3745 3C15.4152 3 16.2654 3.85016 16.2654 4.89088V9.62541Z",
    fill: "#2EB67D"
  }), Ko.createElement("path", {
    d: "M14.3745 17.2182C15.4152 17.2182 16.2654 18.0684 16.2654 19.1091C16.2654 20.1498 15.4152 21 14.3745 21C13.3338 21 12.4836 20.1498 12.4836 19.1091V17.2182H14.3745Z",
    fill: "#ECB22E"
  }), Ko.createElement("path", {
    d: "M14.3745 16.2655C13.3338 16.2655 12.4836 15.4153 12.4836 14.3746C12.4836 13.3339 13.3338 12.4837 14.3745 12.4837H19.109C20.1498 12.4837 20.9999 13.3339 20.9999 14.3746C20.9999 15.4153 20.1498 16.2655 19.109 16.2655H14.3745Z",
    fill: "#ECB22E"
  }));
});
var Sc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M7 11.9273C7 11.0909 7.20605 10.3758 7.61818 9.78182C8.03029 9.18787 8.59393 8.7394 9.30909 8.43636C9.96364 8.15758 10.7697 7.95758 11.7273 7.83636C12.0545 7.8 12.5879 7.75151 13.3273 7.69091V7.38182C13.3273 6.60605 13.2424 6.08485 13.0727 5.81818C12.8182 5.45455 12.4182 5.27273 11.8727 5.27273H11.7273C11.3273 5.30909 10.9818 5.43636 10.6909 5.65455C10.4 5.87273 10.2121 6.17576 10.1273 6.56364C10.0788 6.80605 9.95756 6.94545 9.76364 6.98182L7.67273 6.72727C7.46665 6.67878 7.36364 6.56969 7.36364 6.4C7.36364 6.36364 7.36969 6.32122 7.38182 6.27273C7.58787 5.19395 8.09393 4.39395 8.9 3.87273C9.70605 3.35151 10.6485 3.0606 11.7273 3H12.1818C13.5636 3 14.6424 3.35758 15.4182 4.07273C15.5399 4.19449 15.6523 4.32516 15.7545 4.46364C15.8576 4.60304 15.9394 4.72727 16 4.83636C16.0606 4.94545 16.1151 5.10304 16.1636 5.30909C16.2121 5.51515 16.2485 5.65758 16.2727 5.73636C16.297 5.81515 16.3151 5.98485 16.3273 6.24545C16.3394 6.50605 16.3455 6.6606 16.3455 6.70909V11.1091C16.3455 11.4242 16.3909 11.7121 16.4818 11.9727C16.5727 12.2333 16.6606 12.4212 16.7455 12.5364C16.8303 12.6515 16.9697 12.8364 17.1636 13.0909C17.2364 13.2 17.2727 13.297 17.2727 13.3818C17.2727 13.4788 17.2242 13.5636 17.1273 13.6364C16.1212 14.5091 15.5757 14.9818 15.4909 15.0545C15.3455 15.1636 15.1697 15.1758 14.9636 15.0909C14.7939 14.9455 14.6455 14.8061 14.5182 14.6727C14.3909 14.5394 14.3 14.4424 14.2455 14.3818C14.1909 14.3212 14.103 14.203 13.9818 14.0273C13.8606 13.8515 13.7757 13.7333 13.7273 13.6727C13.0485 14.4121 12.3818 14.8727 11.7273 15.0545C11.3151 15.1758 10.8061 15.2364 10.2 15.2364C9.26665 15.2364 8.5 14.9485 7.9 14.3727C7.3 13.797 7 12.9818 7 11.9273ZM10.1273 11.5636C10.1273 12.0364 10.2455 12.4151 10.4818 12.7C10.7182 12.9849 11.0364 13.1273 11.4364 13.1273C11.4727 13.1273 11.5242 13.1212 11.5909 13.1091C11.6576 13.097 11.703 13.0909 11.7273 13.0909C12.2364 12.9576 12.6303 12.6303 12.9091 12.1091C13.0424 11.8788 13.1424 11.6273 13.2091 11.3545C13.2757 11.0818 13.3121 10.8606 13.3182 10.6909C13.3242 10.5212 13.3273 10.2424 13.3273 9.85455V9.4C12.6242 9.4 12.0909 9.44849 11.7273 9.54545C10.6606 9.84849 10.1273 10.5212 10.1273 11.5636Z",
    fill: "black"
  }), Ko.createElement("path", {
    d: "M2.32727 16.4424C2.19393 16.3576 2.09696 16.3636 2.03636 16.4606C2.01211 16.497 2 16.5333 2 16.5697C2 16.6303 2.03636 16.6909 2.10909 16.7515C3.44242 17.9515 4.95151 18.8818 6.63636 19.5424C8.3212 20.203 10.1091 20.5333 12 20.5333C13.2242 20.5333 14.4788 20.3636 15.7636 20.0242C17.0485 19.6848 18.2121 19.2061 19.2545 18.5879C19.5939 18.3818 19.8727 18.2 20.0909 18.0424C20.2606 17.9212 20.2939 17.7879 20.1909 17.6424C20.0879 17.497 19.9455 17.4606 19.7636 17.5333C19.7151 17.5576 19.6333 17.5939 19.5182 17.6424C19.403 17.6909 19.3151 17.7273 19.2545 17.7515C16.9394 18.6364 14.5939 19.0788 12.2182 19.0788C8.65455 19.0788 5.35756 18.2 2.32727 16.4424Z",
    fill: "#FF9900"
  }), Ko.createElement("path", {
    d: "M18.3818 16.6242C18.3333 16.6727 18.297 16.7212 18.2727 16.7697C18.2606 16.7939 18.2545 16.8121 18.2545 16.8242C18.2424 16.8485 18.2485 16.8727 18.2727 16.897C18.297 16.9212 18.3455 16.9333 18.4182 16.9333C18.6727 16.897 18.9515 16.8606 19.2545 16.8242C19.5333 16.8 19.7757 16.7879 19.9818 16.7879C20.5394 16.7879 20.8788 16.8606 21 17.0061C21.0485 17.0667 21.0727 17.1636 21.0727 17.297C21.0727 17.7091 20.8485 18.4424 20.4 19.497C20.3636 19.5939 20.3818 19.6606 20.4545 19.697C20.4788 19.7091 20.503 19.7152 20.5273 19.7152C20.5757 19.7152 20.6303 19.6909 20.6909 19.6424C21.103 19.2909 21.4242 18.8273 21.6545 18.2515C21.8848 17.6758 22 17.1758 22 16.7515V16.6242C22 16.4788 21.9757 16.3697 21.9273 16.297C21.8182 16.1636 21.4909 16.0727 20.9455 16.0242C20.8364 16 20.7212 15.9939 20.6 16.0061C20.1636 16.0182 19.7151 16.0848 19.2545 16.2061C18.9757 16.2788 18.6848 16.4182 18.3818 16.6242Z",
    fill: "#FF9900"
  }));
});
var xc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M6.98153 7.125C6.68181 7.125 6.45702 7.39974 6.50697 7.67449L8.53009 20.0629C8.58004 20.3877 8.85479 20.6124 9.17948 20.6124H18.9704C19.1952 20.6124 19.395 20.4376 19.4449 20.2128L21.493 7.69947C21.543 7.39974 21.3182 7.14998 21.0185 7.14998L6.98153 7.125ZM15.5736 16.0667H12.4514L11.6272 11.6458H16.3478L15.5736 16.0667Z",
    fill: "#2684FF"
  }), Ko.createElement("path", {
    d: "M20.8186 11.6458H16.3228L15.5735 16.0667H12.4513L8.77979 20.4376C8.77979 20.4376 8.95462 20.5875 9.20439 20.5875H18.9953C19.2201 20.5875 19.4199 20.4126 19.4698 20.1878L20.8186 11.6458Z",
    fill: "url(#paint0_linear_414_2186)"
  }), Ko.createElement("path", {
    d: "M2 2V0.875H0.875V2H2ZM26 2H27.125V0.875H26V2ZM26 26V27.125H27.125V26H26ZM2 26H0.875V27.125H2V26ZM2 3.125H26V0.875H2V3.125ZM24.875 2V26H27.125V2H24.875ZM26 24.875H2V27.125H26V24.875ZM3.125 26V2H0.875V26H3.125Z",
    fill: "#E5E8EB"
  }), Ko.createElement("defs", null, Ko.createElement("linearGradient", {
    id: "paint0_linear_414_2186",
    x1: "21.8703",
    y1: "12.8916",
    x2: "14.42",
    y2: "18.7072",
    gradientUnits: "userSpaceOnUse"
  }, Ko.createElement("stop", {
    offset: "0.176",
    stopColor: "#0052CC"
  }), Ko.createElement("stop", {
    offset: "1",
    stopColor: "#2684FF"
  }))));
});
var Oc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21Z",
    fill: "#0A66C2"
  }), Ko.createElement("path", {
    d: "M18.5 18.5H15.8289V13.9505C15.8289 12.7032 15.3549 12.0061 14.3677 12.0061C13.2937 12.0061 12.7325 12.7315 12.7325 13.9505V18.5H10.1583V9.83333H12.7325V11.0007C12.7325 11.0007 13.5065 9.56855 15.3456 9.56855C17.1839 9.56855 18.5 10.6911 18.5 13.0128V18.5ZM7.08734 8.6985C6.21051 8.6985 5.5 7.98241 5.5 7.09925C5.5 6.21609 6.21051 5.5 7.08734 5.5C7.96416 5.5 8.67425 6.21609 8.67425 7.09925C8.67425 7.98241 7.96416 8.6985 7.08734 8.6985ZM5.75814 18.5H8.44235V9.83333H5.75814V18.5Z",
    fill: "white"
  }));
});
var Lc = $s(function () {
  return Ko.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: "1.2",
    baseProfile: "tiny",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    overflow: "visible",
    xmlSpace: "preserve"
  }, Ko.createElement("path", {
    fill: "#0052FF",
    d: "M512,0L512,0c282.8,0,512,229.2,512,512l0,0c0,282.8-229.2,512-512,512l0,0C229.2,1024,0,794.8,0,512l0,0  C0,229.2,229.2,0,512,0z"
  }), Ko.createElement("path", {
    fill: "#FFFFFF",
    d: "M512.1,692c-99.4,0-180-80.5-180-180s80.6-180,180-180c89.1,0,163.1,65,177.3,150h181.3  c-15.3-184.8-170-330-358.7-330c-198.8,0-360,161.2-360,360s161.2,360,360,360c188.7,0,343.4-145.2,358.7-330H689.3  C675,627,601.2,692,512.1,692z"
  }));
});
var Ac = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M16.1141 9.78571L13.257 12.6429H10.3998L7.89983 15.1429V12.6429H4.68555V1.92857H16.1141V9.78571Z",
    fill: "white"
  }), Ko.createElement("path", {
    d: "M3.97133 0.5L0.399902 4.07143V16.9286H4.68562V20.5L8.25704 16.9286H11.1142L17.5428 10.5V0.5H3.97133ZM16.1142 9.78571L13.257 12.6429H10.3999L7.8999 15.1429V12.6429H4.68562V1.92857H16.1142V9.78571Z",
    fill: "#9146FF"
  }), Ko.createElement("path", {
    d: "M13.9713 4.42857H12.5427V8.71428H13.9713V4.42857Z",
    fill: "#9146FF"
  }), Ko.createElement("path", {
    d: "M10.0428 4.42857H8.61426V8.71428H10.0428V4.42857Z",
    fill: "#9146FF"
  }));
});
var Tc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M19.8991 8.13629C19.9112 8.31129 19.9112 8.48629 19.9112 8.66291C19.9112 14.0444 15.8144 20.2508 8.32331 20.2508V20.2476C6.1104 20.2508 3.94347 19.6169 2.08057 18.4218C2.40234 18.4605 2.72573 18.4798 3.04992 18.4806C4.88379 18.4823 6.66524 17.8669 8.10799 16.7339C6.36524 16.7008 4.83702 15.5645 4.30315 13.9056C4.91363 14.0234 5.54266 13.9992 6.14186 13.8355C4.24186 13.4516 2.87492 11.7823 2.87492 9.84355C2.87492 9.82581 2.87492 9.80887 2.87492 9.79194C3.44105 10.1073 4.07492 10.2823 4.72331 10.3016C2.93379 9.10565 2.38218 6.725 3.46282 4.86371C5.53057 7.40807 8.58137 8.95484 11.8564 9.11855C11.5281 7.70403 11.9765 6.22178 13.0346 5.22742C14.6749 3.68549 17.2548 3.76452 18.7967 5.40403C19.7088 5.2242 20.583 4.88952 21.383 4.41532C21.079 5.35807 20.4427 6.15887 19.5927 6.66774C20.3999 6.57258 21.1886 6.35645 21.9314 6.02661C21.3846 6.84597 20.6959 7.55968 19.8991 8.13629Z",
    fill: "#1D9BF0"
  }));
});
var Pc = $s(function () {
  return Ko.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10",
    fill: "black"
  }), Ko.createElement("path", {
    d: "M14.9767 10.0746C15.8641 10.7087 16.9513 11.0817 18.1255 11.0817V8.8234C17.9033 8.82344 17.6816 8.80028 17.4642 8.75425V10.5319C16.2901 10.5319 15.2031 10.1588 14.3154 9.52481V14.1334C14.3154 16.4389 12.4455 18.3077 10.139 18.3077C9.27835 18.3077 8.47845 18.0477 7.81396 17.6017C8.57236 18.3767 9.63 18.8575 10.8001 18.8575C13.1067 18.8575 14.9767 16.9887 14.9767 14.6832V10.0746H14.9767ZM15.7924 7.79623C15.3389 7.30099 15.0411 6.66099 14.9767 5.95344V5.66297H14.35C14.5077 6.56226 15.0458 7.33057 15.7924 7.79623ZM9.27283 15.8325C9.01944 15.5005 8.8825 15.0942 8.88312 14.6766C8.88312 13.6221 9.7384 12.7672 10.7936 12.7672C10.9902 12.7671 11.1857 12.7972 11.3731 12.8567V10.5478C11.1541 10.5178 10.9331 10.5051 10.7121 10.5098V12.3068C10.5246 12.2474 10.329 12.2172 10.1323 12.2174C9.07713 12.2174 8.22189 13.0723 8.22189 14.1268C8.22189 14.8725 8.64939 15.5181 9.27283 15.8325Z",
    fill: "#FF004F"
  }), Ko.createElement("path", {
    d: "M14.3153 9.52476C15.203 10.1588 16.29 10.5318 17.4641 10.5318V8.7542C16.8087 8.61467 16.2285 8.27236 15.7923 7.79623C15.0456 7.33052 14.5076 6.56222 14.3499 5.66297H12.7039V14.6831C12.7001 15.7346 11.8463 16.5861 10.7934 16.5861C10.1729 16.5861 9.6217 16.2905 9.27259 15.8325C8.6492 15.5181 8.2217 14.8725 8.2217 14.1269C8.2217 13.0724 9.07693 12.2175 10.1321 12.2175C10.3343 12.2175 10.5291 12.2489 10.7119 12.3069V10.5098C8.44594 10.5566 6.62354 12.4072 6.62354 14.6831C6.62354 15.8192 7.07736 16.8492 7.81391 17.6017C8.47839 18.0477 9.2783 18.3078 10.1389 18.3078C12.4455 18.3078 14.3153 16.4389 14.3153 14.1334V9.52476H14.3153Z",
    fill: "white"
  }), Ko.createElement("path", {
    d: "M17.464 8.7542V8.27354C16.873 8.27443 16.2936 8.10901 15.7922 7.79618C16.236 8.28188 16.8205 8.61679 17.464 8.7542ZM14.3498 5.66297C14.3347 5.57703 14.3231 5.49052 14.3151 5.40368V5.1132H12.0424V14.1334C12.0388 15.1848 11.185 16.0363 10.132 16.0363C9.82282 16.0363 9.53093 15.9629 9.27244 15.8326C9.62154 16.2905 10.1728 16.586 10.7932 16.586C11.8461 16.586 12.7 15.7347 12.7037 14.6831V5.66297H14.3498ZM10.7119 10.5098V9.99811C10.522 9.97217 10.3305 9.95915 10.1388 9.95924C7.83206 9.9592 5.96216 11.8281 5.96216 14.1334C5.96216 15.5787 6.69706 16.8524 7.81381 17.6016C7.07725 16.8491 6.62343 15.8191 6.62343 14.6831C6.62343 12.4072 8.44579 10.5566 10.7119 10.5098Z",
    fill: "#00F2EA"
  }));
});
var Mc = $s(function () {
  return Ko.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M18.549 15.4187C16.124 14.2448 15.7375 12.4323 15.7203 12.2978C15.6995 12.135 15.6759 12.007 15.8555 11.8413C16.0288 11.6813 16.7974 11.2055 17.0106 11.0567C17.3631 10.8102 17.5184 10.5642 17.4039 10.2617C17.3239 10.0524 17.1291 9.9736 16.9238 9.9736C16.8591 9.9738 16.7945 9.98105 16.7313 9.99521C16.344 10.0792 15.9679 10.2733 15.7503 10.3257C15.7241 10.3324 15.6973 10.3361 15.6703 10.3365C15.5542 10.3365 15.5102 10.2849 15.5214 10.1453C15.5486 9.72194 15.6062 8.89571 15.5394 8.12391C15.4478 7.06202 15.1053 6.53588 14.6992 6.07055C14.5027 5.84489 13.5905 4.87543 11.83 4.87543C10.0696 4.87543 9.15851 5.84489 8.96326 6.06775C8.55595 6.53308 8.21385 7.05922 8.12303 8.12111C8.05621 8.89291 8.11623 9.71874 8.14104 10.1425C8.14904 10.2753 8.10823 10.3337 7.9922 10.3337C7.96519 10.3332 7.93833 10.3296 7.91217 10.3229C7.69492 10.2705 7.31881 10.0764 6.93151 9.99241C6.86833 9.97825 6.8038 9.971 6.73906 9.9708C6.533 9.9708 6.33895 10.0508 6.25893 10.2589C6.1445 10.5614 6.29894 10.8074 6.65263 11.0539C6.86589 11.2027 7.6345 11.6781 7.80775 11.8385C7.98699 12.0042 7.96379 12.1322 7.94298 12.295C7.92578 12.4315 7.53887 14.244 5.11422 15.4159C4.97218 15.4847 4.73052 15.6303 5.15663 15.8656C5.82561 16.2353 6.27093 16.1957 6.61702 16.4185C6.9107 16.6078 6.73706 17.0159 6.95071 17.1631C7.21319 17.3444 7.98899 17.1503 8.99126 17.4812C9.83149 17.7581 10.342 18.5403 11.832 18.5403C13.322 18.5403 13.8474 17.7545 14.6728 17.4812C15.6731 17.1503 16.4505 17.3444 16.7133 17.1631C16.9266 17.0159 16.7534 16.6078 17.047 16.4185C17.3931 16.1957 17.838 16.2353 18.5074 15.8656C18.9327 15.6331 18.6911 15.4875 18.549 15.4187Z",
    fill: "white"
  }), Ko.createElement("path", {
    d: "M19.604 15.2806C19.4952 14.9846 19.2879 14.8261 19.0519 14.6949C19.0075 14.6689 18.9666 14.6481 18.9318 14.6321C18.8614 14.5957 18.7894 14.5604 18.7178 14.5232C17.982 14.1331 17.4074 13.641 17.0089 13.0576C16.8957 12.8934 16.7976 12.7193 16.7156 12.5375C16.6816 12.4403 16.6832 12.3851 16.7076 12.3346C16.7318 12.2958 16.7639 12.2624 16.8017 12.2366C16.9281 12.153 17.0585 12.0682 17.147 12.011C17.3046 11.9089 17.4294 11.8281 17.5099 11.7709C17.8119 11.5596 18.0232 11.3352 18.1552 11.0843C18.2473 10.911 18.3011 10.7199 18.3127 10.5239C18.3244 10.328 18.2937 10.1318 18.2228 9.9488C18.0228 9.42226 17.5255 9.09537 16.9229 9.09537C16.7958 9.09525 16.669 9.10866 16.5448 9.13538C16.5116 9.14258 16.4784 9.15019 16.446 9.15859C16.4516 8.79849 16.4436 8.41839 16.4116 8.04429C16.2979 6.72913 15.8374 6.03975 15.3573 5.49C15.0498 5.14551 14.6877 4.85405 14.2854 4.62737C13.5568 4.21126 12.7306 4 11.8299 4C10.9293 4 10.1071 4.21126 9.37766 4.62737C8.9744 4.85412 8.61152 5.14616 8.30377 5.4916C7.82364 6.04135 7.36312 6.73194 7.24949 8.04589C7.21748 8.41999 7.20948 8.80209 7.21468 9.16019C7.18227 9.15179 7.14946 9.14419 7.11625 9.13698C6.992 9.11026 6.86525 9.09685 6.73815 9.09697C6.13519 9.09697 5.63705 9.42386 5.4378 9.9504C5.36658 10.1335 5.33561 10.3298 5.347 10.5259C5.35839 10.7221 5.41188 10.9135 5.50382 11.0871C5.63625 11.338 5.84751 11.5624 6.14959 11.7737C6.22961 11.8297 6.35485 11.9105 6.51249 12.0138C6.59771 12.069 6.72215 12.1498 6.84418 12.2306C6.88687 12.2582 6.92316 12.2946 6.95061 12.3374C6.97621 12.3899 6.97702 12.4463 6.939 12.5503C6.85816 12.7283 6.76162 12.8988 6.65053 13.0596C6.26082 13.6298 5.70307 14.1131 4.99088 14.5C4.61358 14.7001 4.22147 14.8337 4.05583 15.2838C3.93099 15.6235 4.01262 16.01 4.3299 16.3357C4.44635 16.4573 4.58141 16.5595 4.73001 16.6386C5.03921 16.8085 5.368 16.9401 5.70907 17.0303C5.77946 17.0485 5.84628 17.0784 5.90673 17.1187C6.02236 17.22 6.00595 17.3724 6.15999 17.5957C6.23732 17.711 6.33557 17.8109 6.44967 17.8901C6.77296 18.1134 7.13626 18.1274 7.52116 18.1422C7.86885 18.1554 8.26296 18.1706 8.71308 18.3191C8.89953 18.3807 9.09318 18.4999 9.31765 18.6391C9.85659 18.9704 10.5944 19.4238 11.8291 19.4238C13.0639 19.4238 13.8069 18.968 14.3498 18.6355C14.5727 18.4987 14.7651 18.3807 14.9464 18.3207C15.3965 18.1718 15.7906 18.157 16.1383 18.1438C16.5232 18.129 16.8865 18.115 17.2098 17.8917C17.3449 17.7975 17.4575 17.6745 17.5395 17.5316C17.6503 17.3432 17.6475 17.2116 17.7515 17.1195C17.8082 17.0811 17.871 17.0524 17.9372 17.0347C18.2829 16.9442 18.6162 16.8114 18.9294 16.6394C19.0873 16.5547 19.2294 16.4434 19.3495 16.3105L19.3535 16.3057C19.6512 15.9872 19.726 15.6119 19.604 15.2806ZM18.5065 15.8704C17.8371 16.2401 17.3922 16.2005 17.0461 16.4233C16.752 16.6126 16.9261 17.0207 16.7124 17.1679C16.45 17.3492 15.6742 17.1551 14.6719 17.486C13.8453 17.7593 13.3179 18.5451 11.8311 18.5451C10.3443 18.5451 9.82938 17.7609 8.98916 17.484C7.98889 17.1531 7.21148 17.3472 6.94861 17.1659C6.73535 17.0187 6.9086 16.6106 6.61492 16.4213C6.26842 16.1985 5.8235 16.2381 5.15452 15.8704C4.72841 15.6351 4.97007 15.4895 5.11211 15.4207C7.53677 14.2468 7.92367 12.4343 7.94087 12.2998C7.96168 12.137 7.98489 12.009 7.80564 11.8433C7.63239 11.6833 6.86378 11.2075 6.65053 11.0587C6.29763 10.8122 6.14239 10.5662 6.25682 10.2637C6.33684 10.0544 6.5321 9.97561 6.73695 9.97561C6.80169 9.97581 6.86623 9.98305 6.9294 9.99722C7.31671 10.0812 7.69281 10.2753 7.91007 10.3277C7.93623 10.3344 7.96308 10.338 7.99009 10.3385C8.10612 10.3385 8.14693 10.2801 8.13893 10.1473C8.11412 9.72354 8.05411 8.89772 8.12092 8.12591C8.21255 7.06402 8.55464 6.53788 8.96115 6.07256C9.1564 5.8489 10.0738 4.87944 11.8283 4.87944C13.5828 4.87944 14.5026 5.8449 14.6979 6.06776C15.1048 6.53308 15.4473 7.05922 15.5381 8.12111C15.6049 8.89292 15.5473 9.71914 15.5201 10.1425C15.5109 10.2821 15.5529 10.3337 15.669 10.3337C15.696 10.3333 15.7228 10.3296 15.749 10.3229C15.9666 10.2705 16.3427 10.0764 16.73 9.99241C16.7932 9.97825 16.8577 9.97101 16.9225 9.97081C17.1285 9.97081 17.3226 10.0508 17.4026 10.2589C17.5171 10.5614 17.3626 10.8074 17.0093 11.0539C16.7961 11.2027 16.0275 11.6781 15.8542 11.8385C15.6746 12.0042 15.6982 12.1322 15.719 12.295C15.7362 12.4315 16.1227 14.244 18.5477 15.4159C18.691 15.4875 18.9326 15.6331 18.5065 15.8704Z",
    fill: "black"
  }));
});
var Rc = $s(function () {
  return Ko.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M12.3157 12C12.3157 10.1591 13.7295 8.66665 15.4736 8.66665C17.2176 8.66665 18.6315 10.1591 18.6315 12C18.6315 13.8409 17.2176 15.3333 15.4736 15.3333C13.7295 15.3333 12.3157 13.8409 12.3157 12Z",
    fill: "#1ABCFE"
  }), Ko.createElement("path", {
    d: "M6 18.6666C6 16.8257 7.41384 15.3333 9.15789 15.3333H12.3158V18.6666C12.3158 20.5076 10.902 22 9.15789 22C7.41384 22 6 20.5076 6 18.6666Z",
    fill: "#0ACF83"
  }), Ko.createElement("path", {
    d: "M12.3157 2V8.66665H15.4736C17.2176 8.66665 18.6315 7.17428 18.6315 5.33333C18.6315 3.49238 17.2176 2 15.4736 2H12.3157Z",
    fill: "#FF7262"
  }), Ko.createElement("path", {
    d: "M6 5.33333C6 7.17428 7.41384 8.66665 9.15789 8.66665H12.3158V2H9.15789C7.41384 2 6 3.49238 6 5.33333Z",
    fill: "#F24E1E"
  }), Ko.createElement("path", {
    d: "M6 12C6 13.8409 7.41384 15.3333 9.15789 15.3333H12.3158V8.66665H9.15789C7.41384 8.66665 6 10.1591 6 12Z",
    fill: "#A259FF"
  }));
});
var Dc = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("g", {
    clipPath: "url(#clip0_1550_2151)"
  }, Ko.createElement("path", {
    d: "M8.3228 1.52737C8.96783 0.855295 9.86583 0.438458 10.859 0.438458C12.1792 0.438458 13.3311 1.17463 13.9445 2.26751C14.4775 2.02935 15.0675 1.89686 15.6883 1.89686C18.0695 1.89686 20 3.84416 20 6.24615C20 8.64841 18.0695 10.5957 15.6883 10.5957C15.4031 10.5959 15.1186 10.5675 14.839 10.5111C14.2989 11.4746 13.2695 12.1256 12.088 12.1256C11.5935 12.1256 11.1256 12.0114 10.7091 11.8082C10.1615 13.0963 8.88577 13.9994 7.39886 13.9994C5.85043 13.9994 4.53077 13.0196 4.02422 11.6456C3.80286 11.6926 3.57351 11.7171 3.33818 11.7171C1.49459 11.7171 0 10.2071 0 8.34416C0 7.09573 0.671511 6.00568 1.66923 5.4225C1.46382 4.94987 1.34957 4.42821 1.34957 3.87976C1.34957 1.73732 3.08889 0.000579834 5.23419 0.000579834C6.49373 0.000579834 7.61311 0.599439 8.3228 1.52737Z",
    fill: "#00A1E0"
  }), Ko.createElement("path", {
    d: "M2.89685 7.26004C2.88432 7.29281 2.90142 7.29966 2.9054 7.30535C2.943 7.33269 2.9812 7.35237 3.01965 7.37429C3.22364 7.48254 3.41625 7.51416 3.61767 7.51416C4.02792 7.51416 4.28262 7.29594 4.28262 6.94465V6.93782C4.28262 6.61301 3.99517 6.49508 3.72536 6.40989L3.69033 6.3985C3.4869 6.33239 3.31141 6.27544 3.31141 6.14152V6.13442C3.31141 6.01988 3.41397 5.93554 3.57295 5.93554C3.74958 5.93554 3.95927 5.99424 4.09431 6.06887C4.09431 6.06887 4.13391 6.09452 4.14844 6.05606C4.15641 6.03554 4.2248 5.85149 4.23193 5.83155C4.23961 5.80989 4.22594 5.79393 4.21199 5.78539C4.05785 5.69165 3.84474 5.62755 3.62424 5.62755L3.58322 5.62783C3.20772 5.62783 2.94562 5.85462 2.94562 6.17968V6.18653C2.94562 6.52925 3.23479 6.64036 3.50574 6.71786L3.54932 6.73125C3.74676 6.79193 3.91685 6.84407 3.91685 6.9831V6.98995C3.91685 7.11702 3.80632 7.21159 3.62796 7.21159C3.55873 7.21159 3.33793 7.21017 3.09947 7.05944C3.07069 7.04262 3.05389 7.03039 3.03167 7.017C3.01999 7.00959 2.99065 6.99676 2.97783 7.03552L2.89685 7.26004ZM8.90282 7.26004C8.89029 7.29281 8.90738 7.29966 8.91137 7.30535C8.94896 7.33269 8.98716 7.35237 9.0256 7.37429C9.22958 7.48254 9.42222 7.51416 9.62362 7.51416C10.0339 7.51416 10.2886 7.29594 10.2886 6.94465V6.93782C10.2886 6.61301 10.0011 6.49508 9.73131 6.40989L9.69627 6.3985C9.49285 6.33239 9.31733 6.27544 9.31733 6.14152V6.13442C9.31733 6.01988 9.41989 5.93554 9.57887 5.93554C9.75551 5.93554 9.9652 5.99424 10.1003 6.06887C10.1003 6.06887 10.1399 6.09452 10.1544 6.05606C10.1623 6.03554 10.2307 5.85149 10.2379 5.83155C10.2456 5.80989 10.2319 5.79393 10.2179 5.78539C10.0638 5.69165 9.85067 5.62755 9.63016 5.62755L9.58912 5.62783C9.21363 5.62783 8.95153 5.85462 8.95153 6.17968V6.18653C8.95153 6.52925 9.2407 6.64036 9.51165 6.71786L9.55523 6.73125C9.75267 6.79193 9.92306 6.84407 9.92306 6.9831V6.98995C9.92306 7.11702 9.81223 7.21159 9.63387 7.21159C9.56466 7.21159 9.34386 7.21017 9.1054 7.05944C9.07661 7.04262 9.05953 7.03095 9.03789 7.017C9.03047 7.01215 8.99571 6.99876 8.98374 7.03552L8.90282 7.26004ZM13.0029 6.57195C13.0029 6.77053 12.9659 6.92693 12.893 7.03748C12.8209 7.14689 12.7118 7.20016 12.5597 7.20016C12.4072 7.20016 12.2987 7.14717 12.2277 7.03748C12.1559 6.92723 12.1195 6.77053 12.1195 6.57195C12.1195 6.37367 12.1559 6.21754 12.2277 6.10813C12.2987 5.99988 12.4072 5.94717 12.5597 5.94717C12.7118 5.94717 12.8209 5.99988 12.8933 6.10813C12.9659 6.21752 13.0029 6.37365 13.0029 6.57195ZM13.3454 6.20386C13.3118 6.09017 13.2594 5.98989 13.1896 5.90643C13.1198 5.82266 13.0314 5.75544 12.9266 5.70643C12.822 5.65772 12.6984 5.63293 12.5597 5.63293C12.4206 5.63293 12.297 5.65772 12.1924 5.70643C12.0876 5.75544 11.9993 5.82268 11.9292 5.90643C11.8597 5.99019 11.8072 6.09047 11.7733 6.20386C11.74 6.31696 11.7232 6.4406 11.7232 6.57195C11.7232 6.7033 11.74 6.82723 11.7733 6.94004C11.8072 7.05343 11.8594 7.15373 11.9295 7.23748C11.9993 7.32124 12.0879 7.38819 12.1924 7.43576C12.2973 7.48334 12.4206 7.50755 12.5597 7.50755C12.6984 7.50755 12.8218 7.48334 12.9266 7.43576C13.0312 7.38819 13.1198 7.32122 13.1896 7.23748C13.2594 7.15399 13.3118 7.05371 13.3454 6.94004C13.3791 6.82695 13.3959 6.703 13.3959 6.57195C13.3959 6.4409 13.379 6.31696 13.3454 6.20386ZM16.1576 7.14713C16.1462 7.11379 16.114 7.12633 16.114 7.12633C16.0641 7.14543 16.0111 7.16308 15.9547 7.17191C15.8974 7.18072 15.8345 7.18531 15.7669 7.18531C15.6012 7.18531 15.4695 7.13602 15.3752 7.03858C15.2806 6.94114 15.2276 6.7836 15.2282 6.57049C15.2288 6.37648 15.2755 6.23059 15.3596 6.1195C15.443 6.00897 15.5701 5.95225 15.7396 5.95225C15.8809 5.95225 15.9886 5.96849 16.1014 6.00411C16.1014 6.00411 16.1285 6.01578 16.1413 5.98046C16.1712 5.89726 16.1934 5.83772 16.2253 5.74627C16.2345 5.72034 16.2122 5.70923 16.2043 5.70609C16.1598 5.68871 16.055 5.66052 15.9758 5.64855C15.9017 5.63716 15.8151 5.63117 15.7188 5.63117C15.5749 5.63117 15.4467 5.65568 15.337 5.70469C15.2276 5.75339 15.1347 5.82062 15.0613 5.90441C14.9877 5.98817 14.9319 6.08843 14.8946 6.20182C14.8576 6.31492 14.8388 6.43914 14.8388 6.57049C14.8388 6.85454 14.9154 7.08415 15.0667 7.25225C15.2182 7.42092 15.4459 7.50667 15.7428 7.50667C15.9183 7.50667 16.0983 7.47107 16.2277 7.42006C16.2277 7.42006 16.2524 7.40809 16.2416 7.37934L16.1576 7.14713ZM16.7567 6.38172C16.773 6.27147 16.8035 6.17972 16.8505 6.10823C16.9214 5.99968 17.0297 5.94014 17.1818 5.94014C17.334 5.94014 17.4345 5.99996 17.5066 6.10823C17.5545 6.17972 17.5753 6.27548 17.5835 6.38172H16.7567ZM17.9097 6.13926C17.8807 6.02957 17.8086 5.91874 17.7613 5.86803C17.6866 5.78769 17.6137 5.73157 17.5414 5.70022C17.4468 5.65976 17.3334 5.63299 17.2092 5.63299C17.0644 5.63299 16.9331 5.65722 16.8265 5.70735C16.7197 5.7575 16.63 5.82589 16.5596 5.91107C16.4892 5.99596 16.4362 6.0971 16.4026 6.21191C16.3687 6.32617 16.3516 6.45067 16.3516 6.58198C16.3516 6.71562 16.3693 6.84012 16.4043 6.95207C16.4397 7.06491 16.496 7.16433 16.5724 7.24665C16.6485 7.32957 16.7465 7.39454 16.8639 7.4398C16.9804 7.48483 17.122 7.50819 17.2847 7.50789C17.6194 7.50675 17.7958 7.43211 17.8684 7.39193C17.8813 7.38483 17.8935 7.37229 17.8781 7.3364L17.8023 7.12413C17.7909 7.09251 17.7587 7.10419 17.7587 7.10419C17.6758 7.13496 17.5579 7.19023 17.2829 7.18967C17.1032 7.18939 16.9698 7.1364 16.8863 7.05347C16.8006 6.96859 16.7587 6.84378 16.7513 6.66773L17.9106 6.66887C17.9106 6.66887 17.941 6.66831 17.9442 6.63866C17.9453 6.62617 17.9841 6.40052 17.9097 6.13926ZM7.47275 6.38172C7.48926 6.27147 7.51947 6.17972 7.56648 6.10823C7.63741 5.99968 7.74568 5.94014 7.89781 5.94014C8.04994 5.94014 8.15053 5.99996 8.22288 6.10823C8.27044 6.17972 8.29125 6.27548 8.29951 6.38172H7.47275ZM8.62544 6.13926C8.59639 6.02957 8.5246 5.91874 8.47731 5.86803C8.40266 5.78769 8.32972 5.73157 8.25737 5.70022C8.16278 5.65976 8.0494 5.63299 7.92518 5.63299C7.78074 5.63299 7.6491 5.65722 7.54256 5.70735C7.43573 5.7575 7.34598 5.82589 7.27561 5.91107C7.20524 5.99596 7.15225 6.0971 7.11863 6.21191C7.08502 6.32617 7.06764 6.45067 7.06764 6.58198C7.06764 6.71562 7.0853 6.84012 7.12036 6.95207C7.15569 7.06491 7.21211 7.16433 7.28844 7.24665C7.36452 7.32957 7.46252 7.39454 7.5799 7.4398C7.69643 7.48483 7.83801 7.50819 8.0007 7.50789C8.33545 7.50675 8.51181 7.43211 8.58446 7.39193C8.59729 7.38483 8.60952 7.37229 8.59415 7.3364L8.51865 7.12413C8.50696 7.09251 8.47479 7.10419 8.47479 7.10419C8.39189 7.13496 8.27421 7.19023 7.99871 7.18967C7.81923 7.18939 7.6859 7.1364 7.60242 7.05347C7.51665 6.96859 7.47479 6.84378 7.46736 6.66773L8.62662 6.66887C8.62662 6.66887 8.65709 6.66831 8.66023 6.63866C8.66134 6.62617 8.70007 6.40052 8.62544 6.13926ZM4.96702 7.14078C4.92172 7.10459 4.91545 7.09548 4.90007 7.07211C4.87727 7.0365 4.8656 6.98579 4.8656 6.9214C4.8656 6.8194 4.89921 6.74619 4.96902 6.6969C4.96818 6.6972 5.06874 6.61001 5.3052 6.61313C5.47129 6.61542 5.61971 6.63992 5.61971 6.63992V7.16699H5.62C5.62 7.16699 5.47271 7.1986 5.3069 7.20857C5.07101 7.22282 4.96616 7.1405 4.96702 7.14078ZM5.42826 6.32625C5.38126 6.32282 5.32028 6.32082 5.24734 6.32082C5.14792 6.32082 5.05191 6.33335 4.96188 6.35758C4.87129 6.38178 4.7898 6.4197 4.71971 6.46981C4.64973 6.51976 4.59221 6.58518 4.55163 6.66098C4.51061 6.73734 4.4898 6.82737 4.4898 6.92823C4.4898 7.03079 4.50746 7.11996 4.5428 7.19291C4.57813 7.26613 4.62912 7.32709 4.69407 7.37412C4.75845 7.42112 4.83795 7.45558 4.93025 7.47638C5.02114 7.49718 5.12426 7.50771 5.23709 7.50771C5.35589 7.50771 5.47441 7.49804 5.58922 7.47836C5.7029 7.45898 5.8425 7.43077 5.88124 7.42196C5.9084 7.41542 5.93547 7.40848 5.96244 7.40116C5.99123 7.39405 5.98894 7.36326 5.98894 7.36326L5.98836 6.30316C5.98836 6.07067 5.92626 5.8983 5.80404 5.79147C5.68238 5.68493 5.50318 5.63105 5.27157 5.63105C5.18466 5.63105 5.04478 5.64304 4.96102 5.65984C4.96102 5.65984 4.70774 5.70885 4.60346 5.79033C4.60346 5.79033 4.58068 5.80459 4.59321 5.8365L4.67527 6.05702C4.68552 6.08551 4.71317 6.07582 4.71317 6.07582C4.71317 6.07582 4.722 6.07239 4.73227 6.06641C4.95535 5.94505 5.23739 5.94875 5.23739 5.94875C5.36276 5.94875 5.45905 5.97381 5.524 6.02366C5.58724 6.07209 5.61943 6.14531 5.61943 6.29972V6.34873C5.51971 6.3345 5.42826 6.32625 5.42826 6.32625ZM14.7782 5.72893C14.787 5.7027 14.7685 5.69017 14.7608 5.68733C14.7412 5.67964 14.6426 5.65884 14.5665 5.65399C14.4209 5.64517 14.34 5.66967 14.2676 5.70214C14.1959 5.73462 14.1161 5.78703 14.0716 5.84659V5.70557C14.0716 5.68591 14.0577 5.67023 14.0383 5.67023H13.7411C13.7218 5.67023 13.7078 5.68589 13.7078 5.70557V7.43462C13.7078 7.45399 13.7238 7.46995 13.7431 7.46995H14.0477C14.057 7.4699 14.066 7.46615 14.0725 7.45952C14.0791 7.4529 14.0828 7.44394 14.0827 7.43462V6.57081C14.0827 6.45486 14.0956 6.3392 14.1212 6.26655C14.1463 6.19474 14.1805 6.1372 14.2226 6.09588C14.2651 6.05486 14.3132 6.02609 14.3659 6.00985C14.4198 5.99331 14.4793 5.98791 14.5215 5.98791C14.5822 5.98791 14.6488 6.00356 14.6488 6.00356C14.671 6.00613 14.6836 5.99245 14.691 5.97223C14.7109 5.91924 14.7674 5.76054 14.7782 5.72893Z",
    fill: "white"
  }), Ko.createElement("path", {
    d: "M11.9195 4.92756C11.8825 4.91617 11.8489 4.90846 11.805 4.90022C11.7605 4.89225 11.7075 4.88824 11.6474 4.88824C11.4377 4.88824 11.2725 4.9475 11.1566 5.0643C11.0412 5.18056 10.9628 5.35747 10.9235 5.59025L10.9092 5.66858H10.646C10.646 5.66858 10.6141 5.66744 10.6072 5.70222L10.5642 5.94352C10.5611 5.96632 10.5711 5.98084 10.6018 5.98084H10.858L10.5981 7.43155C10.5779 7.54836 10.5545 7.64438 10.5286 7.71729C10.5032 7.78911 10.4785 7.84294 10.4477 7.88226C10.4181 7.91988 10.3901 7.94778 10.3417 7.96402C10.3018 7.97741 10.2557 7.98368 10.2052 7.98368C10.1773 7.98368 10.14 7.9791 10.1124 7.97341C10.085 7.96798 10.0705 7.96202 10.0497 7.95317C10.0497 7.95317 10.0198 7.9418 10.0078 7.97171C9.99839 7.99649 9.93003 8.18422 9.92176 8.20732C9.91379 8.23039 9.92518 8.24834 9.9397 8.25375C9.97389 8.26572 9.99924 8.27369 10.0457 8.2848C10.1101 8.29992 10.1645 8.30076 10.2155 8.30076C10.322 8.30076 10.4195 8.28566 10.5001 8.25661C10.581 8.22726 10.6516 8.17625 10.7143 8.10732C10.7819 8.03267 10.8243 7.95461 10.8648 7.84778C10.9049 7.74236 10.9394 7.61131 10.9668 7.45861L11.228 5.98084H11.6098C11.6098 5.98084 11.642 5.98198 11.6485 5.94694L11.6918 5.70592C11.6947 5.68286 11.685 5.66861 11.6539 5.66861H11.2833C11.2853 5.66036 11.3021 5.52985 11.3445 5.40708C11.3628 5.35495 11.397 5.31249 11.4257 5.28342C11.4543 5.25493 11.487 5.23471 11.5229 5.22302C11.5597 5.21105 11.6016 5.20536 11.6474 5.20536C11.6822 5.20536 11.7166 5.20935 11.7426 5.21475C11.7785 5.22246 11.7924 5.22644 11.8018 5.22931C11.8397 5.2407 11.8448 5.22959 11.8523 5.21137L11.9409 4.96806C11.95 4.9418 11.9275 4.93069 11.9195 4.92756ZM6.74074 7.43469C6.74074 7.45407 6.72678 7.46975 6.7074 7.46975H6.4C6.38062 7.46975 6.36694 7.45407 6.36694 7.43469V4.96062C6.36694 4.94126 6.38062 4.92558 6.4 4.92558H6.7074C6.72678 4.92558 6.74074 4.94126 6.74074 4.96062V7.43469Z",
    fill: "white"
  })));
});
var Fc = $s(function () {
  return Ko.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Yahoo!",
    role: "img",
    viewBox: "0 0 512 512",
    fill: "#ffffff"
  }, Ko.createElement("rect", {
    width: "512",
    height: "512",
    rx: "15%",
    fill: "#5f01d1"
  }), Ko.createElement("g", {
    fill: "#ffffff"
  }, Ko.createElement("path", {
    d: "M203 404h-62l25-59-69-165h63l37 95 37-95h62m58 76h-69l62-148h69"
  }), Ko.createElement("circle", {
    cx: "303",
    cy: "308",
    r: "38"
  })));
});
var jc = function jc() {
    var e = Ds();
    if (!e.oauthOptions) return $n(zn, null);
    var _e$oauthOptions = e.oauthOptions,
      t = _e$oauthOptions.providers,
      n = _e$oauthOptions.loginRedirectURL,
      r = _e$oauthOptions.signupRedirectURL;
    return $n(Hs, {
      direction: "column",
      gap: 8,
      className: "oauth-buttons"
    }, t.map(function (e) {
      var _ref52 = function (e) {
          switch (e) {
            case h.Google:
              return {
                providerTypeTitle: "Google",
                icon: $n(rc, null)
              };
            case h.Microsoft:
              return {
                providerTypeTitle: "Microsoft",
                icon: $n(bc, null)
              };
            case h.Apple:
              return {
                providerTypeTitle: "Apple",
                icon: $n(vc, null)
              };
            case h.Github:
              return {
                providerTypeTitle: "GitHub",
                icon: $n(yc, null)
              };
            case h.GitLab:
              return {
                providerTypeTitle: "GitLab",
                icon: $n(wc, null)
              };
            case h.Facebook:
              return {
                providerTypeTitle: "Facebook",
                icon: $n(Cc, null)
              };
            case h.Discord:
              return {
                providerTypeTitle: "Discord",
                icon: $n(kc, null)
              };
            case h.Salesforce:
              return {
                providerTypeTitle: "Salesforce",
                icon: $n(Dc, null)
              };
            case h.Slack:
              return {
                providerTypeTitle: "Slack",
                icon: $n(Ec, null)
              };
            case h.Amazon:
              return {
                providerTypeTitle: "Amazon",
                icon: $n(Sc, null)
              };
            case h.Bitbucket:
              return {
                providerTypeTitle: "Bitbucket",
                icon: $n(xc, null)
              };
            case h.LinkedIn:
              return {
                providerTypeTitle: "LinkedIn",
                icon: $n(Oc, null)
              };
            case h.Coinbase:
              return {
                providerTypeTitle: "Coinbase",
                icon: $n(Lc, null)
              };
            case h.Twitch:
              return {
                providerTypeTitle: "Twitch",
                icon: $n(Ac, null)
              };
            case h.Twitter:
              return {
                providerTypeTitle: "Twitter",
                icon: $n(Tc, null)
              };
            case h.TikTok:
              return {
                providerTypeTitle: "TikTok",
                icon: $n(Pc, null)
              };
            case h.Snapchat:
              return {
                providerTypeTitle: "Snapchat",
                icon: $n(Mc, null)
              };
            case h.Figma:
              return {
                providerTypeTitle: "Figma",
                icon: $n(Rc, null)
              };
            case h.Yahoo:
              return {
                providerTypeTitle: "Yahoo",
                icon: $n(Fc, null)
              };
            default:
              return {
                providerTypeTitle: "",
                icon: $n(zn, null)
              };
          }
        }(e.type),
        t = _ref52.icon,
        o = _ref52.providerTypeTitle;
      return e.one_tap ? $n(_c, {
        position: e.position,
        key: "oauth-".concat(e.type)
      }) : $n(nc, {
        key: "oauth-".concat(e.type),
        providerType: e.type,
        icon: t,
        providerTypeTitle: o,
        customScopes: e.custom_scopes,
        loginRedirectUrl: n,
        signupRedirectUrl: r,
        providerParams: e.provider_params
      });
    }));
  },
  Ic = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? Tr : function () {},
  Bc = Go["useId".toString()] || function () {};
var Nc = 0;
function Hc(e) {
  var _Or11 = Or(Bc()),
    _Or12 = _slicedToArray(_Or11, 2),
    t = _Or12[0],
    n = _Or12[1];
  return Ic(function () {
    e || n(function (e) {
      return null != e ? e : String(Nc++);
    });
  }, [e]), e || (t ? "radix-".concat(t) : "");
}
function Uc(e) {
  var t = Pr(e);
  return Ar(function () {
    t.current = e;
  }), Rr(function () {
    return function () {
      var _n4;
      var n;
      for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        e[_key2] = arguments[_key2];
      }
      return null === (n = t.current) || void 0 === n ? void 0 : (_n4 = n).call.apply(_n4, [t].concat(e));
    };
  }, []);
}
function $c(_ref53) {
  var e = _ref53.prop,
    t = _ref53.defaultProp,
    _ref53$onChange = _ref53.onChange,
    n = _ref53$onChange === void 0 ? function () {} : _ref53$onChange;
  var _ref54 = function (_ref56) {
      var e = _ref56.defaultProp,
        t = _ref56.onChange;
      var n = Or(e),
        _n5 = _slicedToArray(n, 1),
        r = _n5[0],
        o = Pr(r),
        i = Uc(t);
      return Ar(function () {
        o.current !== r && (i(r), o.current = r);
      }, [r, o, i]), n;
    }({
      defaultProp: t,
      onChange: n
    }),
    _ref55 = _slicedToArray(_ref54, 2),
    r = _ref55[0],
    o = _ref55[1],
    i = void 0 !== e,
    a = i ? e : r,
    s = Uc(n);
  return [a, Dr(function (t) {
    if (i) {
      var _n6 = "function" == typeof t ? t(e) : t;
      _n6 !== e && s(_n6);
    } else o(t);
  }, [i, e, o, s])];
}
function Vc() {
  for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    e[_key3] = arguments[_key3];
  }
  return function (t) {
    return e.forEach(function (e) {
      return function (e, t) {
        "function" == typeof e ? e(t) : null != e && (e.current = t);
      }(e, t);
    });
  };
}
function Zc() {
  for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    e[_key4] = arguments[_key4];
  }
  return Dr(Vc.apply(void 0, e), e);
}
function zc() {
  return zc = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zc.apply(this, arguments);
}
var Wc = Jr(function (e, t) {
  var n = e.children,
    r = Wt(e, ["children"]);
  return Qr.toArray(n).some(qc) ? $n(zn, null, Qr.map(n, function (e) {
    return qc(e) ? $n(Kc, zc({}, r, {
      ref: t
    }), e.props.children) : e;
  })) : $n(Kc, zc({}, r, {
    ref: t
  }), n);
});
Wc.displayName = "Slot";
var Kc = Jr(function (e, t) {
  var n = e.children,
    r = Wt(e, ["children"]);
  return Mo(n) ? Do(n, Object.assign(Object.assign({}, function (e, t) {
    var n = Object.assign({}, t);
    var _loop = function _loop() {
      var o = e[_r4],
        i = t[_r4];
      /^on[A-Z]/.test(_r4) ? n[_r4] = function () {
        null == i || i.apply(void 0, arguments), null == o || o.apply(void 0, arguments);
      } : "style" === _r4 ? n[_r4] = Object.assign(Object.assign({}, o), i) : "className" === _r4 && (n[_r4] = [o, i].filter(Boolean).join(" "));
    };
    for (var _r4 in t) {
      _loop();
    }
    return Object.assign(Object.assign({}, e), n);
  }(r, n.props)), {
    ref: Vc(t, n.ref)
  })) : Qr.count(n) > 1 ? Qr.only(null) : null;
});
Kc.displayName = "SlotClone";
var Gc = function Gc(_ref57) {
  var e = _ref57.children;
  return $n(zn, null, e);
};
function qc(e) {
  return Mo(e) && e.type === Gc;
}
var Yc = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (e, t) {
  return Object.assign(Object.assign({}, e), _defineProperty({}, t, Jr(function (e, n) {
    var r = e.asChild,
      o = Wt(e, ["asChild"]),
      i = r ? Wc : t;
    return Ar(function () {
      window[Symbol["for"]("radix-ui")] = !0;
    }, []), $n(i, zc({}, o, {
      ref: n
    }));
  })));
}, {});
function Jc(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var n = [];
  var r = function r() {
    var t = n.map(function (e) {
      return hr(e);
    });
    return function (n) {
      var r = (null == n ? void 0 : n[e]) || t;
      return Rr(function () {
        return _defineProperty({}, "__scope".concat(e), Object.assign(Object.assign({}, n), _defineProperty({}, e, r)));
      }, [n, r]);
    };
  };
  return r.scopeName = e, [function (t, r) {
    var o = hr(r),
      i = n.length;
    function a(t) {
      var n = t.scope,
        r = t.children,
        a = Wt(t, ["scope", "children"]),
        s = (null == n ? void 0 : n[e][i]) || o,
        c = Rr(function () {
          return a;
        }, Object.values(a));
      return $n(s.Provider, {
        value: c
      }, r);
    }
    return n = [].concat(_toConsumableArray(n), [r]), a.displayName = t + "Provider", [a, function (n, a) {
      var s = Fr((null == a ? void 0 : a[e][i]) || o);
      if (s) return s;
      if (void 0 !== r) return r;
      throw new Error("`".concat(n, "` must be used within `").concat(t, "`"));
    }];
  }, Xc.apply(void 0, [r].concat(_toConsumableArray(t)))];
}
function Xc() {
  for (var _len5 = arguments.length, e = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    e[_key5] = arguments[_key5];
  }
  var t = e[0];
  if (1 === e.length) return t;
  var n = function n() {
    var n = e.map(function (e) {
      return {
        useScope: e(),
        scopeName: e.scopeName
      };
    });
    return function (e) {
      var r = n.reduce(function (t, _ref59) {
        var n = _ref59.useScope,
          r = _ref59.scopeName;
        return Object.assign(Object.assign({}, t), n(e)["__scope".concat(r)]);
      }, {});
      return Rr(function () {
        return _defineProperty({}, "__scope".concat(t.scopeName), r);
      }, [r]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Qc(e, t) {
  var _ref61 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref61$checkForDefaul = _ref61.checkForDefaultPrevented,
    n = _ref61$checkForDefaul === void 0 ? !0 : _ref61$checkForDefaul;
  return function (r) {
    if (null == e || e(r), !1 === n || !r.defaultPrevented) return null == t ? void 0 : t(r);
  };
}
var el = {
    bubbles: !1,
    cancelable: !0
  },
  _ref62 = function (e) {
    var t = e + "CollectionProvider",
      _Jc3 = Jc(t),
      _Jc4 = _slicedToArray(_Jc3, 2),
      n = _Jc4[0],
      r = _Jc4[1],
      _n7 = n(t, {
        collectionRef: {
          current: null
        },
        itemMap: new Map()
      }),
      _n8 = _slicedToArray(_n7, 2),
      o = _n8[0],
      i = _n8[1],
      a = e + "CollectionSlot",
      s = Ko.forwardRef(function (e, t) {
        var n = e.scope,
          r = e.children,
          o = Zc(t, i(a, n).collectionRef);
        return Ko.createElement(Wc, {
          ref: o
        }, r);
      }),
      c = e + "CollectionItemSlot",
      l = "data-radix-collection-item",
      u = Ko.forwardRef(function (e, t) {
        var n = e.scope,
          r = e.children,
          o = Wt(e, ["scope", "children"]),
          a = Ko.useRef(null),
          s = Zc(t, a),
          u = i(c, n);
        return Ko.useEffect(function () {
          return u.itemMap.set(a, Object.assign({
            ref: a
          }, o)), function () {
            u.itemMap["delete"](a);
          };
        }), Ko.createElement(Wc, _defineProperty(_defineProperty({}, l, ""), "ref", s), r);
      });
    return [{
      Provider: function Provider(e) {
        var t = e.scope,
          n = e.children,
          r = Ko.useRef(null),
          i = Ko.useRef(new Map()).current;
        return Ko.createElement(o, {
          scope: t,
          itemMap: i,
          collectionRef: r
        }, n);
      },
      Slot: s,
      ItemSlot: u
    }, function (t) {
      var n = i(e + "CollectionConsumer", t);
      return Ko.useCallback(function () {
        var e = n.collectionRef.current;
        if (!e) return [];
        var t = Array.from(e.querySelectorAll("[".concat(l, "]")));
        return Array.from(n.itemMap.values()).sort(function (e, n) {
          return t.indexOf(e.ref.current) - t.indexOf(n.ref.current);
        });
      }, [n.collectionRef, n.itemMap]);
    }, r];
  }("RovingFocusGroup"),
  _ref63 = _slicedToArray(_ref62, 3),
  tl = _ref63[0],
  nl = _ref63[1],
  rl = _ref63[2],
  _Jc = Jc("RovingFocusGroup", [rl]),
  _Jc2 = _slicedToArray(_Jc, 2),
  ol = _Jc2[0],
  il = _Jc2[1],
  _ol = ol("RovingFocusGroup"),
  _ol2 = _slicedToArray(_ol, 2),
  al = _ol2[0],
  sl = _ol2[1],
  cl = Jr(function (e, t) {
    return $n(tl.Provider, {
      scope: e.__scopeRovingFocusGroup
    }, $n(tl.Slot, {
      scope: e.__scopeRovingFocusGroup
    }, $n(ll, zc({}, e, {
      ref: t
    }))));
  }),
  ll = Jr(function (e, t) {
    var n = e.__scopeRovingFocusGroup,
      r = e.orientation,
      _e$dir = e.dir,
      o = _e$dir === void 0 ? "ltr" : _e$dir,
      _e$loop = e.loop,
      i = _e$loop === void 0 ? !1 : _e$loop,
      a = e.currentTabStopId,
      s = e.defaultCurrentTabStopId,
      c = e.onCurrentTabStopIdChange,
      l = e.onEntryFocus,
      u = Wt(e, ["__scopeRovingFocusGroup", "orientation", "dir", "loop", "currentTabStopId", "defaultCurrentTabStopId", "onCurrentTabStopIdChange", "onEntryFocus"]),
      d = Pr(null),
      p = Zc(t, d),
      _$c = $c({
        prop: a,
        defaultProp: s,
        onChange: c
      }),
      _$c2 = _slicedToArray(_$c, 2),
      _$c2$ = _$c2[0],
      h = _$c2$ === void 0 ? null : _$c2$,
      f = _$c2[1],
      _Or13 = Or(!1),
      _Or14 = _slicedToArray(_Or13, 2),
      m = _Or14[0],
      g = _Or14[1],
      _ = Uc(l),
      v = nl(n),
      y = Pr(!1);
    return Ar(function () {
      var e = d.current;
      if (e) return e.addEventListener("rovingFocusGroup.onEntryFocus", _), function () {
        return e.removeEventListener("rovingFocusGroup.onEntryFocus", _);
      };
    }, [_]), $n(al, {
      scope: n,
      orientation: r,
      dir: o,
      loop: i,
      currentTabStopId: h,
      onItemFocus: Dr(function (e) {
        return f(e);
      }, [f]),
      onItemShiftTab: Dr(function () {
        return g(!0);
      }, [])
    }, $n(Yc.div, zc({
      tabIndex: m ? -1 : 0,
      "data-orientation": r
    }, u, {
      ref: p,
      style: Object.assign({
        outline: "none"
      }, e.style),
      onMouseDown: Qc(e.onMouseDown, function () {
        y.current = !0;
      }),
      onFocus: Qc(e.onFocus, function (e) {
        var t = !y.current;
        if (e.target === e.currentTarget && t && !m) {
          var _t4 = new Event("rovingFocusGroup.onEntryFocus", el);
          if (e.currentTarget.dispatchEvent(_t4), !_t4.defaultPrevented) {
            var _e5 = v().filter(function (e) {
              return e.focusable;
            });
            pl([_e5.find(function (e) {
              return e.active;
            }), _e5.find(function (e) {
              return e.id === h;
            })].concat(_toConsumableArray(_e5)).filter(Boolean).map(function (e) {
              return e.ref.current;
            }));
          }
        }
        y.current = !1;
      }),
      onBlur: Qc(e.onBlur, function () {
        return g(!1);
      })
    })));
  }),
  ul = Jr(function (e, t) {
    var n = e.__scopeRovingFocusGroup,
      _e$focusable = e.focusable,
      r = _e$focusable === void 0 ? !0 : _e$focusable,
      _e$active = e.active,
      o = _e$active === void 0 ? !1 : _e$active,
      i = Wt(e, ["__scopeRovingFocusGroup", "focusable", "active"]),
      a = Hc(),
      s = sl("RovingFocusGroupItem", n),
      c = s.currentTabStopId === a,
      l = nl(n);
    return $n(tl.ItemSlot, {
      scope: n,
      id: a,
      focusable: r,
      active: o
    }, $n(Yc.span, zc({
      tabIndex: c ? 0 : -1,
      "data-orientation": s.orientation
    }, i, {
      ref: t,
      onMouseDown: Qc(e.onMouseDown, function (e) {
        r ? s.onItemFocus(a) : e.preventDefault();
      }),
      onFocus: Qc(e.onFocus, function () {
        return s.onItemFocus(a);
      }),
      onKeyDown: Qc(e.onKeyDown, function (e) {
        if ("Tab" === e.key && e.shiftKey) return void s.onItemShiftTab();
        if (e.target !== e.currentTarget) return;
        var t = function (e, t, n) {
          var r = function (e, t) {
            return "rtl" !== t ? e : "ArrowLeft" === e ? "ArrowRight" : "ArrowRight" === e ? "ArrowLeft" : e;
          }(e.key, n);
          return "vertical" === t && ["ArrowLeft", "ArrowRight"].includes(r) || "horizontal" === t && ["ArrowUp", "ArrowDown"].includes(r) ? void 0 : dl[r];
        }(e, s.orientation, s.dir);
        if (void 0 !== t) {
          e.preventDefault();
          var _o3 = l().filter(function (e) {
            return e.focusable;
          }).map(function (e) {
            return e.ref.current;
          });
          if ("last" === t) _o3.reverse();else if ("prev" === t || "next" === t) {
            "prev" === t && _o3.reverse();
            var _i2 = _o3.indexOf(e.currentTarget);
            _o3 = s.loop ? (r = _i2 + 1, (n = _o3).map(function (e, t) {
              return n[(r + t) % n.length];
            })) : _o3.slice(_i2 + 1);
          }
          setTimeout(function () {
            return pl(_o3);
          });
        }
        var n, r;
      })
    })));
  }),
  dl = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };
function pl(e) {
  var t = document.activeElement;
  var _iterator = _createForOfIteratorHelper(e),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _n9 = _step.value;
      if (_n9 === t) return;
      if (_n9.focus(), document.activeElement !== t) return;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
var hl = cl,
  fl = ul,
  _Jc5 = Jc("Tabs", [il]),
  _Jc6 = _slicedToArray(_Jc5, 2),
  ml = _Jc6[0],
  gl = _Jc6[1],
  _l = il(),
  _ml = ml("Tabs"),
  _ml2 = _slicedToArray(_ml, 2),
  vl = _ml2[0],
  yl = _ml2[1],
  Cl = Jr(function (e, t) {
    var n = e.__scopeTabs,
      r = e.value,
      o = e.onValueChange,
      i = e.defaultValue,
      _e$orientation = e.orientation,
      a = _e$orientation === void 0 ? "horizontal" : _e$orientation,
      _e$dir2 = e.dir,
      s = _e$dir2 === void 0 ? "ltr" : _e$dir2,
      _e$activationMode = e.activationMode,
      c = _e$activationMode === void 0 ? "automatic" : _e$activationMode,
      l = Wt(e, ["__scopeTabs", "value", "onValueChange", "defaultValue", "orientation", "dir", "activationMode"]),
      _$c3 = $c({
        prop: r,
        onChange: o,
        defaultProp: i
      }),
      _$c4 = _slicedToArray(_$c3, 2),
      u = _$c4[0],
      d = _$c4[1];
    return $n(vl, {
      scope: n,
      baseId: Hc(),
      value: u,
      onValueChange: d,
      orientation: a,
      dir: s,
      activationMode: c
    }, $n(Yc.div, zc({
      "data-orientation": a
    }, l, {
      ref: t
    })));
  }),
  bl = Jr(function (e, t) {
    var n = e.__scopeTabs,
      _e$loop2 = e.loop,
      r = _e$loop2 === void 0 ? !0 : _e$loop2,
      o = Wt(e, ["__scopeTabs", "loop"]),
      i = yl("TabsList", n),
      a = _l(n);
    return $n(hl, zc({
      asChild: !0
    }, a, {
      orientation: i.orientation,
      dir: i.dir,
      loop: r
    }), $n(Yc.div, zc({
      role: "tablist",
      "aria-orientation": i.orientation,
      dir: i.dir
    }, o, {
      ref: t
    })));
  }),
  wl = Jr(function (e, t) {
    var n = e.__scopeTabs,
      r = e.value,
      _e$disabled = e.disabled,
      o = _e$disabled === void 0 ? !1 : _e$disabled,
      i = Wt(e, ["__scopeTabs", "value", "disabled"]),
      a = yl("TabsTrigger", n),
      s = _l(n),
      c = El(a.baseId, r),
      l = Sl(a.baseId, r),
      u = r === a.value;
    return $n(fl, zc({
      asChild: !0
    }, s, {
      focusable: !o,
      active: u
    }), $n(Yc.button, zc({
      type: "button",
      role: "tab",
      "aria-selected": u,
      "aria-controls": l,
      "data-state": u ? "active" : "inactive",
      "data-disabled": o ? "" : void 0,
      disabled: o,
      id: c
    }, i, {
      ref: t,
      onMouseDown: Qc(e.onMouseDown, function (e) {
        o || 0 !== e.button || !1 !== e.ctrlKey ? e.preventDefault() : a.onValueChange(r);
      }),
      onKeyDown: Qc(e.onKeyDown, function (e) {
        [" ", "Enter"].includes(e.key) && a.onValueChange(r);
      }),
      onFocus: Qc(e.onFocus, function () {
        var e = "manual" !== a.activationMode;
        u || o || !e || a.onValueChange(r);
      })
    })));
  }),
  kl = Jr(function (e, t) {
    var n = e.__scopeTabs,
      r = e.value,
      o = e.children,
      i = Wt(e, ["__scopeTabs", "value", "children"]),
      a = yl("TabsContent", n),
      s = El(a.baseId, r),
      c = Sl(a.baseId, r),
      l = r === a.value;
    return $n(Yc.div, zc({
      "data-state": l ? "active" : "inactive",
      "data-orientation": a.orientation,
      role: "tabpanel",
      "aria-labelledby": s,
      hidden: !l,
      id: c,
      tabIndex: 0
    }, i, {
      ref: t
    }), l && o);
  });
function El(e, t) {
  return "".concat(e, "-trigger-").concat(t);
}
function Sl(e, t) {
  return "".concat(e, "-content-").concat(t);
}
var xl = Cl,
  Ol = bl,
  Ll = wl,
  Al = kl,
  Tl = bs.select(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", ";\n  height: 47px;\n  box-sizing: border-box;\n  padding: 0 8px;\n  color: ", ";\n  font-family: ", ";\n  width: 80px;\n  font-size: 18px;\n"])), function (e) {
    return e.theme.inputs.backgroundColor;
  }, function (e) {
    return e.theme.inputs.borderColor;
  }, function (e) {
    return e.theme.inputs.borderRadius;
  }, function (e) {
    return e.theme.inputs.textColor;
  }, function (e) {
    return e.theme.typography.fontFamily;
  }),
  Pl = function Pl(_ref58) {
    var e = _ref58.country,
      t = _ref58.setCountry;
    var n = new Intl.DisplayNames(["en"], {
      type: "region"
    });
    return Ko.createElement(Tl, {
      "data-testid": "select-test-id",
      value: e,
      onChange: function onChange(e) {
        t(e.target.value);
      }
    }, Object.entries(Qe).map(function (_ref60) {
      var _ref64 = _slicedToArray(_ref60, 2),
        t = _ref64[0],
        r = _ref64[1];
      return Ko.createElement("option", {
        key: t,
        value: t
      }, t !== e ? "+".concat(r, " ").concat(n.of(t)) : "+".concat(r));
    }));
  },
  Ml = bs.input(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 47px;\n  padding: 0 8px;\n  box-sizing: border-box;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled {\n    border: 1px solid ", ";\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (e) {
    return e.theme.inputs.backgroundColor;
  }, function (e) {
    return e.theme.inputs.borderColor;
  }, function (e) {
    return e.theme.inputs.borderRadius;
  }, function (e) {
    return e.theme.inputs.textColor;
  }, function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    return e.theme.inputs.placeholderColor;
  }, function (e) {
    return e.theme.colors.disabledText;
  }, function (e) {
    return e.theme.colors.disabledText;
  }, function (e) {
    return e.theme.colors.disabled;
  }),
  Rl = bs(Ml)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n"]))),
  Dl = function Dl(_ref65) {
    var e = _ref65.phone,
      t = _ref65.setPhone,
      n = _ref65.country,
      r = _ref65.setCountry,
      o = _ref65.parsePhoneNumber,
      i = _ref65.hasPasskeys;
    return Ko.createElement(Hs, {
      direction: "row",
      wrap: "nowrap",
      justifyContent: "flex-start",
      alignContent: "stretch",
      alignItems: "center",
      gap: 8
    }, Ko.createElement(Pl, {
      country: n,
      setCountry: r
    }), Ko.createElement(Rl, Object.assign({
      placeholder: "(123) 456-7890",
      name: i ? "email" : "phoneNumber",
      id: "phone-input",
      autoComplete: i ? "webauthn" : "",
      value: e,
      type: "text",
      onChange: function onChange(e) {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
          var r;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return o(e.target.value, n);
              case 2:
                r = _context13.sent;
                t(r.national);
              case 4:
              case "end":
                return _context13.stop();
            }
          }, _callee13);
        }));
      },
      required: !0
    }, i ? {
      "data-1p-ignore": !0
    } : {})));
  },
  Fl = function Fl(_ref66) {
    var e = _ref66.email,
      t = _ref66.setEmail,
      _ref66$disableInput = _ref66.disableInput,
      n = _ref66$disableInput === void 0 ? !1 : _ref66$disableInput,
      _ref66$hasPasskeys = _ref66.hasPasskeys,
      r = _ref66$hasPasskeys === void 0 ? !1 : _ref66$hasPasskeys;
    return Ko.createElement(Ml, Object.assign({
      placeholder: "example@email.com",
      name: "email",
      type: "email",
      autoComplete: r ? "email webauthn" : "email",
      disabled: n,
      id: "email-input",
      value: e,
      onChange: function onChange(e) {
        return t(e.target.value);
      },
      required: !0
    }, r ? {
      "data-1p-ignore": !0
    } : {}));
  },
  jl = function jl(e) {
    var t = e.isSubmitting || e.disabled;
    return Ko.createElement(Is, {
      id: "submit",
      type: "submit",
      disabled: t
    }, e.isSubmitting ? Ko.createElement(Hs, {
      justifyContent: "center"
    }, Ko.createElement(dc, {
      size: 18,
      thickness: 1,
      "data-testid": "loading-icon"
    })) : e.text);
  },
  Il = /https:\/\/stytch\.com\/[#a-zA-Z0-9/-]+/g,
  Bl = function Bl(_ref67) {
    var e = _ref67.errorMessage;
    var t = Rr(function () {
      return function (e) {
        var t = e.split(Il),
          n = Array.from(e.matchAll(Il)).map(function (e) {
            return e[0];
          }),
          r = [];
        for (; t.length || n.length;) if (t.length && r.push(t.shift()), n.length) {
          var _e6 = n.shift();
          r.push(Ko.createElement("a", {
            key: _e6 + "__" + String(n.length),
            href: _e6,
            target: "_blank",
            rel: "noreferrer"
          }, _e6));
        }
        return r;
      }(e);
    }, [e]);
    return Ko.createElement(Us, {
      size: "helper",
      color: "error"
    }, t);
  };
g.SMS, g.WhatsApp, g.Email;
var Nl = _defineProperty(_defineProperty(_defineProperty({}, g.SMS, "text message"), g.WhatsApp, "WhatsApp"), g.Email, "email"),
  Hl = function Hl() {
    var e = js(),
      t = Fs(),
      n = Ms(),
      r = Ds(),
      _Rs3 = Rs(),
      _Rs4 = _slicedToArray(_Rs3, 2),
      o = _Rs4[1],
      _Or15 = Or(""),
      _Or16 = _slicedToArray(_Or15, 2),
      i = _Or16[0],
      a = _Or16[1],
      _Or17 = Or(""),
      _Or18 = _slicedToArray(_Or17, 2),
      s = _Or18[0],
      c = _Or18[1],
      _Or19 = Or(!1),
      _Or20 = _slicedToArray(_Or19, 2),
      l = _Or20[0],
      u = _Or20[1],
      d = r.products.includes(p.passkeys),
      h = function h(e) {
        return t({
          message: e
        }), u(!1), c(e);
      };
    return Ko.createElement("form", {
      onSubmit: function onSubmit(t) {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
          var a, s, l, d;
          return _regeneratorRuntime().wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                if (!(t.preventDefault(), u(!0), !i.match(an))) {
                  _context14.next = 2;
                  break;
                }
                return _context14.abrupt("return", h("Invalid email, please try again."));
              case 2:
                c(""), u(!0), n.otps.email.loginOrCreate(i, {
                  expiration_minutes: null !== (s = null === (a = r.otpOptions) || void 0 === a ? void 0 : a.expirationMinutes) && void 0 !== s ? s : 5,
                  login_template_id: null === (l = r.otpOptions) || void 0 === l ? void 0 : l.loginTemplateId,
                  signup_template_id: null === (d = r.otpOptions) || void 0 === d ? void 0 : d.signupTemplateId
                }).then(function (t) {
                  u(!1), e({
                    type: _.OTPsLoginOrCreateEvent,
                    data: t
                  }), o({
                    type: "update_otp_state",
                    otpState: {
                      type: g.Email,
                      methodId: t.method_id,
                      otpDestination: i
                    }
                  }), o({
                    type: "transition",
                    screen: Ss.OTPAuthenticate
                  }), xn(n).networkClient.logEvent({
                    name: "email_sent",
                    details: {
                      email: i,
                      type: Ke.LoginOrCreateOTP
                    }
                  });
                })["catch"](function (e) {
                  var t = e.message;
                  e instanceof P && (t = e.error_message), h(t);
                });
              case 3:
              case "end":
                return _context14.stop();
            }
          }, _callee14);
        }));
      }
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Hs, {
      direction: "column",
      minHeight: 52
    }, Ko.createElement(Fl, {
      email: i,
      setEmail: a,
      hasPasskeys: d
    }), Ko.createElement(Bl, {
      errorMessage: s
    })), Ko.createElement(jl, {
      isSubmitting: l,
      text: "Continue with ".concat(Nl[g.Email])
    })));
  },
  Ul = function Ul(_ref68) {
    var e = _ref68.method;
    var t = js(),
      n = Fs(),
      r = Ms(),
      o = Ds(),
      _Rs5 = Rs(),
      _Rs6 = _slicedToArray(_Rs5, 2),
      i = _Rs6[1],
      _Or21 = Or(""),
      _Or22 = _slicedToArray(_Or21, 2),
      a = _Or22[0],
      s = _Or22[1],
      _Or23 = Or("US"),
      _Or24 = _slicedToArray(_Or23, 2),
      c = _Or24[0],
      l = _Or24[1],
      _Or25 = Or(""),
      _Or26 = _slicedToArray(_Or25, 2),
      u = _Or26[0],
      d = _Or26[1],
      _Or27 = Or(!1),
      _Or28 = _slicedToArray(_Or27, 2),
      h = _Or28[0],
      f = _Or28[1],
      m = o.products.includes(p.passkeys),
      g = function g(e) {
        return n({
          message: e
        }), f(!1), d(e);
      },
      v = function v(e, t) {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
          return _regeneratorRuntime().wrap(function _callee15$(_context15) {
            while (1) switch (_context15.prev = _context15.next) {
              case 0:
                return _context15.abrupt("return", xn(r).clientsideServices.parsedPhoneNumber({
                  phoneNumber: e,
                  regionCode: t
                }));
              case 1:
              case "end":
                return _context15.stop();
            }
          }, _callee15);
        }));
      };
    return Ko.createElement("form", {
      onSubmit: function onSubmit(n) {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
          var s, l, u;
          return _regeneratorRuntime().wrap(function _callee16$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                n.preventDefault();
                _context16.next = 3;
                return v(a, c);
              case 3:
                u = _context16.sent;
                if (u.isValid) {
                  _context16.next = 6;
                  break;
                }
                return _context16.abrupt("return", g("Invalid phone number, please try again."));
              case 6:
                f(!0), d(""), r.otps[e].loginOrCreate(u.number, {
                  expiration_minutes: null !== (l = null === (s = o.otpOptions) || void 0 === s ? void 0 : s.expirationMinutes) && void 0 !== l ? l : 5
                }).then(function (n) {
                  f(!1), t({
                    type: _.OTPsLoginOrCreateEvent,
                    data: n
                  }), i({
                    type: "update_otp_state",
                    otpState: {
                      type: e,
                      methodId: n.method_id,
                      otpDestination: u.number
                    }
                  }), i({
                    type: "transition",
                    screen: Ss.OTPAuthenticate
                  });
                })["catch"](function (e) {
                  var t = e.message;
                  e instanceof P && (t = e.error_message), g(t);
                });
              case 7:
              case "end":
                return _context16.stop();
            }
          }, _callee16);
        }));
      }
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Hs, {
      direction: "column",
      minHeight: 52
    }, Ko.createElement(Dl, {
      phone: a,
      setPhone: s,
      country: c,
      setCountry: l,
      parsePhoneNumber: v,
      hasPasskeys: m
    }), Ko.createElement(Bl, {
      errorMessage: u
    })), Ko.createElement(jl, {
      isSubmitting: h,
      text: "Continue with ".concat(Nl[e])
    })));
  },
  $l = function $l() {
    var e = js(),
      t = Fs(),
      _Rs7 = Rs(),
      _Rs8 = _slicedToArray(_Rs7, 2),
      n = _Rs8[1],
      r = Ms(),
      o = Ds(),
      i = o.emailMagicLinksOptions,
      a = o.products.includes(p.passkeys),
      _Or29 = Or(""),
      _Or30 = _slicedToArray(_Or29, 2),
      s = _Or30[0],
      c = _Or30[1],
      _Or31 = Or(""),
      _Or32 = _slicedToArray(_Or31, 2),
      l = _Or32[0],
      u = _Or32[1],
      _Or33 = Or(!1),
      _Or34 = _slicedToArray(_Or33, 2),
      d = _Or34[0],
      h = _Or34[1];
    if (!i) return Ko.createElement(Ko.Fragment, null);
    return Ko.createElement("form", {
      onSubmit: function onSubmit(o) {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
          return _regeneratorRuntime().wrap(function _callee17$(_context17) {
            while (1) switch (_context17.prev = _context17.next) {
              case 0:
                o.preventDefault(), s.match(an) ? (u(""), h(!0), r.magicLinks.email.loginOrCreate(s, sn(i)).then(function (t) {
                  e({
                    type: _.MagicLinkLoginOrCreateEvent,
                    data: t
                  }), h(!1), n({
                    type: "set_magic_link_email",
                    email: s
                  }), n({
                    type: "transition",
                    screen: Ss.EmailConfirmation
                  }), xn(r).networkClient.logEvent({
                    name: "email_try_again_clicked",
                    details: {
                      email: s,
                      type: Ke.LoginOrCreateEML
                    }
                  });
                })["catch"](function (e) {
                  t(e), h(!1);
                  var n = e.message;
                  e instanceof P && (n = e.error_message), u(n);
                })) : u("Invalid email address");
              case 1:
              case "end":
                return _context17.stop();
            }
          }, _callee17);
        }));
      }
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Hs, {
      direction: "column",
      minHeight: 52
    }, Ko.createElement(Fl, {
      email: s,
      setEmail: c,
      hasPasskeys: a
    }), Ko.createElement(Bl, {
      errorMessage: l
    })), Ko.createElement(jl, {
      isSubmitting: d,
      text: "Continue with email"
    })));
  },
  Vl = function Vl() {
    var _Rs9 = Rs(),
      _Rs10 = _slicedToArray(_Rs9, 2),
      e = _Rs10[1],
      t = Ds(),
      n = Ms(),
      r = t.passwordOptions,
      o = t.products.includes(p.passkeys),
      _Or35 = Or(""),
      _Or36 = _slicedToArray(_Or35, 2),
      i = _Or36[0],
      a = _Or36[1],
      _Or37 = Or(""),
      _Or38 = _slicedToArray(_Or37, 2),
      s = _Or38[0],
      c = _Or38[1],
      _Or39 = Or(!1),
      _Or40 = _slicedToArray(_Or39, 2),
      l = _Or40[0],
      u = _Or40[1];
    if (!r) return Ko.createElement(Ko.Fragment, null);
    return Ko.createElement("form", {
      onSubmit: function onSubmit(t) {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
          return _regeneratorRuntime().wrap(function _callee18$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                t.preventDefault(), i.match(an) ? (c(""), u(!0), xn(n).searchManager.searchUser(i).then(function (_ref69) {
                  var t = _ref69.userType;
                  e({
                    type: "update_password_state",
                    passwordState: {
                      email: i,
                      type: t
                    }
                  }), e({
                    type: "transition",
                    screen: Ss.PasswordCreateOrLogin
                  }), xn(n).networkClient.logEvent({
                    name: "email_sent",
                    details: {
                      email: i,
                      type: Ke.ResetPassword
                    }
                  });
                })["catch"](function (e) {
                  u(!1);
                  var t = e.message;
                  e instanceof P && (t = e.error_message), c(t);
                })) : c("Invalid email address");
              case 1:
              case "end":
                return _context18.stop();
            }
          }, _callee18);
        }));
      }
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Hs, {
      direction: "column",
      height: 52
    }, Ko.createElement(Fl, {
      email: i,
      setEmail: a,
      hasPasskeys: o
    }), Ko.createElement(Us, {
      size: "helper",
      color: "error"
    }, s)), Ko.createElement(jl, {
      isSubmitting: l,
      text: "Continue with email"
    })));
  },
  Zl = function Zl(_ref70) {
    var e = _ref70.conditionalMediation;
    var t = Ms(),
      n = Ds(),
      r = n.products.includes(p.passkeys),
      o = js(),
      i = Fs(),
      _Rs11 = Rs(),
      _Rs12 = _slicedToArray(_Rs11, 2),
      a = _Rs12[1],
      _Or41 = Or(5),
      _Or42 = _slicedToArray(_Or41, 2),
      s = _Or42[0],
      c = _Or42[1],
      l = "Unknown error occurred during passkey authentication. Please try again.",
      u = function u(_ref71) {
        var r = _ref71.abortController;
        var s, c;
        return t.webauthn.authenticate({
          session_duration_minutes: null !== (c = null === (s = n.sessionOptions) || void 0 === s ? void 0 : s.sessionDurationMinutes) && void 0 !== c ? c : Te,
          conditional_mediation: e,
          is_passkey: !0,
          signal: null == r ? void 0 : r.signal
        }).then(function (e) {
          if (e) return o({
            type: _.PasskeyAuthenticate,
            data: e
          }), a({
            type: "transition",
            screen: Ss.PasskeyConfirmation
          }), a({
            type: "clear_error_message"
          }), e;
          throw a({
            type: "set_error_message",
            errorMessage: l
          }), new Error("Empty response");
        })["catch"](function (e) {
          throw "webauthn_registration_not_found" === e.error_type ? a({
            type: "set_error_message",
            errorMessage: "Passkey registration not found. You may have deleted the passkey from your account but not password manager. Please try again."
          }) : "StytchAPIError" === e.name && a({
            type: "set_error_message",
            errorMessage: l
          }), i(e), e;
        });
      };
    return {
      prompt: function prompt() {
        return u({});
      },
      promptAutofill: function promptAutofill() {
        Ar(function () {
          if (!r) return;
          if (s < 1) return;
          var e = new AbortController();
          return t.webauthn.browserSupportsAutofill().then(function (t) {
            t && u({
              abortController: e
            })["catch"](function () {
              c(function (e) {
                return e - 1;
              });
            });
          }), function () {
            e.abort();
          };
        }, [s]);
      }
    };
  };
var zl = $s(function () {
  return Ko.createElement("svg", {
    width: "25",
    height: "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M12.5 6.49L20.03 19.5H4.97L12.5 6.49ZM12.5 2.5L1.5 21.5H23.5L12.5 2.5ZM13.5 16.5H11.5V18.5H13.5V16.5ZM13.5 10.5H11.5V14.5H13.5V10.5Z",
    fill: "#C28E1F"
  }));
});
var Wl = $s(function () {
  return Ko.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
    fill: "#0C5A56"
  }));
});
var Kl = $s(function () {
  return Ko.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M9 13H11V15H9V13ZM9 5H11V11H9V5ZM9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z",
    fill: "#AD2E30"
  }));
});
var Gl = {
    error: {
      backgroundColor: "#FFF6F5",
      borderColor: "#FD4E43"
    },
    warning: {
      backgroundColor: "#fffbf0",
      borderColor: "#ffd94a"
    },
    success: {
      backgroundColor: "#f7fffb",
      borderColor: "#0c5a56"
    }
  },
  ql = bs.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-left: 6px solid ", ";\n  border-radius: 4px 0 0 4px;\n  padding: 24px;\n"])), function (e) {
    return Gl[e.variant].backgroundColor;
  }, function (e) {
    return Gl[e.variant].borderColor;
  }),
  Yl = bs(Us)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-family: IBM Plex Sans;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0em;\n"]))),
  Jl = function Jl(_ref72) {
    var e = _ref72.variant,
      t = _ref72.text;
    var _Rs13 = Rs(),
      _Rs14 = _slicedToArray(_Rs13, 1),
      n = _Rs14[0];
    return "" !== n.formState.errorMessage || t ? Ko.createElement(ql, {
      variant: e
    }, Ko.createElement(Hs, {
      gap: 8,
      alignItems: "flex-start"
    }, "error" === e && Ko.createElement(Kl, null), "warning" === e && Ko.createElement(zl, null), "success" === e && Ko.createElement(Wl, null), Ko.createElement(Yl, null, t || n.formState.errorMessage))) : null;
  },
  Xl = bs(Ol)(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  margin-bottom: 24px;\n"])), function (e) {
    return e.theme.colors.secondary;
  }),
  Ql = bs(Ll)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  all: unset;\n  width: 100%;\n  text-align: center;\n  color: ", ";\n  border-bottom: 3px solid ", ";\n  font-weight: ", ";\n"])), function (e) {
    return e.$active ? e.theme.colors.primary : e.theme.colors.secondary;
  }, function (e) {
    return e.$active ? e.theme.colors.primary : "transparent";
  }, function (e) {
    return e.$active ? "500" : "400";
  });
var eu, tu;
!function (e) {
  e.Email = "emailMagicLink";
}(eu || (eu = {})), function (e) {
  e.Email = "passwords";
}(tu || (tu = {}));
var nu = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, g.SMS, "Text"), g.WhatsApp, "WhatsApp"), g.Email, "Email"), eu.Email, "Email"), tu.Email, "Email"),
  ru = function ru() {
    var e, t;
    var n = Ds(),
      r = null !== (t = null === (e = null == n ? void 0 : n.otpOptions) || void 0 === e ? void 0 : e.methods) && void 0 !== t ? t : [],
      o = n.products.includes(p.emailMagicLinks),
      i = n.products.includes(p.otp) && r.includes(g.Email),
      a = n.products.includes(p.passwords);
    var s = o ? [].concat(_toConsumableArray(r), [eu.Email]) : r;
    s = a ? [].concat(_toConsumableArray(s), [tu.Email]) : s;
    var _Zl = Zl({
        conditionalMediation: !0
      }),
      c = _Zl.promptAutofill;
    c(), a && o && (s = s.filter(function (e) {
      return e !== eu.Email;
    })), a && i && (s = s.filter(function (e) {
      return e !== g.Email;
    }));
    var _Or43 = Or(s[0]),
      _Or44 = _slicedToArray(_Or43, 2),
      l = _Or44[0],
      u = _Or44[1];
    if (o && i) return Ko.createElement(Us, {
      size: "helper"
    }, "Error: Cannot use both EML and Email OTP");
    var d = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, g.Email, Hl), g.WhatsApp, function () {
      return Ko.createElement(Ul, {
        method: g.WhatsApp
      });
    }), g.SMS, function () {
      return Ko.createElement(Ul, {
        method: g.SMS
      });
    }), eu.Email, $l), tu.Email, Vl);
    return Ko.createElement(Ko.Fragment, null, Ko.createElement(Jl, {
      variant: "warning"
    }), Ko.createElement(xl, {
      value: l,
      onValueChange: function onValueChange(e) {
        return u(e);
      }
    }, s.length > 1 && Ko.createElement(Xl, {
      "aria-label": "otp-tabs"
    }, s.map(function (e) {
      return Ko.createElement(Ql, {
        value: e,
        key: e,
        $active: e === l
      }, nu[e]);
    })), s.map(function (e) {
      var t = d[e];
      return Ko.createElement(Al, {
        value: e,
        key: e
      }, Ko.createElement(t, null));
    })));
  },
  ou = function ou(e) {
    return Ko.createElement(Is, {
      id: "wallet-".concat(e.walletTypeTitle),
      type: "submit",
      onClick: e.onClick,
      variant: "outlined"
    }, Ko.createElement(Hs, {
      justifyContent: "center",
      alignItems: "center",
      gap: 4
    }, e.icon, Ko.createElement("span", {
      style: {
        verticalAlign: "middle"
      }
    }, e.walletTypeTitle)));
  };
var iu = function iu(e) {
  if (e.length >= 255) throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), n = 0; n < t.length; n++) t[n] = 255;
  for (var r = 0; r < e.length; r++) {
    var o = e.charAt(r),
      i = o.charCodeAt(0);
    if (255 !== t[i]) throw new TypeError(o + " is ambiguous");
    t[i] = r;
  }
  var a = e.length,
    s = e.charAt(0),
    c = Math.log(a) / Math.log(256),
    l = Math.log(256) / Math.log(a);
  function u(e) {
    if ("string" != typeof e) throw new TypeError("Expected String");
    if (0 === e.length) return new Uint8Array();
    for (var n = 0, r = 0, o = 0; e[n] === s;) r++, n++;
    for (var i = (e.length - n) * c + 1 >>> 0, l = new Uint8Array(i); e[n];) {
      var u = t[e.charCodeAt(n)];
      if (255 === u) return;
      for (var d = 0, p = i - 1; (0 !== u || d < o) && -1 !== p; p--, d++) u += a * l[p] >>> 0, l[p] = u % 256 >>> 0, u = u / 256 >>> 0;
      if (0 !== u) throw new Error("Non-zero carry");
      o = d, n++;
    }
    for (var h = i - o; h !== i && 0 === l[h];) h++;
    for (var f = new Uint8Array(r + (i - h)), m = r; h !== i;) f[m++] = l[h++];
    return f;
  }
  return {
    encode: function encode(t) {
      if (t instanceof Uint8Array || (ArrayBuffer.isView(t) ? t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : Array.isArray(t) && (t = Uint8Array.from(t))), !(t instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
      if (0 === t.length) return "";
      for (var n = 0, r = 0, o = 0, i = t.length; o !== i && 0 === t[o];) o++, n++;
      for (var c = (i - o) * l + 1 >>> 0, u = new Uint8Array(c); o !== i;) {
        for (var d = t[o], p = 0, h = c - 1; (0 !== d || p < r) && -1 !== h; h--, p++) d += 256 * u[h] >>> 0, u[h] = d % a >>> 0, d = d / a >>> 0;
        if (0 !== d) throw new Error("Non-zero carry");
        r = p, o++;
      }
      for (var f = c - r; f !== c && 0 === u[f];) f++;
      for (var m = s.repeat(n); f < c; ++f) m += e.charAt(u[f]);
      return m;
    },
    decodeUnsafe: u,
    decode: function decode(e) {
      var t = u(e);
      if (t) return t;
      throw new Error("Non-base" + a + " character");
    }
  };
};
var au = iu("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
var su = $s(function () {
  return Ko.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint0_linear_2_2)"
  }), Ko.createElement("path", {
    d: "M17.2787 10.1428H15.4909C15.4909 6.5258 12.527 3.59375 8.87068 3.59375C5.25956 3.59375 2.32368 6.45402 2.25184 10.0091C2.1775 13.6839 5.66265 16.875 9.3779 16.875H9.84521C13.1207 16.875 17.5108 14.3385 18.1967 11.248C18.3234 10.6783 17.8684 10.1428 17.2787 10.1428ZM6.21389 10.304C6.21389 10.7877 5.81398 11.1833 5.32503 11.1833C4.83607 11.1833 4.43618 10.7875 4.43618 10.304V8.88147C4.43618 8.39777 4.83607 8.00217 5.32503 8.00217C5.81398 8.00217 6.21389 8.39777 6.21389 8.88147V10.304ZM9.30037 10.304C9.30037 10.7877 8.90048 11.1833 8.41153 11.1833C7.92257 11.1833 7.52267 10.7875 7.52267 10.304V8.88147C7.52267 8.39777 7.92275 8.00217 8.41153 8.00217C8.90048 8.00217 9.30037 8.39777 9.30037 8.88147V10.304Z",
    fill: "url(#paint1_linear_2_2)"
  }), Ko.createElement("defs", null, Ko.createElement("linearGradient", {
    id: "paint0_linear_2_2",
    x1: "10",
    y1: "0",
    x2: "10",
    y2: "20",
    gradientUnits: "userSpaceOnUse"
  }, Ko.createElement("stop", {
    stopColor: "#534BB1"
  }), Ko.createElement("stop", {
    offset: "1",
    stopColor: "#551BF9"
  })), Ko.createElement("linearGradient", {
    id: "paint1_linear_2_2",
    x1: "10.2343",
    y1: "3.59375",
    x2: "10.2343",
    y2: "16.875",
    gradientUnits: "userSpaceOnUse"
  }, Ko.createElement("stop", {
    stopColor: "white"
  }), Ko.createElement("stop", {
    offset: "1",
    stopColor: "white",
    stopOpacity: "0.82"
  }))));
});
var cu = $s(function () {
  return Ko.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M17.2065 2.22849L10.9604 6.86753L12.1155 4.13056L17.2065 2.22849Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M2.78717 2.22849L8.98303 6.91147L7.88447 4.13056L2.78717 2.22849Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M14.9592 12.9818L13.2957 15.5304L16.855 16.5097L17.8782 13.0383L14.9592 12.9818Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M2.12805 13.0383L3.145 16.5097L6.70432 15.5304L5.04079 12.9818L2.12805 13.0383Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M6.50344 8.67544L5.5116 10.1757L9.04581 10.3327L8.92026 6.53482L6.50344 8.67544Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M13.4903 8.67543L11.0421 6.49088L10.9604 10.3327L14.4884 10.1757L13.4903 8.67543Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M6.70432 15.5304L8.8261 14.4946L6.99308 13.0634L6.70432 15.5304Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M11.1676 14.4946L13.2957 15.5304L13.0006 13.0634L11.1676 14.4946Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M13.2957 15.5304L11.1676 14.4947L11.3371 15.882L11.3183 16.4658L13.2957 15.5304Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M6.70435 15.5304L8.68175 16.4658L8.66919 15.882L8.82613 14.4947L6.70435 15.5304Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M8.71312 12.1469L6.94287 11.6259L8.19209 11.0546L8.71312 12.1469Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M11.2806 12.1469L11.8016 11.0546L13.0571 11.6259L11.2806 12.1469Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M6.70433 15.5305L7.00565 12.9818L5.0408 13.0383L6.70433 15.5305Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M12.9944 12.9818L13.2957 15.5305L14.9592 13.0383L12.9944 12.9818Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M14.4884 10.1758L10.9604 10.3327L11.2869 12.1469L11.8079 11.0546L13.0634 11.6259L14.4884 10.1758Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M6.94289 11.6259L8.19838 11.0546L8.71313 12.1469L9.04584 10.3327L5.51163 10.1758L6.94289 11.6259Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M5.51163 10.1758L6.99311 13.0634L6.94289 11.6259L5.51163 10.1758Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M13.0634 11.6259L13.0006 13.0634L14.4884 10.1758L13.0634 11.6259Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M9.04584 10.3327L8.71313 12.1469L9.12745 14.2875L9.22161 11.469L9.04584 10.3327Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M10.9605 10.3327L10.791 11.4627L10.8663 14.2875L11.2869 12.1469L10.9605 10.3327Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M11.2869 12.1469L10.8663 14.2875L11.1676 14.4947L13.0006 13.0634L13.0634 11.6259L11.2869 12.1469Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M6.94287 11.6259L6.99309 13.0634L8.82611 14.4947L9.12743 14.2875L8.71312 12.1469L6.94287 11.6259Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M11.3183 16.4658L11.3371 15.882L11.1802 15.7439H8.81357L8.66919 15.882L8.68175 16.4658L6.70435 15.5305L7.39487 16.0954L8.79474 17.0684H11.199L12.6052 16.0954L13.2957 15.5305L11.3183 16.4658Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M11.1676 14.4947L10.8663 14.2875H9.12744L8.82613 14.4947L8.66919 15.882L8.81357 15.7439H11.1802L11.3371 15.882L11.1676 14.4947Z",
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M17.4702 7.16885L18.0038 4.60764L17.2066 2.22849L11.1676 6.71059L13.4903 8.67544L16.7734 9.63589L17.5016 8.78843L17.1877 8.56245L17.6899 8.10419L17.3007 7.80287L17.8029 7.41995L17.4702 7.16885Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M1.99625 4.60764L2.52983 7.16885L2.19085 7.41995L2.69304 7.80287L2.31012 8.10419L2.81232 8.56245L2.49844 8.78843L3.22035 9.63589L6.50347 8.67544L8.82613 6.71059L2.78721 2.22849L1.99625 4.60764Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M16.7734 9.6359L13.4903 8.67545L14.4884 10.1758L13.0006 13.0634L14.9592 13.0383H17.8782L16.7734 9.6359Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M6.50344 8.67545L3.22033 9.6359L2.12805 13.0383H5.0408L6.99309 13.0634L5.51161 10.1758L6.50344 8.67545Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), Ko.createElement("path", {
    d: "M10.9604 10.3327L11.1676 6.71062L12.1218 4.13058H7.88449L8.82611 6.71062L9.04582 10.3327L9.12115 11.4752L9.12743 14.2875H10.8663L10.8788 11.4752L10.9604 10.3327Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});
var lu = $s(function () {
  return Ko.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("g", {
    clipPath: "url(#clip0_517_6831)"
  }, Ko.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.602 3.2325C7.99856 3.2325 4.36714 6.58551 5.54083 11.2565L4.91376 11.414C3.6226 6.27561 7.64076 2.58594 11.602 2.58594C15.8216 2.58594 19.7562 6.44977 18.3304 11.5481L17.7077 11.374C19.0018 6.74671 15.4567 3.2325 11.602 3.2325Z",
    fill: "#2A384A"
  }), Ko.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5988 1.29891C6.41566 1.29891 2.05244 6.14046 3.88531 12.8124L3.26184 12.9836C1.32182 5.92165 5.96682 0.652344 11.5988 0.652344C17.5841 0.652344 22.5861 6.77296 19.5889 13.4516L18.9991 13.1869C21.7871 6.97427 17.1579 1.29891 11.5988 1.29891Z",
    fill: "#2A384A"
  }), Ko.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17894 6.94622C7.48133 7.91408 7.24057 9.10031 7.36887 9.96188C7.39522 10.1385 7.27334 10.303 7.09673 10.3292C6.92019 10.3555 6.75568 10.2337 6.72938 10.0571C6.57532 9.0227 6.86195 7.6676 7.65447 6.56814C8.4568 5.45497 9.77856 4.60352 11.6727 4.60352C13.3065 4.60352 14.641 5.40696 15.4926 6.51476C16.3399 7.61698 16.7272 9.0444 16.4408 10.3222C16.4018 10.4965 16.2289 10.606 16.0547 10.567C15.8804 10.5279 15.7709 10.355 15.8099 10.1808C16.0479 9.11899 15.7297 7.88408 14.98 6.9088C14.2346 5.93917 13.0806 5.25008 11.6727 5.25008C9.99793 5.25008 8.86673 5.99201 8.17894 6.94622Z",
    fill: "#2A384A"
  }), Ko.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.521 14.6751C19.5048 11.7314 16.1357 10.3576 16.1357 10.3576H13.8259L12.9183 8.46875H11.5936H10.2689L9.36128 10.3576H6.91197L4.36073 12.1829L2.74168 10.3576H0.877319L2.15294 13.7625L0.877319 14.6751L2.15294 15.5981L0.877319 19.0416H2.74168L4.36073 17.1956L6.91197 19.0416H16.1357C16.1357 19.0416 19.5371 17.6188 19.521 14.6751ZM7.69518 15.9039C8.38612 15.9039 8.94625 15.3438 8.94625 14.6528C8.94625 13.9618 8.38612 13.4017 7.69518 13.4017C7.00423 13.4017 6.4441 13.9618 6.4441 14.6528C6.4441 15.3438 7.00423 15.9039 7.69518 15.9039ZM12.8871 14.6528C12.8871 15.3438 12.327 15.9039 11.6361 15.9039C10.9451 15.9039 10.385 15.3438 10.385 14.6528C10.385 13.9618 10.9451 13.4017 11.6361 13.4017C12.327 13.4017 12.8871 13.9618 12.8871 14.6528ZM15.5893 15.9039C16.2803 15.9039 16.8405 15.3438 16.8405 14.6528C16.8405 13.9618 16.2803 13.4017 15.5893 13.4017C14.8984 13.4017 14.3383 13.9618 14.3383 14.6528C14.3383 15.3438 14.8984 15.9039 15.5893 15.9039Z",
    fill: "url(#paint0_linear_517_6831)"
  }), Ko.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2704 6.78422C11.2704 6.60567 11.4151 6.46094 11.5936 6.46094H12.858C13.0365 6.46094 13.1813 6.60567 13.1813 6.78422C13.1813 6.96273 13.0365 7.10751 12.858 7.10751H11.9169V8.14474H12.9183C13.0426 8.14474 13.1558 8.216 13.2097 8.32801L14.0293 10.0337H16.1357C16.1775 10.0337 16.219 10.0418 16.2577 10.0576L16.1357 10.3569C16.2577 10.0576 16.2579 10.0576 16.258 10.0577L16.2584 10.0578L16.2592 10.0582L16.2619 10.0593C16.2641 10.0602 16.2672 10.0615 16.271 10.0631C16.2786 10.0663 16.2893 10.0709 16.303 10.0768C16.3302 10.0887 16.3691 10.1061 16.418 10.1291C16.5158 10.1751 16.6538 10.2434 16.8188 10.3347C17.148 10.5167 17.5883 10.7919 18.0306 11.1646C18.9106 11.906 19.8355 13.0668 19.8443 14.6727C19.8531 16.2802 18.9272 17.4542 18.0442 18.2075C17.6001 18.5863 17.157 18.8677 16.8255 19.0544C16.6594 19.1479 16.5203 19.2181 16.4218 19.2655C16.3725 19.2891 16.3333 19.3071 16.3058 19.3193C16.2921 19.3255 16.2814 19.3302 16.2737 19.3335C16.2699 19.3352 16.2669 19.3364 16.2647 19.3374L16.2619 19.3386L16.261 19.339L16.2607 19.3391C16.2606 19.3391 16.2604 19.3392 16.1357 19.041L16.2604 19.3392C16.2209 19.3557 16.1786 19.3642 16.1357 19.3642H6.91201C6.84396 19.3642 6.77763 19.3427 6.72249 19.3029L4.40973 17.6294L2.98477 19.2541C2.92339 19.3241 2.83482 19.3642 2.74172 19.3642H0.877361C0.77156 19.3642 0.672454 19.3125 0.612017 19.2256C0.551579 19.1388 0.537458 19.0278 0.57421 18.9286L1.76453 15.7154L0.687849 14.9363C0.603584 14.8754 0.553802 14.7776 0.55408 14.6735C0.554359 14.5695 0.604664 14.472 0.689255 14.4115L1.76328 13.6431L0.574628 10.4703C0.537435 10.3711 0.551278 10.2599 0.611676 10.1727C0.672073 10.0856 0.771349 10.0337 0.877361 10.0337H2.74172C2.83418 10.0337 2.92222 10.0732 2.98357 10.1424L4.40944 11.7499L6.7239 10.094C6.77877 10.0547 6.84453 10.0337 6.91201 10.0337H9.15798L9.97754 8.32801C10.0314 8.216 10.1447 8.14474 10.2689 8.14474H11.2704V6.78422ZM10.4723 8.79135L9.87534 10.0337H13.3119L12.715 8.79135H10.4723ZM7.01572 10.6802L2.34109 14.0247C2.34102 14.0247 2.34097 14.0248 2.34091 14.0248L1.43088 14.6759L2.34249 15.3355C2.34254 15.3356 2.3426 15.3356 2.34266 15.3356L4.54971 16.9326C4.5499 16.9327 4.55009 16.9329 4.55029 16.933L7.01673 18.7176H16.0672C16.0873 18.7085 16.1123 18.6968 16.1419 18.6827C16.2293 18.6407 16.3558 18.5768 16.5083 18.4909C16.814 18.3188 17.2203 18.0605 17.6246 17.7156C18.4382 17.0215 19.205 16.0124 19.1977 14.6762C19.1904 13.3383 18.4226 12.3403 17.614 11.659C17.2119 11.3203 16.8089 11.068 16.506 10.9005C16.3548 10.8169 16.2295 10.755 16.143 10.7143C16.1135 10.7005 16.0886 10.6891 16.0687 10.6802H7.01572ZM3.88361 17.2487L2.30828 16.1088L1.34187 18.7176H2.59526L3.88361 17.2487ZM2.30778 13.2535L3.88071 12.1282L2.59634 10.6802H1.3437L2.30778 13.2535ZM7.69522 13.7243C7.18283 13.7243 6.76743 14.1397 6.76743 14.6521C6.76743 15.1645 7.18283 15.5799 7.69522 15.5799C8.20761 15.5799 8.62302 15.1645 8.62302 14.6521C8.62302 14.1397 8.20761 13.7243 7.69522 13.7243ZM6.12086 14.6521C6.12086 13.7826 6.82572 13.0778 7.69522 13.0778C8.56471 13.0778 9.26962 13.7826 9.26962 14.6521C9.26962 15.5216 8.56471 16.2264 7.69522 16.2264C6.82572 16.2264 6.12086 15.5216 6.12086 14.6521ZM10.0617 14.6521C10.0617 13.7826 10.7666 13.0778 11.6361 13.0778C12.5056 13.0778 13.2104 13.7826 13.2104 14.6521C13.2104 15.5216 12.5056 16.2264 11.6361 16.2264C10.7666 16.2264 10.0617 15.5216 10.0617 14.6521ZM11.6361 13.7243C11.1236 13.7243 10.7083 14.1397 10.7083 14.6521C10.7083 15.1645 11.1236 15.5799 11.6361 15.5799C12.1485 15.5799 12.5639 15.1645 12.5639 14.6521C12.5639 14.1397 12.1485 13.7243 11.6361 13.7243ZM15.5894 13.7243C15.077 13.7243 14.6616 14.1397 14.6616 14.6521C14.6616 15.1645 15.077 15.5799 15.5894 15.5799C16.1018 15.5799 16.5172 15.1645 16.5172 14.6521C16.5172 14.1397 16.1018 13.7243 15.5894 13.7243ZM14.015 14.6521C14.015 13.7826 14.7199 13.0778 15.5894 13.0778C16.4589 13.0778 17.1638 13.7826 17.1638 14.6521C17.1638 15.5216 16.4589 16.2264 15.5894 16.2264C14.7199 16.2264 14.015 15.5216 14.015 14.6521Z",
    fill: "#2A384A"
  })), Ko.createElement("defs", null, Ko.createElement("linearGradient", {
    id: "paint0_linear_517_6831",
    x1: "10.2255",
    y1: "6.04818",
    x2: "8.95738",
    y2: "20.334",
    gradientUnits: "userSpaceOnUse"
  }, Ko.createElement("stop", {
    stopColor: "#FFFF82"
  }), Ko.createElement("stop", {
    offset: "1",
    stopColor: "#FF99B4"
  })), Ko.createElement("clipPath", {
    id: "clip0_517_6831"
  }, Ko.createElement("rect", {
    width: "20",
    height: "18.805",
    fill: "white",
    transform: "translate(0.5 0.597656)"
  }))));
});
var uu = $s(function () {
  return Ko.createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "#14151A"
  }), Ko.createElement("path", {
    d: "M7.26562 10L6.13281 11.1328L5 10L6.13281 8.86719L7.26562 10ZM10 7.25781L11.9375 9.19531L13.0703 8.0625L11.1328 6.13281L10 5L8.875 6.13281L6.9375 8.0625L8.07031 9.19531L10 7.25781ZM13.8672 8.875L12.7422 10L13.875 11.1328L15 10L13.8672 8.875ZM10 12.7422L8.0625 10.8047L6.9375 11.9375L8.875 13.875L10 15L11.1328 13.8672L13.0703 11.9297L11.9375 10.8047L10 12.7422ZM10 11.125L11.1328 10L10 8.86719L8.875 10L10 11.125Z",
    fill: "#F0B90B"
  }));
});
var du = $s(function () {
  return Ko.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M18.5 4.28V2C18.5 0.9 17.6 0 16.5 0H2.5C1.39 0 0.5 0.9 0.5 2V16C0.5 17.1 1.39 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V13.72C19.09 13.37 19.5 12.74 19.5 12V6C19.5 5.26 19.09 4.63 18.5 4.28ZM17.5 6V12H10.5V6H17.5ZM2.5 16V2H16.5V4H10.5C9.4 4 8.5 4.9 8.5 6V12C8.5 13.1 9.4 14 10.5 14H16.5V16H2.5Z",
    fill: "black"
  }), Ko.createElement("path", {
    d: "M13.5 10.5C14.3284 10.5 15 9.82843 15 9C15 8.17157 14.3284 7.5 13.5 7.5C12.6716 7.5 12 8.17157 12 9C12 9.82843 12.6716 10.5 13.5 10.5Z",
    fill: "black"
  }));
});
var pu = function pu() {
    var e;
    return !!(null === (e = window.ethereum) || void 0 === e ? void 0 : e.providers);
  },
  hu = function hu() {
    var e;
    return !!(pu() ? null === (e = window.ethereum.providers) || void 0 === e ? void 0 : e.find(function (e) {
      return e.isMetaMask;
    }) : window.ethereum.isMetaMask);
  },
  fu = function fu() {
    var e, t;
    return !!(pu() ? null === (e = window.ethereum.providers) || void 0 === e ? void 0 : e.find(function (e) {
      return e.isCoinbaseWallet;
    }) : null === (t = window.ethereum) || void 0 === t ? void 0 : t.isCoinbaseWallet);
  },
  mu = function mu() {
    var e;
    return pu() ? null === (e = window.ethereum.providers) || void 0 === e ? void 0 : e.find(function (e) {
      return e.isMetaMask;
    }) : window.ethereum;
  },
  gu = function gu() {
    var e;
    return pu() ? null === (e = window.ethereum.providers) || void 0 === e ? void 0 : e.find(function (e) {
      return e.isCoinbaseWallet;
    }) : window.ethereum;
  },
  _u = function _u() {
    var e;
    return null === (e = window.ethereum.providers) || void 0 === e ? void 0 : e.find(function (e) {
      return !e.isCoinbaseWallet && !e.isMetaMask;
    });
  },
  vu = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, f.Phantom, su), f.Vessel, lu), f.Binance, uu), f.Coinbase, Lc), f.Metamask, cu), f.GenericEthereumWallet, du), f.GenericSolanaWallet, du),
  yu = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, f.Phantom, "Phantom"), f.Vessel, "Vessel"), f.Binance, "Binance"), f.Coinbase, "Coinbase"), f.Metamask, "Metamask"), f.GenericEthereumWallet, "Other Ethereum Wallet"), f.GenericSolanaWallet, "Other Solana Wallet"),
  Cu = function Cu(e) {
    var t, n;
    switch (e) {
      case f.Metamask:
        return !!window.ethereum && hu();
      case f.Phantom:
        return null !== (n = !!window.solana && (null === (t = window.solana) || void 0 === t ? void 0 : t.isPhantom)) && void 0 !== n && n;
      case f.Vessel:
        return !!window.vessel;
      case f.Binance:
        return !!window.BinanceChain;
      case f.Coinbase:
        return !!window.ethereum && fu();
      case f.GenericEthereumWallet:
        return !(!window.ethereum || hu() || fu() || !window.ethereum);
      case f.GenericSolanaWallet:
        return !!window.solana && !window.solana.isPhantom;
      default:
        return !1;
    }
  },
  bu = function bu(e) {
    return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
      var _yield$e, _yield$e2, t;
      return _regeneratorRuntime().wrap(function _callee19$(_context19) {
        while (1) switch (_context19.prev = _context19.next) {
          case 0:
            _context19.next = 2;
            return e({
              method: "eth_requestAccounts"
            });
          case 2:
            _yield$e = _context19.sent;
            _yield$e2 = _slicedToArray(_yield$e, 1);
            t = _yield$e2[0];
            return _context19.abrupt("return", t);
          case 6:
          case "end":
            return _context19.stop();
        }
      }, _callee19);
    }));
  },
  wu = function wu(e, t, n) {
    return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
      return _regeneratorRuntime().wrap(function _callee20$(_context20) {
        while (1) switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return e({
              method: "personal_sign",
              params: [t, n]
            });
          case 2:
            return _context20.abrupt("return", _context20.sent);
          case 3:
          case "end":
            return _context20.stop();
        }
      }, _callee20);
    }));
  },
  ku = function ku(_ref73) {
    var e = _ref73.wallet,
      t = _ref73.message,
      n = _ref73.address;
    return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
      var _e7, _e8, _e9, _e10;
      return _regeneratorRuntime().wrap(function _callee22$(_context22) {
        while (1) switch (_context22.prev = _context22.next) {
          case 0:
            _context22.t0 = e;
            _context22.next = _context22.t0 === f.Phantom ? 3 : _context22.t0 === f.GenericSolanaWallet ? 3 : _context22.t0 === f.Metamask ? 4 : _context22.t0 === f.Vessel ? 6 : _context22.t0 === f.Binance ? 7 : _context22.t0 === f.Coinbase ? 9 : _context22.t0 === f.GenericEthereumWallet ? 11 : 13;
            break;
          case 3:
            return _context22.abrupt("return", function (e) {
              return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
                var t, n;
                return _regeneratorRuntime().wrap(function _callee21$(_context21) {
                  while (1) switch (_context21.prev = _context21.next) {
                    case 0:
                      t = new TextEncoder().encode(e);
                      _context21.next = 3;
                      return window.solana.request({
                        method: "signMessage",
                        params: {
                          message: t,
                          display: "utf8"
                        }
                      });
                    case 3:
                      n = _context21.sent;
                      return _context21.abrupt("return", au.encode(n.signature));
                    case 5:
                    case "end":
                      return _context21.stop();
                  }
                }, _callee21);
              }));
            }(t));
          case 4:
            _e7 = mu();
            return _context22.abrupt("return", (null == _e7 ? void 0 : _e7.request) ? wu(null == _e7 ? void 0 : _e7.request, t, n) : "");
          case 6:
            return _context22.abrupt("return", wu(window.vessel.ethereum.request, t, n));
          case 7:
            _e8 = window.BinanceChain;
            return _context22.abrupt("return", (null == _e8 ? void 0 : _e8.request) ? wu(null == _e8 ? void 0 : _e8.request, t, n) : "");
          case 9:
            _e9 = gu();
            return _context22.abrupt("return", (null == _e9 ? void 0 : _e9.request) ? wu(null == _e9 ? void 0 : _e9.request, t, n) : "");
          case 11:
            _e10 = _u();
            return _context22.abrupt("return", (null == _e10 ? void 0 : _e10.request) ? wu(null == _e10 ? void 0 : _e10.request, t, n) : "");
          case 13:
            return _context22.abrupt("return", "");
          case 14:
          case "end":
            return _context22.stop();
        }
      }, _callee22);
    }));
  },
  Eu = function Eu(e) {
    return [f.Phantom, f.GenericSolanaWallet].includes(e);
  },
  Su = bs.button(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  all: unset;\n  width: 100%;\n  cursor: pointer;\n  text-align: center;\n  font-weight: 600;\n"]))),
  xu = function xu(_ref74) {
    var e = _ref74.type;
    var t, n;
    var _Rs15 = Rs(),
      _Rs16 = _slicedToArray(_Rs15, 2),
      r = _Rs16[0],
      o = _Rs16[1],
      i = 6 - (null !== (n = null === (t = Ds().oauthOptions) || void 0 === t ? void 0 : t.providers.length) && void 0 !== n ? n : 0) - 1,
      a = Object.keys(f).filter(function (e) {
        return Cu(f[e]);
      }),
      s = a.length > i,
      c = a.slice(0, i),
      l = a.slice(i),
      u = function u(_ref75) {
        var e = _ref75.wallet;
        return $n(vu[e], null);
      };
    return $n(Hs, {
      direction: "column",
      gap: 8,
      className: "wallet-buttons"
    }, ("main" === e ? c : l).map(function (t) {
      return $n(ou, {
        key: t,
        icon: $n(u, {
          wallet: f[t]
        }),
        walletTypeTitle: "main" === e ? "Continue with ".concat(yu[f[t]]) : yu[f[t]],
        onClick: function onClick() {
          return function (e) {
            o({
              type: "update_crypto_state",
              cryptoState: Object.assign(Object.assign({}, r.formState.cryptoState), {
                walletOption: e
              })
            }), o({
              type: "transition",
              screen: Ss.CryptoConnect
            });
          }(f[t]);
        }
      });
    }), s && "main" === e ? $n(ou, {
      walletTypeTitle: "Continue with other Crypto Wallet",
      icon: $n(u, {
        wallet: f.GenericEthereumWallet
      }),
      onClick: function onClick() {
        return o({
          type: "transition",
          screen: Ss.CryptoOtherScreen
        });
      }
    }) : $n(Su, {
      onClick: function onClick() {
        return o({
          type: "transition",
          screen: Ss.CryptoSetupWallet
        });
      }
    }, "Set up a new crypto wallet"));
  };
var Ou = $s(function () {
  return Ko.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, Ko.createElement("path", {
    d: "M8.75 10C10.8211 10 12.5 8.32107 12.5 6.25C12.5 4.17893 10.8211 2.5 8.75 2.5C6.67893 2.5 5 4.17893 5 6.25C5 8.32107 6.67893 10 8.75 10Z",
    fill: "#19303D"
  }), Ko.createElement("path", {
    d: "M18.7501 10.0001C18.7519 9.47774 18.6134 8.96445 18.349 8.51388C18.0847 8.06332 17.7041 7.69203 17.2472 7.43881C16.7903 7.18559 16.2738 7.05973 15.7516 7.07439C15.2294 7.08905 14.7207 7.24369 14.2787 7.52214C13.8367 7.8006 13.4776 8.19265 13.239 8.65733C13.0003 9.12202 12.8908 9.64227 12.9219 10.1637C12.9531 10.6852 13.1237 11.1887 13.416 11.6217C13.7082 12.0547 14.1114 12.4012 14.5834 12.6251V17.0835L15.8334 18.3335L17.9167 16.2501L16.6667 15.0001L17.9167 13.7501L16.8834 12.7168C17.4322 12.505 17.9042 12.1323 18.2373 11.6474C18.5704 11.1626 18.7492 10.5884 18.7501 10.0001ZM15.8334 10.0001C15.6686 10.0001 15.5075 9.95126 15.3704 9.85969C15.2334 9.76812 15.1266 9.63797 15.0635 9.4857C15.0004 9.33343 14.9839 9.16587 15.0161 9.00422C15.0482 8.84257 15.1276 8.69409 15.2441 8.57754C15.3607 8.461 15.5092 8.38163 15.6708 8.34948C15.8325 8.31732 16 8.33383 16.1523 8.3969C16.3046 8.45997 16.4347 8.56678 16.5263 8.70382C16.6179 8.84086 16.6667 9.00198 16.6667 9.1668C16.6667 9.38781 16.5789 9.59977 16.4227 9.75605C16.2664 9.91233 16.0544 10.0001 15.8334 10.0001Z",
    fill: "#19303D"
  }), Ko.createElement("path", {
    d: "M12.0333 11.6833C11.3934 11.398 10.7007 11.2504 10 11.25H7.5C6.17392 11.25 4.90215 11.7768 3.96447 12.7145C3.02678 13.6521 2.5 14.9239 2.5 16.25V17.9167H13.3333V13.325C12.7713 12.8933 12.3248 12.3293 12.0333 11.6833Z",
    fill: "#19303D"
  }));
});
var Lu = function Lu() {
    var _Zl2 = Zl({
        conditionalMediation: !1
      }),
      e = _Zl2.prompt;
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Is, {
      variant: "outlined",
      onClick: e
    }, Ko.createElement(Hs, {
      justifyContent: "center",
      alignItems: "center",
      gap: 4
    }, Ko.createElement(Ou, null), Ko.createElement("span", {
      style: {
        verticalAlign: "middle"
      }
    }, "Login with a Passkey"))));
  },
  Au = bs(Hs)(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  .oauth-buttons + .wallet-buttons {\n    margin-top: 8px;\n  }\n  .wallet-buttons + .oauth-buttons {\n    margin-top: 8px;\n  }\n  > * + * {\n    margin-top: 24px;\n  }\n"]))),
  Tu = bs.img(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  max-height: 50px;\n  max-width: 100px;\n"]))),
  Pu = function Pu() {
    var e = Ms(),
      t = Ds(),
      n = new Set(),
      _Cs = Cs(),
      r = _Cs.displayHeader,
      o = _Cs.logo,
      _Or45 = Or([]),
      _Or46 = _slicedToArray(_Or45, 2),
      i = _Or46[0],
      a = _Or46[1],
      s = t.products,
      c = s.includes(p.oauth) && t.oauthOptions || s.includes(p.crypto),
      l = t.products.includes(p.passkeys),
      u = s.includes(p.emailMagicLinks) || s.includes(p.otp) || s.includes(p.passwords);
    return Ar(function () {
      Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
        var r, o;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              r = t.products.map(function (e) {
                switch (e) {
                  case p.oauth:
                    return Ko.createElement(jc, {
                      key: e
                    });
                  case p.crypto:
                    return Ko.createElement(xu, {
                      type: "main",
                      key: e
                    });
                  case p.emailMagicLinks:
                  case p.otp:
                  case p.passwords:
                    return Ko.createElement(ru, {
                      key: "login-form"
                    });
                }
              }).filter(function (e) {
                var t = n.has(null == e ? void 0 : e.key);
                return n.add(null == e ? void 0 : e.key), !t;
              }), o = c && u;
              r.length > 1 && o && r.splice(r.length - 1, 0, Ko.createElement(tc, {
                key: "divider"
              }));
              _context23.t0 = l;
              if (!_context23.t0) {
                _context23.next = 12;
                break;
              }
              _context23.next = 6;
              return e.webauthn.browserSupportsAutofill();
            case 6:
              _context23.t1 = _context23.sent;
              if (!_context23.t1) {
                _context23.next = 9;
                break;
              }
              _context23.t1 = u;
            case 9:
              _context23.t2 = _context23.t1;
              if (_context23.t2) {
                _context23.next = 12;
                break;
              }
              r.splice(0, 0, Ko.createElement(Lu, {
                key: "passkey-button"
              }));
            case 12:
              a(r);
            case 13:
            case "end":
              return _context23.stop();
          }
        }, _callee23);
      }));
    }, []), l && 1 === s.length ? Ko.createElement(Us, {
      size: "helper"
    }, "Error: Cannot use Passkeys by itself, please add another product to the config.") : Ko.createElement(Au, {
      direction: "column"
    }, "" !== o.logoImageUrl && Ko.createElement(Hs, {
      justifyContent: "center"
    }, Ko.createElement(Tu, {
      src: o.logoImageUrl
    })), r && Ko.createElement(Hs, {
      justifyContent: "center"
    }, Ko.createElement(Us, {
      size: "header"
    }, "Sign up or log in")), i.map(function (e) {
      return e;
    }));
  };
var Mu,
  Ru,
  Du,
  Fu = {
    data: ""
  },
  ju = function ju(e) {
    return "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), {
      innerHTML: " ",
      id: "_goober"
    })).firstChild : e || Fu;
  },
  Iu = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,
  Bu = /\/\*[^]*?\*\/|  +/g,
  Nu = /\n+/g,
  Hu = function Hu(e, t) {
    var n = "",
      r = "",
      o = "";
    var _loop2 = function _loop2(_i3) {
      var a = e[_i3];
      "@" == _i3[0] ? "i" == _i3[1] ? n = _i3 + " " + a + ";" : r += "f" == _i3[1] ? Hu(a, _i3) : _i3 + "{" + Hu(a, "k" == _i3[1] ? "" : t) + "}" : "object" == _typeof(a) ? r += Hu(a, t ? t.replace(/([^,])+/g, function (e) {
        return _i3.replace(/(^:.*)|([^,])+/g, function (t) {
          return /&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t;
        });
      }) : _i3) : null != a && (_i3 = /^--/.test(_i3) ? _i3 : _i3.replace(/[A-Z]/g, "-$&").toLowerCase(), o += Hu.p ? Hu.p(_i3, a) : _i3 + ":" + a + ";");
    };
    for (var _i3 in e) {
      _loop2(_i3);
    }
    return n + (t && o ? t + "{" + o + "}" : o) + r;
  },
  Uu = {},
  $u = function $u(e) {
    if ("object" == _typeof(e)) {
      var _t5 = "";
      for (var _n10 in e) _t5 += _n10 + $u(e[_n10]);
      return _t5;
    }
    return e;
  },
  Vu = function Vu(e, t, n, r, o) {
    var i = $u(e),
      a = Uu[i] || (Uu[i] = function (e) {
        var t = 0,
          n = 11;
        for (; t < e.length;) n = 101 * n + e.charCodeAt(t++) >>> 0;
        return "go" + n;
      }(i));
    if (!Uu[a]) {
      var _t6 = i !== e ? e : function (e) {
        var t,
          n,
          r = [{}];
        for (; t = Iu.exec(e.replace(Bu, ""));) t[4] ? r.shift() : t[3] ? (n = t[3].replace(Nu, " ").trim(), r.unshift(r[0][n] = r[0][n] || {})) : r[0][t[1]] = t[2].replace(Nu, " ").trim();
        return r[0];
      }(e);
      Uu[a] = Hu(o ? _defineProperty({}, "@keyframes " + a, _t6) : _t6, n ? "" : "." + a);
    }
    var s = n && Uu.g ? Uu.g : null;
    return n && (Uu.g = Uu[a]), function (e, t, n, r) {
      r ? t.data = t.data.replace(r, e) : -1 === t.data.indexOf(e) && (t.data = n ? e + t.data : t.data + e);
    }(Uu[a], t, r, s), a;
  },
  Zu = function Zu(e, t, n) {
    return e.reduce(function (e, r, o) {
      var i = t[o];
      if (i && i.call) {
        var _e11 = i(n),
          _t7 = _e11 && _e11.props && _e11.props.className || /^go/.test(_e11) && _e11;
        i = _t7 ? "." + _t7 : _e11 && "object" == _typeof(_e11) ? _e11.props ? "" : Hu(_e11, "") : !1 === _e11 ? "" : _e11;
      }
      return e + r + (null == i ? "" : i);
    }, "");
  };
function zu(e) {
  var t = this || {},
    n = e.call ? e(t.p) : e;
  return Vu(n.unshift ? n.raw ? Zu(n, [].slice.call(arguments, 1), t.p) : n.reduce(function (e, n) {
    return Object.assign(e, n && n.call ? n(t.p) : n);
  }, {}) : n, ju(t.target), t.g, t.o, t.k);
}
zu.bind({
  g: 1
});
var Wu = zu.bind({
  k: 1
});
function Ku(e, t) {
  var n = this || {};
  return function () {
    var r = arguments;
    function o(i, a) {
      var s = Object.assign({}, i),
        c = s.className || o.className;
      n.p = Object.assign({
        theme: Ru && Ru()
      }, s), n.o = / *go\d+/.test(c), s.className = zu.apply(n, r) + (c ? " " + c : ""), t && (s.ref = a);
      var l = e;
      return e[0] && (l = s.as || e, delete s.as), Du && l[0] && Du(s), Mu(l, s);
    }
    return t ? t(o) : o;
  };
}
function Gu() {
  return Gu = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Gu.apply(this, arguments);
}
function qu(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}
var Yu,
  Ju = function Ju(e, t) {
    return function (e) {
      return "function" == typeof e;
    }(e) ? e(t) : e;
  },
  Xu = function () {
    var e = 0;
    return function () {
      return (++e).toString();
    };
  }(),
  Qu = function () {
    var e = void 0;
    return function () {
      if (void 0 === e && "undefined" != typeof window) {
        var t = matchMedia("(prefers-reduced-motion: reduce)");
        e = !t || t.matches;
      }
      return e;
    };
  }();
!function (e) {
  e[e.ADD_TOAST = 0] = "ADD_TOAST", e[e.UPDATE_TOAST = 1] = "UPDATE_TOAST", e[e.UPSERT_TOAST = 2] = "UPSERT_TOAST", e[e.DISMISS_TOAST = 3] = "DISMISS_TOAST", e[e.REMOVE_TOAST = 4] = "REMOVE_TOAST", e[e.START_PAUSE = 5] = "START_PAUSE", e[e.END_PAUSE = 6] = "END_PAUSE";
}(Yu || (Yu = {}));
var ed = new Map(),
  td = function td(e) {
    if (!ed.has(e)) {
      var t = setTimeout(function () {
        ed["delete"](e), id({
          type: Yu.REMOVE_TOAST,
          toastId: e
        });
      }, 1e3);
      ed.set(e, t);
    }
  },
  nd = function e(t, n) {
    switch (n.type) {
      case Yu.ADD_TOAST:
        return Gu({}, t, {
          toasts: [n.toast].concat(t.toasts).slice(0, 20)
        });
      case Yu.UPDATE_TOAST:
        return n.toast.id && function (e) {
          var t = ed.get(e);
          t && clearTimeout(t);
        }(n.toast.id), Gu({}, t, {
          toasts: t.toasts.map(function (e) {
            return e.id === n.toast.id ? Gu({}, e, n.toast) : e;
          })
        });
      case Yu.UPSERT_TOAST:
        var r = n.toast;
        return t.toasts.find(function (e) {
          return e.id === r.id;
        }) ? e(t, {
          type: Yu.UPDATE_TOAST,
          toast: r
        }) : e(t, {
          type: Yu.ADD_TOAST,
          toast: r
        });
      case Yu.DISMISS_TOAST:
        var o = n.toastId;
        return o ? td(o) : t.toasts.forEach(function (e) {
          td(e.id);
        }), Gu({}, t, {
          toasts: t.toasts.map(function (e) {
            return e.id === o || void 0 === o ? Gu({}, e, {
              visible: !1
            }) : e;
          })
        });
      case Yu.REMOVE_TOAST:
        return void 0 === n.toastId ? Gu({}, t, {
          toasts: []
        }) : Gu({}, t, {
          toasts: t.toasts.filter(function (e) {
            return e.id !== n.toastId;
          })
        });
      case Yu.START_PAUSE:
        return Gu({}, t, {
          pausedAt: n.time
        });
      case Yu.END_PAUSE:
        var i = n.time - (t.pausedAt || 0);
        return Gu({}, t, {
          pausedAt: void 0,
          toasts: t.toasts.map(function (e) {
            return Gu({}, e, {
              pauseDuration: e.pauseDuration + i
            });
          })
        });
    }
  },
  rd = [],
  od = {
    toasts: [],
    pausedAt: void 0
  },
  id = function id(e) {
    od = nd(od, e), rd.forEach(function (e) {
      e(od);
    });
  },
  ad = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
  },
  sd = function sd(e) {
    return function (t, n) {
      var r = function (e, t, n) {
        return void 0 === t && (t = "blank"), Gu({
          createdAt: Date.now(),
          visible: !0,
          type: t,
          ariaProps: {
            role: "status",
            "aria-live": "polite"
          },
          message: e,
          pauseDuration: 0
        }, n, {
          id: (null == n ? void 0 : n.id) || Xu()
        });
      }(t, e, n);
      return id({
        type: Yu.UPSERT_TOAST,
        toast: r
      }), r.id;
    };
  },
  cd = function cd(e, t) {
    return sd("blank")(e, t);
  };
cd.error = sd("error"), cd.success = sd("success"), cd.loading = sd("loading"), cd.custom = sd("custom"), cd.dismiss = function (e) {
  id({
    type: Yu.DISMISS_TOAST,
    toastId: e
  });
}, cd.remove = function (e) {
  return id({
    type: Yu.REMOVE_TOAST,
    toastId: e
  });
}, cd.promise = function (e, t, n) {
  var r = cd.loading(t.loading, Gu({}, n, null == n ? void 0 : n.loading));
  return e.then(function (e) {
    return cd.success(Ju(t.success, e), Gu({
      id: r
    }, n, null == n ? void 0 : n.success)), e;
  })["catch"](function (e) {
    cd.error(Ju(t.error, e), Gu({
      id: r
    }, n, null == n ? void 0 : n.error));
  }), e;
};
var ld = function ld(e) {
  var t = function (e) {
      void 0 === e && (e = {});
      var t = Or(od),
        n = t[0],
        r = t[1];
      Ar(function () {
        return rd.push(r), function () {
          var e = rd.indexOf(r);
          e > -1 && rd.splice(e, 1);
        };
      }, [n]);
      var o = n.toasts.map(function (t) {
        var n, r, o;
        return Gu({}, e, e[t.type], t, {
          duration: t.duration || (null == (n = e[t.type]) ? void 0 : n.duration) || (null == (r = e) ? void 0 : r.duration) || ad[t.type],
          style: Gu({}, e.style, null == (o = e[t.type]) ? void 0 : o.style, t.style)
        });
      });
      return Gu({}, n, {
        toasts: o
      });
    }(e),
    n = t.toasts,
    r = t.pausedAt;
  Ar(function () {
    if (!r) {
      var e = Date.now(),
        t = n.map(function (t) {
          if (t.duration !== 1 / 0) {
            var n = (t.duration || 0) + t.pauseDuration - (e - t.createdAt);
            if (!(n < 0)) return setTimeout(function () {
              return cd.dismiss(t.id);
            }, n);
            t.visible && cd.dismiss(t.id);
          }
        });
      return function () {
        t.forEach(function (e) {
          return e && clearTimeout(e);
        });
      };
    }
  }, [n, r]);
  var o = Rr(function () {
    return {
      startPause: function startPause() {
        id({
          type: Yu.START_PAUSE,
          time: Date.now()
        });
      },
      endPause: function endPause() {
        r && id({
          type: Yu.END_PAUSE,
          time: Date.now()
        });
      },
      updateHeight: function updateHeight(e, t) {
        return id({
          type: Yu.UPDATE_TOAST,
          toast: {
            id: e,
            height: t
          }
        });
      },
      calculateOffset: function calculateOffset(e, t) {
        var r,
          o = t || {},
          i = o.reverseOrder,
          a = void 0 !== i && i,
          s = o.gutter,
          c = void 0 === s ? 8 : s,
          l = o.defaultPosition,
          u = n.filter(function (t) {
            return (t.position || l) === (e.position || l) && t.height;
          }),
          d = u.findIndex(function (t) {
            return t.id === e.id;
          }),
          p = u.filter(function (e, t) {
            return t < d && e.visible;
          }).length,
          h = (r = u.filter(function (e) {
            return e.visible;
          })).slice.apply(r, a ? [p + 1] : [0, p]).reduce(function (e, t) {
            return e + (t.height || 0) + c;
          }, 0);
        return h;
      }
    };
  }, [n, r]);
  return {
    toasts: n,
    handlers: o
  };
};
function ud() {
  var e = qu(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ", ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"]);
  return ud = function ud() {
    return e;
  }, e;
}
function dd() {
  var e = qu(["\nfrom {\n  transform: scale(0) rotate(90deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n\topacity: 1;\n}"]);
  return dd = function dd() {
    return e;
  }, e;
}
function pd() {
  var e = qu(["\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);
  return pd = function pd() {
    return e;
  }, e;
}
function hd() {
  var e = qu(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"]);
  return hd = function hd() {
    return e;
  }, e;
}
var fd = Wu(hd()),
  md = Wu(pd()),
  gd = Wu(dd()),
  _d = Ku("div")(ud(), function (e) {
    return e.primary || "#ff4b4b";
  }, fd, md, function (e) {
    return e.secondary || "#fff";
  }, gd);
function vd() {
  var e = qu(["\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ", ";\n  border-right-color: ", ";\n  animation: ", " 1s linear infinite;\n"]);
  return vd = function vd() {
    return e;
  }, e;
}
function yd() {
  var e = qu(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]);
  return yd = function yd() {
    return e;
  }, e;
}
var Cd = Wu(yd()),
  bd = Ku("div")(vd(), function (e) {
    return e.secondary || "#e0e0e0";
  }, function (e) {
    return e.primary || "#616161";
  }, Cd);
function wd() {
  var e = qu(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ", " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ", ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"]);
  return wd = function wd() {
    return e;
  }, e;
}
function kd() {
  var e = qu(["\n0% {\n\theight: 0;\n\twidth: 0;\n\topacity: 0;\n}\n40% {\n  height: 0;\n\twidth: 6px;\n\topacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"]);
  return kd = function kd() {
    return e;
  }, e;
}
function Ed() {
  var e = qu(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n\topacity: 1;\n}"]);
  return Ed = function Ed() {
    return e;
  }, e;
}
var Sd = Wu(Ed()),
  xd = Wu(kd()),
  Od = Ku("div")(wd(), function (e) {
    return e.primary || "#61d345";
  }, Sd, xd, function (e) {
    return e.secondary || "#fff";
  });
function Ld() {
  var e = qu(["\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ", " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"]);
  return Ld = function Ld() {
    return e;
  }, e;
}
function Ad() {
  var e = qu(["\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);
  return Ad = function Ad() {
    return e;
  }, e;
}
function Td() {
  var e = qu(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"]);
  return Td = function Td() {
    return e;
  }, e;
}
function Pd() {
  var e = qu(["\n  position: absolute;\n"]);
  return Pd = function Pd() {
    return e;
  }, e;
}
var Md = Ku("div")(Pd()),
  Rd = Ku("div")(Td()),
  Dd = Wu(Ad()),
  Fd = Ku("div")(Ld(), Dd),
  jd = function jd(e) {
    var t = e.toast,
      n = t.icon,
      r = t.type,
      o = t.iconTheme;
    return void 0 !== n ? "string" == typeof n ? $n(Fd, null, n) : n : "blank" === r ? null : $n(Rd, null, $n(bd, Object.assign({}, o)), "loading" !== r && $n(Md, null, $n("error" === r ? _d : Od, Object.assign({}, o))));
  };
function Id() {
  var e = qu(["\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"]);
  return Id = function Id() {
    return e;
  }, e;
}
function Bd() {
  var e = qu(["\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"]);
  return Bd = function Bd() {
    return e;
  }, e;
}
var Nd = function Nd(e) {
    return "\n0% {transform: translate3d(0," + -200 * e + "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n";
  },
  Hd = function Hd(e) {
    return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0," + -150 * e + "%,-1px) scale(.6); opacity:0;}\n";
  },
  Ud = Ku("div", Jr)(Bd()),
  $d = Ku("div")(Id()),
  Vd = Gr(function (e) {
    var t = e.toast,
      n = e.position,
      r = e.style,
      o = e.children,
      i = null != t && t.height ? function (e, t) {
        var n = e.includes("top") ? 1 : -1,
          r = Qu() ? ["0%{opacity:0;} 100%{opacity:1;}", "0%{opacity:1;} 100%{opacity:0;}"] : [Nd(n), Hd(n)],
          o = r[1];
        return {
          animation: t ? Wu(r[0]) + " 0.35s cubic-bezier(.21,1.02,.73,1) forwards" : Wu(o) + " 0.4s forwards cubic-bezier(.06,.71,.55,1)"
        };
      }(t.position || n || "top-center", t.visible) : {
        opacity: 0
      },
      a = $n(jd, {
        toast: t
      }),
      s = $n($d, Object.assign({}, t.ariaProps), Ju(t.message, t));
    return $n(Ud, {
      className: t.className,
      style: Gu({}, i, r, t.style)
    }, "function" == typeof o ? o({
      icon: a,
      message: s
    }) : $n(zn, null, a, s));
  });
function Zd() {
  var e = qu(["\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"]);
  return Zd = function Zd() {
    return e;
  }, e;
}
!function (e, t, n, r) {
  Hu.p = t, Mu = e, Ru = n, Du = r;
}($n);
var zd = zu(Zd()),
  Wd = function Wd(e) {
    var t = e.reverseOrder,
      n = e.position,
      r = void 0 === n ? "top-center" : n,
      o = e.toastOptions,
      i = e.gutter,
      a = e.children,
      s = e.containerStyle,
      c = e.containerClassName,
      l = ld(o),
      u = l.toasts,
      d = l.handlers;
    return $n("div", {
      style: Gu({
        position: "fixed",
        zIndex: 9999,
        top: 16,
        left: 16,
        right: 16,
        bottom: 16,
        pointerEvents: "none"
      }, s),
      className: c,
      onMouseEnter: d.startPause,
      onMouseLeave: d.endPause
    }, u.map(function (e) {
      var n,
        o = e.position || r,
        s = function (e, t) {
          var n = e.includes("top"),
            r = n ? {
              top: 0
            } : {
              bottom: 0
            },
            o = e.includes("center") ? {
              justifyContent: "center"
            } : e.includes("right") ? {
              justifyContent: "flex-end"
            } : {};
          return Gu({
            left: 0,
            right: 0,
            display: "flex",
            position: "absolute",
            transition: Qu() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
            transform: "translateY(" + t * (n ? 1 : -1) + "px)"
          }, r, o);
        }(o, d.calculateOffset(e, {
          reverseOrder: t,
          gutter: i,
          defaultPosition: r
        }));
      return $n("div", {
        ref: e.height ? void 0 : (n = function n(t) {
          d.updateHeight(e.id, t.height);
        }, function (e) {
          e && setTimeout(function () {
            var t = e.getBoundingClientRect();
            n(t);
          });
        }),
        className: e.visible ? zd : "",
        key: e.id,
        style: s
      }, "custom" === e.type ? Ju(e.message, e) : a ? a(e) : $n(Vd, {
        toast: e,
        position: o
      }));
    }));
  };
var Kd = bs.button(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n"]))),
  Gd = function Gd(_ref77) {
    var e = _ref77.color;
    return Ko.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Ko.createElement("path", {
      d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z",
      fill: e
    }));
  },
  qd = function qd(_ref78) {
    var e = _ref78.onClick;
    var t = Cs();
    return Ko.createElement(Kd, {
      type: "button",
      onClick: e,
      "aria-label": "Back"
    }, Ko.createElement(Gd, {
      color: t.colors.primary
    }));
  },
  Yd = function Yd(_ref79) {
    var e = _ref79.onClick,
      t = _ref79.children;
    return Ko.createElement("button", {
      onClick: e,
      style: {
        all: "unset"
      }
    }, Ko.createElement("b", {
      style: {
        cursor: "pointer"
      }
    }, t));
  },
  Jd = bs.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-rows: ", ";\n  transition: grid-template-rows 0.15s ease-out;\n"])), function (_ref80) {
    var e = _ref80.isOpen;
    return e ? "1fr" : "0fr";
  }),
  Xd = bs.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  overflow: hidden;\n"]))),
  Qd = function Qd(_ref81) {
    var e = _ref81.isOpen,
      t = _ref81.children;
    return Ko.createElement(Jd, {
      isOpen: e
    }, Ko.createElement(Xd, null, t));
  },
  ep = bs.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  height: 4px;\n  background-color: ", ";\n  border-radius: 3px;\n  overflow: hidden;\n"])), function (_ref82) {
    var e = _ref82.theme;
    return e.colors.disabled;
  }),
  tp = ys(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(-1%);\n  }\n"]))),
  np = bs.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  background-color: ", ";\n  animation: ", " 10s cubic-bezier(0.22, 1, 0.36, 1);\n"])), function (_ref83) {
    var e = _ref83.theme;
    return e.colors.primary;
  }, tp),
  rp = function rp(_ref84) {
    var e = _ref84.isLoading;
    return Ko.createElement(ep, null, e && Ko.createElement(np, null));
  },
  op = "46px",
  ip = "46px",
  ap = bs.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  border: 1px solid ", ";\n  border-radius: 4px;\n  align-items: center;\n  display: flex;\n  font-size: 18px;\n  justify-content: center;\n  height: ", ";\n  width: ", ";\n  background: ", ";\n  color: ", ";\n"])), function (_ref85) {
    var e = _ref85.disabled,
      t = _ref85.theme;
    return e ? t.colors.disabled : "#ADBCC5";
  }, ip, op, function (_ref86) {
    var e = _ref86.disabled,
      t = _ref86.theme;
    return e ? t.colors.disabled : t.inputs.backgroundColor;
  }, function (_ref87) {
    var e = _ref87.disabled,
      t = _ref87.theme;
    return e ? t.colors.disabledText : t.inputs.textColor;
  }),
  sp = {
    display: "flex",
    justifyContent: "space-between",
    gap: "8px",
    position: "relative",
    zIndex: -1
  },
  cp = {
    overflow: "hidden",
    position: "relative",
    textAlign: "initial",
    zIndex: 1
  },
  lp = {
    background: "transparent",
    border: "none",
    color: "transparent",
    height: ip,
    margin: 0,
    outline: "none",
    position: "absolute",
    width: "calc(100% - (0.5 * ".concat(op, "))"),
    caretColor: "#ADBCC5",
    letterSpacing: "calc(".concat(op, " - 1ch + 8px)"),
    paddingLeft: "calc(0.5 * ".concat(op, ")"),
    zIndex: 10
  },
  up = function up(_ref88) {
    var e = _ref88.index,
      t = _ref88.disabled,
      n = _ref88.otp;
    var r = n ? n[e] : "";
    return Ko.createElement(ap, {
      disabled: t,
      "data-testid": "otp-".concat(e)
    }, r);
  },
  dp = function dp(_ref89) {
    var e = _ref89.otp,
      t = _ref89.setOtp,
      n = _ref89.disabled;
    return Ko.createElement("div", {
      style: cp
    }, Ko.createElement("input", {
      "aria-label": "One-time passcode",
      autoComplete: "one-time-code",
      autoFocus: !0,
      disabled: n,
      style: lp,
      maxLength: 6,
      onChange: function onChange(e) {
        /^\d*$/.test(e.target.value) && t(e.target.value);
      },
      type: "text",
      inputMode: "numeric",
      value: e,
      "data-1p-ignore": "true"
    }), Ko.createElement("div", {
      style: sp
    }, _toConsumableArray(Array(6).keys()).map(function (t) {
      return Ko.createElement(up, {
        key: "digit-".concat(t),
        index: t,
        otp: e,
        disabled: !!n
      });
    })));
  },
  pp = function pp(_ref90) {
    var e = _ref90.isSubmitting,
      t = _ref90.onSubmit,
      n = _ref90.errorMessage;
    var _Or47 = Or(""),
      _Or48 = _slicedToArray(_Or47, 2),
      r = _Or48[0],
      o = _Or48[1];
    return Ko.createElement(Hs, {
      direction: "column",
      maxWidth: 316
    }, Ko.createElement(dp, {
      otp: r,
      setOtp: function setOtp(e) {
        o(e), 6 === e.length && t(e);
      },
      disabled: e
    }), Ko.createElement(Qd, {
      isOpen: e
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 8,
      marginTop: 8
    }, Ko.createElement(Us, {
      color: "secondary",
      size: "helper"
    }, "Verifying passcode..."), Ko.createElement(rp, {
      isLoading: e
    }))), !e && Ko.createElement(Bl, {
      errorMessage: null != n ? n : ""
    }));
  },
  hp = function hp(_ref91) {
    var e = _ref91.header,
      t = _ref91.helperContent,
      n = _ref91.instruction,
      r = _ref91.isSubmitting,
      o = _ref91.onSubmit,
      i = _ref91.errorMessage;
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(Us, {
      size: "header"
    }, e), Ko.createElement(Us, null, n), Ko.createElement(pp, {
      isSubmitting: r,
      onSubmit: o,
      errorMessage: i
    }), Ko.createElement(Us, {
      size: "helper",
      color: "secondary"
    }, t));
  },
  fp = function fp(e) {
    var t = new Date();
    return Math.ceil((e.getTime() - t.getTime()) / 1e3);
  },
  mp = function mp(_ref92) {
    var e = _ref92.expiration,
      t = _ref92.resendOTP;
    var _Or49 = Or(function () {
        return fp(e);
      }),
      _Or50 = _slicedToArray(_Or49, 2),
      n = _Or50[0],
      r = _Or50[1],
      o = n <= 0;
    Ar(function () {
      if (!o) {
        var _t8 = function _t8() {
            return r(fp(e));
          },
          _n11 = setInterval(_t8, 1e3);
        return _t8(), function () {
          return clearInterval(_n11);
        };
      }
    }, [o, e]);
    var i = Math.floor(Number(n / 60)),
      a = n - 60 * i,
      s = n > 0 ? "Your code expires in ".concat("".concat(i, ":").concat(a < 10 ? "0".concat(a) : a), ". Didn't get it? ") : "Your code has expired. ";
    return Ko.createElement(Ko.Fragment, null, s, Ko.createElement(Yd, {
      onClick: t
    }, "Resend code"));
  },
  gp = function gp(_ref93) {
    var e = _ref93.expiration,
      t = _ref93.formattedDestination,
      n = _ref93.isSubmitting,
      r = _ref93.onSubmit,
      o = _ref93.errorMessage,
      i = _ref93.resendOTP;
    return Ko.createElement(hp, {
      header: "Enter passcode",
      helperContent: Ko.createElement(mp, {
        expiration: e,
        resendOTP: i
      }),
      instruction: Ko.createElement(Ko.Fragment, null, "A 6-digit passcode was sent to you at ", Ko.createElement("b", null, t), "."),
      isSubmitting: n,
      onSubmit: r,
      errorMessage: o
    });
  },
  _p = function _p(_ref94) {
    var _ref94$hideBackArrow = _ref94.hideBackArrow,
      e = _ref94$hideBackArrow === void 0 ? !1 : _ref94$hideBackArrow;
    var t = js(),
      n = Fs(),
      r = Ms(),
      o = Ds(),
      _Rs17 = Rs(),
      _Rs18 = _slicedToArray(_Rs17, 2),
      i = _Rs18[0],
      a = _Rs18[1],
      _Or51 = Or(!1),
      _Or52 = _slicedToArray(_Or51, 2),
      s = _Or52[0],
      c = _Or52[1],
      l = i.formState.otpState.otpDestination,
      u = i.formState.otpState.type,
      _Or53 = Or(""),
      _Or54 = _slicedToArray(_Or53, 2),
      d = _Or54[0],
      p = _Or54[1],
      _Or55 = Or(l),
      _Or56 = _slicedToArray(_Or55, 2),
      h = _Or56[0],
      f = _Or56[1],
      m = function m() {
        var e, t;
        return new Date(Date.now() + 6e4 * (null !== (t = null === (e = o.otpOptions) || void 0 === e ? void 0 : e.expirationMinutes) && void 0 !== t ? t : 5));
      };
    Ar(function () {
      xn(r).clientsideServices.parsedPhoneNumber({
        phoneNumber: l
      }).then(function (e) {
        f(u === g.Email ? l : e.number);
      });
    }, [u, l, r]);
    var _Or57 = Or(m),
      _Or58 = _slicedToArray(_Or57, 2),
      v = _Or58[0],
      y = _Or58[1];
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, !e && Ko.createElement(qd, {
      onClick: function onClick() {
        return a({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(gp, {
      expiration: v,
      formattedDestination: h,
      isSubmitting: s,
      onSubmit: function onSubmit(e) {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee24() {
          var s, l;
          return _regeneratorRuntime().wrap(function _callee24$(_context24) {
            while (1) switch (_context24.prev = _context24.next) {
              case 0:
                c(!0), r.otps.authenticate(e, i.formState.otpState.methodId, {
                  session_duration_minutes: null !== (l = null === (s = o.sessionOptions) || void 0 === s ? void 0 : s.sessionDurationMinutes) && void 0 !== l ? l : Te
                }).then(function (e) {
                  t({
                    type: _.OTPsAuthenticate,
                    data: e
                  }), c(!1), a({
                    type: "transition",
                    screen: Ss.OTPConfirmation
                  });
                })["catch"](function (e) {
                  n(e), c(!1), p("Invalid passcode, please try again.");
                });
              case 1:
              case "end":
                return _context24.stop();
            }
          }, _callee24);
        }));
      },
      resendOTP: function resendOTP() {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
          var e, i;
          return _regeneratorRuntime().wrap(function _callee25$(_context25) {
            while (1) switch (_context25.prev = _context25.next) {
              case 0:
                u === g.Email && xn(r).networkClient.logEvent({
                  name: "email_try_again_clicked",
                  details: {
                    email: l,
                    type: Ke.LoginOrCreateOTP
                  }
                }), r.otps[u].loginOrCreate(l, {
                  expiration_minutes: null !== (i = null === (e = o.otpOptions) || void 0 === e ? void 0 : e.expirationMinutes) && void 0 !== i ? i : 5
                }).then(function (e) {
                  t({
                    type: _.OTPsLoginOrCreateEvent,
                    data: e
                  }), y(m()), a({
                    type: "update_otp_state",
                    otpState: {
                      type: u,
                      methodId: e.method_id,
                      otpDestination: l
                    }
                  }), cd.success("Code resent");
                })["catch"](function (e) {
                  n(e);
                  var t = e.message;
                  e instanceof P && (t = e.error_message), cd.error(t);
                });
              case 1:
              case "end":
                return _context25.stop();
            }
          }, _callee25);
        }));
      },
      errorMessage: d
    }));
  },
  vp = function vp(_ref95) {
    var _ref95$enabled = _ref95.enabled,
      e = _ref95$enabled === void 0 ? !1 : _ref95$enabled;
    return Ko.createElement("svg", {
      width: "20",
      height: "14",
      viewBox: "0 0 20 14",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Ko.createElement("path", {
      d: "M9.99992 2.41667C13.1583 2.41667 15.9749 4.19167 17.3499 7C15.9749 9.80833 13.1583 11.5833 9.99992 11.5833C6.84158 11.5833 4.02492 9.80833 2.64992 7C4.02492 4.19167 6.84158 2.41667 9.99992 2.41667ZM9.99992 0.75C5.83325 0.75 2.27492 3.34167 0.833252 7C2.27492 10.6583 5.83325 13.25 9.99992 13.25C14.1666 13.25 17.7249 10.6583 19.1666 7C17.7249 3.34167 14.1666 0.75 9.99992 0.75ZM9.99992 4.91667C11.1499 4.91667 12.0833 5.85 12.0833 7C12.0833 8.15 11.1499 9.08333 9.99992 9.08333C8.84992 9.08333 7.91658 8.15 7.91658 7C7.91658 5.85 8.84992 4.91667 9.99992 4.91667ZM9.99992 3.25C7.93325 3.25 6.24992 4.93333 6.24992 7C6.24992 9.06667 7.93325 10.75 9.99992 10.75C12.0666 10.75 13.7499 9.06667 13.7499 7C13.7499 4.93333 12.0666 3.25 9.99992 3.25Z",
      fill: e ? "#19303D" : "#5C727D"
    }));
  },
  yp = function yp() {
    return Ko.createElement("svg", {
      width: "20",
      height: "16",
      viewBox: "0 0 20 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Ko.createElement("path", {
      d: "M10.0002 2.97921C13.1585 2.97921 15.9752 4.75421 17.3502 7.56254C16.8585 8.57921 16.1668 9.45421 15.3418 10.1625L16.5168 11.3375C17.6752 10.3125 18.5918 9.02921 19.1668 7.56254C17.7252 3.90421 14.1668 1.31254 10.0002 1.31254C8.94183 1.31254 7.92516 1.47921 6.96683 1.78754L8.34183 3.16254C8.8835 3.05421 9.4335 2.97921 10.0002 2.97921ZM9.1085 3.92921L10.8335 5.65421C11.3085 5.86254 11.6918 6.24587 11.9002 6.72087L13.6252 8.44587C13.6918 8.16254 13.7418 7.86254 13.7418 7.55421C13.7502 5.48754 12.0668 3.81254 10.0002 3.81254C9.69183 3.81254 9.40016 3.85421 9.1085 3.92921ZM1.67516 1.20421L3.9085 3.43754C2.55016 4.50421 1.47516 5.92087 0.833496 7.56254C2.27516 11.2209 5.8335 13.8125 10.0002 13.8125C11.2668 13.8125 12.4835 13.5709 13.6002 13.1292L16.4502 15.9792L17.6252 14.8042L2.85016 0.020874L1.67516 1.20421ZM7.92516 7.45421L10.1002 9.62921C10.0668 9.63754 10.0335 9.64587 10.0002 9.64587C8.85016 9.64587 7.91683 8.71254 7.91683 7.56254C7.91683 7.52087 7.92516 7.49587 7.92516 7.45421ZM5.09183 4.62087L6.55016 6.07921C6.3585 6.53754 6.25016 7.03754 6.25016 7.56254C6.25016 9.62921 7.9335 11.3125 10.0002 11.3125C10.5252 11.3125 11.0252 11.2042 11.4752 11.0125L12.2918 11.8292C11.5585 12.0292 10.7918 12.1459 10.0002 12.1459C6.84183 12.1459 4.02516 10.3709 2.65016 7.56254C3.2335 6.37087 4.0835 5.38754 5.09183 4.62087Z",
      fill: "#19303D"
    }));
  },
  Cp = bs.input(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  border: 0;\n  padding: 0;\n  width: 100%;\n\n  background-color: transparent;\n  height: 45px;\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n\n  &::placeholder: {\n    color: ", ";\n  }\n\n  &:disabled {\n    color: ", ";\n    background-color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])), function (e) {
    return e.theme.inputs.textColor;
  }, function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    return e.theme.inputs.placeholderColor;
  }, function (e) {
    return e.theme.colors.disabledText;
  }, function (e) {
    return e.theme.colors.disabled;
  }),
  bp = bs(Hs)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 45px;\n  padding-left: 8px;\n  padding-right: 8px;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n  width: calc(100% - 18px);\n  & input::placeholder: {\n    color: ", ";\n  }\n"])), function (e) {
    return e.theme.inputs.backgroundColor;
  }, function (e) {
    return e.theme.inputs.borderColor;
  }, function (e) {
    return e.theme.inputs.borderRadius;
  }, function (e) {
    return e.theme.inputs.textColor;
  }, function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    return e.theme.inputs.placeholderColor;
  }),
  wp = bs.button(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  all: unset;\n  cursor: pointer;\n"]))),
  kp = function kp(_ref96) {
    var e = _ref96.onClick,
      t = _ref96.enabled,
      n = _ref96.visible;
    return Ko.createElement(wp, {
      onClick: e,
      type: "button"
    }, n ? Ko.createElement(yp, null) : Ko.createElement(vp, {
      enabled: t
    }));
  },
  Ep = function Ep(_ref97) {
    var e = _ref97.password,
      t = _ref97.setPassword,
      n = _ref97.type;
    var _Or59 = Or(!1),
      _Or60 = _slicedToArray(_Or59, 2),
      r = _Or60[0],
      o = _Or60[1];
    return Ko.createElement(bp, {
      gap: 2,
      alignItems: "center"
    }, Ko.createElement(Cp, {
      name: "password",
      "aria-label": "Password",
      id: "".concat(n, "-password"),
      autoComplete: "".concat(n, "-password"),
      type: r ? "text" : "password",
      value: e,
      onChange: function onChange(e) {
        return t(e.target.value);
      },
      required: !0
    }), Ko.createElement(kp, {
      onClick: function onClick() {
        return o(function (e) {
          return !e;
        });
      },
      enabled: !!e,
      visible: r
    }));
  },
  Sp = bs.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  height: 4px;\n  width: 25%;\n  background-color: ", ";\n"])), function (e) {
    return e.$bgColor;
  }),
  xp = function xp(_ref98) {
    var e = _ref98.score;
    var t = [];
    switch (e) {
      case 0:
      case 1:
        t = ["#8B1214", "#ADBCC5", "#ADBCC5", "#ADBCC5"];
        break;
      case 2:
        t = ["#8B1214", "#8B1214", "#ADBCC5", "#ADBCC5"];
        break;
      case 3:
        t = ["#0C5A56", "#0C5A56", "#0C5A56", "#ADBCC5"];
        break;
      case 4:
        t = ["#0C5A56", "#0C5A56", "#0C5A56", "#0C5A56"];
        break;
      default:
        t = ["#ADBCC5", "#ADBCC5", "#ADBCC5", "#ADBCC5"];
    }
    return Ko.createElement(Hs, {
      gap: 2
    }, t.map(function (e, t) {
      return Ko.createElement(Sp, {
        key: "".concat(e, "-").concat(t),
        $bgColor: e
      });
    }));
  },
  Op = function Op() {
    return $n(Hs, {
      height: 16,
      width: 16
    }, $n("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, $n("path", {
      d: "M5.86332 10.5833L3.08332 7.80333L2.13666 8.74333L5.86332 12.47L13.8633 4.47L12.9233 3.53L5.86332 10.5833Z",
      fill: "#0C5A56"
    })));
  },
  Lp = function Lp() {
    return $n(Hs, {
      height: 16,
      width: 16
    }, $n("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, $n("path", {
      d: "M12.6667 4.27334L11.7267 3.33334L8.00001 7.06001L4.27334 3.33334L3.33334 4.27334L7.06001 8.00001L3.33334 11.7267L4.27334 12.6667L8.00001 8.94001L11.7267 12.6667L12.6667 11.7267L8.94001 8.00001L12.6667 4.27334Z",
      fill: "#8B1214"
    })));
  };
var Ap = Yo(Go);
var Tp = "function" == typeof Object.is ? Object.is : function (e, t) {
    return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
  },
  Pp = Ap.useState,
  Mp = Ap.useEffect,
  Rp = Ap.useLayoutEffect,
  Dp = Ap.useDebugValue;
function Fp(e) {
  var t = e.getSnapshot;
  e = e.value;
  try {
    var n = t();
    return !Tp(e, n);
  } catch (e) {
    return !0;
  }
}
"undefined" == typeof window || void 0 === window.document || window.document.createElement;
void 0 !== Ap.useSyncExternalStore && Ap.useSyncExternalStore;
var jp = new WeakMap(),
  Ip = {},
  Bp = {},
  Np = function Np() {},
  Hp = Np(),
  Up = Object,
  $p = function $p(e) {
    return e === Hp;
  },
  Vp = function Vp(e) {
    return "function" == typeof e;
  },
  Zp = function Zp(e, t) {
    return Object.assign(Object.assign({}, e), t);
  },
  zp = "undefined",
  Wp = (typeof window === "undefined" ? "undefined" : _typeof(window)) != zp,
  Kp = (typeof document === "undefined" ? "undefined" : _typeof(document)) != zp,
  Gp = new WeakMap();
var qp = 0;
var Yp = function Yp(e) {
  var t = _typeof(e),
    n = e && e.constructor,
    r = n == Date;
  var o, i;
  if (Up(e) !== e || r || n == RegExp) o = r ? e.toJSON() : "symbol" == t ? e.toString() : "string" == t ? JSON.stringify(e) : "" + e;else {
    if (o = Gp.get(e), o) return o;
    if (o = ++qp + "~", Gp.set(e, o), n == Array) {
      for (o = "@", i = 0; i < e.length; i++) o += Yp(e[i]) + ",";
      Gp.set(e, o);
    }
    if (n == Up) {
      o = "#";
      var _t9 = Up.keys(e).sort();
      for (; !$p(i = _t9.pop());) $p(e[i]) || (o += i + ":" + Yp(e[i]) + ",");
      Gp.set(e, o);
    }
  }
  return o;
};
var Jp = !0;
var _ref99 = Wp && window.addEventListener ? [window.addEventListener.bind(window), window.removeEventListener.bind(window)] : [Np, Np],
  _ref100 = _slicedToArray(_ref99, 2),
  Xp = _ref100[0],
  Qp = _ref100[1],
  eh = {
    isOnline: function isOnline() {
      return Jp;
    },
    isVisible: function isVisible() {
      var e = Kp && document.visibilityState;
      return $p(e) || "hidden" !== e;
    }
  },
  th = {
    initFocus: function initFocus(e) {
      return Kp && document.addEventListener("visibilitychange", e), Xp("focus", e), function () {
        Kp && document.removeEventListener("visibilitychange", e), Qp("focus", e);
      };
    },
    initReconnect: function initReconnect(e) {
      var t = function t() {
          Jp = !0, e();
        },
        n = function n() {
          Jp = !1;
        };
      return Xp("online", t), Xp("offline", n), function () {
        Qp("online", t), Qp("offline", n);
      };
    }
  };
Ko.useId;
var nh = !Wp || "Deno" in window,
  rh = "undefined" != typeof navigator && navigator.connection,
  oh = !nh && rh && (["slow-2g", "2g"].includes(rh.effectiveType) || rh.saveData),
  ih = function ih(e) {
    if (Vp(e)) try {
      e = e();
    } catch (t) {
      e = "";
    }
    var t = e;
    return [e = "string" == typeof e ? e : (Array.isArray(e) ? e.length : e) ? Yp(e) : "", t];
  };
var ah = 0;
var sh = function sh() {
  return ++ah;
};
function ch() {
  for (var _len6 = arguments.length, e = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    e[_key6] = arguments[_key6];
  }
  return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee27() {
    var t, n, r, o, i, a, s, c, l, u, _e12, _r5, _o4, _n12, _o5, d;
    return _regeneratorRuntime().wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          d = function _d2(n) {
            return Kt(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
              var _ih, _ih2, o, _ref76, _ref101, i, d, _jp$get, _jp$get2, p, h, f, m, g, _, v, y, C, b, w, k, E, S;
              return _regeneratorRuntime().wrap(function _callee26$(_context26) {
                while (1) switch (_context26.prev = _context26.next) {
                  case 0:
                    _ih = ih(n), _ih2 = _slicedToArray(_ih, 1), o = _ih2[0];
                    if (o) {
                      _context26.next = 3;
                      break;
                    }
                    return _context26.abrupt("return");
                  case 3:
                    _ref76 = function (e, t) {
                      var n = jp.get(e);
                      return [function () {
                        return e.get(t) || Ip;
                      }, function (r) {
                        if (!$p(t)) {
                          var _o6 = e.get(t);
                          t in Bp || (Bp[t] = _o6), n[5](t, Zp(_o6, r), _o6 || Ip);
                        }
                      }, n[6], function () {
                        return !$p(t) && t in Bp ? Bp[t] : e.get(t) || Ip;
                      }];
                    }(t, o), _ref101 = _slicedToArray(_ref76, 2), i = _ref101[0], d = _ref101[1], _jp$get = jp.get(t), _jp$get2 = _slicedToArray(_jp$get, 3), p = _jp$get2[0], h = _jp$get2[1], f = _jp$get2[2], m = p[o], g = function g() {
                      return l && (delete f[o], m && m[0]) ? m[0](2).then(function () {
                        return i().data;
                      }) : i().data;
                    };
                    if (!(e.length < 3)) {
                      _context26.next = 6;
                      break;
                    }
                    return _context26.abrupt("return", g());
                  case 6:
                    v = r;
                    y = sh();
                    h[o] = [y, 0];
                    C = !$p(c), b = i(), w = b.data, k = b._c, E = $p(k) ? w : k;
                    if (C && (c = Vp(c) ? c(E) : c, d({
                      data: c,
                      _c: E
                    })), Vp(v)) try {
                      v = v(E);
                    } catch (e) {
                      _ = e;
                    }
                    if (!(v && Vp(v.then))) {
                      _context26.next = 20;
                      break;
                    }
                    _context26.next = 14;
                    return v["catch"](function (e) {
                      _ = e;
                    });
                  case 14:
                    v = _context26.sent;
                    if (!(y !== h[o][0])) {
                      _context26.next = 19;
                      break;
                    }
                    if (!_) {
                      _context26.next = 18;
                      break;
                    }
                    throw _;
                  case 18:
                    return _context26.abrupt("return", v);
                  case 19:
                    _ && C && function (e) {
                      return "function" == typeof s ? s(e) : !1 !== s;
                    }(_) && (a = !0, v = E, d({
                      data: v,
                      _c: Hp
                    }));
                  case 20:
                    a && (_ || (Vp(a) && (v = a(v, E)), d({
                      data: v,
                      _c: Hp
                    }))), h[o][1] = sh();
                    _context26.next = 23;
                    return g();
                  case 23:
                    S = _context26.sent;
                    if (!(d({
                      _c: Hp
                    }), !_)) {
                      _context26.next = 26;
                      break;
                    }
                    return _context26.abrupt("return", a ? S : v);
                  case 26:
                    if (!u) {
                      _context26.next = 28;
                      break;
                    }
                    throw _;
                  case 28:
                  case "end":
                    return _context26.stop();
                }
              }, _callee26);
            }));
          };
          t = e[0], n = e[1], r = e[2], o = e[3], i = Zp({
            populateCache: !0,
            throwOnError: !0
          }, "boolean" == typeof o ? {
            revalidate: o
          } : o || {});
          a = i.populateCache;
          s = i.rollbackOnError;
          c = i.optimisticData;
          l = !1 !== i.revalidate, u = i.throwOnError;
          if (!Vp(n)) {
            _context27.next = 10;
            break;
          }
          _e12 = n, _r5 = [], _o4 = t.keys();
          for (_n12 = _o4.next(); !_n12.done; _n12 = _o4.next()) {
            _o5 = _n12.value;
            !/^\$(inf|sub)\$/.test(_o5) && _e12(t.get(_o5)._k) && _r5.push(_o5);
          }
          return _context27.abrupt("return", Promise.all(_r5.map(d)));
        case 10:
          return _context27.abrupt("return", d(n));
        case 11:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
}
var lh = function lh(e, t) {
    for (var _n13 in e) e[_n13][0] && e[_n13][0](t);
  },
  _ref102 = function (e, t) {
    if (!jp.has(e)) {
      var _n14 = Zp(th, t),
        _r6 = {},
        _o7 = ch.bind(Hp, e);
      var _i4 = Np;
      var _a2 = {},
        _s2 = function _s2(e, t) {
          var n = _a2[e] || [];
          return _a2[e] = n, n.push(t), function () {
            return n.splice(n.indexOf(t), 1);
          };
        },
        _c2 = function _c2(t, n, r) {
          e.set(t, n);
          var o = _a2[t];
          if (o) {
            var _iterator2 = _createForOfIteratorHelper(o),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var _e13 = _step2.value;
                _e13(n, r);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        },
        _l2 = function _l2() {
          if (!jp.has(e) && (jp.set(e, [_r6, {}, {}, {}, _o7, _c2, _s2]), !nh)) {
            var _t10 = _n14.initFocus(setTimeout.bind(Hp, lh.bind(Hp, _r6, 0))),
              _o8 = _n14.initReconnect(setTimeout.bind(Hp, lh.bind(Hp, _r6, 1)));
            _i4 = function _i4() {
              _t10 && _t10(), _o8 && _o8(), jp["delete"](e);
            };
          }
        };
      return _l2(), [e, _o7, _l2, _i4];
    }
    return [e, jp.get(e)[4]];
  }(new Map()),
  _ref103 = _slicedToArray(_ref102, 2),
  uh = _ref103[0],
  dh = _ref103[1];
Zp({
  onLoadingSlow: Np,
  onSuccess: Np,
  onError: Np,
  onErrorRetry: function onErrorRetry(e, t, n, r, o) {
    var i = n.errorRetryCount,
      a = o.retryCount,
      s = ~~((Math.random() + .5) * (1 << (a < 8 ? a : 8))) * n.errorRetryInterval;
    !$p(i) && a > i || setTimeout(r, s, o);
  },
  onDiscarded: Np,
  revalidateOnFocus: !0,
  revalidateOnReconnect: !0,
  revalidateIfStale: !0,
  shouldRetryOnError: !0,
  errorRetryInterval: oh ? 1e4 : 5e3,
  focusThrottleInterval: 5e3,
  dedupingInterval: 2e3,
  loadingTimeout: oh ? 5e3 : 3e3,
  compare: function compare(e, t) {
    return Yp(e) == Yp(t);
  },
  isPaused: function isPaused() {
    return !1;
  },
  cache: uh,
  mutate: dh,
  fallback: {}
}, eh);
var ph = Wp && window.__SWR_DEVTOOLS_USE__;
(ph ? window.__SWR_DEVTOOLS_USE__ : []).concat(function (e) {
  return function (t, n, r) {
    return e(t, n && function () {
      var r = ih(t)[0],
        _jp$get3 = jp.get(uh),
        _jp$get4 = _slicedToArray(_jp$get3, 4),
        o = _jp$get4[3],
        i = o[r];
      return i ? (delete o[r], i) : n.apply(void 0, arguments);
    }, r);
  };
}), ph && (window.__SWR_DEVTOOLS_REACT__ = Ko);
var hh;
b.totp, b.smsOtp, function (e) {
  e.Main = "Main", e.EmailConfirmation = "Email Confirmation", e.LoggedIn = "Logged In", e.Discovery = "Discovery", e.ErrorOrganization = "Error Organization Not Found", e.Error = "Error", e.PasswordEmailForm = "Password Email", e.PasswordAuthenticate = "Password Authenticate", e.PasswordResetForm = "Password Reset Form", e.PasswordResetVerifyConfirmation = "Password Reset Verify Confirmation", e.PasswordForgotForm = "Password Forgot Form", e.PasswordSetNewConfirmation = "Password Set New Confirmation", e.MFAEnrollmentSelection = "MFA Enrollment Selection", e.RecoveryCodeEntry = "Recovery Code Entry", e.RecoveryCodeSave = "Recovery Code Save", e.SMSOTPEnrollment = "SMS OTP Enrollment", e.SMSOTPEntry = "SMS OTP Entry", e.TOTPEnrollmentManual = "TOTP Enrollment Manual", e.TOTPEnrollmentQRCode = "TOTP Enrollment QR Code", e.TOTPEntry = "TOTP Entry";
}(hh || (hh = {}));
var fh = {
    screen: hh.Main,
    formState: {
      magicLinkState: {
        email: ""
      },
      discoveryState: {
        email: "",
        intermediateSessionToken: "",
        discoveredOrganizations: []
      },
      passwordState: {
        email: ""
      }
    },
    flowState: {
      type: C.Organization,
      organization: null
    },
    mfa: {
      primaryInfo: null,
      isEnrolling: !1,
      smsOtp: {
        isSending: !1,
        sendError: null,
        codeExpiration: null,
        formattedDestination: null,
        enrolledNumber: null
      },
      totp: {
        isCreating: !1,
        createError: null,
        enrollment: null
      }
    }
  },
  mh = {
    products: [y.emailMagicLinks],
    authFlowType: C.Organization,
    sessionOptions: {
      sessionDurationMinutes: 60
    }
  };
Ko.createContext({
  client: {},
  config: mh,
  state: [fh, function () {
    return null;
  }]
}), _.B2BMagicLinkAuthenticate, _.B2BSSOAuthenticate, _.B2BMagicLinkDiscoveryAuthenticate, _.B2BDiscoveryOrganizationsCreate, _.B2BDiscoveryIntermediateSessionExchange, _.B2BMagicLinkEmailLoginOrSignup, _.B2BMagicLinkEmailDiscoverySend, _.B2BOAuthAuthenticate, _.B2BOAuthDiscoveryAuthenticate, _.B2BSMSOTPSend, _.B2BSMSOTPAuthenticate, _.B2BTOTPCreate, _.B2BTOTPAuthenticate, _.B2BRecoveryCodesRecover;
var gh = function gh(e) {
    var t, n;
    var r = function () {
        var e = Ms(),
          _Or61 = Or(xn(e).bootstrap.getSync()),
          _Or62 = _slicedToArray(_Or61, 2),
          t = _Or62[0],
          n = _Or62[1];
        return Ar(function () {
          xn(e).bootstrap.getAsync().then(function (e) {
            n(e);
          });
        }, [e]), t;
      }(),
      o = null === (t = r.passwordConfig) || void 0 === t ? void 0 : t.ludsComplexity,
      i = null === (n = r.passwordConfig) || void 0 === n ? void 0 : n.ludsMinimumCount;
    return "none" === e.passwordPolicy ? null : "zxcvbn" === e.passwordPolicy ? Ko.createElement(Ko.Fragment, null, Ko.createElement(xp, {
      score: e.passwordScore
    }), Ko.createElement(Bl, {
      errorMessage: "" !== e.errorMessage ? e.errorMessage : e.passwordFeedback
    })) : Ko.createElement(Hs, {
      direction: "column",
      gap: 4
    }, Ko.createElement(Hs, {
      gap: 4
    }, 0 === e.missingCharacters ? Ko.createElement(Op, null) : Ko.createElement(Lp, null), Ko.createElement(Us, {
      size: "helper",
      color: 0 === e.missingCharacters ? "success" : "error"
    }, "Must be at least ", i, " characters long")), Ko.createElement(Hs, {
      gap: 4
    }, 0 === e.missingComplexity ? Ko.createElement(Op, null) : Ko.createElement(Lp, null), Ko.createElement(Us, {
      size: "helper",
      color: 0 === e.missingComplexity ? "success" : "error"
    }, "Must contain ", o, " of the following: uppercase letter, lowercase letter, number, symbol")), e.isPasswordBreached && Ko.createElement(Hs, {
      gap: 4
    }, Ko.createElement(Lp, null), Ko.createElement(Us, {
      size: "helper",
      color: "error"
    }, "This password may have been used on a different site that experienced a security issue. Please choose another password.")));
  },
  _h = function _h() {
    var e = Ms(),
      t = Ds(),
      n = t.passwordOptions,
      _Rs19 = Rs(),
      _Rs20 = _slicedToArray(_Rs19, 2),
      r = _Rs20[0],
      o = _Rs20[1],
      i = js(),
      a = Fs(),
      _Or63 = Or(r.formState.passwordState.email),
      _Or64 = _slicedToArray(_Or63, 2),
      s = _Or64[0],
      c = _Or64[1],
      _Or65 = Or(""),
      _Or66 = _slicedToArray(_Or65, 2),
      l = _Or66[0],
      u = _Or66[1],
      _Or67 = Or(""),
      _Or68 = _slicedToArray(_Or67, 2),
      d = _Or68[0],
      p = _Or68[1],
      _Or69 = Or(0),
      _Or70 = _slicedToArray(_Or69, 2),
      h = _Or70[0],
      f = _Or70[1],
      _Or71 = Or(""),
      _Or72 = _slicedToArray(_Or71, 2),
      m = _Or72[0],
      g = _Or72[1],
      _Or73 = Or(!0),
      _Or74 = _slicedToArray(_Or73, 2),
      v = _Or74[0],
      y = _Or74[1],
      _Or75 = Or(!1),
      _Or76 = _slicedToArray(_Or75, 2),
      C = _Or76[0],
      b = _Or76[1],
      _Or77 = Or("none"),
      _Or78 = _slicedToArray(_Or77, 2),
      w = _Or78[0],
      k = _Or78[1],
      _Or79 = Or(0),
      _Or80 = _slicedToArray(_Or79, 2),
      E = _Or80[0],
      S = _Or80[1],
      _Or81 = Or(0),
      _Or82 = _slicedToArray(_Or81, 2),
      x = _Or82[0],
      O = _Or82[1],
      _Or83 = Or(!1),
      _Or84 = _slicedToArray(_Or83, 2),
      L = _Or84[0],
      A = _Or84[1],
      T = Rr(function () {
        return ln(function (t, n) {
          p(""), e.passwords.strengthCheck({
            email: t,
            password: n
          }).then(function (_ref104) {
            var e = _ref104.score,
              t = _ref104.feedback,
              n = _ref104.valid_password,
              r = _ref104.strength_policy,
              o = _ref104.breached_password;
            k(r), "zxcvbn" === r ? (f(e), g(t.warning)) : "luds" === r && (S(t.luds_requirements.missing_characters), O(t.luds_requirements.missing_complexity), A(o)), y(!n);
          })["catch"](function (e) {
            "invalid_email" === e.error_type && p(e.error_message);
          });
        });
      }, [e.passwords]);
    if (!n) return Ko.createElement(Ko.Fragment, null);
    return Ko.createElement("form", {
      onSubmit: function onSubmit(r) {
        var c, u;
        r.preventDefault(), p(""), b(!0), e.passwords.create({
          email: s,
          password: l,
          session_duration_minutes: null !== (u = null === (c = t.sessionOptions) || void 0 === c ? void 0 : c.sessionDurationMinutes) && void 0 !== u ? u : Te
        }).then(function (e) {
          b(!1), i({
            type: _.PasswordCreate,
            data: e
          }), o({
            type: "transition",
            screen: Ss.PasswordConfirmation
          });
        })["catch"](function (t) {
          a(t), "reset_password" === t.error_type && e.passwords.resetByEmailStart(cn(s, n)).then(function () {
            o({
              type: "transition",
              screen: Ss.PasswordDedupe
            });
          }), p(t.error_message), b(!1);
        });
      }
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Us, null, "Finish creating your account by setting a password."), Ko.createElement(Hs, {
      direction: "column",
      gap: 2
    }, Ko.createElement(Us, {
      size: "helper",
      color: "secondary"
    }, "Email"), Ko.createElement(Fl, {
      email: s,
      setEmail: c,
      disableInput: !0
    })), Ko.createElement(Hs, {
      direction: "column",
      gap: 4
    }, Ko.createElement(Us, {
      size: "helper",
      color: "secondary"
    }, "Password"), Ko.createElement(Ep, {
      password: l,
      setPassword: function setPassword(e) {
        u(e), T(s, e);
      },
      type: "new"
    }), Ko.createElement(gh, {
      passwordPolicy: w,
      passwordScore: h,
      errorMessage: d,
      passwordFeedback: m,
      missingCharacters: E,
      missingComplexity: x,
      isPasswordBreached: L
    })), Ko.createElement(jl, {
      isSubmitting: C,
      text: "Continue",
      disabled: v
    })));
  },
  vh = bs(Us)(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  cursor: pointer;\n"]))),
  yh = function yh() {
    var e = Ms(),
      t = Ds(),
      n = t.passwordOptions,
      _Rs21 = Rs(),
      _Rs22 = _slicedToArray(_Rs21, 2),
      r = _Rs22[0],
      o = _Rs22[1],
      i = js(),
      a = Fs(),
      _Or85 = Or(r.formState.passwordState.email),
      _Or86 = _slicedToArray(_Or85, 2),
      s = _Or86[0],
      c = _Or86[1],
      _Or87 = Or(""),
      _Or88 = _slicedToArray(_Or87, 2),
      l = _Or88[0],
      u = _Or88[1],
      _Or89 = Or(""),
      _Or90 = _slicedToArray(_Or89, 2),
      d = _Or90[0],
      p = _Or90[1],
      _Or91 = Or(!1),
      _Or92 = _slicedToArray(_Or91, 2),
      h = _Or92[0],
      f = _Or92[1];
    if (!n) return Ko.createElement(Ko.Fragment, null);
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 36
    }, Ko.createElement(Us, {
      size: "header"
    }, "Log In"), Ko.createElement("form", {
      onSubmit: function onSubmit(r) {
        var c, u;
        r.preventDefault(), p(""), f(!0), e.passwords.authenticate({
          email: s,
          password: l,
          session_duration_minutes: null !== (u = null === (c = t.sessionOptions) || void 0 === c ? void 0 : c.sessionDurationMinutes) && void 0 !== u ? u : Te
        }).then(function (e) {
          f(!1), i({
            type: _.PasswordAuthenticate,
            data: e
          }), o({
            type: "transition",
            screen: Ss.PasswordConfirmation
          });
        })["catch"](function (t) {
          a(t), "reset_password" === t.error_type && e.passwords.resetByEmailStart(cn(s, n)).then(function () {
            o({
              type: "transition",
              screen: Ss.PasswordDedupe
            });
          }), p(t.error_message), f(!1);
        });
      }
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 2
    }, Ko.createElement(Us, {
      size: "helper",
      color: "secondary"
    }, "Email"), Ko.createElement(Fl, {
      email: s,
      setEmail: c,
      disableInput: !0
    })), Ko.createElement(Hs, {
      direction: "column",
      gap: 2
    }, Ko.createElement(Us, {
      size: "helper",
      color: "secondary"
    }, "Password"), Ko.createElement(Ep, {
      password: l,
      setPassword: u,
      type: "current"
    }), Ko.createElement(Bl, {
      errorMessage: d
    })), Ko.createElement(Hs, {
      justifyContent: "flex-end"
    }, Ko.createElement(vh, {
      onClick: function onClick() {
        e.passwords.resetByEmailStart(cn(s, n)).then(function () {
          o({
            type: "transition",
            screen: Ss.PasswordForgot
          });
        });
      }
    }, "Forgot Password?")), Ko.createElement(jl, {
      isSubmitting: h,
      text: "Continue"
    }))));
  },
  Ch = function Ch() {
    var _Rs23 = Rs(),
      _Rs24 = _slicedToArray(_Rs23, 2),
      e = _Rs24[0],
      t = _Rs24[1],
      n = Fs(),
      r = js(),
      o = Ms(),
      i = Ds().passwordOptions,
      a = e.formState.passwordState.email,
      _Or93 = Or(""),
      _Or94 = _slicedToArray(_Or93, 2),
      s = _Or94[0],
      c = _Or94[1];
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 4
    }, Ko.createElement(Is, {
      onClick: function onClick() {
        o.passwords.resetByEmailStart(cn(a, i)).then(function (e) {
          r({
            type: _.PasswordResetByEmailStart,
            data: e
          }), t({
            type: "transition",
            screen: Ss.PasswordSetNew
          });
        })["catch"](function (e) {
          n(e), c(e.error_message);
        });
      },
      variant: "text"
    }, "Create a password instead"), Ko.createElement(Bl, {
      errorMessage: s
    }));
  },
  bh = function bh(_ref105) {
    var e = _ref105.secondaryType;
    var t = Ms(),
      n = Ds(),
      _Rs25 = Rs(),
      _Rs26 = _slicedToArray(_Rs25, 2),
      r = _Rs26[0],
      o = _Rs26[1],
      _Or95 = Or(!1),
      _Or96 = _slicedToArray(_Or95, 2),
      i = _Or96[1],
      a = js(),
      s = Fs(),
      c = n.emailMagicLinksOptions,
      l = r.formState.passwordState.email,
      u = r.formState.passwordState.type,
      d = "eml" === e ? "Email me a login link" : "Email me a login code",
      p = "eml" === e ? function () {
        t.magicLinks.email.loginOrCreate(l, c && sn(c)).then(function (e) {
          a({
            type: _.MagicLinkLoginOrCreateEvent,
            data: e
          }), i(!1), o({
            type: "set_magic_link_email",
            email: l
          }), o({
            type: "transition",
            screen: Ss.EmailConfirmation
          });
        })["catch"](function (e) {
          s(e), i(!1);
        });
      } : function () {
        var e, r;
        t.otps.email.loginOrCreate(l, {
          expiration_minutes: null !== (r = null === (e = n.otpOptions) || void 0 === e ? void 0 : e.expirationMinutes) && void 0 !== r ? r : 5
        }).then(function (e) {
          i(!1), a({
            type: _.OTPsLoginOrCreateEvent,
            data: e
          }), o({
            type: "update_otp_state",
            otpState: {
              type: g.Email,
              methodId: e.method_id,
              otpDestination: l
            }
          }), o({
            type: "transition",
            screen: Ss.OTPAuthenticate
          });
        })["catch"](function (e) {
          s(e), i(!1);
        });
      };
    return {
      "new": Ko.createElement(function () {
        return Ko.createElement(Hs, {
          direction: "column",
          gap: 36
        }, Ko.createElement(Us, {
          size: "header"
        }, "Choose how you would like to create your account."), Ko.createElement(Is, {
          onClick: p
        }, d));
      }, null),
      password: Ko.createElement(function () {
        return Ko.createElement(Is, {
          variant: "text",
          onClick: p
        }, d);
      }, null),
      passwordless: null
    }[u];
  },
  wh = function wh() {
    var e, t;
    var n = Ds(),
      r = Ms(),
      o = js(),
      i = Fs(),
      _Rs27 = Rs(),
      _Rs28 = _slicedToArray(_Rs27, 2),
      a = _Rs28[0],
      s = _Rs28[1],
      c = a.formState.passwordState.email,
      l = null !== (t = null === (e = null == n ? void 0 : n.otpOptions) || void 0 === e ? void 0 : e.methods) && void 0 !== t ? t : [],
      u = n.products.includes(p.emailMagicLinks) && !!n.emailMagicLinksOptions,
      d = l.includes(g.Email) ? "otp" : u ? "eml" : "",
      h = a.formState.passwordState.type,
      f = n.emailMagicLinksOptions,
      m = n.passwordOptions;
    Ar(function () {
      var e, t;
      if ("passwordless" === h) switch (d) {
        case "eml":
          return void r.magicLinks.email.loginOrCreate(a.formState.passwordState.email, f && sn(f)).then(function (e) {
            o({
              type: _.MagicLinkLoginOrCreateEvent,
              data: e
            }), s({
              type: "set_magic_link_email",
              email: c
            });
          })["catch"](function (e) {
            i(e);
          });
        case "otp":
          return void r.otps.email.loginOrCreate(c, {
            expiration_minutes: null !== (t = null === (e = n.otpOptions) || void 0 === e ? void 0 : e.expirationMinutes) && void 0 !== t ? t : 5
          }).then(function (e) {
            o({
              type: _.OTPsLoginOrCreateEvent,
              data: e
            }), s({
              type: "update_otp_state",
              otpState: {
                type: g.Email,
                methodId: e.method_id,
                otpDestination: c
              }
            });
          })["catch"](function (e) {
            i(e);
          });
        default:
          return void r.passwords.resetByEmailStart(cn(c, m)).then(function (e) {
            o({
              type: _.PasswordResetByEmailStart,
              data: e
            }), s({
              type: "transition",
              screen: Ss.PasswordSetNew
            });
          })["catch"](function (e) {
            i(e);
          });
      }
    }, [h, d]);
    var v = {
      "new": Ko.createElement(Ko.Fragment, null, d && Ko.createElement(Ko.Fragment, null, Ko.createElement(bh, {
        secondaryType: d
      }), Ko.createElement(tc, null)), Ko.createElement(_h, null)),
      password: Ko.createElement(Ko.Fragment, null, Ko.createElement(yh, null), d && Ko.createElement(Ko.Fragment, null, Ko.createElement(tc, null), Ko.createElement(bh, {
        secondaryType: d
      }))),
      passwordless: Ko.createElement(Ko.Fragment, null, Ko.createElement(Ko.Fragment, null, d && Ko.createElement(Ko.Fragment, null, "eml" === d ? Ko.createElement(qs, null) : Ko.createElement(_p, {
        hideBackArrow: !0
      }), Ko.createElement(tc, null), Ko.createElement(Ch, null))))
    };
    return Ko.createElement(Hs, {
      gap: 24,
      direction: "column"
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return s({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), v[h]);
  },
  kh = bs(Hs)(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  > div {\n    height: 200px;\n    width: 200px;\n  }\n"]))),
  Eh = function Eh() {
    var e = js(),
      t = Fs(),
      n = function n() {
        t({
          message: "[Error] Could not connect to wallet"
        }), i({
          type: "transition",
          screen: Ss.CryptoError
        });
      },
      r = Ms(),
      _Rs29 = Rs(),
      _Rs30 = _slicedToArray(_Rs29, 2),
      o = _Rs30[0],
      i = _Rs30[1],
      a = o.formState.cryptoState.walletOption,
      s = Eu(a) ? "solana" : "ethereum",
      c = function c() {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
          var t;
          return _regeneratorRuntime().wrap(function _callee29$(_context29) {
            while (1) switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return function (_ref106) {
                  var e = _ref106.wallet;
                  return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
                    var _e14, _e15, _yield$window$vessel$, _yield$window$vessel$2, _e16, _e17, _e18;
                    return _regeneratorRuntime().wrap(function _callee28$(_context28) {
                      while (1) switch (_context28.prev = _context28.next) {
                        case 0:
                          _context28.t0 = e;
                          _context28.next = _context28.t0 === f.Metamask ? 3 : _context28.t0 === f.Phantom ? 5 : _context28.t0 === f.Binance ? 8 : _context28.t0 === f.Vessel ? 10 : _context28.t0 === f.Coinbase ? 16 : _context28.t0 === f.GenericEthereumWallet ? 18 : _context28.t0 === f.GenericSolanaWallet ? 20 : 23;
                          break;
                        case 3:
                          _e14 = mu();
                          return _context28.abrupt("return", (null == _e14 ? void 0 : _e14.request) ? bu(null == _e14 ? void 0 : _e14.request) : "");
                        case 5:
                          _context28.next = 7;
                          return window.solana.connect();
                        case 7:
                          return _context28.abrupt("return", _context28.sent.publicKey.toString());
                        case 8:
                          _e15 = window.BinanceChain;
                          return _context28.abrupt("return", (null == _e15 ? void 0 : _e15.request) ? bu(null == _e15 ? void 0 : _e15.request) : "");
                        case 10:
                          _context28.next = 12;
                          return window.vessel.ethereum.request({
                            method: "eth_requestAccounts"
                          });
                        case 12:
                          _yield$window$vessel$ = _context28.sent;
                          _yield$window$vessel$2 = _slicedToArray(_yield$window$vessel$, 1);
                          _e16 = _yield$window$vessel$2[0];
                          return _context28.abrupt("return", _e16);
                        case 16:
                          _e17 = gu();
                          return _context28.abrupt("return", (null == _e17 ? void 0 : _e17.request) ? bu(null == _e17 ? void 0 : _e17.request) : "");
                        case 18:
                          _e18 = _u();
                          return _context28.abrupt("return", (null == _e18 ? void 0 : _e18.request) ? bu(null == _e18 ? void 0 : _e18.request) : "");
                        case 20:
                          _context28.next = 22;
                          return window.solana.connect();
                        case 22:
                          return _context28.abrupt("return", _context28.sent.publicKey.toString());
                        case 23:
                          return _context28.abrupt("return", "");
                        case 24:
                        case "end":
                          return _context28.stop();
                      }
                    }, _callee28);
                  }));
                }({
                  wallet: a
                });
              case 2:
                t = _context29.sent;
                r.cryptoWallets.authenticateStart({
                  crypto_wallet_address: t,
                  crypto_wallet_type: s
                }).then(function (n) {
                  e({
                    type: _.CryptoWalletAuthenticateStart,
                    data: n
                  }), i({
                    type: "update_crypto_state",
                    cryptoState: {
                      walletAddress: t,
                      walletChallenge: n.challenge,
                      walletOption: a
                    }
                  }), i({
                    type: "transition",
                    screen: Ss.CryptoSignMessage
                  });
                })["catch"](n);
              case 4:
              case "end":
                return _context29.stop();
            }
          }, _callee29);
        }));
      };
    Ar(function () {
      c();
    }, []);
    var l = vu[a];
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return i({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Connecting to your wallet..."), Ko.createElement(kh, {
      justifyContent: "center"
    }, Ko.createElement(l, null)), Ko.createElement(Us, null, "Complete sign in by connecting through the wallet pop up in the right corner of your screen."), Ko.createElement(Us, null, "Having trouble? Use the back arrow to return to the main screen and try logging in again."));
  },
  Sh = bs(Hs)(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  > div {\n    height: 200px;\n    width: 200px;\n  }\n"]))),
  xh = function xh() {
    var e = js(),
      t = Fs(),
      n = function n() {
        t({
          message: "[Error] Could not sign message"
        }), a({
          type: "transition",
          screen: Ss.CryptoError
        });
      },
      r = Ms(),
      o = Ds(),
      _Rs31 = Rs(),
      _Rs32 = _slicedToArray(_Rs31, 2),
      i = _Rs32[0],
      a = _Rs32[1],
      _i$formState$cryptoSt = i.formState.cryptoState,
      s = _i$formState$cryptoSt.walletChallenge,
      c = _i$formState$cryptoSt.walletAddress,
      l = _i$formState$cryptoSt.walletOption,
      u = Eu(l) ? "solana" : "ethereum";
    Ar(function () {
      Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee30() {
        var t, i, d;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return ku({
                wallet: l,
                message: s,
                address: c
              });
            case 2:
              d = _context30.sent;
              r.cryptoWallets.authenticate({
                crypto_wallet_address: c,
                crypto_wallet_type: u,
                signature: d,
                session_duration_minutes: null !== (i = null === (t = o.sessionOptions) || void 0 === t ? void 0 : t.sessionDurationMinutes) && void 0 !== i ? i : Te
              }).then(function (t) {
                e({
                  type: _.CryptoWalletAuthenticate,
                  data: t
                }), a({
                  type: "transition",
                  screen: Ss.CryptoConfirmation
                });
              })["catch"](n);
            case 4:
            case "end":
              return _context30.stop();
          }
        }, _callee30);
      }));
    }, []);
    var d = vu[l];
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return a({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Completing signature request..."), Ko.createElement(Sh, {
      justifyContent: "center"
    }, Ko.createElement(d, null)), Ko.createElement(Us, null, "Complete the signature request through the wallet pop up in the right corner of your screen."), Ko.createElement(Us, null, "Having trouble? Use the back arrow to return to the main screen and try logging in again."));
  },
  Oh = function Oh(_ref107) {
    var e = _ref107.icon,
      t = _ref107.name,
      n = _ref107.link;
    return Ko.createElement("a", {
      href: n,
      target: "_blank",
      rel: "noreferrer",
      style: {
        textDecoration: "none",
        color: "inherit"
      }
    }, Ko.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }
    }, e, Ko.createElement("span", null, t)));
  },
  Lh = function Lh() {
    var _Rs33 = Rs(),
      _Rs34 = _slicedToArray(_Rs33, 2),
      e = _Rs34[1],
      t = function t(_ref108) {
        var e = _ref108.wallet;
        var t = vu[e];
        return Ko.createElement(t, null);
      };
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return e({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Set up a new crypto wallet"), Ko.createElement(Us, null, "Signing in with a crypto wallet can help keep your account private and secure."), Ko.createElement(Us, null, "Get started by downloading any Ethereum or Solana wallet. We’ve included a few examples of wallet extensions you can find below. Once you’ve set up your wallet, you can use it to sign in!"), Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(Hs, {
      justifyContent: "space-evenly"
    }, Ko.createElement(Oh, {
      icon: Ko.createElement(t, {
        wallet: f.Vessel
      }),
      name: "Vessel",
      link: "https://www.vessel.xyz/"
    }), Ko.createElement(Oh, {
      icon: Ko.createElement(t, {
        wallet: f.Metamask
      }),
      name: "Metamask",
      link: "https://metamask.io/"
    }), Ko.createElement(Oh, {
      icon: Ko.createElement(t, {
        wallet: f.Phantom
      }),
      name: "Phantom",
      link: "https://phantom.app/"
    })), Ko.createElement(Hs, {
      justifyContent: "space-evenly"
    }, Ko.createElement(Oh, {
      icon: Ko.createElement(t, {
        wallet: f.Coinbase
      }),
      name: "Coinbase",
      link: "https://www.coinbase.com/wallet"
    }), Ko.createElement(Oh, {
      icon: Ko.createElement(t, {
        wallet: f.Binance
      }),
      name: "Binance",
      link: "https://www.bnbchain.world/en/binance-wallet"
    }))));
  },
  Ah = function Ah() {
    var _Rs35 = Rs(),
      _Rs36 = _slicedToArray(_Rs35, 2),
      e = _Rs36[1];
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return e({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Continue with other wallet"), Ko.createElement(xu, {
      type: "other"
    }));
  },
  Th = function Th() {
    var _Rs37 = Rs(),
      _Rs38 = _slicedToArray(_Rs37, 2),
      e = _Rs38[1];
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return e({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Success!"), Ko.createElement(Us, null, "You have successfully connected your wallet."), Ko.createElement(Ys, null));
  },
  Ph = function Ph() {
    var _Rs39 = Rs(),
      _Rs40 = _slicedToArray(_Rs39, 2),
      e = _Rs40[1];
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return e({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Looks like there was an error!"), Ko.createElement(Us, null, "Your sign in request could not be completed. Use the back arrow to return to the log in screen and try again!"));
  },
  Mh = function Mh() {
    return $n("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, $n("path", {
      d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z",
      fill: "#0F4447"
    }));
  },
  Rh = function Rh() {
    return $n("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, $n("path", {
      d: "M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z",
      fill: "#590607"
    }));
  },
  Dh = {
    display: "flex",
    gap: "8px",
    padding: "8px",
    fontSize: "14px",
    borderRadius: "4px"
  },
  Fh = Object.assign(Object.assign({}, Dh), {
    background: "#ECFFF5",
    boxShadow: "0px 5px 10px rgba(15, 68, 71, 0.18)",
    color: "#0F4447"
  }),
  jh = Object.assign(Object.assign({}, Dh), {
    background: "#FFEEEC",
    boxShadow: "0px 5px 10px rgba(89, 6, 7, 0.2)",
    color: "#590607"
  }),
  Ih = function Ih() {
    return Ko.createElement(Wd, {
      containerStyle: {
        position: "sticky",
        marginTop: "4px",
        marginBottom: "24px"
      },
      toastOptions: {
        success: {
          style: Fh,
          icon: Ko.createElement(Mh, null)
        },
        error: {
          style: jh,
          icon: Ko.createElement(Rh, null)
        }
      }
    });
  },
  Bh = function Bh() {
    var _Rs41 = Rs(),
      _Rs42 = _slicedToArray(_Rs41, 2),
      e = _Rs42[0],
      t = _Rs42[1],
      n = Ms(),
      r = Ds().emailMagicLinksOptions,
      o = e.formState.passwordState.email;
    if (!r) return Ko.createElement(Ko.Fragment, null);
    return Ko.createElement(Ko.Fragment, null, Ko.createElement(tc, null), Ko.createElement(Is, {
      variant: "text",
      onClick: function onClick() {
        n.magicLinks.email.loginOrCreate(o, sn(r)).then(function () {
          t({
            type: "transition",
            screen: Ss.EmailConfirmation
          });
        });
      }
    }, "Login without a password"));
  },
  Nh = function Nh() {
    var _Rs43 = Rs(),
      _Rs44 = _slicedToArray(_Rs43, 2),
      e = _Rs44[0],
      t = _Rs44[1],
      n = Ms(),
      r = Ds().passwordOptions,
      o = e.formState.passwordState.email;
    if (!r) return Ko.createElement(Ko.Fragment, null);
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return t({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Forgot password?"), Ko.createElement(Us, null, "A link to reset your password was sent to you at ", Ko.createElement("b", null, o), "."), Ko.createElement(Us, null, "Didn't get it?", " ", Ko.createElement("button", {
      onClick: function onClick() {
        return Kt(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
          return _regeneratorRuntime().wrap(function _callee31$(_context31) {
            while (1) switch (_context31.prev = _context31.next) {
              case 0:
                xn(n).networkClient.logEvent({
                  name: "email_try_again_clicked",
                  details: {
                    email: o,
                    type: Ke.ResetPassword
                  }
                }), n.passwords.resetByEmailStart(cn(o, r)).then(function () {
                  return cd.success("Email resent");
                });
              case 1:
              case "end":
                return _context31.stop();
            }
          }, _callee31);
        }));
      },
      style: {
        all: "unset"
      }
    }, Ko.createElement("b", {
      style: {
        cursor: "pointer"
      }
    }, "Resend email"))), Ko.createElement(Bh, null));
  },
  Hh = function Hh() {
    var _Rs45 = Rs(),
      _Rs46 = _slicedToArray(_Rs45, 2),
      e = _Rs46[0],
      t = _Rs46[1],
      n = Ms(),
      r = Ds().passwordOptions,
      o = e.formState.passwordState.email;
    if (!r) return Ko.createElement(Ko.Fragment, null);
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return t({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Check your email to set a new password"), Ko.createElement(Us, null, "A different site where you use the same password had a security issue recently. For your safety, an email was sent to you at ", Ko.createElement("b", null, o), " to reset your password."), Ko.createElement(Us, null, "Didn't get it?", " ", Ko.createElement("button", {
      onClick: function onClick() {
        n.passwords.resetByEmailStart(cn(o, r)).then(function () {
          return cd.success("Email resent");
        });
      },
      style: {
        all: "unset"
      }
    }, Ko.createElement("b", {
      style: {
        cursor: "pointer"
      }
    }, "Resend email"))), Ko.createElement(Bh, null));
  },
  Uh = function Uh() {
    var _Rs47 = Rs(),
      _Rs48 = _slicedToArray(_Rs47, 2),
      e = _Rs48[0],
      t = _Rs48[1],
      n = Fs(),
      r = js(),
      o = Ms(),
      i = Ds().passwordOptions,
      a = e.formState.passwordState.email;
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return t({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Check your email!"), Ko.createElement(Us, null, "A login link was sent to you at ", Ko.createElement("b", null, a), "."), Ko.createElement(Us, null, "Didn't get it?", " ", Ko.createElement("button", {
      onClick: function onClick() {
        o.passwords.resetByEmailStart(cn(a, i)).then(function (e) {
          cd.success("Email resent"), r({
            type: _.PasswordResetByEmailStart,
            data: e
          });
        })["catch"](function (e) {
          n(e);
        });
      },
      style: {
        all: "unset"
      }
    }, Ko.createElement("b", {
      style: {
        cursor: "pointer"
      }
    }, "Resend email"))));
  },
  $h = function $h() {
    var _Rs49 = Rs(),
      _Rs50 = _slicedToArray(_Rs49, 2),
      e = _Rs50[0],
      t = _Rs50[1],
      n = Ms(),
      r = Ds().passwordOptions,
      o = e.formState.passwordState.email;
    if (!r) return Ko.createElement(Ko.Fragment, null);
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 24
    }, Ko.createElement(qd, {
      onClick: function onClick() {
        return t({
          type: "transition",
          screen: Ss.Main
        });
      }
    }), Ko.createElement(Us, {
      size: "header"
    }, "Check your email to set a new password!"), Ko.createElement(Us, null, "We want to make sure your account is secure and that it's really you logging in! A login link was sent to you at ", Ko.createElement("b", null, o), "."), Ko.createElement(Us, null, "Didn't get it?", " ", Ko.createElement("button", {
      onClick: function onClick() {
        n.passwords.resetByEmailStart(cn(o, r)).then(function () {
          return cd.success("Email resent");
        });
      },
      style: {
        all: "unset"
      }
    }, Ko.createElement("b", {
      style: {
        cursor: "pointer"
      }
    }, "Resend email"))), Ko.createElement(Bh, null));
  },
  Vh = bs.form(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  width: 100%;\n"]))),
  Zh = function Zh() {
    var e = Ms(),
      t = Ds(),
      _Rs51 = Rs(),
      _Rs52 = _slicedToArray(_Rs51, 2),
      n = _Rs52[0],
      r = _Rs52[1],
      o = n.formState.resetPasswordState.token,
      i = js(),
      a = Fs(),
      _Or97 = Or("reset_password"),
      _Or98 = _slicedToArray(_Or97, 2),
      s = _Or98[0],
      c = _Or98[1],
      _Or99 = Or(""),
      _Or100 = _slicedToArray(_Or99, 2),
      l = _Or100[0],
      u = _Or100[1],
      _Or101 = Or(""),
      _Or102 = _slicedToArray(_Or101, 2),
      d = _Or102[0],
      p = _Or102[1],
      _Or103 = Or(0),
      _Or104 = _slicedToArray(_Or103, 2),
      h = _Or104[0],
      f = _Or104[1],
      _Or105 = Or(""),
      _Or106 = _slicedToArray(_Or105, 2),
      m = _Or106[0],
      g = _Or106[1],
      _Or107 = Or(!0),
      _Or108 = _slicedToArray(_Or107, 2),
      v = _Or108[0],
      y = _Or108[1],
      _Or109 = Or(!1),
      _Or110 = _slicedToArray(_Or109, 2),
      C = _Or110[0],
      b = _Or110[1],
      _Or111 = Or("none"),
      _Or112 = _slicedToArray(_Or111, 2),
      w = _Or112[0],
      k = _Or112[1],
      _Or113 = Or(0),
      _Or114 = _slicedToArray(_Or113, 2),
      E = _Or114[0],
      S = _Or114[1],
      _Or115 = Or(0),
      _Or116 = _slicedToArray(_Or115, 2),
      x = _Or116[0],
      O = _Or116[1],
      _Or117 = Or(!1),
      _Or118 = _slicedToArray(_Or117, 2),
      L = _Or118[0],
      A = _Or118[1],
      _Or119 = Or(""),
      _Or120 = _slicedToArray(_Or119, 2),
      T = _Or120[0],
      M = _Or120[1],
      _Or121 = Or(!1),
      _Or122 = _slicedToArray(_Or121, 2),
      R = _Or122[0],
      D = _Or122[1],
      F = Rr(function () {
        return ln(function (t) {
          return e.passwords.strengthCheck({
            password: t
          }).then(function (_ref109) {
            var e = _ref109.score,
              t = _ref109.feedback,
              n = _ref109.valid_password,
              r = _ref109.strength_policy,
              o = _ref109.breached_password;
            k(r), y(!n), "zxcvbn" === r ? (f(e), g(t.warning)) : "luds" === r && (S(t.luds_requirements.missing_characters), O(t.luds_requirements.missing_complexity), A(o));
          });
        });
      }, [e.passwords]);
    Ar(function () {
      var e;
      var t = null !== (e = new URLSearchParams(window.location.search).get("stytch_token_type")) && void 0 !== e ? e : "";
      c(t);
    }, []), Ar(function () {
      var n, i;
      "login" === s && e.magicLinks.authenticate(o, {
        session_duration_minutes: null !== (i = null === (n = t.sessionOptions) || void 0 === n ? void 0 : n.sessionDurationMinutes) && void 0 !== i ? i : Te
      }).then(function () {
        r({
          type: "transition",
          screen: Ss.PasswordConfirmation
        });
      })["catch"](function (e) {
        a(e);
      });
    }, [s]);
    return "login" === s ? Ko.createElement(Hs, {
      direction: "column",
      gap: 36,
      className: "resetPasswordContainer",
      alignItems: "center"
    }, Ko.createElement(Us, {
      size: "header"
    }, "Logging in"), Ko.createElement(dc, {
      size: 100,
      thickness: 2
    })) : Ko.createElement(Hs, {
      direction: "column",
      gap: 36,
      className: "resetPasswordContainer",
      alignItems: "center",
      width: "100%"
    }, Ko.createElement(Us, {
      size: "header"
    }, "Reset your password"), Ko.createElement(Vh, {
      onSubmit: function onSubmit(n) {
        var s, c;
        n.preventDefault(), p(""), b(!0), e.passwords.resetByEmail({
          token: o,
          password: l,
          session_duration_minutes: null !== (c = null === (s = t.sessionOptions) || void 0 === s ? void 0 : s.sessionDurationMinutes) && void 0 !== c ? c : Te
        }).then(function (e) {
          b(!1), i({
            type: _.PasswordResetByEmail,
            data: e
          }), r({
            type: "transition",
            screen: Ss.PasswordConfirmation
          });
        })["catch"](function (e) {
          a(e);
          var t = e.message;
          e instanceof P && (t = e.error_message), p(t), b(!1);
        });
      }
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 8
    }, Ko.createElement(Hs, {
      direction: "column",
      gap: 2
    }, Ko.createElement(Us, {
      size: "helper",
      color: "secondary"
    }, "Password"), Ko.createElement(Ep, {
      password: l,
      setPassword: function setPassword(e) {
        u(e), F(e);
      },
      type: "new"
    }), Ko.createElement(gh, {
      passwordPolicy: w,
      passwordScore: h,
      errorMessage: d,
      passwordFeedback: m,
      missingCharacters: E,
      missingComplexity: x,
      isPasswordBreached: L
    })), Ko.createElement(jl, {
      isSubmitting: C,
      text: "Continue",
      disabled: v
    }))), Ko.createElement(tc, null), Ko.createElement(Hs, {
      direction: "column",
      gap: 8,
      width: "100%"
    }, Ko.createElement(Is, {
      variant: "text",
      disabled: R,
      onClick: function onClick() {
        var n, i;
        M(""), D(!0), e.magicLinks.authenticate(o, {
          session_duration_minutes: null !== (i = null === (n = t.sessionOptions) || void 0 === n ? void 0 : n.sessionDurationMinutes) && void 0 !== i ? i : Te
        }).then(function () {
          r({
            type: "transition",
            screen: Ss.PasswordConfirmation
          });
        })["catch"](function (e) {
          a(e);
          var t = e.message;
          e instanceof P && (t = e.error_message), M(t);
        })["finally"](function () {
          D(!1);
        });
      }
    }, R ? Ko.createElement(Hs, {
      justifyContent: "center",
      alignItems: "center",
      gap: 8
    }, Ko.createElement(dc, {
      size: 18,
      thickness: 1
    }), "Logging in...") : "Login without a password"), T && Ko.createElement(Bl, {
      errorMessage: T
    })));
  },
  zh = function zh() {
    return $n(Hs, {
      direction: "column",
      gap: 24,
      alignItems: "center"
    }, $n(Us, {
      size: "header"
    }, "Success!"), $n(Us, null, "You have successfully logged in."), $n(Ys, null));
  },
  Wh = function Wh() {
    return Ko.createElement("svg", {
      width: "112",
      height: "96",
      viewBox: "0 0 112 96",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Ko.createElement("g", {
      clipPath: "url(#clip0_2877_10121)"
    }, Ko.createElement("ellipse", {
      cx: "55.9998",
      cy: "48.0004",
      rx: "48",
      ry: "48.0003",
      fill: "#C7F1FF"
    }), Ko.createElement("path", {
      d: "M100.866 74.5461H103.823",
      stroke: "#0C5A56",
      strokeWidth: "1.28124",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M84.604 67.3945C84.604 67.2618 84.7116 67.1542 84.8442 67.1542H106.54C106.672 67.1542 106.78 67.2618 106.78 67.3945V77.2627C106.78 77.3954 106.672 77.503 106.54 77.503H84.8442C84.7116 77.503 84.604 77.3954 84.604 77.2627V67.3945Z",
      stroke: "#0C5A56",
      strokeWidth: "1.28124",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M91.2568 70.8503L87.5608 74.5463",
      stroke: "#0C5A56",
      strokeWidth: "1.28124",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M91.2568 74.5463L87.5608 70.8503",
      stroke: "#0C5A56",
      strokeWidth: "1.28124",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M97.9096 70.8503L94.2136 74.5463",
      stroke: "#0C5A56",
      strokeWidth: "1.28124",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M97.9096 74.5463L94.2136 70.8503",
      stroke: "#0C5A56",
      strokeWidth: "1.28124",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M87.9158 31.7665C87.8368 31.7271 87.7974 31.6629 87.7974 31.5742C87.7974 31.4854 87.8171 31.4015 87.8566 31.3226C89.0799 29.6256 90.6289 28.3135 92.5034 27.3861C94.3779 26.4587 96.3806 25.995 98.5117 25.995C100.643 25.995 102.65 26.4489 104.535 27.3565C106.419 28.2642 107.983 29.5665 109.226 31.2634C109.285 31.362 109.31 31.441 109.3 31.5002C109.29 31.5594 109.256 31.6185 109.196 31.6777C109.137 31.7369 109.063 31.7665 108.974 31.7665C108.886 31.7665 108.802 31.7172 108.723 31.6185C107.559 30.0005 106.074 28.7575 104.268 27.8893C102.463 27.0211 100.544 26.587 98.5117 26.587C96.4793 26.587 94.5752 27.026 92.7993 27.9041C91.0235 28.7821 89.5436 30.0203 88.3597 31.6185C88.2808 31.7172 88.2068 31.7764 88.1377 31.7961C88.0687 31.8159 87.9947 31.806 87.9158 31.7665ZM102.034 46.6541C100.001 46.141 98.3291 45.1249 97.017 43.6055C95.7048 42.0862 95.0487 40.2413 95.0487 38.0708C95.0487 37.1434 95.3891 36.364 96.0699 35.7326C96.7506 35.1012 97.5645 34.7855 98.5117 34.7855C99.4588 34.7855 100.273 35.1012 100.953 35.7326C101.634 36.364 101.975 37.1434 101.975 38.0708C101.975 38.8206 102.266 39.452 102.848 39.965C103.43 40.4781 104.106 40.7346 104.875 40.7346C105.625 40.7346 106.281 40.4781 106.843 39.965C107.406 39.452 107.687 38.8206 107.687 38.0708C107.687 35.6438 106.784 33.6114 104.979 31.9737C103.173 30.336 101.018 29.5171 98.5117 29.5171C96.0057 29.5171 93.85 30.336 92.0446 31.9737C90.2392 33.6114 89.3364 35.6438 89.3364 38.0708C89.3364 38.5444 89.3907 39.161 89.4992 39.9206C89.6077 40.6803 89.8396 41.5436 90.1948 42.5104C90.2342 42.6091 90.2342 42.6831 90.1948 42.7324C90.1553 42.7817 90.106 42.8261 90.0468 42.8656C89.9678 42.9051 89.884 42.9149 89.7952 42.8952C89.7064 42.8755 89.6423 42.8163 89.6028 42.7176C89.3463 41.9678 89.144 41.2032 88.9961 40.4238C88.8481 39.6444 88.7741 38.8601 88.7741 38.0708C88.7741 35.5254 89.7409 33.35 91.6746 31.5446C93.6083 29.7391 95.8873 28.8364 98.5117 28.8364C101.195 28.8364 103.499 29.7243 105.423 31.5002C107.347 33.276 108.308 35.4662 108.308 38.0708C108.308 38.9785 107.973 39.748 107.302 40.3794C106.631 41.0108 105.822 41.3265 104.875 41.3265C103.908 41.3265 103.08 41.0108 102.389 40.3794C101.698 39.748 101.353 38.9785 101.353 38.0708C101.353 37.3013 101.072 36.66 100.509 36.147C99.9471 35.6339 99.2812 35.3774 98.5117 35.3774C97.7421 35.3774 97.0712 35.6339 96.499 36.147C95.9268 36.66 95.6407 37.3013 95.6407 38.0708C95.6407 40.1229 96.2622 41.8346 97.5053 43.206C98.7484 44.5773 100.297 45.5392 102.152 46.0917C102.271 46.1312 102.345 46.1805 102.374 46.2397C102.404 46.2989 102.409 46.368 102.389 46.4469C102.369 46.5455 102.33 46.6146 102.271 46.6541C102.211 46.6935 102.132 46.6935 102.034 46.6541ZM91.5858 25.3439C91.4872 25.3833 91.4132 25.3883 91.3639 25.3587C91.3145 25.3291 91.2701 25.2847 91.2307 25.2255C91.1912 25.186 91.1715 25.1268 91.1715 25.0479C91.1715 24.969 91.2011 24.9098 91.2603 24.8703C92.385 24.2586 93.5639 23.7949 94.7972 23.4792C96.0304 23.1635 97.2686 23.0057 98.5117 23.0057C99.7942 23.0057 101.052 23.1635 102.285 23.4792C103.519 23.7949 104.698 24.2389 105.822 24.8111C105.921 24.8506 105.975 24.9098 105.985 24.9887C105.995 25.0676 105.98 25.1367 105.941 25.1959C105.901 25.2551 105.847 25.3044 105.778 25.3439C105.709 25.3833 105.625 25.3833 105.526 25.3439C104.441 24.8111 103.306 24.3918 102.123 24.086C100.939 23.7801 99.735 23.6272 98.5117 23.6272C97.2883 23.6272 96.0945 23.7703 94.9304 24.0564C93.7662 24.3425 92.6514 24.7717 91.5858 25.3439ZM95.5519 46.3285C94.4075 45.1446 93.5146 43.9015 92.8733 42.5992C92.2321 41.2969 91.9114 39.7875 91.9114 38.0708C91.9114 36.3147 92.5576 34.8348 93.85 33.6312C95.1425 32.4275 96.6963 31.8257 98.5117 31.8257C100.327 31.8257 101.891 32.4275 103.203 33.6312C104.515 34.8348 105.171 36.3147 105.171 38.0708C105.171 38.1695 105.146 38.2435 105.097 38.2928C105.048 38.3421 104.974 38.3668 104.875 38.3668C104.776 38.3668 104.698 38.3421 104.638 38.2928C104.579 38.2435 104.55 38.1695 104.55 38.0708C104.55 36.4725 103.953 35.1308 102.759 34.0455C101.565 32.9603 100.149 32.4177 98.5117 32.4177C96.8739 32.4177 95.468 32.9603 94.294 34.0455C93.12 35.1308 92.533 36.4725 92.533 38.0708C92.533 39.748 92.824 41.1785 93.4061 42.3624C93.9882 43.5463 94.8514 44.7302 95.9959 45.9141C96.0748 45.9931 96.1093 46.0671 96.0995 46.1361C96.0896 46.2052 96.0551 46.2693 95.9959 46.3285C95.9564 46.368 95.8923 46.4025 95.8035 46.4321C95.7147 46.4617 95.6308 46.4272 95.5519 46.3285ZM104.609 44.1679C102.872 44.1679 101.368 43.5907 100.095 42.4364C98.8224 41.2821 98.1861 39.8269 98.1861 38.0708C98.1861 37.9721 98.2107 37.8932 98.2601 37.834C98.3094 37.7748 98.3834 37.7452 98.4821 37.7452C98.5807 37.7452 98.6547 37.7748 98.704 37.834C98.7534 37.8932 98.778 37.9721 98.778 38.0708C98.778 39.6691 99.365 40.9862 100.539 42.0221C101.713 43.058 103.07 43.5759 104.609 43.5759C104.767 43.5759 104.954 43.5661 105.171 43.5463C105.388 43.5266 105.625 43.497 105.881 43.4575C105.98 43.4378 106.059 43.4526 106.118 43.5019C106.177 43.5513 106.217 43.6055 106.237 43.6647C106.256 43.7437 106.251 43.8127 106.222 43.8719C106.192 43.9311 106.128 43.9706 106.029 43.9903C105.674 44.089 105.363 44.1432 105.097 44.1531C104.831 44.1629 104.668 44.1679 104.609 44.1679Z",
      stroke: "#0C5A56",
      strokeWidth: "0.721422"
    }), Ko.createElement("g", {
      clipPath: "url(#clip1_2877_10121)"
    }, Ko.createElement("path", {
      d: "M25.7683 49.5923V52.5147C25.7683 52.9022 25.6144 53.2739 25.3403 53.5479C25.0663 53.8219 24.6947 53.9759 24.3071 53.9759H21.3848",
      stroke: "#0C5A56",
      strokeWidth: "1.42772",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M21.3848 32.0582H24.3071C24.6947 32.0582 25.0663 32.2121 25.3403 32.4861C25.6144 32.7602 25.7683 33.1318 25.7683 33.5193V36.4417",
      stroke: "#0C5A56",
      strokeWidth: "1.42772",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M3.85059 36.4417V33.5193C3.85059 33.1318 4.00453 32.7602 4.27856 32.4861C4.55258 32.2121 4.92424 32.0582 5.31177 32.0582H8.23413",
      stroke: "#0C5A56",
      strokeWidth: "1.42772",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M8.23413 53.9759H5.31177C4.92424 53.9759 4.55258 53.8219 4.27856 53.5479C4.00453 53.2739 3.85059 52.9022 3.85059 52.5147V49.5923",
      stroke: "#0C5A56",
      strokeWidth: "1.42772",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M14.8093 44.1129C17.0285 44.1129 18.8275 42.3139 18.8275 40.0947C18.8275 37.8754 17.0285 36.0764 14.8093 36.0764C12.59 36.0764 10.791 37.8754 10.791 40.0947C10.791 42.3139 12.59 44.1129 14.8093 44.1129Z",
      stroke: "#0C5A56",
      strokeWidth: "1.42772",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), Ko.createElement("path", {
      d: "M21.0097 49.9586C20.5564 48.6763 19.7168 47.5662 18.6064 46.781C17.4959 45.9957 16.1694 45.5741 14.8094 45.5741C13.4494 45.5741 12.1229 45.9957 11.0125 46.781C9.90207 47.5662 9.06241 48.6763 8.60913 49.9586",
      stroke: "#0C5A56",
      strokeWidth: "1.42772",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), Ko.createElement("path", {
      d: "M54.7371 47.9187C57.8367 47.9187 60.3495 45.406 60.3495 42.3064C60.3495 39.2068 57.8367 36.694 54.7371 36.694C51.6375 36.694 49.1248 39.2068 49.1248 42.3064C49.1248 45.406 51.6375 47.9187 54.7371 47.9187Z",
      fill: "#0C5A56"
    }), Ko.createElement("path", {
      d: "M69.7034 47.9187C69.7062 47.1369 69.4989 46.3687 69.1032 45.6944C68.7076 45.0201 68.1381 44.4644 67.4542 44.0854C66.7704 43.7064 65.9973 43.518 65.2158 43.54C64.4343 43.5619 63.673 43.7934 63.0115 44.2101C62.35 44.6268 61.8126 45.2136 61.4554 45.9091C61.0982 46.6045 60.9343 47.3832 60.9809 48.1636C61.0275 48.944 61.2828 49.6976 61.7203 50.3457C62.1577 50.9937 62.7611 51.5123 63.4675 51.8474V58.5198L65.3383 60.3906L68.4563 57.2727L66.5855 55.4019L68.4563 53.5311L66.9097 51.9846C67.7311 51.6676 68.4374 51.1097 68.936 50.3841C69.4346 49.6585 69.7021 48.7991 69.7034 47.9187ZM65.3383 47.9187C65.0916 47.9187 64.8505 47.8456 64.6454 47.7085C64.4403 47.5715 64.2804 47.3767 64.186 47.1488C64.0916 46.9209 64.0669 46.6702 64.1151 46.4282C64.1632 46.1863 64.282 45.9641 64.4564 45.7896C64.6308 45.6152 64.853 45.4964 65.095 45.4483C65.3369 45.4002 65.5877 45.4249 65.8156 45.5193C66.0435 45.6137 66.2382 45.7735 66.3753 45.9786C66.5123 46.1837 66.5855 46.4249 66.5855 46.6715C66.5855 47.0023 66.4541 47.3195 66.2202 47.5534C65.9863 47.7873 65.6691 47.9187 65.3383 47.9187Z",
      fill: "#0C5A56"
    }), Ko.createElement("path", {
      d: "M59.6512 50.4382C58.6934 50.0111 57.6566 49.7902 56.608 49.7896H52.8664C50.8818 49.7896 48.9784 50.578 47.5751 51.9814C46.1717 53.3847 45.3833 55.2881 45.3833 57.2728V59.7671H61.5968V52.8951C60.7557 52.249 60.0873 51.405 59.6512 50.4382Z",
      fill: "#0C5A56"
    }), Ko.createElement("rect", {
      x: "39.2727",
      y: "15.4204",
      width: "35.8443",
      height: "65.4755",
      rx: "1.67273",
      stroke: "#0C5A56",
      strokeWidth: "2.38962",
      strokeLinejoin: "round"
    })), Ko.createElement("defs", null, Ko.createElement("clipPath", {
      id: "clip0_2877_10121"
    }, Ko.createElement("rect", {
      width: "110.4",
      height: "96.0005",
      fill: "white",
      transform: "translate(0.799805)"
    })), Ko.createElement("clipPath", {
      id: "clip1_2877_10121"
    }, Ko.createElement("rect", {
      width: "23.3789",
      height: "23.3789",
      fill: "white",
      transform: "translate(3.11987 31.3276)"
    }))));
  };
var Kh;
!function (e) {
  e.DESKTOP = "Desktop device", e.MOBILE = "Mobile device", e.UNKNOWN = "Unknown device";
}(Kh || (Kh = {}));
var Gh = bs(Hs)(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n   {\n    width: 100%;\n    background-color: #ecfaff;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n"]))),
  qh = bs(Us)(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n   {\n    font-family: IBM Plex Sans;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 30px;\n    letter-spacing: 0em;\n  }\n"]))),
  Yh = bs(Us)(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n   {\n    font-family: IBM Plex Sans;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 25px;\n    letter-spacing: 0em;\n  }\n"]))),
  Jh = bs(Us)(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n   {\n    font-family: IBM Plex Sans;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    letter-spacing: 0em;\n    color: #5c727d;\n  }\n"]))),
  Xh = function Xh() {
    var e = Ms(),
      _Or123 = Or(!0),
      _Or124 = _slicedToArray(_Or123, 2),
      t = _Or124[0],
      n = _Or124[1],
      r = Ds();
    Ar(function () {
      e.user.get().then(function () {
        n(!0);
      })["catch"](function (e) {
        n(!1), a(e);
      });
    }, [e]);
    var _Rs53 = Rs(),
      _Rs54 = _slicedToArray(_Rs53, 2),
      o = _Rs54[1],
      i = js(),
      a = Fs();
    return t ? Ko.createElement(Hs, {
      direction: "column",
      gap: 36,
      marginTop: 12,
      marginLeft: 6.5,
      marginRight: 6.5
    }, Ko.createElement(qh, {
      size: "header"
    }, "Set up a new Passkey"), Ko.createElement(Jl, {
      variant: "warning"
    }), Ko.createElement(Gh, {
      direction: "column",
      gap: 20
    }, Ko.createElement(Hs, {
      direction: "column",
      padding: 20,
      gap: 20,
      alignItems: "center"
    }, Ko.createElement(Wh, null), Ko.createElement(Yh, null, "With Passkeys you don't need to remember complex passwords."), Ko.createElement(Jh, null, "Passkeys are encrypted digital keys you create using your fingerprint, face, or screen lock. Creating a Passkey will allow you to easily and securely log in to your account."))), Ko.createElement(Hs, {
      direction: "column",
      gap: 12
    }, Ko.createElement(Is, {
      onClick: function onClick() {
        var t, n;
        e.webauthn.register({
          is_passkey: !0,
          session_duration_minutes: null !== (n = null === (t = r.sessionOptions) || void 0 === t ? void 0 : t.sessionDurationMinutes) && void 0 !== n ? n : Te
        }).then(function (e) {
          i({
            type: _.PasskeyRegister,
            data: e
          }), o({
            type: "clear_error_message"
          }), o({
            type: "transition",
            screen: Ss.PasskeyRegistrationSuccess
          });
        })["catch"](function (e) {
          a(e), e.message.includes("At least one credential matches an entry of the excludeCredentials list in the platform attached authenticator.") || e.message.includes("The user attempted to register an authenticator that contains one of the credentials already registered with the relying party.") ? o({
            type: "set_error_message",
            errorMessage: "The Passkey cannot be created as it seems to be already registered. It is possible this Passkey was registered on another device but has synced cross-device."
          }) : o({
            type: "set_error_message",
            errorMessage: "Your Passkey was not created. Click “Create a Passkey” to try again or skip without adding a Passkey."
          });
        });
      }
    }, "Create a Passkey"), Ko.createElement(Is, {
      variant: "text",
      onClick: function onClick() {
        return i({
          type: _.PasskeySkip,
          data: {}
        }), void o({
          type: "transition",
          screen: Ss.PasskeyRegistrationSuccess
        });
      }
    }, "Skip"))) : Ko.createElement(Jl, {
      variant: "warning",
      text: "Error: Cannot use PasskeyRegistration component without active user authenticated."
    });
  },
  Qh = function Qh() {
    return Ko.createElement("svg", {
      width: "101",
      height: "101",
      viewBox: "0 0 101 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, Ko.createElement("path", {
      d: "M60.6296 95.0741C56.8399 96.0414 52.8689 96.5556 48.7778 96.5556C22.3908 96.5556 1 75.1647 1 48.7778C1 22.3908 22.3908 1 48.7778 1C75.1647 1 96.5556 22.3908 96.5556 48.7778C96.5556 52.8689 96.0414 56.8398 95.0741 60.6296",
      stroke: "#0C5A56",
      strokeWidth: "1.78025",
      strokeLinecap: "round"
    }), Ko.createElement("path", {
      d: "M81 61C78.3736 61 75.7728 61.5173 73.3463 62.5224C70.9198 63.5275 68.715 65.0007 66.8579 66.8579C65.0007 68.715 63.5275 70.9198 62.5224 73.3463C61.5173 75.7728 61 78.3736 61 81C61 83.6264 61.5173 86.2272 62.5224 88.6537C63.5275 91.0802 65.0007 93.285 66.8579 95.1421C68.715 96.9993 70.9198 98.4725 73.3463 99.4776C75.7728 100.483 78.3736 101 81 101C83.6264 101 86.2272 100.483 88.6537 99.4776C91.0802 98.4725 93.285 96.9993 95.1421 95.1421C96.9993 93.285 98.4725 91.0802 99.4776 88.6537C100.483 86.2272 101 83.6264 101 81C101 78.3736 100.483 75.7728 99.4776 73.3463C98.4725 70.9198 96.9993 68.715 95.1421 66.8579C93.285 65.0007 91.0802 63.5275 88.6537 62.5224C86.2272 61.5173 83.6264 61 81 61Z",
      fill: "#C7F1FF"
    }), Ko.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M91.9508 71.6043C92.3374 71.8892 92.4199 72.4336 92.135 72.8202L79.9611 89.3419C79.8207 89.5324 79.6088 89.6575 79.3742 89.6883C79.1396 89.7191 78.9026 89.6529 78.7178 89.5051L70.0222 82.5486C69.6472 82.2486 69.5864 81.7014 69.8864 81.3264C70.1864 80.9514 70.7336 80.8906 71.1086 81.1906L79.0977 87.5819L90.7349 71.7886C91.0198 71.4019 91.5642 71.3194 91.9508 71.6043Z",
      fill: "#0C5A56"
    }), Ko.createElement("path", {
      d: "M46.1713 49.1485C50.3301 49.1485 53.7015 45.7771 53.7015 41.6183C53.7015 37.4595 50.3301 34.0881 46.1713 34.0881C42.0125 34.0881 38.6411 37.4595 38.6411 41.6183C38.6411 45.7771 42.0125 49.1485 46.1713 49.1485Z",
      fill: "#0C5A56"
    }), Ko.createElement("path", {
      d: "M66.2519 49.1485C66.2556 48.0995 65.9775 47.0688 65.4466 46.164C64.9158 45.2593 64.1517 44.5137 63.2341 44.0052C62.3166 43.4967 61.2794 43.244 60.2308 43.2734C59.1822 43.3029 58.1608 43.6134 57.2732 44.1725C56.3857 44.7317 55.6646 45.5189 55.1854 46.4521C54.7061 47.3852 54.4862 48.4299 54.5487 49.477C54.6113 50.5241 54.9539 51.5352 55.5408 52.4047C56.1276 53.2742 56.9373 53.97 57.885 54.4196V63.3722L60.3951 65.8822L64.5786 61.6988L62.0685 59.1887L64.5786 56.6787L62.5036 54.6037C63.6056 54.1784 64.5533 53.4299 65.2222 52.4563C65.8912 51.4828 66.2501 50.3297 66.2519 49.1485ZM60.3951 49.1485C60.0642 49.1485 59.7406 49.0503 59.4654 48.8664C59.1902 48.6826 58.9758 48.4212 58.8491 48.1155C58.7225 47.8097 58.6893 47.4732 58.7539 47.1486C58.8185 46.824 58.9778 46.5259 59.2119 46.2918C59.4459 46.0578 59.744 45.8984 60.0687 45.8339C60.3933 45.7693 60.7297 45.8024 61.0355 45.9291C61.3413 46.0557 61.6026 46.2702 61.7865 46.5454C61.9704 46.8206 62.0685 47.1441 62.0685 47.4751C62.0685 47.9189 61.8922 48.3445 61.5784 48.6583C61.2646 48.9722 60.8389 49.1485 60.3951 49.1485Z",
      fill: "#0C5A56"
    }), Ko.createElement("path", {
      d: "M52.7645 52.5288C51.4795 51.9558 50.0884 51.6594 48.6815 51.6586H43.6614C40.9985 51.6586 38.4447 52.7164 36.5618 54.5993C34.6789 56.4822 33.6211 59.036 33.6211 61.6989V65.0456H55.375V55.8253C54.2465 54.9584 53.3497 53.8259 52.7645 52.5288Z",
      fill: "#0C5A56"
    }));
  },
  ef = function ef() {
    return $n("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, $n("path", {
      d: "M7.33317 13.2503L3.83317 9.75033L2.6665 10.917L7.33317 15.5837L17.3332 5.58366L16.1665 4.41699L7.33317 13.2503Z",
      fill: "#19303D"
    }));
  },
  tf = function tf() {
    return $n("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, $n("path", {
      d: "M11.7157 7.51667L12.4824 8.28333L4.93236 15.8333H4.16569V15.0667L11.7157 7.51667ZM14.7157 2.5C14.5074 2.5 14.2907 2.58333 14.1324 2.74167L12.6074 4.26667L15.7324 7.39167L17.2574 5.86667C17.5824 5.54167 17.5824 5.01667 17.2574 4.69167L15.3074 2.74167C15.1407 2.575 14.9324 2.5 14.7157 2.5ZM11.7157 5.15833L2.49902 14.375V17.5H5.62402L14.8407 8.28333L11.7157 5.15833Z",
      fill: "#19303D"
    }));
  },
  nf = function nf() {
    return $n("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, $n("path", {
      d: "M5.00008 15.8333C5.00008 16.75 5.75008 17.5 6.66675 17.5H13.3334C14.2501 17.5 15.0001 16.75 15.0001 15.8333V5.83333H5.00008V15.8333ZM6.66675 7.5H13.3334V15.8333H6.66675V7.5ZM12.9167 3.33333L12.0834 2.5H7.91675L7.08341 3.33333H4.16675V5H15.8334V3.33333H12.9167Z",
      fill: "#19303D"
    }));
  },
  rf = function rf(e) {
    return Ko.createElement(Is, {
      "data-testid": "clickable-edit-icon-" + e.id,
      variant: "text",
      onClick: e.onClick
    }, Ko.createElement(Hs, {
      justifyContent: "center",
      alignItems: "center"
    }, e.icon));
  },
  of = function of(e) {
    return e.isDeletingAny || e.isEditingAny && !e.isEditing ? Ko.createElement(Ko.Fragment, null) : Ko.createElement(Ko.Fragment, null, e.isEditing ? Ko.createElement(Ko.Fragment, null, Ko.createElement(rf, {
      id: "save" + e.id,
      onClick: function onClick() {
        e.handleStopEditing(e.name);
      },
      icon: Ko.createElement(ef, null)
    })) : Ko.createElement(Ko.Fragment, null, Ko.createElement(rf, {
      id: "edit" + e.id,
      name: e.name,
      onClick: e.handleEditing,
      icon: Ko.createElement(tf, null)
    })), Ko.createElement(rf, {
      id: "delete" + e.id,
      onClick: e.handleDeleting,
      icon: Ko.createElement(nf, null)
    }));
  },
  af = bs.input(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  background-color: transparent;\n  height: 45px;\n  padding: 0 8px;\n  color: ", ";\n  font-family: ", ";\n  font-size: 18px;\n  border: none;\n\n  &:disabled {\n    color: ", ";\n    border: none;\n    background-color: transparent;\n  }\n  &:focus-visible {\n    outline: none !important;\n    border: 1px solid #adbcc5;\n    border-radius: 4px;\n  }\n"])), function (e) {
    return e.theme.colors.primary;
  }, function (e) {
    return e.theme.typography.fontFamily;
  }, function (e) {
    return e.theme.colors.disabledText;
  }),
  sf = function sf(e) {
    var _Or125 = Or(e.name),
      _Or126 = _slicedToArray(_Or125, 2),
      t = _Or126[0],
      n = _Or126[1],
      r = Pr(null);
    return Ar(function () {
      var t;
      e.isEditingCurr && (null === (t = r.current) || void 0 === t || t.focus());
    }, [e.isEditingCurr]), Ko.createElement(Hs, {
      direction: "row",
      gap: 2,
      alignItems: "center",
      width: "100%"
    }, Ko.createElement(af, {
      ref: r,
      disabled: !e.isEditingCurr && !e.isDeletingCurr,
      value: t,
      onChange: function onChange(e) {
        return n(e.target.value);
      },
      "data-testid": "editable-row-input-" + e.id,
      id: e.id
    }), Ko.createElement(of, {
      id: e.id,
      isEditing: e.isEditingCurr,
      isEditingAny: e.isEditingAny,
      isDeletingAny: e.isDeletingAny,
      handleEditing: e.handleEditing,
      handleStopEditing: function handleStopEditing() {
        e.handleStopEditing(t);
      },
      handleDeleting: e.handleDeleting,
      name: t
    }));
  },
  cf = bs(Us)(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n   {\n    font-family: IBM Plex Sans;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 30px;\n    letter-spacing: 0em;\n  }\n"]))),
  lf = bs(Us)(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n   {\n    font-family: IBM Plex Sans;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 30px;\n    letter-spacing: 0.03em;\n    text-transform: uppercase;\n  }\n"]))),
  uf = function uf() {
    var e = Ms(),
      _Or127 = Or([]),
      _Or128 = _slicedToArray(_Or127, 2),
      t = _Or128[0],
      n = _Or128[1],
      _Or129 = Or(""),
      _Or130 = _slicedToArray(_Or129, 2),
      r = _Or130[0],
      o = _Or130[1],
      _Or131 = Or(""),
      _Or132 = _slicedToArray(_Or131, 2),
      i = _Or132[0],
      a = _Or132[1],
      s = js(),
      _Rs55 = Rs(),
      _Rs56 = _slicedToArray(_Rs55, 2),
      c = _Rs56[1];
    Ar(function () {
      e.user.get().then(function (e) {
        e ? n(e.webauthn_registrations) : console.log("User is null, we should never get to this screen in a non-logged in state.");
      })["catch"](function (e) {
        console.log(e);
      });
    }, [e.user]);
    return Ko.createElement(Hs, {
      direction: "column",
      gap: 18,
      marginTop: 12,
      marginLeft: 6.5,
      marginRight: 6.5
    }, Ko.createElement(cf, {
      size: "header"
    }, "Passkey successfully created!"), Ko.createElement(Hs, {
      direction: "column",
      gap: 20
    }, Ko.createElement(Hs, {
      direction: "column",
      padding: 20,
      gap: 20,
      alignItems: "center"
    }, Ko.createElement(Qh, null), Ko.createElement(Jl, {
      variant: "error"
    }), t && t.length > 0 && Ko.createElement(Hs, {
      "align-items": "left",
      direction: "column",
      width: "100%",
      gap: 8
    }, Ko.createElement(lf, null, "Existing Passkeys"), t.map(function (t, s) {
      return Ko.createElement(Ko.Fragment, null, Ko.createElement(Hs, {
        direction: "row",
        gap: 8,
        alignItems: "center",
        key: s
      }, Ko.createElement(sf, {
        id: t.webauthn_registration_id,
        name: t.name,
        isEditingCurr: t.webauthn_registration_id === r,
        isEditingAny: "" !== r,
        isDeletingCurr: t.webauthn_registration_id === i,
        isDeletingAny: "" !== i,
        handleEditing: function handleEditing() {
          o(t.webauthn_registration_id);
        },
        handleStopEditing: function handleStopEditing(r) {
          (function (t, r) {
            e.webauthn.update({
              webauthn_registration_id: t,
              name: r
            })["catch"](function (e) {
              console.log(e);
            }), n(function (e) {
              return e.map(function (e) {
                return e.webauthn_registration_id === t ? Object.assign(Object.assign({}, e), {
                  name: r
                }) : e;
              });
            });
          })(t.webauthn_registration_id, r), o("");
        },
        handleDeleting: function handleDeleting() {
          a(t.webauthn_registration_id), c({
            type: "set_error_message",
            errorMessage: "Once deleted, the passkey cannot be restored."
          });
        },
        key: t.webauthn_registration_id
      })));
    })))), Ko.createElement(Hs, {
      direction: "column",
      gap: 12
    }, "" !== i ? Ko.createElement(Ko.Fragment, null, Ko.createElement(Is, {
      variant: "outlined",
      onClick: function onClick() {
        var t;
        c({
          type: "clear_error_message"
        }), t = i, e.user.deleteWebauthnRegistration(t)["catch"](function (e) {
          console.log(e);
        }), n(function (e) {
          return e.filter(function (e) {
            return e.webauthn_registration_id !== t;
          });
        }), a("");
      }
    }, "Delete"), Ko.createElement(Is, {
      variant: "text",
      onClick: function onClick() {
        a("");
      }
    }, "Cancel")) : Ko.createElement(Ko.Fragment, null, Ko.createElement(Is, {
      disabled: "" !== r,
      onClick: function onClick() {
        c({
          type: "transition",
          screen: Ss.PasskeyRegistrationStart
        });
      }
    }, "Set up another Passkey"), Ko.createElement(Is, {
      variant: "text",
      disabled: "" !== r,
      onClick: function onClick() {
        s({
          type: _.PasskeyDone,
          data: {}
        });
      }
    }, "Done"))));
  },
  df = function df() {
    return $n(Hs, {
      direction: "column",
      gap: 24
    }, $n(Us, {
      size: "header"
    }, "Success"), $n(Us, null, "Your Passkey has been successfully authenticated."), $n("div", {
      style: {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        width: "50%"
      }
    }, $n(Ys, null)));
  },
  pf = bs.div(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  width: ", ";\n  font-family: ", ";\n  box-sizing: border-box;\n  * {\n    box-sizing: content-box;\n  }\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n"])), function (_ref110) {
    var e = _ref110.theme;
    return e.container.width;
  }, function (_ref111) {
    var e = _ref111.theme;
    return e.typography.fontFamily;
  }, function (_ref112) {
    var e = _ref112.theme;
    return e.container.backgroundColor;
  }, function (_ref113) {
    var e = _ref113.theme;
    return e.container.border;
  }, function (_ref114) {
    var e = _ref114.theme;
    return e.container.borderRadius;
  }),
  hf = bs.div(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  padding: 24px 32px;\n"]))),
  ff = bs.div(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  border-bottom-left-radius: ", ";\n  border-bottom-right-radius: ", ";\n  background-color: #19303d;\n  opacity: 50%;\n  padding: 4px 0px 0px;\n  display: flex;\n  justify-content: center;\n"])), function (_ref115) {
    var e = _ref115.theme;
    return e.container.borderRadius;
  }, function (_ref116) {
    var e = _ref116.theme;
    return e.container.borderRadius;
  }),
  mf = bs.img(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  width: 150px;\n"]))),
  gf = function gf() {
    var _o9;
    var _Rs57 = Rs(),
      _Rs58 = _slicedToArray(_Rs57, 1),
      e = _Rs58[0],
      _Cs2 = Cs(),
      t = _Cs2.displayWatermark,
      n = pc(),
      r = e.screen,
      o = (_o9 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_o9, Ss.Main, Ko.createElement(Pu, null)), Ss.PasskeyRegistrationStart, Ko.createElement(Xh, null)), Ss.PasskeyRegistrationSuccess, Ko.createElement(uf, null)), Ss.PasskeyConfirmation, Ko.createElement(df, null)), Ss.PasswordResetForm, Ko.createElement(Zh, null)), Ss.PasswordCreateOrLogin, Ko.createElement(wh, null)), Ss.PasswordForgot, Ko.createElement(Nh, null)), Ss.PasswordBreached, Ko.createElement(Hh, null)), Ss.PasswordSetNew, Ko.createElement(Uh, null)), Ss.PasswordDedupe, Ko.createElement($h, null)), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_o9, Ss.PasswordConfirmation, Ko.createElement(zh, null)), Ss.EmailConfirmation, Ko.createElement(qs, null)), Ss.OTPAuthenticate, Ko.createElement(_p, null)), Ss.OTPConfirmation, Ko.createElement(Js, null)), Ss.CryptoConnect, Ko.createElement(Eh, null)), Ss.CryptoSignMessage, Ko.createElement(xh, null)), Ss.CryptoOtherScreen, Ko.createElement(Ah, null)), Ss.CryptoSetupWallet, Ko.createElement(Lh, null)), Ss.CryptoError, Ko.createElement(Ph, null)), Ss.CryptoConfirmation, Ko.createElement(Th, null)));
    return n ? Ko.createElement(_c, {
      position: m.floating
    }) : Ko.createElement(pf, null, Ko.createElement(hf, null, o[r], Ko.createElement(Ih, null)), t && Ko.createElement(ff, null, Ko.createElement("a", {
      href: "https://stytch.com/",
      target: "_blank",
      rel: "noreferrer"
    }, Ko.createElement(mf, {
      alt: "Powered by Stytch",
      src: "https://public-assets.stytch.com/et_powered_by_stytch_logo.png"
    }))));
  };
var _f = {
  exports: {}
};
!function (e, t) {
  var n = "__lodash_hash_undefined__",
    r = 9007199254740991,
    o = "[object Arguments]",
    i = "[object AsyncFunction]",
    a = "[object Function]",
    s = "[object GeneratorFunction]",
    c = "[object Null]",
    l = "[object Object]",
    u = "[object Proxy]",
    d = "[object Undefined]",
    p = /^\[object .+?Constructor\]$/,
    h = /^(?:0|[1-9]\d*)$/,
    f = {};
  f["[object Float32Array]"] = f["[object Float64Array]"] = f["[object Int8Array]"] = f["[object Int16Array]"] = f["[object Int32Array]"] = f["[object Uint8Array]"] = f["[object Uint8ClampedArray]"] = f["[object Uint16Array]"] = f["[object Uint32Array]"] = !0, f[o] = f["[object Array]"] = f["[object ArrayBuffer]"] = f["[object Boolean]"] = f["[object DataView]"] = f["[object Date]"] = f["[object Error]"] = f[a] = f["[object Map]"] = f["[object Number]"] = f[l] = f["[object RegExp]"] = f["[object Set]"] = f["[object String]"] = f["[object WeakMap]"] = !1;
  var m = "object" == _typeof(qo) && qo && qo.Object === Object && qo,
    g = "object" == (typeof self === "undefined" ? "undefined" : _typeof(self)) && self && self.Object === Object && self,
    _ = m || g || Function("return this")(),
    v = t && !t.nodeType && t,
    y = v && e && !e.nodeType && e,
    C = y && y.exports === v,
    b = C && m.process,
    w = function () {
      try {
        var e = y && y.require && y.require("util").types;
        return e || b && b.binding && b.binding("util");
      } catch (e) {}
    }(),
    k = w && w.isTypedArray;
  var E,
    S,
    x,
    O = Array.prototype,
    L = Function.prototype,
    A = Object.prototype,
    T = _["__core-js_shared__"],
    P = L.toString,
    M = A.hasOwnProperty,
    R = (E = /[^.]+$/.exec(T && T.keys && T.keys.IE_PROTO || "")) ? "Symbol(src)_1." + E : "",
    D = A.toString,
    F = P.call(Object),
    j = RegExp("^" + P.call(M).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
    I = C ? _.Buffer : void 0,
    B = _.Symbol,
    N = _.Uint8Array,
    H = I ? I.allocUnsafe : void 0,
    U = (S = Object.getPrototypeOf, x = Object, function (e) {
      return S(x(e));
    }),
    $ = Object.create,
    V = A.propertyIsEnumerable,
    Z = O.splice,
    z = B ? B.toStringTag : void 0,
    W = function () {
      try {
        var e = ve(Object, "defineProperty");
        return e({}, "", {}), e;
      } catch (e) {}
    }(),
    K = I ? I.isBuffer : void 0,
    G = Math.max,
    q = Date.now,
    Y = ve(_, "Map"),
    J = ve(Object, "create"),
    X = function () {
      function e() {}
      return function (t) {
        if (!Te(t)) return {};
        if ($) return $(t);
        e.prototype = t;
        var n = new e();
        return e.prototype = void 0, n;
      };
    }();
  function Q(e) {
    var t = -1,
      n = null == e ? 0 : e.length;
    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }
  function ee(e) {
    var t = -1,
      n = null == e ? 0 : e.length;
    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }
  function te(e) {
    var t = -1,
      n = null == e ? 0 : e.length;
    for (this.clear(); ++t < n;) {
      var r = e[t];
      this.set(r[0], r[1]);
    }
  }
  function ne(e) {
    var t = this.__data__ = new ee(e);
    this.size = t.size;
  }
  function re(e, t) {
    var n = Se(e),
      r = !n && Ee(e),
      o = !n && !r && Oe(e),
      i = !n && !r && !o && Me(e),
      a = n || r || o || i,
      s = a ? function (e, t) {
        for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
        return r;
      }(e.length, String) : [],
      c = s.length;
    for (var l in e) !t && !M.call(e, l) || a && ("length" == l || o && ("offset" == l || "parent" == l) || i && ("buffer" == l || "byteLength" == l || "byteOffset" == l) || ye(l, c)) || s.push(l);
    return s;
  }
  function oe(e, t, n) {
    (void 0 !== n && !ke(e[t], n) || void 0 === n && !(t in e)) && se(e, t, n);
  }
  function ie(e, t, n) {
    var r = e[t];
    M.call(e, t) && ke(r, n) && (void 0 !== n || t in e) || se(e, t, n);
  }
  function ae(e, t) {
    for (var n = e.length; n--;) if (ke(e[n][0], t)) return n;
    return -1;
  }
  function se(e, t, n) {
    "__proto__" == t && W ? W(e, t, {
      configurable: !0,
      enumerable: !0,
      value: n,
      writable: !0
    }) : e[t] = n;
  }
  Q.prototype.clear = function () {
    this.__data__ = J ? J(null) : {}, this.size = 0;
  }, Q.prototype["delete"] = function (e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }, Q.prototype.get = function (e) {
    var t = this.__data__;
    if (J) {
      var r = t[e];
      return r === n ? void 0 : r;
    }
    return M.call(t, e) ? t[e] : void 0;
  }, Q.prototype.has = function (e) {
    var t = this.__data__;
    return J ? void 0 !== t[e] : M.call(t, e);
  }, Q.prototype.set = function (e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = J && void 0 === t ? n : t, this;
  }, ee.prototype.clear = function () {
    this.__data__ = [], this.size = 0;
  }, ee.prototype["delete"] = function (e) {
    var t = this.__data__,
      n = ae(t, e);
    return !(n < 0) && (n == t.length - 1 ? t.pop() : Z.call(t, n, 1), --this.size, !0);
  }, ee.prototype.get = function (e) {
    var t = this.__data__,
      n = ae(t, e);
    return n < 0 ? void 0 : t[n][1];
  }, ee.prototype.has = function (e) {
    return ae(this.__data__, e) > -1;
  }, ee.prototype.set = function (e, t) {
    var n = this.__data__,
      r = ae(n, e);
    return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
  }, te.prototype.clear = function () {
    this.size = 0, this.__data__ = {
      hash: new Q(),
      map: new (Y || ee)(),
      string: new Q()
    };
  }, te.prototype["delete"] = function (e) {
    var t = _e(this, e)["delete"](e);
    return this.size -= t ? 1 : 0, t;
  }, te.prototype.get = function (e) {
    return _e(this, e).get(e);
  }, te.prototype.has = function (e) {
    return _e(this, e).has(e);
  }, te.prototype.set = function (e, t) {
    var n = _e(this, e),
      r = n.size;
    return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
  }, ne.prototype.clear = function () {
    this.__data__ = new ee(), this.size = 0;
  }, ne.prototype["delete"] = function (e) {
    var t = this.__data__,
      n = t["delete"](e);
    return this.size = t.size, n;
  }, ne.prototype.get = function (e) {
    return this.__data__.get(e);
  }, ne.prototype.has = function (e) {
    return this.__data__.has(e);
  }, ne.prototype.set = function (e, t) {
    var n = this.__data__;
    if (n instanceof ee) {
      var r = n.__data__;
      if (!Y || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
      n = this.__data__ = new te(r);
    }
    return n.set(e, t), this.size = n.size, this;
  };
  var ce,
    le = function le(e, t, n) {
      for (var r = -1, o = Object(e), i = n(e), a = i.length; a--;) {
        var s = i[ce ? a : ++r];
        if (!1 === t(o[s], s, o)) break;
      }
      return e;
    };
  function ue(e) {
    return null == e ? void 0 === e ? d : c : z && z in Object(e) ? function (e) {
      var t = M.call(e, z),
        n = e[z];
      try {
        e[z] = void 0;
        var r = !0;
      } catch (e) {}
      var o = D.call(e);
      r && (t ? e[z] = n : delete e[z]);
      return o;
    }(e) : function (e) {
      return D.call(e);
    }(e);
  }
  function de(e) {
    return Pe(e) && ue(e) == o;
  }
  function pe(e) {
    return !(!Te(e) || function (e) {
      return !!R && R in e;
    }(e)) && (Le(e) ? j : p).test(function (e) {
      if (null != e) {
        try {
          return P.call(e);
        } catch (e) {}
        try {
          return e + "";
        } catch (e) {}
      }
      return "";
    }(e));
  }
  function he(e) {
    if (!Te(e)) return function (e) {
      var t = [];
      if (null != e) for (var n in Object(e)) t.push(n);
      return t;
    }(e);
    var t = Ce(e),
      n = [];
    for (var r in e) ("constructor" != r || !t && M.call(e, r)) && n.push(r);
    return n;
  }
  function fe(e, t, n, r, o) {
    e !== t && le(t, function (i, a) {
      if (o || (o = new ne()), Te(i)) !function (e, t, n, r, o, i, a) {
        var s = be(e, n),
          c = be(t, n),
          u = a.get(c);
        if (u) return void oe(e, n, u);
        var d = i ? i(s, c, n + "", e, t, a) : void 0,
          p = void 0 === d;
        if (p) {
          var h = Se(c),
            f = !h && Oe(c),
            m = !h && !f && Me(c);
          d = c, h || f || m ? Se(s) ? d = s : Pe(C = s) && xe(C) ? d = function (e, t) {
            var n = -1,
              r = e.length;
            t || (t = Array(r));
            for (; ++n < r;) t[n] = e[n];
            return t;
          }(s) : f ? (p = !1, d = function (e, t) {
            if (t) return e.slice();
            var n = e.length,
              r = H ? H(n) : new e.constructor(n);
            return e.copy(r), r;
          }(c, !0)) : m ? (p = !1, g = c, _ = !0 ? (v = g.buffer, y = new v.constructor(v.byteLength), new N(y).set(new N(v)), y) : g.buffer, d = new g.constructor(_, g.byteOffset, g.length)) : d = [] : function (e) {
            if (!Pe(e) || ue(e) != l) return !1;
            var t = U(e);
            if (null === t) return !0;
            var n = M.call(t, "constructor") && t.constructor;
            return "function" == typeof n && n instanceof n && P.call(n) == F;
          }(c) || Ee(c) ? (d = s, Ee(s) ? d = function (e) {
            return function (e, t, n, r) {
              var o = !n;
              n || (n = {});
              var i = -1,
                a = t.length;
              for (; ++i < a;) {
                var s = t[i],
                  c = r ? r(n[s], e[s], s, n, e) : void 0;
                void 0 === c && (c = e[s]), o ? se(n, s, c) : ie(n, s, c);
              }
              return n;
            }(e, Re(e));
          }(s) : Te(s) && !Le(s) || (d = function (e) {
            return "function" != typeof e.constructor || Ce(e) ? {} : X(U(e));
          }(c))) : p = !1;
        }
        var g, _, v, y;
        var C;
        p && (a.set(c, d), o(d, c, r, i, a), a["delete"](c));
        oe(e, n, d);
      }(e, t, a, n, fe, r, o);else {
        var s = r ? r(be(e, a), i, a + "", e, t, o) : void 0;
        void 0 === s && (s = i), oe(e, a, s);
      }
    }, Re);
  }
  function me(e, t) {
    return we(function (e, t, n) {
      return t = G(void 0 === t ? e.length - 1 : t, 0), function () {
        for (var r = arguments, o = -1, i = G(r.length - t, 0), a = Array(i); ++o < i;) a[o] = r[t + o];
        o = -1;
        for (var s = Array(t + 1); ++o < t;) s[o] = r[o];
        return s[t] = n(a), function (e, t, n) {
          switch (n.length) {
            case 0:
              return e.call(t);
            case 1:
              return e.call(t, n[0]);
            case 2:
              return e.call(t, n[0], n[1]);
            case 3:
              return e.call(t, n[0], n[1], n[2]);
          }
          return e.apply(t, n);
        }(e, this, s);
      };
    }(e, t, je), e + "");
  }
  var ge = W ? function (e, t) {
    return W(e, "toString", {
      configurable: !0,
      enumerable: !1,
      value: (n = t, function () {
        return n;
      }),
      writable: !0
    });
    var n;
  } : je;
  function _e(e, t) {
    var n,
      r,
      o = e.__data__;
    return ("string" == (r = _typeof(n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? o["string" == typeof t ? "string" : "hash"] : o.map;
  }
  function ve(e, t) {
    var n = function (e, t) {
      return null == e ? void 0 : e[t];
    }(e, t);
    return pe(n) ? n : void 0;
  }
  function ye(e, t) {
    var n = _typeof(e);
    return !!(t = null == t ? r : t) && ("number" == n || "symbol" != n && h.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }
  function Ce(e) {
    var t = e && e.constructor;
    return e === ("function" == typeof t && t.prototype || A);
  }
  function be(e, t) {
    if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
  }
  var we = function (e) {
    var t = 0,
      n = 0;
    return function () {
      var r = q(),
        o = 16 - (r - n);
      if (n = r, o > 0) {
        if (++t >= 800) return arguments[0];
      } else t = 0;
      return e.apply(void 0, arguments);
    };
  }(ge);
  function ke(e, t) {
    return e === t || e != e && t != t;
  }
  var Ee = de(function () {
      return arguments;
    }()) ? de : function (e) {
      return Pe(e) && M.call(e, "callee") && !V.call(e, "callee");
    },
    Se = Array.isArray;
  function xe(e) {
    return null != e && Ae(e.length) && !Le(e);
  }
  var Oe = K || function () {
    return !1;
  };
  function Le(e) {
    if (!Te(e)) return !1;
    var t = ue(e);
    return t == a || t == s || t == i || t == u;
  }
  function Ae(e) {
    return "number" == typeof e && e > -1 && e % 1 == 0 && e <= r;
  }
  function Te(e) {
    var t = _typeof(e);
    return null != e && ("object" == t || "function" == t);
  }
  function Pe(e) {
    return null != e && "object" == _typeof(e);
  }
  var Me = k ? function (e) {
    return function (t) {
      return e(t);
    };
  }(k) : function (e) {
    return Pe(e) && Ae(e.length) && !!f[ue(e)];
  };
  function Re(e) {
    return xe(e) ? re(e, !0) : he(e);
  }
  var De,
    Fe = (De = function De(e, t, n) {
      fe(e, t, n);
    }, me(function (e, t) {
      var n = -1,
        r = t.length,
        o = r > 1 ? t[r - 1] : void 0,
        i = r > 2 ? t[2] : void 0;
      for (o = De.length > 3 && "function" == typeof o ? (r--, o) : void 0, i && function (e, t, n) {
        if (!Te(n)) return !1;
        var r = _typeof(t);
        return !!("number" == r ? xe(n) && ye(t, n.length) : "string" == r && (t in n)) && ke(n[t], e);
      }(t[0], t[1], i) && (o = r < 3 ? void 0 : o, r = 1), e = Object(e); ++n < r;) {
        var a = t[n];
        a && De(e, a, n, o);
      }
      return e;
    }));
  function je(e) {
    return e;
  }
  e.exports = Fe;
}(_f, _f.exports);
var vf = _f.exports;
var yf = "#8296A1",
  Cf = function Cf(_ref117) {
    var e = _ref117.styles,
      t = _ref117.displayWatermark;
    return Rr(function () {
      return function (e) {
        var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        var n, r, o, i, a, s, c, l, u, d;
        var p = vf({}, Ls, e);
        return {
          typography: {
            fontFamily: p.fontFamily,
            header: {
              fontFamily: p.fontFamily,
              fontSize: 24,
              fontWeight: 600,
              lineHeight: "30px"
            },
            body: {
              fontFamily: p.fontFamily,
              fontSize: 16,
              fontWeight: "normal",
              lineHeight: "21px"
            },
            helper: {
              fontFamily: p.fontFamily,
              fontSize: 14,
              fontWeight: "400",
              lineHeight: "20px",
              whiteSpace: "pre-wrap"
            }
          },
          colors: {
            primary: p.colors.primary,
            secondary: p.colors.secondary,
            success: p.colors.success,
            error: p.colors.error,
            disabled: "#F3F5F6",
            disabledText: yf
          },
          container: {
            width: p.container.width,
            border: "1px solid ".concat(p.container.borderColor),
            borderRadius: p.container.borderRadius,
            backgroundColor: p.container.backgroundColor
          },
          buttons: {
            primary: {
              backgroundColor: p.buttons.primary.backgroundColor,
              textColor: p.buttons.primary.textColor,
              border: "1px solid ".concat(p.buttons.primary.borderColor),
              borderRadius: p.buttons.primary.borderRadius
            },
            secondary: {
              backgroundColor: p.buttons.secondary.backgroundColor,
              textColor: p.buttons.secondary.textColor,
              border: "1px solid ".concat(p.buttons.secondary.borderColor),
              borderRadius: p.buttons.secondary.borderRadius
            }
          },
          inputs: {
            backgroundColor: null !== (r = null === (n = p.inputs) || void 0 === n ? void 0 : n.backgroundColor) && void 0 !== r ? r : "transparent",
            textColor: null !== (i = null === (o = p.inputs) || void 0 === o ? void 0 : o.textColor) && void 0 !== i ? i : p.colors.primary,
            borderColor: null !== (s = null === (a = p.inputs) || void 0 === a ? void 0 : a.borderColor) && void 0 !== s ? s : p.colors.primary,
            borderRadius: null !== (l = null === (c = p.inputs) || void 0 === c ? void 0 : c.borderRadius) && void 0 !== l ? l : "4px",
            placeholderColor: null !== (d = null === (u = p.inputs) || void 0 === u ? void 0 : u.placeholderColor) && void 0 !== d ? d : yf
          },
          displayHeader: !p.hideHeaderText,
          displayWatermark: t,
          logo: {
            logoImageUrl: p.logo.logoImageUrl
          }
        };
      }(e, t);
    }, [e, t]);
  },
  bf = "stytch-ui",
  wf = "stytch-reset-password",
  kf = "stytch-passkey-registration",
  Ef = ks(function (_ref118) {
    var e = _ref118.client,
      t = _ref118.config,
      n = _ref118.styles,
      r = _ref118.callbacks;
    var _Or133 = Or(function () {
        var _xn$bootstrap$getSync2 = xn(e).bootstrap.getSync(),
          t = _xn$bootstrap$getSync2.displayWatermark;
        return t;
      }),
      _Or134 = _slicedToArray(_Or133, 2),
      o = _Or134[0],
      i = _Or134[1];
    Ar(function () {
      xn(e).networkClient.logEvent({
        name: "render_login_screen",
        details: {
          options: t
        }
      }), xn(e).bootstrap.getAsync().then(function (_ref119) {
        var e = _ref119.displayWatermark;
        i(e);
      });
    }, [e]);
    var a = Cf({
      styles: n,
      displayWatermark: o
    });
    return Ko.createElement(Ts, {
      client: e,
      config: t,
      callbacks: r
    }, Ko.createElement(ms, {
      theme: a
    }, Ko.createElement(gf, null)));
  }, bf),
  Sf = ks(function (_ref120) {
    var e = _ref120.client,
      t = _ref120.config,
      n = _ref120.styles,
      r = _ref120.callbacks,
      o = _ref120.passwordResetToken;
    var _Or135 = Or(function () {
        var _xn$bootstrap$getSync3 = xn(e).bootstrap.getSync(),
          t = _xn$bootstrap$getSync3.displayWatermark;
        return t;
      }),
      _Or136 = _slicedToArray(_Or135, 2),
      i = _Or136[0],
      a = _Or136[1],
      s = Object.assign(Object.assign({}, xs), {
        screen: Ss.PasswordResetForm,
        formState: Object.assign(Object.assign({}, xs.formState), {
          resetPasswordState: {
            token: o
          }
        })
      });
    Ar(function () {
      xn(e).bootstrap.getAsync().then(function (_ref121) {
        var e = _ref121.displayWatermark;
        a(e);
      });
    }, [e]);
    var c = Cf({
      styles: n,
      displayWatermark: i
    });
    return Ko.createElement(Ts, {
      client: e,
      config: t,
      callbacks: r,
      initialState: s
    }, Ko.createElement(ms, {
      theme: c
    }, Ko.createElement(gf, null)));
  }, wf),
  xf = ks(function (_ref122) {
    var e = _ref122.client,
      t = _ref122.config,
      n = _ref122.styles,
      r = _ref122.callbacks;
    var _Or137 = Or(function () {
        var _xn$bootstrap$getSync4 = xn(e).bootstrap.getSync(),
          t = _xn$bootstrap$getSync4.displayWatermark;
        return t;
      }),
      _Or138 = _slicedToArray(_Or137, 2),
      o = _Or138[0],
      i = _Or138[1],
      a = Object.assign(Object.assign({}, xs), {
        screen: Ss.PasskeyRegistrationStart,
        formState: Object.assign({}, xs.formState)
      });
    Ar(function () {
      xn(e).bootstrap.getAsync().then(function (_ref123) {
        var e = _ref123.displayWatermark;
        i(e);
      });
    }, [e]);
    var s = Cf({
      styles: n,
      displayWatermark: o
    });
    return Ko.createElement(Ts, {
      client: e,
      config: t,
      callbacks: r,
      initialState: a
    }, Ko.createElement(ms, {
      theme: s
    }, Ko.createElement(gf, null)));
  }, kf);
var Of = /*#__PURE__*/function (_On) {
  _inherits(Of, _On);
  function Of() {
    var _this14;
    _classCallCheck(this, Of);
    for (var _len7 = arguments.length, e = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      e[_key7] = arguments[_key7];
    }
    Xe("StytchUIClient"), _this14 = _callSuper(this, Of, [].concat(e));
    return _this14;
  }
  _createClass(Of, [{
    key: "mountLogin",
    value: function mountLogin(_ref124) {
      var e = _ref124.elementId,
        t = _ref124.config,
        n = _ref124.styles,
        r = _ref124.callbacks;
      var o;
      var i = document.querySelector(e);
      if (!i) {
        throw new Error("The selector you specified (".concat(e, ") applies to no DOM elements that are currently on the page. Make sure the element exists on the page before calling mountLogin()."));
      }
      if ((null === (o = i.firstChild) || void 0 === o ? void 0 : o.nodeName.toLowerCase()) === bf.toLowerCase()) {
        return void i.firstChild.render({
          client: this,
          config: t,
          callbacks: r,
          styles: n
        });
      }
      var a = Ef({
        client: this,
        config: t,
        callbacks: r,
        styles: n
      });
      i.appendChild(a);
    }
  }, {
    key: "mountResetPassword",
    value: function mountResetPassword(_ref125) {
      var e = _ref125.elementId,
        t = _ref125.config,
        n = _ref125.styles,
        r = _ref125.callbacks,
        o = _ref125.passwordResetToken;
      var i;
      var a = document.querySelector(e);
      if (!a) {
        throw new Error("The selector you specified (".concat(e, ") applies to no DOM elements that are currently on the page. Make sure the element exists on the page before calling mountLogin()."));
      }
      if ((null === (i = a.firstChild) || void 0 === i ? void 0 : i.nodeName.toLowerCase()) === wf.toLowerCase()) {
        return void a.firstChild.render({
          client: this,
          config: t,
          callbacks: r,
          styles: n,
          passwordResetToken: o
        });
      }
      var s = Sf({
        client: this,
        config: t,
        callbacks: r,
        styles: n,
        passwordResetToken: o
      });
      a.appendChild(s);
    }
  }, {
    key: "mountPasskeyRegistration",
    value: function mountPasskeyRegistration(_ref126) {
      var e = _ref126.elementId,
        t = _ref126.config,
        n = _ref126.styles,
        r = _ref126.callbacks;
      var o;
      var i = document.querySelector(e);
      if (!i) {
        throw new Error("The selector you specified (".concat(e, ") applies to no DOM elements that are currently on the page. Make sure the element exists on the page before calling mountPasskeyRegistration()."));
      }
      if ((null === (o = i.firstChild) || void 0 === o ? void 0 : o.nodeName.toLowerCase()) === kf.toLowerCase()) {
        return void i.firstChild.render({
          client: this,
          config: t,
          callbacks: r,
          styles: n
        });
      }
      var a = xf({
        client: this,
        config: t,
        callbacks: r,
        styles: n
      });
      i.appendChild(a);
    }
  }]);
  return Of;
}(On);
export { C as AuthFlowType, b as B2BMFAProducts, w as B2BOAuthProviders, y as B2BProducts, ee as BiometricsFailedError, j as BiometricsUnavailableError, q as ChallengeSigningFailedError, $ as DeviceCredentialsNotAllowedError, J as FailedCodeChallengeError, Q as FailedToDecryptDataError, D as InternalError, W as InvalidAuthorizationCredentialError, oe as InvalidCredentialTypeError, ne as InvalidRedirectSchemeError, te as InvalidStartUrlError, ae as JSONDataNotConvertibleToStringError, I as KeyInvalidatedError, B as KeystoreUnavailableError, ie as MissingAttestationObjectError, z as MissingAuthorizationCredentialIDTokenError, V as MissingGoogleClientIDError, Z as MissingPKCEError, G as MissingPublicKeyError, re as MissingUrlError, N as NoBiometricsEnrolledError, F as NoBiometricsRegistrationError, K as NoCredentialsPresentError, R as NoCurrentSessionError, h as OAuthProviders, g as OTPMethods, m as OneTapPositions, ce as PasskeysInvalidEncoding, le as PasskeysMisconfigured, X as PasskeysUnsupportedError, p as Products, v as RNUIProducts, se as RandomNumberGenerationFailed, k as SDKAPIUnreachableError, Y as SDKNotConfiguredError, ue as SignInWithAppleMisconfigured, P as StytchAPIError, T as StytchAPISchemaError, A as StytchAPIUnreachableError, L as StytchError, _ as StytchEventType, x as StytchSDKAPIError, M as StytchSDKError, S as StytchSDKSchemaError, E as StytchSDKUsageError, Of as StytchUIClient, O as UNRECOVERABLE_ERROR_TYPES, H as UserCancellationError, U as UserLockedOutError, f as Wallets, de as errorToStytchError };
